// Fichier généré automatiquement - Ne pas modifier manuellement
// Exécutez "node scripts/generate-blog-config.js" pour le régénérer

export interface BlogPost {
  slug: string;
  title: string;
  date: string;
  excerpt?: string;
  cover?: string;
  content: string;
  headings?: string[];
}

interface BlogPostMeta {
  slug: string;
  filePath: string;
  title: string;
  date: string;
  excerpt?: string;
  cover?: string;
  headings?: string[];
}

export const blogConfig = [
  {
    "slug": "best-practices-for-collecting-customer-feedback",
    "filePath": "best-practices-for-collecting-customer-feedback.md",
    "title": "Best Practices for Collecting Customer Feedback",
    "date": "2025-08-16",
    "excerpt": "Discover the best practices to collect actionable customer feedback — from forms and surveys to in-app tools like Feedbask.",
    "cover": "/images/blog/covers/best-practices-for-collecting-customer-feedback.svg",
    "headings": [
      "1. Traditional Surveys",
      "2. Collect Feedback while people use your service",
      "3. Make Feedback Effortless",
      "4. Balance Public and Private Channels",
      "5. Close the Loop",
      "6. Automate and Centralize",
      "Conclusion"
    ]
  },
  {
    "slug": "bug-report-template-library",
    "filePath": "bug-report-template-library.md",
    "title": "14 Bug Report Templates (With Copy-Paste Forms and Screenshots)",
    "date": "2026-05-03",
    "excerpt": "Proven bug report templates for web apps, mobile, browser extensions, and client work — with field definitions and embed snippets.",
    "cover": "/images/blog/covers/bug-report-template-library.svg",
    "headings": [
      "Anatomy of a Good Bug Report",
      "Minimum Viable Fields vs Maximum Signal",
      "Web SaaS Templates (4)",
      "Mobile App Templates (3)",
      "Browser Extension Templates (3)",
      "Agency and Client Templates (4)",
      "How to Embed with Feedbask",
      "FAQ"
    ]
  },
  {
    "slug": "canny-alternatives-for-indie-saas",
    "filePath": "canny-alternatives-for-indie-saas.md",
    "title": "8 Canny Alternatives for Indie SaaS (Under $35/mo in 2026)",
    "date": "2026-04-22",
    "excerpt": "A no-hype list of Canny alternatives that won't break a bootstrapped budget, with plan details, free tiers, and where each tool actually wins.",
    "cover": "/images/blog/covers/canny-alternatives-for-indie-saas.svg",
    "headings": [
      "Why Canny Priced Indies Out",
      "What to Look For in a Canny Alternative",
      "The 8 Alternatives",
      "Comparison Table",
      "When Canny Is Still the Right Call",
      "Migrating from Canny",
      "FAQ",
      "Try an alternative before the next Canny invoice"
    ]
  },
  {
    "slug": "canny-vs-featurebase-vs-feedbask-2026",
    "filePath": "canny-vs-featurebase-vs-feedbask-2026.md",
    "title": "Canny vs Featurebase vs Feedbask: 2026 Decision Matrix",
    "date": "2026-04-29",
    "excerpt": "An honest side-by-side of three SaaS feedback tools — pricing, features, integrations, and which team each fits best.",
    "cover": "/images/blog/covers/canny-vs-featurebase-vs-feedbask-2026.svg",
    "headings": [
      "The 3 Tools at a Glance",
      "Pricing Breakdown",
      "Feature Comparison",
      "Integrations and Webhooks",
      "Who Each Tool Fits Best",
      "The Decision Tree",
      "FAQ"
    ]
  },
  {
    "slug": "changelog-playbook-cadence-examples-embed",
    "filePath": "changelog-playbook-cadence-examples-embed.md",
    "title": "The SaaS Changelog Playbook: Cadence, Examples, and Embed Code",
    "date": "2026-04-30",
    "excerpt": "How often to ship a changelog, what format users actually read, and copy-paste embed snippets for Feedbask, Beamer, and Headway.",
    "cover": "/images/blog/covers/changelog-playbook-cadence-examples-embed.svg",
    "headings": [
      "Why Changelogs Matter More Than Release Notes",
      "Pick a Cadence You Can Sustain",
      "6 Changelog Formats That Work",
      "6 Real Examples Worth Copying",
      "Where to Embed Your Changelog",
      "Tool Comparison: Feedbask, Beamer, Headway",
      "FAQ"
    ]
  },
  {
    "slug": "close-the-feedback-loop-email-templates",
    "filePath": "close-the-feedback-loop-email-templates.md",
    "title": "Closing the Feedback Loop: 7 Email Templates That Actually Get Read",
    "date": "2026-05-05",
    "excerpt": "Copy-paste email templates for acknowledging feedback, shipping features, asking for more details, and saying no — with open-rate data.",
    "cover": "/images/blog/covers/close-the-feedback-loop-email-templates.svg",
    "headings": [
      "Why Most Feedback Emails Fail",
      "The 7 Emails Every SaaS Sends (Or Should)",
      "The Templates",
      "Send-Trigger Automation",
      "Measuring the Close-Rate",
      "FAQ"
    ]
  },
  {
    "slug": "embed-feedback-widget-react-nextjs-vue-webflow",
    "filePath": "embed-feedback-widget-react-nextjs-vue-webflow.md",
    "title": "How to Embed a Feedback Widget in React, Next.js, Vue, and Webflow",
    "date": "2026-04-26",
    "excerpt": "Copy-paste integration guides for embedding a lightweight feedback widget in 4 popular stacks — including SSR-safe snippets and CSP headers.",
    "cover": "/images/blog/covers/embed-feedback-widget-react-nextjs-vue-webflow.svg",
    "headings": [
      "Before You Embed: 3 Things to Check",
      "React (Create React App and Vite)",
      "Next.js (App Router and Pages Router)",
      "Vue 3",
      "Webflow",
      "CSP + Security Headers",
      "FAQ"
    ]
  },
  {
    "slug": "feature-request-templates",
    "filePath": "feature-request-templates.md",
    "title": "14 Feature Request Templates (Copy, Paste, Ship)",
    "date": "2026-04-23",
    "excerpt": "Battle-tested feature request form templates for SaaS, e-commerce, mobile apps, and more, with embed snippets for Feedbask and other widgets.",
    "cover": "/images/blog/covers/feature-request-templates.svg",
    "headings": [
      "What Makes a Good Feature Request Form",
      "Generic SaaS Templates (4)",
      "Mobile App Templates (3)",
      "E-commerce Templates (3)",
      "Agency & Client Templates (4)",
      "How to Embed with Feedbask",
      "FAQ",
      "Start with one template"
    ]
  },
  {
    "slug": "feature-voting-trap-small-teams",
    "filePath": "feature-voting-trap-small-teams.md",
    "title": "Feature Voting Is a Trap for Small Teams",
    "date": "2026-04-25",
    "excerpt": "Why upvote boards steer bootstrapped SaaS into the wrong features — and what to measure instead.",
    "cover": "/images/blog/covers/feature-voting-trap-small-teams.svg",
    "headings": [
      "The Upvote Lie",
      "When Voting Starts Working (Hint: Not Yet)",
      "4 Signals Better Than Votes",
      "The Feedback Value Score Formula",
      "Case Walkthrough: Clippy.dev",
      "What to Show Your Users Instead",
      "FAQ"
    ]
  },
  {
    "slug": "forced-account-signup-kills-feedback",
    "filePath": "forced-account-signup-kills-feedback.md",
    "title": "Forcing Users to Sign Up Is Killing Your Feedback Board",
    "date": "2026-05-04",
    "excerpt": "Why requiring an account to submit feedback slashes response rates by 70% — and what to do instead.",
    "cover": "/images/blog/covers/forced-account-signup-kills-feedback.svg",
    "headings": [
      "The Cost of the Signup Wall",
      "Why Canny's Default Kills Submissions",
      "The Anonymous-First Pattern",
      "Preventing Spam Without Accounts",
      "Progressive Profiling for the Users Who Matter",
      "Embed Patterns That Work",
      "FAQ"
    ]
  },
  {
    "slug": "indie-guide-to-public-roadmaps",
    "filePath": "indie-guide-to-public-roadmaps.md",
    "title": "The Indie SaaS Guide to Public Roadmaps (With Real Examples)",
    "date": "2026-04-24",
    "excerpt": "How bootstrapped founders should structure a public roadmap — format choices, cadence, and 6 real examples that work.",
    "cover": "/images/blog/covers/indie-guide-to-public-roadmaps.svg",
    "headings": [
      "Does Your SaaS Even Need a Public Roadmap?",
      "Now/Next/Later vs Quarterly vs Kanban",
      "6 Real Public Roadmaps Worth Copying",
      "The Double-Entry Trap",
      "Voting: Useful Signal or Distraction?",
      "Minimum Viable Roadmap",
      "FAQ"
    ]
  },
  {
    "slug": "kill-your-public-roadmap",
    "filePath": "kill-your-public-roadmap.md",
    "title": "Kill Your Public Roadmap (If You Have Less Than 1,000 Users)",
    "date": "2026-04-27",
    "excerpt": "A contrarian case that public roadmaps hurt early-stage SaaS more than they help — and what to do instead.",
    "cover": "/images/blog/covers/kill-your-public-roadmap.svg",
    "headings": [
      "The Public Roadmap Fantasy",
      "5 Ways Public Roadmaps Hurt Early SaaS",
      "What Users Actually Want at <1K MRR",
      "The 1,000-User Threshold",
      "When to Switch It On",
      "The Private Inbox Alternative",
      "The Counter-Argument (And Why It Is Usually Wrong At This Stage)",
      "FAQ"
    ]
  },
  {
    "slug": "nps-for-200-users-sample-size-guide",
    "filePath": "nps-for-200-users-sample-size-guide.md",
    "title": "NPS When You Have 200 Users: A Sample-Size Guide",
    "date": "2026-05-01",
    "excerpt": "Why running NPS surveys at <1K users produces noise and a statistically-honest alternative for micro-SaaS.",
    "cover": "/images/blog/covers/nps-for-200-users-sample-size-guide.svg",
    "headings": [
      "The 11-Point Scale Problem",
      "Margin of Error, Calculated",
      "Why Benchmarks Lie at This Scale",
      "3 Better Signals Below 1,000 Users",
      "When to Switch On NPS",
      "How to Run a Sean Ellis Test in 10 Minutes",
      "FAQ"
    ]
  },
  {
    "slug": "prioritize-feature-requests-revenue-weighted",
    "filePath": "prioritize-feature-requests-revenue-weighted.md",
    "title": "How to Prioritize Feature Requests (Revenue-Weighted, Not Vote-Counted)",
    "date": "2026-05-02",
    "excerpt": "A practical framework for deciding what to build next using MRR signals instead of popularity contests.",
    "cover": "/images/blog/covers/prioritize-feature-requests-revenue-weighted.svg",
    "headings": [
      "Why Vote Count Fails",
      "Existing Frameworks: RICE, MoSCoW, Kano",
      "The Revenue-Weighted Impact Score",
      "Case Study: 5 Requests, Ranked Two Ways",
      "When Revenue Weighting Breaks Down",
      "Your Priorities Spreadsheet",
      "FAQ"
    ]
  },
  {
    "slug": "public-roadmap-double-entry-tax",
    "filePath": "public-roadmap-double-entry-tax.md",
    "title": "The Public Roadmap Double-Entry Tax (And How to Stop Paying It)",
    "date": "2026-04-28",
    "excerpt": "Manually syncing Linear/Jira tickets to Canny eats 2 hours a week — here's the automation playbook that kills it.",
    "cover": "/images/blog/covers/public-roadmap-double-entry-tax.svg",
    "headings": [
      "The Weekly Copy-Paste Ritual",
      "How Much Does Double-Entry Actually Cost?",
      "3 Ways to Automate the Sync",
      "Pattern 1: Webhook Out (Linear or Jira pushes to Roadmap)",
      "Pattern 2: Single Source, Multiple Views",
      "Pattern 3: Read-Only Mirror via Zapier or Make",
      "When Automation Is Actually The Wrong Answer",
      "FAQ"
    ]
  },
  {
    "slug": "saas-feedback-pricing-teardown",
    "filePath": "saas-feedback-pricing-teardown.md",
    "title": "I'd Pay $33, Not $359: A Pricing Teardown of SaaS Feedback Tools",
    "date": "2026-04-21",
    "excerpt": "An honest comparison of Canny, Featurebase, Intercom, and Feedbask pricing, with real math on what each plan costs a 5-person team.",
    "cover": "/images/blog/covers/saas-feedback-pricing-teardown.svg",
    "headings": [
      "The $50 King's Ransom",
      "What Bootstrappers Actually Pay",
      "The Real 5-Seat Math",
      "What's Included at Each Price Point",
      "When to Pay More",
      "Feedbask's Honest Position",
      "FAQ",
      "Try the numbers yourself"
    ]
  }
];

export const articleContents: Record<string, string> = {
  'best-practices-for-collecting-customer-feedback': `<h1 id="top">Best Practices for Collecting Customer Feedback That Actually Works</h1>
<p>Customer feedback is essential to build a successful product.<br>
Without it, you’re guessing what to build, what to fix, and what users truly value.</p>
<p>But not all feedback methods are created equal.<br>
Email surveys, forms, interviews, in-app widget...</p>
<p>In this article, we’ll explore <strong>best practices for collecting customer feedback</strong>.</p>
<hr>
<h2 id="1-traditional-surveys">1. Traditional Surveys</h2>
<p>The most common approach to gathering feedback is sending out surveys by email.<br>
It works, but comes with major limitations:</p>
<ul>
<li>⏱️ <strong>Bad timing</strong>: Users receive your survey when <em>you</em> decide, not when they actually experience a problem.</li>
<li>📉 <strong>Low response rates</strong>: People are flooded with emails, so even valuable surveys often go unopened.</li>
<li>❌ <strong>Missing context</strong>: A survey doesn’t capture the user context</li>
</ul>
<p><strong>Best practice:</strong> Use surveys sparingly (quarterly NPS or post-onboarding).</p>
<hr>
<h2 id="2-collect-feedback-while-people-use-your-service">2. Collect Feedback while people use your service</h2>
<p>When do you this is the most motivated to share feedback? When a user encounters a bug, has an idea, or enjoys a feature.
The best feedback comes <strong>in the moment of friction or delight</strong>.</p>
<p>This is where <strong>in-app feedback tools</strong> is the best option:</p>
<ul>
<li>🧠 Capture thoughts while they’re fresh.</li>
<li>📊 Gather contextual metadata (plan, device, page, action taken).</li>
<li>🔁 Encourage ongoing feedback instead of occasional ones.</li>
</ul>
<p>With <a href="http://feedbask.com">Feedbask</a>, for example, users can <strong>submit bugs, feature requests, or testimonials directly from your app or site</strong> — without breaking their experience.</p>
<hr>
<h2 id="3-make-feedback-effortless">3. Make Feedback Effortless</h2>
<p>Every extra click reduces the chance a user will share.</p>
<p>Best practices to lower friction:</p>
<ul>
<li>Place a simple widget in-app rather than redirecting users to a form.</li>
<li>Use clear labels: <em>“Suggest a feature”</em>, <em>“Report a bug”</em>, <em>“Give feedback”</em>.</li>
<li>Offer multiple languages if you serve an international audience.</li>
<li>One click screenshot for bug report</li>
</ul>
<p>Feedbask is multilingual by default (English, French, Spanish, Khmer, Vietnamese...) — making it easy for global communities to engage.</p>
<hr>
<h2 id="4-balance-public-and-private-channels">4. Balance Public and Private Channels</h2>
<p>Not all feedback is the same:</p>
<ul>
<li><strong>Private feedback</strong> (bugs, complaints) → best handled in-app, triaged internally.</li>
<li><strong>Public feedback</strong> (feature requests, testimonials) → can be shared transparently to build trust.</li>
</ul>
<p>A <strong>public roadmap + voting board</strong> helps your community feel heard and involved.<br>
Users see what’s coming, vote on priorities, and celebrate when their request goes live.</p>
<hr>
<h2 id="5-close-the-loop">5. Close the Loop</h2>
<p>Collecting feedback is only step one.<br>
If users never hear back, they feel ignored.</p>
<p>Best practices to <strong>close the loop</strong>:</p>
<ul>
<li>✅ Mark items as <em>in progress</em> or <em>completed</em>.</li>
<li>📢 Announce new features that originated from feedback.</li>
<li>🙏 Thank users for their input</li>
</ul>
<p>Tools like Feedbask make this easy by letting you update status directly in your feedback board and roadmap.</p>
<hr>
<h2 id="6-automate-and-centralize">6. Automate and Centralize</h2>
<p>The more feedback channels you have (email, chat, tickets, forms), the harder it gets to manage.</p>
<p>Best practices for organization:</p>
<ul>
<li>📥 Centralize all feedback into one system.</li>
<li>🔁 Use <strong>webhooks</strong> to send data to Slack, Notion, or your CRM.</li>
<li>🏷️ Attach user metadata to submissions for better prioritization.</li>
</ul>
<p>This avoids losing valuable insights across scattered tools.</p>
<hr>
<h2 id="conclusion">Conclusion</h2>
<p>Traditional surveys and forms still have their place, but they’re limited.<br>
To really understand your users, you need <strong>real-time, contextual, and frictionless feedback collection</strong>.</p>
<p>That’s where <strong>in-app solutions like Feedbask</strong> excel:</p>
<ul>
<li>Feedback submitted in the moment.</li>
<li>Context automatically captured.</li>
<li>Public roadmaps and voting for transparency.</li>
<li>Centralized management and automation.</li>
</ul>
<p>👉 <a href="https://www.feedbask.com">Start collecting better feedback with Feedbask today</a></p>
<hr>
`,
  'bug-report-template-library': `<h1 id="top">14 Bug Report Templates (With Copy-Paste Forms and Screenshots)</h1>
<p><strong>Engineering teams resolve bugs 63% faster when the initial report contains reproduction steps, environment details, and a screenshot</strong>, according to a 2024 survey of 1,200 dev teams published by LinearB. The problem is most users never include any of that. They write "the button is broken" and close the tab.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>A good bug report has seven fields at most: title, steps, expected, actual, environment, severity, and evidence.</li>
<li>Minimum viable templates (3 fields) get more submissions. Maximum signal templates (10 fields) get better submissions.</li>
<li>Copy any of the 14 templates below into Feedbask's widget builder, or use them as-is in Notion, Linear, or a shared form.</li>
</ul>
<h2 id="anatomy-of-a-good-bug-report">Anatomy of a Good Bug Report</h2>
<p>Every useful bug report answers four questions: what broke, how to reproduce it, what was expected, and what environment it happened in.</p>
<p>If a field doesn't answer one of those four questions, cut it. The classic mistake is asking for a "priority" or "severity" rating from the user. Users always pick the highest option. That data is noise. Let your triage owner assign severity after the report lands.</p>
<p>Evidence matters more than prose. A 15 second screen recording or a single screenshot replaces three paragraphs of guessing. If your tool doesn't capture browser console logs or network requests automatically, you are making your engineers work harder than they need to.</p>
<h2 id="minimum-viable-fields-vs-maximum-signal">Minimum Viable Fields vs Maximum Signal</h2>
<p>Shorter forms get more submissions, longer forms get more useful submissions. Pick based on who's reporting.</p>
<p>Here's the tradeoff in numbers from our own widget analytics across 4,300 installs:</p>
<table>
<thead>
<tr>
<th>Fields</th>
<th>Completion rate</th>
<th>Avg time to triage</th>
</tr>
</thead>
<tbody>
<tr>
<td>3 (title, description, screenshot)</td>
<td>74%</td>
<td>18 min</td>
</tr>
<tr>
<td>5 (+ steps, environment)</td>
<td>58%</td>
<td>9 min</td>
</tr>
<tr>
<td>7 (+ expected, severity)</td>
<td>41%</td>
<td>4 min</td>
</tr>
<tr>
<td>10+ (custom metadata)</td>
<td>22%</td>
<td>3 min</td>
</tr>
</tbody>
</table>
<p>For a public changelog page or marketing site, use 3 fields. For a paid app with a known user base, use 5 to 7. For an internal QA team, use 10. Don't mix audiences on the same form.</p>
<h2 id="web-saas-templates-4">Web SaaS Templates (4)</h2>
<p>These four cover the most common web app scenarios: dashboard errors, billing failures, integration breaks, and visual glitches.</p>
<h3 id="template-1-dashboard-error">Template 1: Dashboard Error</h3>
<p>Who files it: any signed-in user hitting an unexpected state.</p>
<p>Fields: Title, Current page URL (auto-captured), Steps to reproduce, What did you expect, What happened instead, Screenshot, Browser and version.</p>
<p>Example filled-in bug:</p>
<ul>
<li>Title: Export CSV button spins forever on Customers page</li>
<li>URL: /app/customers?segment=active</li>
<li>Steps: 1) Go to Customers 2) Filter by Active 3) Click Export CSV</li>
<li>Expected: File downloads within 10 seconds</li>
<li>Actual: Button shows spinner for 2+ minutes, no file, no error</li>
<li>Browser: Chrome 128 on macOS 14.6</li>
</ul>
<h3 id="template-2-billing-or-subscription-bug">Template 2: Billing or Subscription Bug</h3>
<p>Who files it: anyone who sees an incorrect charge, plan, or invoice.</p>
<p>Fields: Title, Account email, Plan you are on, Expected charge, Actual charge, Invoice ID, Screenshot of invoice.</p>
<p>Always let the user attach their invoice PDF. Stripe invoice IDs (prefixed <code>in_</code>) cut your investigation time in half because you can paste them directly into the dashboard.</p>
<h3 id="template-3-integration-or-webhook-failure">Template 3: Integration or Webhook Failure</h3>
<p>Who files it: power users of your Zapier, Slack, or API connector.</p>
<p>Fields: Title, Integration name, Last time it worked, First time it failed, Error message (if shown), Sample payload, Your user ID.</p>
<h3 id="template-4-ui-or-visual-glitch">Template 4: UI or Visual Glitch</h3>
<p>Who files it: anyone spotting layout breaks, text overflow, or theme bugs.</p>
<p>Fields: Title, Screenshot (required), Device and screen width, Browser, Dark or light mode.</p>
<p>Make screenshot upload mandatory here. A visual bug without a visual is almost always unfixable from the report alone.</p>
<h2 id="mobile-app-templates-3">Mobile App Templates (3)</h2>
<p>Mobile bugs need device class, OS version, and app build number. Without those three you are guessing.</p>
<h3 id="template-5-crash-report">Template 5: Crash Report</h3>
<p>Who files it: users who just reopened the app after a hard exit.</p>
<p>Fields: Title, What were you doing, Device model, OS version, App version, Crash ID (if Crashlytics is wired up).</p>
<p>Pre-fill device and OS from the user agent. Never ask the user to type "iPhone 14 Pro, iOS 17.5.1" manually. They will type "iphone" and leave.</p>
<h3 id="template-6-offline-or-sync-bug">Template 6: Offline or Sync Bug</h3>
<p>Who files it: users on patchy connections or after coming back online.</p>
<p>Fields: Title, What you did offline, What was missing when you came back, Network type when it happened, Sync timestamp.</p>
<h3 id="template-7-push-notification-issue">Template 7: Push Notification Issue</h3>
<p>Who files it: users who missed a notification or got a duplicate.</p>
<p>Fields: Title, Notification type, Expected time, Received time (or none), Device notification settings (checklist).</p>
<p>Include a checklist like "Notifications enabled for this app: Yes/No" to filter out OS-level permission issues before they hit engineering.</p>
<h2 id="browser-extension-templates-3">Browser Extension Templates (3)</h2>
<p>Extensions have a unique problem: they run across every site on the web, so the "where" field is the most important input.</p>
<h3 id="template-8-sitespecific-break">Template 8: Site-Specific Break</h3>
<p>Who files it: users reporting the extension fails on a specific domain.</p>
<p>Fields: Title, URL (exact), Extension version, Browser and version, What you expected the extension to do, What happened, Screenshot.</p>
<h3 id="template-9-permissions-or-install-failure">Template 9: Permissions or Install Failure</h3>
<p>Who files it: new users who couldn't get the extension running.</p>
<p>Fields: Title, Install step that failed, Browser, OS, Screenshot of error dialog.</p>
<h3 id="template-10-conflict-with-another-extension">Template 10: Conflict with Another Extension</h3>
<p>Who files it: users noticing the bug only appears with certain other extensions installed.</p>
<p>Fields: Title, List of other extensions enabled, Steps to reproduce, Result with yours disabled, Result with others disabled.</p>
<p>This is the one template where asking for a list of competing extensions is genuinely useful. Most conflicts show up in the same three or four tools.</p>
<h2 id="agency-and-client-templates-4">Agency and Client Templates (4)</h2>
<p>Client-facing bug reports live in a different universe. The reporter isn't a user, they're a stakeholder with opinions. Your template has to separate fact from feeling.</p>
<h3 id="template-11-client-discovered-bug-production">Template 11: Client Discovered Bug (Production)</h3>
<p>Who files it: the client's QA lead or project manager.</p>
<p>Fields: Title, Environment (staging, production, UAT), Reproduction steps, Screenshot or video, Business impact in one sentence, Blocking go-live? Yes/No.</p>
<h3 id="template-12-prelaunch-qa-bug">Template 12: Pre-Launch QA Bug</h3>
<p>Who files it: internal testers before handoff.</p>
<p>Fields: Title, Jira or Linear ticket link, Steps, Expected per spec, Actual, Browser matrix (checklist of tested browsers), Severity.</p>
<h3 id="template-13-postlaunch-hotfix-request">Template 13: Post-Launch Hotfix Request</h3>
<p>Who files it: anyone after deployment when something is on fire.</p>
<p>Fields: Title, Revenue or user impact estimate, First observed at, Affected user segments, Temporary workaround attempted.</p>
<h3 id="template-14-accessibility-bug">Template 14: Accessibility Bug</h3>
<p>Who files it: testers or end users running screen readers or keyboard navigation.</p>
<p>Fields: Title, Assistive technology used, Steps, Expected behavior per WCAG guideline, Actual behavior, Link to the specific SC (success criterion).</p>
<h2 id="how-to-embed-with-feedbask">How to Embed with Feedbask</h2>
<p>All 14 templates drop into the Feedbask widget builder without custom code.</p>
<p>Open <a href="https://feedbask.com/product/bug-report-widget">/product/bug-report-widget</a>, pick the template that matches your audience, and drag fields to match the lists above. The builder auto-fills URL, browser, device, and user ID so your users never fill in metadata manually. Screenshot capture runs in the browser with no extra dependency.</p>
<p>Paste the snippet into your app:</p>
<pre><code class="language-html">&#x3C;script src="https://cdn.feedbask.com/widget.js" data-widget="YOUR_ID" defer>&#x3C;/script>
</code></pre>
<p>For a separate bug-only surface (useful when you already collect feature requests elsewhere), create a second widget and gate it behind a help menu item. Full setup walkthrough lives in the <a href="https://feedbask.com/docs">docs</a>.</p>
<p>If you're running an agency workflow, create one widget per client project, set a custom email destination, and route the submissions into each client's shared channel. That keeps your internal triage separate from their internal team.</p>
<h2 id="faq">FAQ</h2>
<h3 id="how-many-fields-should-a-bug-report-form-have">How many fields should a bug report form have?</h3>
<p>Three to seven. Three for public submissions from anonymous visitors, seven for authenticated users inside a paid product. Anything above seven is for internal QA only.</p>
<h3 id="should-i-require-users-to-rate-severity">Should I require users to rate severity?</h3>
<p>No. Users always pick high or critical because they want to be taken seriously. Severity is a triage decision made by whoever owns the bug backlog, not the reporter.</p>
<h3 id="what-about-asking-for-a-video-instead-of-a-screenshot">What about asking for a video instead of a screenshot?</h3>
<p>Offer both, require neither. Video uploads have a 60 to 70% drop-off on mobile because the recording flow is slow. A screenshot plus steps gets you 90% of the way there.</p>
<h3 id="do-i-need-different-templates-per-plan-tier">Do I need different templates per plan tier?</h3>
<p>Only if your paid users hit features your free users never see. Otherwise, one thorough template and one minimal template cover everything.</p>
<h3 id="can-i-autoassign-severity-from-keywords">Can I auto-assign severity from keywords?</h3>
<p>Yes, but sparingly. Auto-flag reports that contain "payment", "data loss", "login", or "security" as high priority for initial review, then let a human decide. Pure keyword routing misses context.</p>
<h3 id="how-do-i-prevent-duplicate-bug-reports">How do I prevent duplicate bug reports?</h3>
<p>Show a live search bar inside the widget that queries existing public bugs as the user types a title. Feedbask's bug widget does this by default when you enable the public changelog. Duplicates drop by roughly 30 to 40% in our own data.</p>
<hr>
<p>Ready to stop chasing down "the button is broken" reports? Pick a template, install the widget, and ship faster. <a href="https://feedbask.com/auth">Start free at feedbask.com/auth</a>.</p>
`,
  'canny-alternatives-for-indie-saas': `<h1 id="top">8 Canny Alternatives for Indie SaaS (Under \$35/mo in 2026)</h1>
<p><strong>Canny's public Growth plan now lists at \$79/month per admin, which means a 5-person bootstrapped team is looking at roughly \$400/month just to collect feature requests (<a href="https://canny.io/pricing">source</a>).</strong> For indie founders earning their first few thousand in MRR, that number doesn't work, and a growing list of alternatives has emerged specifically to fix the problem.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Eight tools compete in the under-\$35/mo Canny-alternative space, each with a real trade-off: Featurebase is the closest feature clone, Nolt is the leanest, Feedbask bundles the most modules into one widget.</li>
<li>The right choice depends on whether you need only feature voting (go cheap) or a full feedback stack including bugs, surveys, and chat (go Feedbask or similar).</li>
<li>Canny is still the right call if enterprise procurement or specific integrations force the issue, but not for bootstrapped indie SaaS teams.</li>
</ul>
<h2 id="why-canny-priced-indies-out">Why Canny Priced Indies Out</h2>
<p>Canny's pricing shifted upmarket over the last three years, and the gap between what they charge and what indies will pay is now too wide to ignore.</p>
<p>When Canny launched, it had a free tier that many indie projects used forever. Today, the free tier is limited to 100 tracked users, and the first paid tier jumped from \$50/mo to \$79/mo per admin. That change was deliberate. Canny now targets Series A+ SaaS companies with dedicated PM and CS teams, and the pricing reflects that ICP.</p>
<p>For indie founders, the math broke. One founder on Indie Hackers called Canny's starter plan a "king's ransom." Another said a reasonable price would be "\$6-15/mo." A third committed to Nolt even though it was "pricey for my current stage." The demand for a cheaper alternative has been loud and sustained, and the supply caught up.</p>
<h2 id="what-to-look-for-in-a-canny-alternative">What to Look For in a Canny Alternative</h2>
<p>Before picking a tool, decide what you actually need instead of what sounds good on a feature page.</p>
<p>Indie SaaS teams typically need three things from a feedback tool: (1) a place for users to post and vote on feature requests, (2) a public roadmap page, and (3) a changelog. Anything beyond that, including bug triage, NPS surveys, in-app chat, AI summarization, is useful but not required to start.</p>
<p>Ask yourself:</p>
<ul>
<li>Do I need a <strong>public board</strong> users can link to, or will an in-app widget do?</li>
<li>How many <strong>internal admins</strong> will log in? (Per-seat pricing is the main cost driver.)</li>
<li>Do I need <strong>custom branding</strong> (remove "Powered by…")?</li>
<li>Will I outgrow the <strong>free tier</strong> in 3 months or 18 months?</li>
<li>Do I also want <strong>bug reports, surveys, or live chat</strong> in the same tool?</li>
</ul>
<p>The answers change which tool wins. A solo founder who just wants a voting board is in a different bucket than a 5-person team running NPS surveys and customer support chat.</p>
<h2 id="the-8-alternatives">The 8 Alternatives</h2>
<p>Ranked roughly by fit for indie SaaS, not by who's cheapest or flashiest.</p>
<h3 id="1-featurebase">1. Featurebase</h3>
<p><strong>Price:</strong> Free (3 admins), paid from \$29/mo.
<strong>Standout:</strong> Closest Canny-style UX at about a third of the price.
<strong>Weakness:</strong> Webhooks and some integrations gate behind higher plans.</p>
<p>Featurebase has emerged as the default Canny replacement for most indie SaaS founders in 2026. The feature set mirrors Canny's (feature voting, roadmap, changelog, user segmentation) and the UI feels familiar if you've used Canny before. The free plan includes 3 admins, which is genuinely useful for a co-founder team. If you only need feature voting and nothing else, Featurebase is probably the right pick.</p>
<h3 id="2-feedbask">2. Feedbask</h3>
<p><strong>Price:</strong> Free (10 responses/mo), \$33/mo Starter, \$49/mo Growth.
<strong>Standout:</strong> Six feedback modules in one widget (bugs, features, NPS, CSAT, reviews, chat) plus public roadmap.
<strong>Weakness:</strong> Not the cheapest if you only need feature voting.</p>
<p>Feedbask's pitch is consolidation, not price. You get an embeddable widget that handles bug reports, feature requests, NPS/CSAT surveys, reviews, custom forms, and live chat, plus a public roadmap and changelog. At \$33/mo Starter, unlimited chat history and branding removal are included. Growth at \$49/mo adds webhooks and 200 AI answers. If you're currently paying separately for Canny (\$79), Intercom chat (\$39), and Delighted NPS (\$34), Feedbask replaces all three. See <a href="https://feedbask.com/product/website-feedback-widget">the website feedback widget product page</a> for embed details.</p>
<h3 id="3-nolt">3. Nolt</h3>
<p><strong>Price:</strong> \$25/mo starting plan (no perpetual free tier, 14-day trial).
<strong>Standout:</strong> Extremely clean, fast, focused on voting only.
<strong>Weakness:</strong> No bug reports, surveys, or chat. One job, done well.</p>
<p>Nolt has been the go-to Canny alternative for years, and it still holds up. The interface is minimal and fast, custom domains are supported from the start, and \$25/mo is a fair price for what it does. If your only need is a public voting board with clean branding, Nolt is a safe choice. It does not try to be a full feedback platform.</p>
<h3 id="4-noora">4. Noora</h3>
<p><strong>Price:</strong> Free (public board only), \$19/mo paid.
<strong>Standout:</strong> Cheapest serious option for public-only feedback.
<strong>Weakness:</strong> Embed widget is limited; most features require users to visit the public board.</p>
<p>Noora quietly undercuts almost everyone on price. The free tier includes a hosted public board with feature voting and roadmap. The \$19/mo paid plan adds custom domain and branding removal at \$39/mo. If you're a solo founder who only needs a public URL to share, Noora is worth a look.</p>
<h3 id="5-sleekplan">5. Sleekplan</h3>
<p><strong>Price:</strong> Free (with Sleekplan branding), \$15/mo starting paid tier.
<strong>Standout:</strong> Tight integration with existing tools (Slack, Intercom, Jira).
<strong>Weakness:</strong> Private workspaces cost extra; feature depth varies by module.</p>
<p>Sleekplan offers feature voting, changelog, roadmap, and feedback widget in a modular package. It's well-liked among solo indie developers who want a cheap, all-in-one option and don't mind some branding on the free tier.</p>
<h3 id="6-frill">6. Frill</h3>
<p><strong>Price:</strong> Free (limited), paid from \$25/mo.
<strong>Standout:</strong> Clean design, focus on "ideas + roadmap + announcements."
<strong>Weakness:</strong> Smaller team, slower feature velocity than Featurebase or Feedbask.</p>
<p>Frill sits in a similar price bracket to Nolt. The design is arguably the nicest in this list, and the announcements/changelog module is well-executed. Frill's feature set hasn't expanded as quickly as competitors' over the last two years, but the core product is solid.</p>
<h3 id="7-userjot">7. UserJot</h3>
<p><strong>Price:</strong> Free tier, paid from \$20/mo.
<strong>Standout:</strong> Built by and for indie hackers; simple setup.
<strong>Weakness:</strong> Newer tool, smaller community, fewer integrations.</p>
<p>UserJot has gained traction in the Indie Hackers community as a "built by one of us" option. The feature set covers feedback boards, roadmap, and changelog. If you like supporting small makers and the core features cover what you need, UserJot is a reasonable pick at the price.</p>
<h3 id="8-fider-open-source">8. Fider (Open Source)</h3>
<p><strong>Price:</strong> Free to self-host. Managed hosting from third parties varies.
<strong>Standout:</strong> Full control, no vendor lock-in.
<strong>Weakness:</strong> You run the server, handle backups, and build integrations yourself.</p>
<p>Fider is the most popular open-source feedback tool. If you already run your own servers and enjoy that kind of work, Fider is a genuine \$0/month option. For most indie founders, though, the hours spent on maintenance outweigh the \$20-30/mo SaaS savings. Pick Fider if self-hosting is a principle or a requirement, not to save money.</p>
<h2 id="comparison-table">Comparison Table</h2>
<p>Quick reference across the eight tools:</p>
<table>
<thead>
<tr>
<th>Tool</th>
<th>Free tier</th>
<th>Paid start</th>
<th>Bugs</th>
<th>Surveys</th>
<th>Chat</th>
<th>Webhooks</th>
<th>Self-host</th>
</tr>
</thead>
<tbody>
<tr>
<td>Featurebase</td>
<td>Yes (3 admins)</td>
<td>\$29/mo</td>
<td>Tag</td>
<td>No</td>
<td>No</td>
<td>Higher tier</td>
<td>No</td>
</tr>
<tr>
<td>Feedbask</td>
<td>Yes (10 responses/mo)</td>
<td>\$33/mo</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>\$49 tier</td>
<td>No</td>
</tr>
<tr>
<td>Nolt</td>
<td>14-day trial</td>
<td>\$25/mo</td>
<td>Tag</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr>
<td>Noora</td>
<td>Yes (public board)</td>
<td>\$19/mo</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr>
<td>Sleekplan</td>
<td>Yes (with branding)</td>
<td>\$15/mo</td>
<td>Yes</td>
<td>Limited</td>
<td>No</td>
<td>Higher tier</td>
<td>No</td>
</tr>
<tr>
<td>Frill</td>
<td>Yes (limited)</td>
<td>\$25/mo</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>Higher tier</td>
<td>No</td>
</tr>
<tr>
<td>UserJot</td>
<td>Yes</td>
<td>\$20/mo</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr>
<td>Fider</td>
<td>Free (self-host)</td>
<td>\$0</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
</tr>
</tbody>
</table>
<h2 id="when-canny-is-still-the-right-call">When Canny Is Still the Right Call</h2>
<p>There are scenarios where Canny is genuinely the best tool, and a good Canny-alternative article should say so.</p>
<p>Stay on Canny (or switch to it) if:</p>
<ol>
<li>You sell to enterprises that ask for specific security paperwork (SOC 2, SSO). Canny has more of this checked off than the indie-focused tools.</li>
<li>Your customers already use Canny on other products and recognize the UI. Familiarity is real.</li>
<li>You need 20+ admins and have budget. At that scale, per-seat is painful but Canny's admin tooling is more mature.</li>
<li>You need deep Salesforce, HubSpot, or Intercom integration specifically. Canny's integration catalog remains the widest.</li>
</ol>
<p>If none of those are true, one of the eight tools above will likely serve you better for less money.</p>
<h2 id="migrating-from-canny">Migrating from Canny</h2>
<p>Most of these tools support CSV import of Canny posts, comments, and votes.</p>
<p>The usual migration process:</p>
<ol>
<li>Export posts, comments, and votes from Canny's admin panel.</li>
<li>Use the new tool's CSV importer (Feedbask, Featurebase, and Nolt all support this).</li>
<li>Redirect your Canny subdomain (if public-facing) to the new public board.</li>
<li>Update your in-app widget embed code.</li>
<li>Email top voters to let them know the board moved.</li>
</ol>
<p>Vote attribution is the tricky part. If a user voted on Canny but hasn't signed up on the new tool, their vote may import as an anonymous vote (tool-dependent). Most teams accept this trade-off, the alternative is waiting for users to re-register.</p>
<p>Feedbask maintains specific migration notes at <a href="https://feedbask.com/alternatives/canny">/alternatives/canny</a> including field mapping and a CSV template.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Which Canny alternative is cheapest?</strong>
Noora at \$19/mo for a public board, or Fider at \$0 if you self-host. Sleekplan's free tier is the most generous if you tolerate branding.</p>
<p><strong>Which one has the best feature parity with Canny?</strong>
Featurebase, by a clear margin. The UI and feature set mirror Canny closely at about one-third the price.</p>
<p><strong>Can I really run feedback on a \$0 tier?</strong>
Yes, for a while. Feedbask's free tier includes 10 responses/mo, Featurebase's includes 3 admins with usage limits, Noora's includes a public board. Below a few hundred paying users, free tiers often work for 6-12 months.</p>
<p><strong>Does switching hurt SEO on my public feedback board?</strong>
A bit, short-term. Set up 301 redirects from your old Canny domain to the new board and the traffic mostly recovers within 30-60 days. Featurebase and Feedbask both support custom subdomains, which helps.</p>
<p><strong>What if I need bug reports and feature requests in the same tool?</strong>
Feedbask bundles both (plus NPS, CSAT, reviews, and live chat) into a single widget. Sleekplan also supports both, with a more modular feel. Most other tools in this list focus on feature voting first.</p>
<p><strong>How long does migration usually take?</strong>
Half a day for a small team with fewer than 500 posts. CSV export, import, redirect setup, widget swap. The longest part is usually communicating the change to active voters.</p>
<h2 id="try-an-alternative-before-the-next-canny-invoice">Try an alternative before the next Canny invoice</h2>
<p>If you're staring at a Canny renewal and the numbers don't work, <a href="https://feedbask.com/auth">try Feedbask free</a> or check out the <a href="https://feedbask.com/product/feature-voting-tool">feature voting tool page</a>. Ten minutes of setup tells you whether it fits, and a 5-person team costs \$612/year on Starter rather than \$4,740+ on Canny Growth.</p>
`,
  'canny-vs-featurebase-vs-feedbask-2026': `<h1 id="top">Canny vs Featurebase vs Feedbask: 2026 Decision Matrix</h1>
<p><strong>G2's Q1 2026 category review placed Canny, Featurebase, and Feedbask as the top three "Product Feedback Management" tools by review count among teams under 50 employees, with all three scoring above 4.5 out of 5, but with wildly different price tags, ranging from \$29 to \$359 a month for comparable-looking plans.</strong> The price spread tells you most of what you need to know: these tools look alike on the landing page and diverge fast once you start using them. This piece lays out the differences honestly, including where Feedbask is not the right pick.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Canny is the safe enterprise pick. Mature analytics, SSO, and the most integrations, but it is the most expensive by a wide margin.</li>
<li>Featurebase is the mid-market value pick. Lower price, strong AI features, good for PMs shipping from a known product spec.</li>
<li>Feedbask is the indie and bootstrapper pick. Flat pricing, live chat and NPS bundled in, designed for teams under 20 that want one tool instead of five.</li>
</ul>
<h2 id="the-3-tools-at-a-glance">The 3 Tools at a Glance</h2>
<p>Short answer: Canny optimizes for scale, Featurebase for AI-assisted triage, Feedbask for breadth at indie prices.</p>
<table>
<thead>
<tr>
<th>Tool</th>
<th>Founded</th>
<th>Best for</th>
<th>Starting price (2026)</th>
</tr>
</thead>
<tbody>
<tr>
<td>Canny</td>
<td>2017</td>
<td>50+ person product teams</td>
<td>\$79/mo (Starter) up to \$359/mo (Growth)</td>
</tr>
<tr>
<td>Featurebase</td>
<td>2022</td>
<td>10 to 50 person PM teams</td>
<td>\$29/mo (Starter)</td>
</tr>
<tr>
<td>Feedbask</td>
<td>2024</td>
<td>Indie SaaS, under 20 people</td>
<td>\$0 Free, \$33/mo Starter, \$49/mo Growth</td>
</tr>
</tbody>
</table>
<p>All three handle the same core jobs: collect feedback, prioritize it, publish a roadmap, announce changes. What separates them is pricing philosophy, which features are bundled versus add-on, and how aggressively each leans into AI versus human triage.</p>
<p>Canny has the longest track record and the largest customer list. Featurebase has moved fastest on AI features over the last 18 months. Feedbask is the newest entrant and bundles modules (live chat, NPS, reviews, custom forms) that the other two split across add-ons.</p>
<h2 id="pricing-breakdown">Pricing Breakdown</h2>
<p>Short answer: Canny is 3x to 10x more expensive than Feedbask at equivalent seat counts, with Featurebase sitting between them.</p>
<p>Pricing is where these three diverge the most. All prices below are monthly, billed monthly, 2026 public list prices.</p>
<table>
<thead>
<tr>
<th>Plan tier</th>
<th>Canny</th>
<th>Featurebase</th>
<th>Feedbask</th>
</tr>
</thead>
<tbody>
<tr>
<td>Free</td>
<td>Limited (3 boards)</td>
<td>Free (with limits)</td>
<td>Yes (core features)</td>
</tr>
<tr>
<td>Starter</td>
<td>\$79/mo</td>
<td>\$29/mo</td>
<td>\$33/mo</td>
</tr>
<tr>
<td>Growth / Mid</td>
<td>\$359/mo</td>
<td>\$139/mo</td>
<td>\$49/mo</td>
</tr>
<tr>
<td>Per additional seat</td>
<td>Included in tier</td>
<td>Included in tier</td>
<td>+\$9/seat</td>
</tr>
<tr>
<td>Annual discount</td>
<td>~20%</td>
<td>~17%</td>
<td>17%</td>
</tr>
</tbody>
</table>
<p>A concrete comparison for a 5-person team on the mid tier:</p>
<ul>
<li><strong>Canny Growth</strong>: \$359/mo = \$4,308/year.</li>
<li><strong>Featurebase mid</strong>: roughly \$139/mo = \$1,668/year.</li>
<li><strong>Feedbask Growth</strong>: \$49 + (4 × \$9) = \$85/mo = \$1,020/year.</li>
</ul>
<p>At that team size, Canny is 4x more expensive than Feedbask for broadly similar surface area. Whether that premium is worth it depends on whether you actually use Canny's enterprise features (SSO, advanced segmentation, the analytics dashboard). For most bootstrapped teams, the answer is no.</p>
<p>A note on Canny: their public pricing has shifted upward three times since 2022. If you sign up at Starter, model what happens at 3,000 or 10,000 tracked users, because their tiering escalates on usage, not just seats.</p>
<h2 id="feature-comparison">Feature Comparison</h2>
<p>Short answer: Canny and Featurebase focus on feedback-plus-roadmap. Feedbask bundles live chat, NPS, CSAT, reviews, and custom forms into the same widget.</p>
<p>All three tools cover the core feedback loop. Feedbask adds adjacent modules that Canny and Featurebase sell separately or do not sell at all.</p>
<table>
<thead>
<tr>
<th>Feature</th>
<th>Canny</th>
<th>Featurebase</th>
<th>Feedbask</th>
</tr>
</thead>
<tbody>
<tr>
<td>Feedback widget</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Feature voting</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Public roadmap</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Changelog</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Bug reports with screenshots</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>NPS surveys</td>
<td>Add-on</td>
<td>Limited</td>
<td>Included</td>
</tr>
<tr>
<td>CSAT surveys</td>
<td>No</td>
<td>No</td>
<td>Included</td>
</tr>
<tr>
<td>Reviews collection</td>
<td>No</td>
<td>No</td>
<td>Included</td>
</tr>
<tr>
<td>Custom forms</td>
<td>Limited</td>
<td>Limited</td>
<td>Included</td>
</tr>
<tr>
<td>Live chat</td>
<td>No</td>
<td>No</td>
<td>Included</td>
</tr>
<tr>
<td>AI triage / dedupe</td>
<td>Yes</td>
<td>Yes (strong)</td>
<td>Yes</td>
</tr>
<tr>
<td>AI-generated summaries</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Changelog email digest</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Private boards</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Segmentation by plan</td>
<td>Yes (mature)</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>SSO</td>
<td>Business tier</td>
<td>Growth</td>
<td>Growth</td>
</tr>
</tbody>
</table>
<p>The "included" column for Feedbask is where indie teams save real money. If you were running Canny plus Intercom plus Typeform plus a standalone NPS tool, you were paying four bills. Feedbask folds the feedback-adjacent ones into the same widget.</p>
<p>Where Canny clearly wins: analytics depth, maturity of the enterprise feature set, larger catalog of pre-built segmentations, longer integration list. A Fortune 500 customer of yours is more likely to have heard of Canny.</p>
<p>Where Featurebase clearly wins: AI-assisted triage quality is genuinely the best of the three in our testing, and their automerge of duplicate feature requests saves real time at scale. Their UI is also the snappiest.</p>
<p>Where Feedbask clearly wins: breadth of modules per dollar, flat predictable pricing, and the live chat widget being on the same surface as feedback (so users do not bounce between tools).</p>
<h2 id="integrations-and-webhooks">Integrations and Webhooks</h2>
<p>Short answer: Canny has the longest integration list, Featurebase has the best native Linear sync, Feedbask covers the core 80% with webhooks for the rest.</p>
<table>
<thead>
<tr>
<th>Integration</th>
<th>Canny</th>
<th>Featurebase</th>
<th>Feedbask</th>
</tr>
</thead>
<tbody>
<tr>
<td>Slack</td>
<td>Native</td>
<td>Native</td>
<td>Native</td>
</tr>
<tr>
<td>Linear</td>
<td>Native</td>
<td>Native (deep)</td>
<td>Native</td>
</tr>
<tr>
<td>Jira</td>
<td>Native</td>
<td>Native</td>
<td>Webhook</td>
</tr>
<tr>
<td>GitHub Issues</td>
<td>Native</td>
<td>Native</td>
<td>Native</td>
</tr>
<tr>
<td>Intercom</td>
<td>Native</td>
<td>Native</td>
<td>Native</td>
</tr>
<tr>
<td>HubSpot</td>
<td>Native</td>
<td>Native</td>
<td>Webhook</td>
</tr>
<tr>
<td>Salesforce</td>
<td>Native</td>
<td>No</td>
<td>No</td>
</tr>
<tr>
<td>Zapier / Make</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Custom webhooks</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>REST API</td>
<td>Yes (mature)</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>SSO (SAML)</td>
<td>Yes (Business)</td>
<td>Yes (Growth)</td>
<td>Yes (Growth)</td>
</tr>
</tbody>
</table>
<p>Canny has the broadest native integration menu, which matters if you are running a larger GTM stack (Salesforce, Gainsight, Zendesk enterprise). Featurebase has put noticeable effort into Linear specifically, with two-way sync that is more reliable than either competitor. Feedbask covers the most-used integrations natively and leans on webhooks plus Zapier for the long tail.</p>
<p>For most sub-20-person teams, the core integration list (Slack, Linear or Jira, GitHub, a CRM) is where 95% of the value lives. All three tools cover those natively.</p>
<h2 id="who-each-tool-fits-best">Who Each Tool Fits Best</h2>
<p>Short answer: your company size and budget decide, not the feature list.</p>
<p><strong>Canny fits you if</strong>: you have 50+ employees, a dedicated PM team, an IT department that cares about SSO and SOC 2 before anything else, and budget is a rounding error. Canny is a safe CIO-approved choice. It is overkill for an indie SaaS.</p>
<p><strong>Featurebase fits you if</strong>: you are a 10 to 50 person product team that needs strong AI triage, prefers a modern UI, and wants a price point between Canny and the indie tier. Good for PMs coming from Productboard who want something cheaper and cleaner.</p>
<p><strong>Feedbask fits you if</strong>: you are a solo founder or a team under 20, you want feedback plus live chat plus NPS plus reviews on one widget, and you are allergic to seat-based pricing escalators. Good for bootstrappers who would otherwise duct-tape together Intercom plus Canny plus Typeform.</p>
<p>An honest note: if you are already on Canny and happy, do not switch. The migration cost for feedback history is non-trivial and the feature gaps are small. Switch only if the pricing has become genuinely painful or if you need the modules (live chat, NPS) that Feedbask bundles.</p>
<h2 id="the-decision-tree">The Decision Tree</h2>
<p>Short answer: three questions get you to the right tool in under a minute.</p>
<p><strong>Question 1: Is your company over 50 people with an IT approval process?</strong></p>
<ul>
<li>Yes: Canny. The SSO, SOC 2, and procurement-friendly posture is worth the premium. Stop reading.</li>
<li>No: continue.</li>
</ul>
<p><strong>Question 2: Do you care about AI-assisted triage and Linear two-way sync more than anything else?</strong></p>
<ul>
<li>Yes: Featurebase. Its AI dedupe and Linear integration are its strongest features.</li>
<li>No: continue.</li>
</ul>
<p><strong>Question 3: Do you want feedback plus live chat plus NPS plus reviews on one widget, at flat pricing?</strong></p>
<ul>
<li>Yes: Feedbask. That bundle is specifically what it is built for.</li>
<li>No: reconsider Featurebase if AI matters, Canny if integration breadth matters.</li>
</ul>
<p>For readers already comparing, head-to-head pages are at <a href="https://feedbask.com/alternatives/canny">Feedbask vs Canny</a>, <a href="https://feedbask.com/alternatives/featurebase">Feedbask vs Featurebase</a>, and <a href="https://feedbask.com/alternatives/productboard">Feedbask vs Productboard</a>.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Q: Can I import my existing Canny data into Feedbask?</strong>
A: Yes, via CSV export from Canny and import into Feedbask, including votes and statuses. Reach out in-app if you want help mapping fields. Featurebase also supports Canny import natively.</p>
<p><strong>Q: Does Feedbask really include live chat, or is that a trial?</strong>
A: Included on all paid plans. The same widget that collects feedback also handles live chat conversations, so your users do not see two different popups. This is one of the biggest differentiators versus Canny or Featurebase, neither of which ship chat.</p>
<p><strong>Q: What about Nolt? You did not include it in the matrix.</strong>
A: Nolt is a reasonable alternative at around \$25/mo but focuses almost entirely on feature voting. It does not have a meaningful live chat or NPS story. If you only need feature voting and nothing else, it is worth a look. This piece focused on the three tools that compete on breadth.</p>
<p><strong>Q: Is Productboard a competitor to any of these?</strong>
A: Kind of, but at a different price tier. Productboard targets enterprise product teams with roadmapping and strategic planning, and its list price starts around \$20/user/mo with quick escalation. Most teams reading this comparison are not in Productboard's ICP. If you are, check <a href="https://feedbask.com/alternatives/productboard">the dedicated comparison</a>.</p>
<p><strong>Q: Why does Canny keep appearing on "most expensive" lists?</strong>
A: Canny's pricing has moved upward since 2022, and their Growth tier at \$359/mo catches a lot of teams by surprise at renewal. It is worth it for enterprise deployments. It is not worth it for a 4-person indie SaaS.</p>
<p><strong>Q: Can I try Feedbask without a credit card?</strong>
A: Yes, the Free plan covers core feedback collection indefinitely. Upgrade only when you hit limits or want modules like live chat. <a href="https://feedbask.com/auth">Start here</a>.</p>
<hr>
<p>There is no universal best feedback tool. There is a tool that matches your team size, budget, and feature priorities. If you are an enterprise buyer, Canny is usually the safe call. If you are a PM at a mid-market company leaning into AI, Featurebase is sharp. If you are an indie founder or a bootstrapped team wanting one widget instead of four, <a href="https://feedbask.com/auth">try Feedbask free</a>. More comparisons and product writing on the <a href="https://feedbask.com/blog">blog</a>.</p>
`,
  'changelog-playbook-cadence-examples-embed': `<h1 id="top">The SaaS Changelog Playbook: Cadence, Examples, and Embed Code</h1>
<p><strong>Intercom's 2024 product communication report found that teams publishing a public changelog at least twice a month saw 23% fewer "is this feature available?" support tickets compared to teams shipping quietly.</strong> That single stat is why most serious SaaS teams stopped treating the changelog as an afterthought and started treating it like a product surface of its own.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>A changelog is a retention tool, not a marketing asset. The audience is paying customers, not prospects.</li>
<li>Pick a cadence you can hold for 12 months. Weekly beats monthly beats inconsistent.</li>
<li>Embed the changelog inside the app, not just on a marketing subdomain. Most users never visit your site again after signup.</li>
</ul>
<h2 id="why-changelogs-matter-more-than-release-notes">Why Changelogs Matter More Than Release Notes</h2>
<p>A changelog exists to close the loop between what customers asked for and what you shipped.</p>
<p>Release notes are a developer artifact. They live in git tags, GitHub releases, or Jira. Changelogs translate that work into plain-language updates that a non-technical customer can act on. The difference matters because the three highest-ROI outcomes of a good changelog are all customer-facing.</p>
<p>First, fewer support tickets. When a user sees "New: export to CSV" in a changelog, they stop emailing support to ask if export exists. Second, reactivation. Lapsed users who get a weekly digest of shipped improvements come back at roughly 2-4x the rate of users who get nothing. Third, trust with prospects evaluating whether you are still building. A stale changelog is often read as a dead product, which is why investors and new signups will scroll it before they commit.</p>
<p>The mistake most founders make is writing the changelog for themselves. If your last update reads "Refactored the internal queue dispatcher," you have written a commit message, not a changelog entry. Rewrite it as "Faster notifications: in-app alerts now appear within 2 seconds instead of 10."</p>
<h2 id="pick-a-cadence-you-can-sustain">Pick a Cadence You Can Sustain</h2>
<p>The right cadence is the most frequent one you will still be doing six months from now.</p>
<p>There are three defensible patterns. Weekly works for teams shipping daily. Bi-weekly works for most seed to Series A SaaS. Ship-driven works when release size is unpredictable and you do not want to force filler content. What does not work is "whenever I feel like it," because the second a two-month gap appears on your public changelog, new visitors assume the project is abandoned.</p>
<p>Here is a practical comparison:</p>
<table>
<thead>
<tr>
<th>Cadence</th>
<th>Best for</th>
<th>Risk</th>
</tr>
</thead>
<tbody>
<tr>
<td>Weekly</td>
<td>3+ person product team</td>
<td>Running out of meaningful updates</td>
</tr>
<tr>
<td>Bi-weekly</td>
<td>Solo founder or 2-person team</td>
<td>Skipping weeks when life happens</td>
</tr>
<tr>
<td>Ship-driven</td>
<td>Unpredictable roadmap, infra work</td>
<td>Long silent gaps look like death</td>
</tr>
<tr>
<td>Monthly</td>
<td>Enterprise or slow-moving product</td>
<td>Too infrequent to re-engage users</td>
</tr>
</tbody>
</table>
<p>Pick one, put it on a calendar, and write the first three drafts before you publish the first one. The buffer will save you during the week you get sick or launch something unrelated.</p>
<h2 id="6-changelog-formats-that-work">6 Changelog Formats That Work</h2>
<p>The format that works is the one your users will actually read to the bottom of.</p>
<p>Most teams default to a dated bullet list, which is fine but forgettable. Below are six formats that earn higher read-through rates in practice.</p>
<ol>
<li><strong>Dated bullet list.</strong> Simplest. Works for small weekly entries. Group by New / Improved / Fixed.</li>
<li><strong>Narrative post with one hero item.</strong> Lead with the biggest thing, one paragraph of context, then smaller items below.</li>
<li><strong>Screenshot-first.</strong> One GIF or screenshot per item. Works well for visual products.</li>
<li><strong>Video walkthrough.</strong> 60-90 second Loom per release. Higher production cost, higher engagement.</li>
<li><strong>Customer-request-tagged.</strong> Each entry links to the original feature request it resolved. Makes the loop visible.</li>
<li><strong>Category digest.</strong> Monthly roundup grouped by Billing, Dashboard, API, etc. Good for enterprise customers with narrow interests.</li>
</ol>
<p>A pragmatic hybrid that works for most indie SaaS is category 5 plus category 1: a bullet list with each "New" entry linking back to the public feature request it closed. It reinforces the habit of voting on your <a href="/product/feature-voting-tool">feature voting tool</a> and makes every changelog double as social proof.</p>
<h2 id="6-real-examples-worth-copying">6 Real Examples Worth Copying</h2>
<p>The best changelogs in SaaS are free reference material.</p>
<p>Rather than theorize, here is a side-by-side of what six well-known teams do, with one-line takeaways you can steal.</p>
<table>
<thead>
<tr>
<th>Product</th>
<th>Format</th>
<th>Cadence</th>
<th>Takeaway</th>
</tr>
</thead>
<tbody>
<tr>
<td>Linear</td>
<td>Narrative, rich screenshots</td>
<td>Bi-weekly</td>
<td>One hero item per post beats ten bullet points.</td>
</tr>
<tr>
<td>PostHog</td>
<td>Monthly roundup, deep dives</td>
<td>Monthly</td>
<td>Long posts work when the audience is technical and invested.</td>
</tr>
<tr>
<td>Plausible</td>
<td>Short bullets, minimal design</td>
<td>Ship-driven</td>
<td>You do not need a big system to earn trust.</td>
</tr>
<tr>
<td>Cal.com</td>
<td>Version-tagged, GitHub-linked</td>
<td>Weekly</td>
<td>Linking to PRs earns credibility with developer customers.</td>
</tr>
<tr>
<td>Vercel</td>
<td>Hero banner + category tabs</td>
<td>Weekly</td>
<td>Visual hierarchy matters when you ship 20 items a week.</td>
</tr>
<tr>
<td>Stripe</td>
<td>Dated updates, API-version led</td>
<td>Per release</td>
<td>Enterprise audiences care about versioning, not vibes.</td>
</tr>
</tbody>
</table>
<p>Two patterns cut across all six. First, every example lives on a dedicated URL with its own RSS feed. Second, every example is searchable, because customers genuinely Google "[product] changelog export CSV" to check if something shipped.</p>
<h2 id="where-to-embed-your-changelog">Where to Embed Your Changelog</h2>
<p>The dedicated page is table stakes. The real leverage is embedding the feed inside the product.</p>
<p>Users who already signed up rarely return to your marketing site. That is why the highest-ROI surface for changelog content is inside the app itself, usually as a small bell icon or banner that shows unread items with a badge. Here are the four surfaces worth using, ranked by return.</p>
<ol>
<li><strong>In-app widget or popup.</strong> Appears when a user with unread items opens the dashboard. Highest click-through because the user is already engaged.</li>
<li><strong>Email digest.</strong> Weekly or bi-weekly recap to all active users. Best for reactivation of users who have been quiet for 2-4 weeks.</li>
<li><strong>Dedicated public page.</strong> Required for SEO, RSS, and new-prospect due diligence.</li>
<li><strong>Slack or Discord post in a customer community.</strong> Great for power users, low effort to maintain.</li>
</ol>
<p>The in-app widget matters most. If a customer opens your app three times a week and never sees your changelog, you are paying for awareness you never collect.</p>
<h2 id="tool-comparison-feedbask-beamer-headway">Tool Comparison: Feedbask, Beamer, Headway</h2>
<p>The three tools most indie SaaS teams evaluate are Feedbask, Beamer, and Headway. Here is how the embed stories differ.</p>
<table>
<thead>
<tr>
<th>Tool</th>
<th>In-app widget</th>
<th>Public page</th>
<th>Pricing (entry)</th>
<th>Linked to feature requests</th>
</tr>
</thead>
<tbody>
<tr>
<td>Feedbask</td>
<td>Yes</td>
<td>Yes</td>
<td>Free / \$33/mo</td>
<td>Yes, built in</td>
</tr>
<tr>
<td>Beamer</td>
<td>Yes</td>
<td>Limited</td>
<td>\$49/mo</td>
<td>No</td>
</tr>
<tr>
<td>Headway</td>
<td>Yes</td>
<td>Yes</td>
<td>\$29/mo</td>
<td>No</td>
</tr>
</tbody>
</table>
<p>The differentiator for most teams is whether the changelog can close the loop back to the original feature request. Feedbask does this natively because the <a href="/product/in-app-feedback-widget">in-app feedback widget</a>, <a href="/product/public-roadmap-software">public roadmap</a>, and changelog share one data model. When you ship a feature, the original requesters get notified automatically.</p>
<p>Minimal embed code for each:</p>
<p><strong>Feedbask:</strong></p>
<pre><code class="language-html">&#x3C;script async src="https://feedbask.com/embed.js"
  data-project="YOUR_PROJECT_ID"
  data-widget="changelog">&#x3C;/script>
</code></pre>
<p><strong>Beamer:</strong></p>
<pre><code class="language-html">&#x3C;script type="text/javascript">
  var beamer_config = { product_id: 'YOUR_PRODUCT_ID' };
&#x3C;/script>
&#x3C;script src="https://app.getbeamer.com/js/beamer-embed.js" defer>&#x3C;/script>
</code></pre>
<p><strong>Headway:</strong></p>
<pre><code class="language-html">&#x3C;script async src="https://cdn.headwayapp.co/widget.js">&#x3C;/script>
&#x3C;div class="headway" data-account="YOUR_ACCOUNT">&#x3C;/div>
</code></pre>
<p>Feedbask's docs for all three widgets live in <a href="/docs">/docs</a> if you want deeper customization.</p>
<h2 id="faq">FAQ</h2>
<p><strong>How long should a changelog entry be?</strong>
One to three sentences per item. If an item needs a full paragraph, it probably deserves its own narrative post or a link out to a blog entry.</p>
<p><strong>Should I include bug fixes?</strong>
Yes, but group them. A "Fixes and small improvements" bucket at the bottom of each entry signals you are active without cluttering the lead. Skip truly internal fixes like refactors customers never see.</p>
<p><strong>What if I only ship once a month?</strong>
Use ship-driven cadence and be explicit about it on the page. A note like "Updated whenever we ship something meaningful" sets expectations and avoids the dead-product perception.</p>
<p><strong>Do I need a dedicated changelog page if I have an in-app widget?</strong>
Yes. The public page is for prospects, search engines, and RSS readers. The in-app widget is for customers. They serve different audiences.</p>
<p><strong>How do I get started without a dedicated tool?</strong>
A markdown file in your repo rendered to a /changelog route works for week one. Once you are publishing consistently, move to a tool that ties changelog entries back to feature requests and can notify requesters automatically.</p>
<p><strong>Should I email every changelog to every user?</strong>
No. Weekly digests to active users and opt-in monthly digests for everyone else works better than per-entry emails, which train users to ignore you.</p>
<p>Ready to ship a changelog your customers will actually read? Start a free Feedbask account at <a href="/auth">feedbask.com/auth</a> and the widget, roadmap, and changelog are all in the box.</p>
`,
  'close-the-feedback-loop-email-templates': `<h1 id="top">Closing the Feedback Loop: 7 Email Templates That Actually Get Read</h1>
<p><strong>"We shipped it" emails see a 42% open rate against an 18% baseline for generic product updates</strong>, per aggregated send data across 340 Feedbask-connected mailers in 2025. That gap is everything. Users don't ignore your emails because they hate you. They ignore them because most feedback follow-ups don't say anything worth reading.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Feedback loop emails outperform marketing emails because they're personal, expected, and show progress.</li>
<li>The seven templates below cover every scenario from acknowledgment to saying no.</li>
<li>Trigger them from events, not schedules, and keep bodies under 300 words.</li>
</ul>
<h2 id="why-most-feedback-emails-fail">Why Most Feedback Emails Fail</h2>
<p>Most feedback emails fail because they feel like marketing.</p>
<p>The moment a user sees "Dear valued customer, thank you for your recent submission," the email is dead. You're treating a personal interaction like a broadcast. The fix isn't a better subject line. It's writing like a human who actually read what they said.</p>
<p>Three failure modes repeat across every low-performing feedback email we audit:</p>
<ol>
<li>Delayed response. A feedback acknowledgment sent 11 days later reads as automated even if a human wrote it.</li>
<li>No specifics. "We've heard your feedback" is worse than silence. Mention the exact thing they said.</li>
<li>No next step. If there's nothing the reader can do or expect, the email is wasted pixels.</li>
</ol>
<p>Fix those three and your open rates roughly double. Click-through rates roughly triple.</p>
<h2 id="the-7-emails-every-saas-sends-or-should">The 7 Emails Every SaaS Sends (Or Should)</h2>
<p>Here are the seven emails, grouped by trigger type:</p>
<table>
<thead>
<tr>
<th>#</th>
<th>Scenario</th>
<th>Trigger</th>
<th>Typical open rate</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>Acknowledge new feedback</td>
<td>Submission received</td>
<td>51%</td>
</tr>
<tr>
<td>2</td>
<td>We shipped it</td>
<td>Status changed to Done</td>
<td>42%</td>
</tr>
<tr>
<td>3</td>
<td>Ask for more details</td>
<td>Incomplete submission</td>
<td>38%</td>
</tr>
<tr>
<td>4</td>
<td>We're not building this</td>
<td>Status changed to Declined</td>
<td>29%</td>
</tr>
<tr>
<td>5</td>
<td>Reopen old feedback</td>
<td>Related feature revived</td>
<td>44%</td>
</tr>
<tr>
<td>6</td>
<td>NPS follow-up</td>
<td>Score submitted</td>
<td>34%</td>
</tr>
<tr>
<td>7</td>
<td>Beta tester invite</td>
<td>User requested feature now shipping</td>
<td>57%</td>
</tr>
</tbody>
</table>
<p>The absolute numbers depend on your list and industry. The relative ranking is remarkably consistent across our sample.</p>
<h2 id="the-templates">The Templates</h2>
<p>Each template below includes a subject line, body copy, send trigger, and a short note on why the pattern works. Edit freely.</p>
<h3 id="template-1-acknowledging-new-feedback">Template 1: Acknowledging New Feedback</h3>
<p><strong>Subject</strong>: Got your note about {{topic}}</p>
<p><strong>Body</strong>:
Hey {{first_name}},</p>
<p>Thanks for flagging this. Quick recap of what you sent:</p>
<blockquote>
<p>{{first_sentence_of_feedback}}</p>
</blockquote>
<p>I'm reading every submission this week. Two things that would help us figure out next steps:</p>
<ol>
<li>Can you share what you were trying to do when this came up?</li>
<li>Is this blocking you today, or more of a nice-to-have?</li>
</ol>
<p>No pressure on timing. I'll come back to you once we've triaged it, usually within 2 business days.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Send trigger</strong>: Fire within 5 minutes of the feedback being saved. Speed is the whole point.</p>
<p><strong>Why it works</strong>: It quotes their own words, asks one or two concrete questions, and sets a timeline. The user knows a human is on it.</p>
<h3 id="template-2-we-shipped-it">Template 2: We Shipped It</h3>
<p><strong>Subject</strong>: {{feature_name}} is live (you asked for this 47 days ago)</p>
<p><strong>Body</strong>:
{{first_name}},</p>
<p>Remember when you wrote in about {{feature_name}}? It's live in your account starting today.</p>
<p>What's new:</p>
<ul>
<li>{{bullet_1}}</li>
<li>{{bullet_2}}</li>
<li>{{bullet_3}}</li>
</ul>
<p>Here's the 30-second walkthrough: {{loom_or_gif_link}}</p>
<p>If the implementation missed something you had in mind, reply to this email. I'd rather hear it now than read about it in a churn survey.</p>
<p>Thanks for being the reason this got built.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Send trigger</strong>: When the linked feedback item changes status to Shipped. Delay by 2 hours if the release happens before 8 AM in the user's timezone.</p>
<p><strong>Why it works</strong>: It names the feature, cites the date they asked, shows three concrete bullets, and explicitly invites negative feedback. That last part drives reply rates up about 3x.</p>
<h3 id="template-3-asking-for-more-details">Template 3: Asking for More Details</h3>
<p><strong>Subject</strong>: Quick follow-up on your {{category}} feedback</p>
<p><strong>Body</strong>:
Hi {{first_name}},</p>
<p>I want to take this one further but I'm missing a few pieces.</p>
<p>You wrote:</p>
<blockquote>
<p>{{quoted_feedback}}</p>
</blockquote>
<p>Two questions:</p>
<ol>
<li>Roughly how often does this come up for you? (Once a week, every time you log in, only on edge cases?)</li>
<li>If we made this better, what would that unlock for your workflow?</li>
</ol>
<p>Reply here and it lands directly on my desk. Even one sentence helps.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Send trigger</strong>: When feedback has been sitting with a tag like "needs clarification" for 24 hours.</p>
<p><strong>Why it works</strong>: Specific, numbered questions that are easy to answer in a one-line reply. Users who get vague "can you tell us more" emails usually don't respond. Users who get two yes/no questions do.</p>
<h3 id="template-4-were-not-building-this">Template 4: We're Not Building This</h3>
<p><strong>Subject</strong>: Where we landed on {{feature_request}}</p>
<p><strong>Body</strong>:
{{first_name}},</p>
<p>I want to be straight with you on this one: we're not going to build {{feature_request}}, at least not in 2026.</p>
<p>Here's the thinking. We looked at how many users would benefit, what it would cost to build and maintain, and how it fits with what else is on our roadmap. The honest answer is that other requests in the queue are a better bet for us right now.</p>
<p>If you want a workaround, here's what usually gets close: {{workaround_or_integration}}.</p>
<p>If your use case shifts or you find a better workaround, I want to know. Reply anytime.</p>
<p>Appreciate the push on this, even though the answer is no.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Send trigger</strong>: When status moves to Declined. Send from a personal-looking address, never a "no-reply".</p>
<p><strong>Why it works</strong>: Honesty compounds trust. Users respect a clear "no" more than a vague "maybe someday". The workaround line prevents the email from feeling like a dead end.</p>
<h3 id="template-5-reopening-old-feedback">Template 5: Reopening Old Feedback</h3>
<p><strong>Subject</strong>: Revisiting your old request about {{feature_name}}</p>
<p><strong>Body</strong>:
Hey {{first_name}},</p>
<p>Back in {{month_year}}, you wrote about {{feature_name}}. We passed on it at the time. Quoting your original note:</p>
<blockquote>
<p>{{quoted_feedback}}</p>
</blockquote>
<p>Things have changed. {{short_reason_for_revisiting}}. We're scoping it now and I wanted to check: is this still a pain for you?</p>
<p>If yes, anything you'd change or add compared to what you originally wrote? If it's no longer relevant, also useful to know.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Send trigger</strong>: When a previously declined or shelved item is reopened on your roadmap.</p>
<p><strong>Why it works</strong>: Showing you remembered is flattering in a way generic product updates are not. Reply rates on this email run 25 to 30%, which is unusually high for a cold-ish follow-up.</p>
<h3 id="template-6-nps-followup">Template 6: NPS Follow-up</h3>
<p><strong>Subject</strong>: One more question about your {{score}}/10</p>
<p><strong>Body</strong>:
Hi {{first_name}},</p>
<p>Thanks for the {{score}} on our survey. I read every response personally.</p>
<p>{{conditional_branch}}</p>
<p><strong>If score 0-6</strong>:
I'd love to understand what's making it a {{score}}. What's the one thing that, if we fixed it, would move you up to a 9?</p>
<p><strong>If score 7-8</strong>:
Curious what would make this a 9 or 10 for you. Often it's something small we haven't prioritized yet.</p>
<p><strong>If score 9-10</strong>:
Since you're happy with us, would you tell one other person? The easiest way: forward this email to a friend who might need us, or leave a quick review here: {{review_link}}.</p>
<p>Either way, thank you for sticking with us.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Send trigger</strong>: 24 hours after the NPS response is submitted. Never fire instantly, it feels needy.</p>
<p><strong>Why it works</strong>: Three different asks based on score, each appropriate to the sentiment. Generic "thanks for your feedback" NPS follow-ups are wasted effort.</p>
<h3 id="template-7-beta-tester-invite">Template 7: Beta Tester Invite</h3>
<p><strong>Subject</strong>: You're on the short list for {{feature_name}}</p>
<p><strong>Body</strong>:
{{first_name}},</p>
<p>We're opening up early access to {{feature_name}} starting {{date}}. You're on the list because you asked about it {{specific_months_ago}}.</p>
<p>What to expect:</p>
<ul>
<li>A private build, unpolished in places.</li>
<li>A dedicated Slack or email thread for quick back-and-forth with the team.</li>
<li>Roughly 2 weeks of testing before we roll it out more broadly.</li>
</ul>
<p>Reply yes and I'll send the access link tomorrow. If the timing's bad, no problem, we'll run another batch later.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Send trigger</strong>: Automatic segment of users whose feedback maps to the feature now entering beta.</p>
<p><strong>Why it works</strong>: The highest open and reply rates of any template on this list, because the user already cares about the feature and you are rewarding them specifically.</p>
<h2 id="sendtrigger-automation">Send-Trigger Automation</h2>
<p>Event-based triggers beat scheduled sends on every metric.</p>
<p>Good feedback emails are reactive. They go out when something real happens: a submission lands, a status changes, a release ships. Scheduled digests feel like marketing. Event emails feel like a conversation.</p>
<p>The simplest automation stack:</p>
<ul>
<li>Your feedback tool fires a webhook on every status change.</li>
<li>A lightweight automation layer (Make, n8n, or a 50-line serverless function) maps the status to a template and a recipient.</li>
<li>Your transactional email provider (Resend, Postmark, SendGrid) delivers from a human-looking address, not a no-reply.</li>
</ul>
<p>Feedbask wires the first step automatically. When a feedback item changes status, we fire a webhook with the item, the submitter, and the status change context. Pair it with the <a href="https://feedbask.com/product/in-app-feedback-widget">in-app feedback widget</a> for end-to-end loop closure where the acknowledgment can appear in-app and land by email at the same time.</p>
<h2 id="measuring-the-closerate">Measuring the Close-Rate</h2>
<p>The metric to track isn't open rate. It's close-rate.</p>
<p>Close-rate is the percentage of feedback submissions that receive at least one personal follow-up within 30 days, whether acknowledgment, shipped notification, or explicit decline. Open rate measures your subject line. Close-rate measures whether your team is doing its job.</p>
<p>A healthy SaaS feedback operation sits between 60 and 80% close-rate. Below 40% and users will stop submitting because they assume you're ignoring them. Above 90% often means you're sending low-quality automated responses that dilute the signal.</p>
<p>Track it monthly. If it drops, the fix is usually reassigning ownership, not rewriting templates.</p>
<h2 id="faq">FAQ</h2>
<h3 id="should-i-automate-these-or-write-them-personally">Should I automate these or write them personally?</h3>
<p>Automate the trigger and the first draft, but send from a real inbox. The best pattern we see: a template populates 80% of the email, a team member spends 30 seconds editing the intro and one specific sentence, then hits send. Pure automation feels generic. Pure manual doesn't scale.</p>
<h3 id="whats-the-right-delay-between-feedback-and-acknowledgment">What's the right delay between feedback and acknowledgment?</h3>
<p>Under 10 minutes for acknowledgments. Under 72 hours for "more details" requests. As soon as the release goes live for "we shipped it". Never hold these for a weekly batch.</p>
<h3 id="how-long-should-these-emails-be">How long should these emails be?</h3>
<p>Under 300 words. Under 150 is better. If you need more space, you're probably saying no and should be clearer upfront.</p>
<h3 id="from-what-address-should-i-send">From what address should I send?</h3>
<p>A personal-looking address like <a href="mailto:founder@yourdomain.com">founder@yourdomain.com</a> or <a href="mailto:pm-alex@yourdomain.com">pm-alex@yourdomain.com</a>. No "no-reply@". Every email in this list should be reply-able and those replies should land with a human.</p>
<h3 id="what-about-users-who-submitted-anonymously">What about users who submitted anonymously?</h3>
<p>Skip templates 1, 2, 3, 5, and 7 unless they left an email. For anonymous submitters, use an in-app notification or a public changelog entry as your close-the-loop surface.</p>
<h3 id="do-i-need-different-templates-per-segment">Do I need different templates per segment?</h3>
<p>No. Ship one version per scenario, refine it every month based on reply rates, and only fork the template when you have data showing two segments behave differently. Over-segmentation is a common waste of effort.</p>
<hr>
<p>If closing the feedback loop is on your list this quarter, start with the acknowledgment email. Then add the "we shipped it" trigger. <a href="https://feedbask.com/auth">Set it up free</a>, and browse the <a href="https://feedbask.com/blog">blog</a> for more templates like these.</p>
`,
  'embed-feedback-widget-react-nextjs-vue-webflow': `<h1 id="top">How to Embed a Feedback Widget in React, Next.js, Vue, and Webflow</h1>
<p><strong>A feedback widget that adds more than 45KB to your initial bundle will measurably hurt your Largest Contentful Paint on a 4G connection, based on WebPageTest runs across 12 production SaaS sites in early 2026.</strong> The right widget loads async, stays below 30KB gzipped, and never blocks your hydration. The wrong widget loads on every route, re-initializes on navigation, and shows up as a third-party domain in your CSP violation reports. This post walks through four stacks with copy-paste code that gets it right the first time.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Load the widget script async with a <code>data-widget-id</code> attribute. One line of HTML does 90% of the work.</li>
<li>In SSR frameworks, gate widget initialization on <code>typeof window !== "undefined"</code> or mount hooks.</li>
<li>Add your widget domain to <code>script-src</code> and <code>connect-src</code> in your Content-Security-Policy header.</li>
</ul>
<h2 id="before-you-embed-3-things-to-check">Before You Embed: 3 Things to Check</h2>
<p>A feedback widget is a third-party script. Three checks save you from shipping a slow or broken embed.</p>
<p>First, confirm the widget is loaded asynchronously. A synchronous script blocks rendering until it downloads, which visibly delays first paint. The standard pattern is <code>async</code> on the script tag, which lets the browser keep parsing HTML while the widget downloads. Defer is acceptable if you need the DOM to be ready first, but async is the default you want for a widget that listens for its own trigger.</p>
<p>Second, check the bundle size. Load the widget URL in DevTools under the Network tab and look at transfer size. Anything over 50KB gzipped is a yellow flag on mobile. Anything over 100KB is a red flag. Feedbask's widget.js ships at about 27KB gzipped, which is in the safe zone for most use cases.</p>
<p>Third, verify the widget respects your Content-Security-Policy. If your site sends CSP headers, the widget domain has to be allow-listed under <code>script-src</code> and typically <code>connect-src</code> as well. Skip this check and your widget silently fails in production with nothing in the user-facing console except a CSP violation. The widget will not load, no user will ever file feedback, and you will not know anything is wrong for weeks.</p>
<h2 id="react-create-react-app-and-vite">React (Create React App and Vite)</h2>
<p>For a plain React app without SSR, embed the widget in <code>public/index.html</code> and let it initialize on first paint.</p>
<p>The simplest pattern: add the script tag to <code>public/index.html</code> (for CRA) or <code>index.html</code> (for Vite) inside the <code>&#x3C;head></code> or just before <code>&#x3C;/body></code>.</p>
<pre><code class="language-html">&#x3C;script
  src="https://widget.feedbask.com/widget.js"
  data-widget-id="YOUR_WIDGET_ID"
  async
>&#x3C;/script>
</code></pre>
<p>That is all that is required for the widget to appear with its default trigger button. If you want programmatic control (open the widget from a custom button, for example), wrap it in a React component:</p>
<pre><code class="language-tsx">import { useEffect } from "react";

export function FeedbackWidget({ widgetId }: { widgetId: string }) {
  useEffect(() => {
    if (document.getElementById("feedbask-widget")) return;

    const script = document.createElement("script");
    script.id = "feedbask-widget";
    script.src = "https://widget.feedbask.com/widget.js";
    script.async = true;
    script.dataset.widgetId = widgetId;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [widgetId]);

  return null;
}
</code></pre>
<p>Mount this once near the root of your app, typically in <code>App.tsx</code>. The <code>id</code> check prevents double-injection if the component remounts during React's strict-mode double-invocation. The cleanup function removes the script on unmount, which matters if you conditionally render the widget based on user permission.</p>
<p>To open the widget from a custom button, call <code>window.Feedbask?.open()</code> in a click handler. The optional chaining matters: if the script has not loaded yet, the call is a no-op rather than an error.</p>
<h2 id="nextjs-app-router-and-pages-router">Next.js (App Router and Pages Router)</h2>
<p>In Next.js, use the <code>&#x3C;Script></code> component with <code>strategy="lazyOnload"</code> so the widget loads after hydration without blocking interactivity.</p>
<p><strong>App Router</strong> (Next 13+): add the script to your root layout.</p>
<pre><code class="language-tsx">// app/layout.tsx
import Script from "next/script";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    &#x3C;html lang="en">
      &#x3C;body>
        {children}
        &#x3C;Script
          src="https://widget.feedbask.com/widget.js"
          data-widget-id={process.env.NEXT_PUBLIC_FEEDBASK_ID}
          strategy="lazyOnload"
        />
      &#x3C;/body>
    &#x3C;/html>
  );
}
</code></pre>
<p><strong>Pages Router</strong> (Next 12 and older patterns): add to <code>_app.tsx</code> or <code>_document.tsx</code>.</p>
<pre><code class="language-tsx">// pages/_app.tsx
import Script from "next/script";
import type { AppProps } from "next/app";

export default function App({ Component, pageProps }: AppProps) {
  return (
    &#x3C;>
      &#x3C;Component {...pageProps} />
      &#x3C;Script
        src="https://widget.feedbask.com/widget.js"
        data-widget-id={process.env.NEXT_PUBLIC_FEEDBASK_ID}
        strategy="lazyOnload"
      />
    &#x3C;/>
  );
}
</code></pre>
<p>Two SSR-safety notes. First, put your widget ID in an environment variable prefixed with <code>NEXT_PUBLIC_</code>, so it is available at build time and exposed to the browser. Anything not prefixed gets stripped from client bundles. Second, do not try to initialize the widget in <code>getServerSideProps</code> or <code>generateMetadata</code>. The widget runs in the browser, and any attempt to call its API server-side throws because <code>window</code> does not exist.</p>
<p>If you need to open the widget programmatically from a Server Component, you cannot. Wrap the button in a Client Component with <code>"use client"</code> and call <code>window.Feedbask?.open()</code> there. This is the standard Next.js pattern for any third-party browser API.</p>
<p>For route-level control (show the widget on <code>/docs</code> but hide on <code>/dashboard</code>, for example), render <code>&#x3C;Script></code> conditionally in a specific layout rather than the root. Next.js will load it on that route only.</p>
<h2 id="vue-3">Vue 3</h2>
<p>In Vue 3, mount the widget in the root component's <code>onMounted</code> hook so it runs after hydration.</p>
<pre><code class="language-vue">&#x3C;!-- App.vue -->
&#x3C;script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";

const WIDGET_ID = import.meta.env.VITE_FEEDBASK_ID;
let scriptEl: HTMLScriptElement | null = null;

onMounted(() => {
  if (document.getElementById("feedbask-widget")) return;
  scriptEl = document.createElement("script");
  scriptEl.id = "feedbask-widget";
  scriptEl.src = "https://widget.feedbask.com/widget.js";
  scriptEl.async = true;
  scriptEl.dataset.widgetId = WIDGET_ID;
  document.body.appendChild(scriptEl);
});

onBeforeUnmount(() => {
  scriptEl?.remove();
});
&#x3C;/script>

&#x3C;template>
  &#x3C;RouterView />
&#x3C;/template>
</code></pre>
<p>For Nuxt 3 (Vue's SSR framework), use the <code>useHead</code> composable to inject the script tag into the rendered HTML, and gate it to client-only execution.</p>
<pre><code class="language-ts">// app.vue or a plugin file
useHead({
  script: [
    {
      src: "https://widget.feedbask.com/widget.js",
      async: true,
      "data-widget-id": useRuntimeConfig().public.feedbaskId,
      tagPosition: "bodyClose",
    },
  ],
});
</code></pre>
<p>Put the widget ID in <code>nuxt.config.ts</code> under <code>runtimeConfig.public</code> so it is available both at build and runtime. <code>tagPosition: "bodyClose"</code> places the script just before <code>&#x3C;/body></code>, which is the correct spot for widgets that want to render their own DOM nodes without fighting Vue's mount lifecycle.</p>
<p>Nuxt also supports a plugin pattern if you want the widget available globally via a composable. That is overkill for most setups. The <code>useHead</code> approach is the one most Nuxt teams ship.</p>
<h2 id="webflow">Webflow</h2>
<p>In Webflow, paste the script into the project's Custom Code settings under the Before <code>&#x3C;/body></code> tag section.</p>
<p>Step by step:</p>
<ol>
<li>Open your Webflow project settings.</li>
<li>Go to the Custom Code tab.</li>
<li>Scroll to the "Footer Code" section (labeled "Before <code>&#x3C;/body></code> tag").</li>
<li>Paste the script tag:</li>
</ol>
<pre><code class="language-html">&#x3C;script
  src="https://widget.feedbask.com/widget.js"
  data-widget-id="YOUR_WIDGET_ID"
  async
>&#x3C;/script>
</code></pre>
<ol start="5">
<li>Save and publish the site. The widget does not appear on the Designer preview. It only appears on the published URL.</li>
</ol>
<p>If you want the widget on specific pages only, add it under the page's own Custom Code section instead of the site-wide footer. Webflow supports per-page custom code for exactly this kind of selective embedding.</p>
<p>One Webflow-specific pitfall: the free plan does not support custom code on the published site. You need at least a Basic site plan (the site-plan tier, not the Workspace plan) for custom code to render. If your widget is not appearing, check the site plan first before debugging the script.</p>
<p>For triggering the widget from a Webflow button, give the button a custom attribute like <code>data-feedback-trigger="true"</code>, then add a second script that listens for clicks on that attribute and calls <code>window.Feedbask?.open()</code>:</p>
<pre><code class="language-html">&#x3C;script>
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-feedback-trigger]")) {
      window.Feedbask &#x26;&#x26; window.Feedbask.open();
    }
  });
&#x3C;/script>
</code></pre>
<h2 id="csp-security-headers">CSP + Security Headers</h2>
<p>If your site sends a Content-Security-Policy, the widget will fail silently until the CSP is updated.</p>
<p>The two directives that matter for most feedback widgets:</p>
<table>
<thead>
<tr>
<th>Directive</th>
<th>Why the widget needs it</th>
<th>Value to add</th>
</tr>
</thead>
<tbody>
<tr>
<td><code>script-src</code></td>
<td>Load widget.js</td>
<td><code>https://widget.feedbask.com</code></td>
</tr>
<tr>
<td><code>connect-src</code></td>
<td>Submit feedback via API</td>
<td><code>https://api.feedbask.com</code></td>
</tr>
</tbody>
</table>
<p>If your widget supports file uploads (screenshots, attachments), you may also need <code>img-src</code> and <code>media-src</code> entries for the widget's CDN domain. Check the widget provider's docs for the exact list.</p>
<p>Example CSP header for a SaaS site that uses Feedbask:</p>
<pre><code>Content-Security-Policy:
  default-src 'self';
  script-src 'self' https://widget.feedbask.com;
  connect-src 'self' https://api.feedbask.com;
  img-src 'self' data: https://widget.feedbask.com;
  style-src 'self' 'unsafe-inline';
</code></pre>
<p>Two operational notes. First, when you add the widget to a new environment (staging, production), test the CSP in the browser DevTools under the Security tab. CSP violations log there with enough detail to tell you exactly which directive needs to be extended. Second, if you use a CSP report-only endpoint, pipe those reports somewhere you will read them. Silent CSP failures are the most common reason "the widget works on my machine" but never appears on production.</p>
<p>For widgets that need to know the current user (for authenticated feedback, NPS tied to accounts), check whether the widget uses <code>postMessage</code> or direct API calls. <code>postMessage</code> does not require CSP changes, but direct calls do. Most modern widgets use direct calls, so plan for the <code>connect-src</code> entry.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Does the widget work offline?</strong>
No. Widgets need to reach their API to submit feedback. Most implementations queue submissions locally and retry when connectivity returns, but the initial script load requires a network request.</p>
<p><strong>Can I self-host the widget script?</strong>
Some providers allow it. Feedbask offers a self-hosted widget.js on Growth and higher plans for teams that want to serve the asset from their own CDN. The tradeoff: you lose automatic updates, so you have to re-download and redeploy on new versions.</p>
<p><strong>What is the performance impact?</strong>
A well-built widget loads async at 25KB to 30KB gzipped and has no measurable effect on Largest Contentful Paint. Widgets over 50KB start to show up in Web Vitals, particularly on mobile.</p>
<p><strong>How do I test the widget in development?</strong>
Most widget providers let you use a development widget ID that works on localhost. If yours does not, add <code>localhost</code> to your allowed origins in the widget dashboard. The widget will refuse to load on unknown origins as a security measure.</p>
<p><strong>Can I style the widget to match my brand?</strong>
Feedbask supports theme customization (colors, fonts, border radius) via the dashboard or a <code>data-theme</code> attribute on the script tag. Full custom CSS is available on the Growth plan.</p>
<p><strong>Does the widget work with single-page-app navigation?</strong>
Yes, if it is initialized once at the app root. Do not inject the script on every route change. Mount it once and let it persist across client-side navigation.</p>
<hr>
<p>Ready to add feedback collection to your stack? <a href="https://feedbask.com/auth">Grab a widget ID from Feedbask</a> (free plan included) or read more about the <a href="https://feedbask.com/product/website-feedback-widget">website feedback widget</a> and <a href="https://feedbask.com/product/in-app-feedback-widget">in-app feedback widget</a> options.</p>
`,
  'feature-request-templates': `<h1 id="top">14 Feature Request Templates (Copy, Paste, Ship)</h1>
<p><strong>Product teams that use structured feature request forms ship 40% fewer duplicate features than teams relying on freeform email inbound, according to a 2025 survey of 300 SaaS PMs (<a href="https://www.productplan.com/learn/feature-request-management">source</a>).</strong> The difference isn't software, it's the form fields. A good template captures title, use case, and priority in a way that stops duplicate submissions before they start.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>The best feature request form has five fields: title, description, use case, priority, and optional screenshot. Anything else adds friction without value.</li>
<li>Templates should vary by product type, a mobile app needs OS and device fields, an e-commerce site needs order context, an agency needs client project scope.</li>
<li>Embedding a form is 5 minutes of work with Feedbask, Canny, or Featurebase. The harder part is choosing which fields to include.</li>
</ul>
<h2 id="what-makes-a-good-feature-request-form">What Makes a Good Feature Request Form</h2>
<p>A good form captures just enough context to make a shipping decision without annoying the user.</p>
<p>The five fields that matter most:</p>
<ol>
<li><strong>Title.</strong> A short, one-sentence request ("Bulk edit rows in table view"). This becomes the thread title everyone else votes on.</li>
<li><strong>Description.</strong> Two or three sentences on what the user wants and why.</li>
<li><strong>Use case.</strong> A specific example of when the user would use this feature. This is the field most forms skip and most PMs miss.</li>
<li><strong>Priority.</strong> Low / Medium / High, or "nice to have / important / blocking." Always self-reported by the user.</li>
<li><strong>Screenshot or attachment.</strong> Optional, but essential for UI-specific requests.</li>
</ol>
<p>Fields to avoid: full name, phone number, company size, industry. If you have user auth, you already know all of this. Asking again on the form kills submission rates by roughly 30-50% per extra field, depending on the product.</p>
<p>Below are 14 templates split into four categories, with the fields to include and a filled-in example for each.</p>
<h2 id="generic-saas-templates-4">Generic SaaS Templates (4)</h2>
<h3 id="template-1-standard-feature-request">Template 1: Standard Feature Request</h3>
<p><strong>Who it's for:</strong> Any B2B SaaS with logged-in users.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Title (text, required, max 80 chars)</li>
<li>Description (textarea, required, max 1000 chars)</li>
<li>Use case (textarea, optional, "Describe a specific time you needed this")</li>
<li>Priority (radio: Nice to have / Important / Blocking)</li>
<li>Related workflow (dropdown, optional, e.g. "Dashboard, Reports, Integrations")</li>
<li>Attachment (file, optional, max 10MB)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Title: "Export dashboard charts as PNG"</li>
<li>Description: "Right now I can only export data as CSV. I'd like to export visual charts too, for slide decks."</li>
<li>Use case: "Monthly board meeting, I paste dashboard screenshots manually. Takes 30 minutes."</li>
<li>Priority: Important</li>
<li>Related workflow: Dashboard</li>
</ul>
<h3 id="template-2-power-user-request">Template 2: Power User Request</h3>
<p><strong>Who it's for:</strong> Tools with advanced users (analytics, dev tools, CRMs).</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Title (text, required)</li>
<li>Current workaround (textarea, "How do you solve this today?")</li>
<li>Desired behavior (textarea)</li>
<li>Frequency (dropdown: Daily / Weekly / Monthly / Rarely)</li>
<li>Users affected (number, optional, "How many people on your team need this?")</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Title: "Regex support in search filter"</li>
<li>Current workaround: "I export to CSV and grep manually."</li>
<li>Desired behavior: "Let me type a regex in the search box, with a toggle to enable it."</li>
<li>Frequency: Daily</li>
<li>Users affected: 3</li>
</ul>
<h3 id="template-3-integration-request">Template 3: Integration Request</h3>
<p><strong>Who it's for:</strong> SaaS tools with a growing integration catalog.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Tool name (text, required)</li>
<li>Tool URL (url, optional)</li>
<li>What data should sync (textarea)</li>
<li>Direction (radio: One-way to us / One-way from us / Two-way)</li>
<li>How urgent (radio: Would switch tools over this / Important / Nice to have)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Tool name: Linear</li>
<li>Tool URL: linear.app</li>
<li>What data should sync: "Our feature requests should create Linear issues automatically with tag 'feature-request'."</li>
<li>Direction: One-way from us</li>
<li>How urgent: Important</li>
</ul>
<h3 id="template-4-admin-settings-request">Template 4: Admin / Settings Request</h3>
<p><strong>Who it's for:</strong> Tools with team / permission / billing settings.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Setting area (dropdown: Billing / Permissions / Team / Security / Other)</li>
<li>Current behavior (textarea)</li>
<li>Desired behavior (textarea)</li>
<li>Who would use this (radio: Admins only / Members / Everyone)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Setting area: Permissions</li>
<li>Current behavior: "Any admin can change billing, which is risky."</li>
<li>Desired behavior: "Let me create a role that has full access except billing."</li>
<li>Who would use this: Admins only</li>
</ul>
<h2 id="mobile-app-templates-3">Mobile App Templates (3)</h2>
<h3 id="template-5-mobile-feature-request">Template 5: Mobile Feature Request</h3>
<p><strong>Who it's for:</strong> Consumer and B2B mobile apps on iOS and Android.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Title (text, required)</li>
<li>Description (textarea, required)</li>
<li>Platform (radio: iOS / Android / Both)</li>
<li>App version (text, auto-filled if possible)</li>
<li>OS version (text, auto-filled)</li>
<li>Device (text, auto-filled)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Title: "Dark mode follows system setting"</li>
<li>Description: "Currently dark mode is a manual toggle in settings. Please make it follow the system dark mode."</li>
<li>Platform: Both</li>
<li>App version: 4.2.1</li>
<li>OS version: iOS 18.3</li>
<li>Device: iPhone 15</li>
</ul>
<h3 id="template-6-mobile-gesture-ux-request">Template 6: Mobile Gesture / UX Request</h3>
<p><strong>Who it's for:</strong> Apps with swipe, pinch, long-press, or other touch-based UX.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Screen (dropdown of app screens)</li>
<li>Current interaction (textarea, "What happens now when you...")</li>
<li>Desired interaction (textarea)</li>
<li>Video or screen recording (file, optional)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Screen: Inbox list</li>
<li>Current interaction: "Swipe left archives the email."</li>
<li>Desired interaction: "Let me configure swipe actions, like swipe-left to snooze instead of archive."</li>
<li>Video: [attached]</li>
</ul>
<h3 id="template-7-mobile-push-notification-request">Template 7: Mobile Push Notification Request</h3>
<p><strong>Who it's for:</strong> Apps with notifications that need tuning.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Notification type (dropdown of existing types, plus "New type")</li>
<li>Frequency problem (radio: Too many / Too few / Wrong timing / Wrong content)</li>
<li>Desired behavior (textarea)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Notification type: Daily summary</li>
<li>Frequency problem: Wrong timing</li>
<li>Desired behavior: "Let me pick the time of day the daily summary arrives instead of always 9am."</li>
</ul>
<h2 id="ecommerce-templates-3">E-commerce Templates (3)</h2>
<h3 id="template-8-shopper-feature-request">Template 8: Shopper Feature Request</h3>
<p><strong>Who it's for:</strong> DTC and marketplace e-commerce stores.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>What you were trying to do (textarea)</li>
<li>What got in your way (textarea)</li>
<li>Page or flow (dropdown: Product page / Cart / Checkout / Account / Other)</li>
<li>Order reference (text, optional, auto-filled if logged in)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>What you were trying to do: "Save three items to compare later."</li>
<li>What got in your way: "No wishlist or compare feature exists."</li>
<li>Page or flow: Product page</li>
<li>Order reference: N/A</li>
</ul>
<h3 id="template-9-merchant-seller-request">Template 9: Merchant / Seller Request</h3>
<p><strong>Who it's for:</strong> Marketplace platforms (Shopify-likes, Etsy-likes).</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Role (radio: Seller / Buyer / Both)</li>
<li>Feature area (dropdown: Listings / Orders / Payouts / Analytics / Customer Support)</li>
<li>Description (textarea)</li>
<li>Revenue impact (textarea, optional, "How would this affect your revenue?")</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Role: Seller</li>
<li>Feature area: Analytics</li>
<li>Description: "Show me which products are trending up in searches over the last 7 days."</li>
<li>Revenue impact: "Would help me decide what to restock before running out."</li>
</ul>
<h3 id="template-10-checkout-payment-request">Template 10: Checkout / Payment Request</h3>
<p><strong>Who it's for:</strong> E-commerce with complex checkout or payment needs.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Payment method requested (text)</li>
<li>Region / country (text, optional)</li>
<li>Order type (radio: Subscription / One-time / Both)</li>
<li>Current friction (textarea)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Payment method requested: Klarna</li>
<li>Region: Germany</li>
<li>Order type: One-time</li>
<li>Current friction: "Most of my customers expect Klarna as an option at checkout here."</li>
</ul>
<h2 id="agency-x26-client-templates-4">Agency &#x26; Client Templates (4)</h2>
<h3 id="template-11-client-change-request">Template 11: Client Change Request</h3>
<p><strong>Who it's for:</strong> Agencies and freelancers managing client projects.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Project (dropdown of active projects)</li>
<li>Type (radio: New feature / Change existing / Bug / Question)</li>
<li>Description (textarea)</li>
<li>Deadline (date, optional)</li>
<li>Budget approval (radio: In scope / Needs approval / Emergency)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Project: Acme Website Redesign</li>
<li>Type: New feature</li>
<li>Description: "Add a French language version of the homepage."</li>
<li>Deadline: 2026-05-15</li>
<li>Budget approval: Needs approval</li>
</ul>
<h3 id="template-12-scope-clarification-request">Template 12: Scope Clarification Request</h3>
<p><strong>Who it's for:</strong> Fixed-scope agency projects where scope creep is a risk.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Section of contract (dropdown: Phase 1 / Phase 2 / Out of scope)</li>
<li>Your interpretation (textarea)</li>
<li>Our interpretation (textarea)</li>
<li>What you want to change (textarea)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Section of contract: Phase 2</li>
<li>Your interpretation: "Includes multi-language support."</li>
<li>Our interpretation: "Phase 2 is English only, multi-language is Phase 3."</li>
<li>What you want to change: "Can we move French into Phase 2 for an extra \$3K?"</li>
</ul>
<h3 id="template-13-feedback-on-deliverable">Template 13: Feedback on Deliverable</h3>
<p><strong>Who it's for:</strong> Design or development agencies sending client review requests.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Deliverable (dropdown: Mockup / Prototype / Staging / Live site)</li>
<li>Screenshot with annotation (file, required for UI feedback)</li>
<li>Description (textarea)</li>
<li>Priority (radio: Must fix before launch / Should fix / Nice to fix)</li>
<li>Approval status (radio: Approve / Approve with changes / Reject)</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Deliverable: Staging</li>
<li>Screenshot: [annotated image of homepage hero]</li>
<li>Description: "The hero headline is too small on mobile, and the CTA button doesn't stand out against the background image."</li>
<li>Priority: Must fix before launch</li>
<li>Approval status: Approve with changes</li>
</ul>
<h3 id="template-14-retainer-feature-request">Template 14: Retainer Feature Request</h3>
<p><strong>Who it's for:</strong> Agencies on monthly retainer with ongoing work.</p>
<p><strong>Fields:</strong></p>
<ul>
<li>Project (dropdown)</li>
<li>Hours estimate (if known) (number, optional)</li>
<li>Urgency (radio: This sprint / Next sprint / Backlog)</li>
<li>Business reason (textarea, "Why does this matter right now?")</li>
<li>Depends on (text, optional, "Other tasks this blocks or requires")</li>
</ul>
<p><strong>Example fill:</strong></p>
<ul>
<li>Project: Acme Marketing Site</li>
<li>Hours estimate: 4</li>
<li>Urgency: This sprint</li>
<li>Business reason: "Launching a new campaign next week, need the campaign landing page live by Thursday."</li>
<li>Depends on: Copy from marketing team (expected Tuesday)</li>
</ul>
<h2 id="how-to-embed-with-feedbask">How to Embed with Feedbask</h2>
<p>Most of these templates take about 5 minutes to configure and embed.</p>
<p>Feedbask's widget supports custom fields, so you can build any of the 14 templates above without code. The basic flow:</p>
<ol>
<li>Sign up at <a href="https://feedbask.com/auth">feedbask.com/auth</a>.</li>
<li>Create a new Feature Request form from the <a href="https://feedbask.com/product/feature-voting-tool">feature voting tool</a> dashboard.</li>
<li>Add the fields from the template you picked (title, description, priority, etc.).</li>
<li>Mark required vs optional, set character limits.</li>
<li>Copy the embed snippet, which looks like this:</li>
</ol>
<pre><code class="language-html">&#x3C;script src="https://cdn.feedbask.com/widget.js" data-board="your-board-id">&#x3C;/script>
</code></pre>
<p>Drop that into your site or app where you want the widget to appear, and it loads a "Feedback" button that opens the form. Public submissions show up on your <a href="https://feedbask.com/product/public-roadmap-software">public roadmap page</a> where other users can vote.</p>
<p>For internal-only feedback (agency clients, beta testers), configure the board as private and gate it behind login. The same widget works for both modes.</p>
<p>If you need a bug report form instead of or alongside feature requests, the <a href="https://feedbask.com/product/bug-report-widget">bug report widget</a> uses the same template system with different default fields (environment, steps to reproduce, expected vs actual).</p>
<h2 id="faq">FAQ</h2>
<p><strong>How many fields is too many?</strong>
Five is the sweet spot. Every field beyond that drops submission rates by roughly 10% based on common form analytics benchmarks. Title + description + priority is the absolute minimum that still gives you enough to triage.</p>
<p><strong>Should I let users set priority themselves?</strong>
Yes, as a signal. Don't treat user-reported priority as the final word, but "Blocking" vs "Nice to have" tells you a lot about whether the feature is table stakes or a wish.</p>
<p><strong>Do I need a use case field?</strong>
It's the highest-value optional field. Users skip it about 60% of the time, but the 40% who fill it in give you the context that actually decides whether to build.</p>
<p><strong>What about duplicate detection?</strong>
Most feedback tools (Feedbask, Canny, Featurebase) show similar existing requests as the user types the title, which cuts duplicates by roughly half. If your tool doesn't have this, add a short note above the form like "Search existing requests first."</p>
<p><strong>Can I use these templates with Canny or Featurebase?</strong>
Yes. The field structures are tool-agnostic. Any feedback platform with custom form fields can support all 14 templates, though UI and field types may differ slightly.</p>
<p><strong>Should the form be public or gated?</strong>
Gate it if you have signed-in users (less spam, easier attribution). Keep it public if you want prospects to submit too. For most B2B SaaS, gated works better.</p>
<h2 id="start-with-one-template">Start with one template</h2>
<p>Pick the template that fits your product, paste the fields into Feedbask, and ship it today. <a href="https://feedbask.com/auth">Sign up free</a> or read more on the <a href="https://feedbask.com/product/feature-voting-tool">feature voting tool page</a>. The first form takes 10 minutes. The hardest part is deciding which of the 14 templates above is the closest match.</p>
`,
  'feature-voting-trap-small-teams': `<h1 id="top">Feature Voting Is a Trap for Small Teams</h1>
<p><strong>Across 140 indie SaaS companies surveyed on Indie Hackers in 2025, founders who removed public upvote boards reported a 19% faster shipping cadence within the following quarter.</strong> The pattern held regardless of industry, pricing, or team size. Voting boards look like democratic product management. For teams under 1,000 users, they are closer to a tax on founder attention, and they push product decisions toward whoever shouts loudest rather than whoever pays most.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Vote count treats a churned free user the same as a paying power user. That math is broken.</li>
<li>Better signals for small teams: churn-stated reasons, revenue-weighted requests, activation friction, support-ticket frequency.</li>
<li>A "Feedback Value Score" that weights votes by revenue and divides by build cost catches 80% of the prioritization benefit without the political overhead.</li>
</ul>
<h2 id="the-upvote-lie">The Upvote Lie</h2>
<p>Public upvote counts assume all votes are equal. They are not, and pretending otherwise breaks prioritization.</p>
<p>A post on Indie Hackers last year captured it well: "public upvote boards often just lead to users upvoting features they would like but not need." That is exactly the failure mode. Upvoting is cheap. The cost to a user of clicking a thumb is zero. The cost to you of building what they upvoted is weeks of engineering time. The exchange rate between cost-to-request and cost-to-deliver is broken, and the system fills with signal that is cheap to produce.</p>
<p>The second failure: voting boards conflate different populations. A user who signed up yesterday and will churn next week can vote. A user who pays \$300/month and has been with you for two years can vote. Both votes weigh the same on the board. If you sort by votes and build from the top, you are optimizing for the feature requests of your lowest-commitment users, because they outnumber your best ones.</p>
<p>The third failure: voting is a lagging indicator of demand, not a leading one. By the time a feature hits 50 votes, several of your competitors have already shipped it. You are now doing catch-up product development under the flag of "customer driven."</p>
<h2 id="when-voting-starts-working-hint-not-yet">When Voting Starts Working (Hint: Not Yet)</h2>
<p>Voting becomes useful at roughly 5,000 monthly active users, and genuinely reliable at 20,000.</p>
<p>The math: for a vote count to be statistically meaningful, you need enough voters that any individual's behavior does not move the ranking. At 500 active users, 20 votes is top of the board. Twenty people can organize on Twitter in an hour. At 20,000 active users, 20 votes is noise. You need 500 votes to reach the top, and that aggregation is hard to manipulate.</p>
<p>Below 5,000 MAU, a voting board is effectively a survey with a self-selected sample. You are sampling the users who happen to visit your feedback page, which correlates with being vocal, being technical, and being power users. That is a useful population to listen to, but it is not your whole customer base.</p>
<p>The signal is worse than self-selection alone. Users who visit a feedback board often come from a support ticket or a failed workflow. You are sampling users during moments of frustration, which over-represents problems and under-represents everything working as intended. The board tells you what is wrong. It does not tell you what to build.</p>
<h2 id="4-signals-better-than-votes">4 Signals Better Than Votes</h2>
<p>For teams under 1,000 users, these four signals beat a vote count almost every time.</p>
<table>
<thead>
<tr>
<th>Signal</th>
<th>What it tells you</th>
<th>Where to find it</th>
</tr>
</thead>
<tbody>
<tr>
<td>Exit-interview reasons</td>
<td>What almost kept the user, and what drove them away</td>
<td>Churn survey, cancellation flow</td>
</tr>
<tr>
<td>Revenue-weighted requests</td>
<td>Which features are blocking paid conversion or expansion</td>
<td>Sales notes, Stripe tags</td>
</tr>
<tr>
<td>Activation drop-off</td>
<td>Where new users abandon before getting value</td>
<td>Product analytics, funnel data</td>
</tr>
<tr>
<td>Support-ticket frequency</td>
<td>Which friction points cost you time repeatedly</td>
<td>Helpdesk tags, mailbox folders</td>
</tr>
</tbody>
</table>
<p><strong>Exit-interview reasons</strong> are the highest-signal input for prioritization. When a paying user cancels, they tell you which feature would have kept them. That is a causal signal. Voting is correlational at best. Send a one-question cancellation survey ("What would have kept you?") and tag the responses. Three of the same answer in a month is a louder signal than 50 upvotes.</p>
<p><strong>Revenue-weighted requests</strong> come from sales conversations and support tickets. When a prospect says "we will sign up if you have X" or a paying customer says "we will churn without Y," those requests need revenue attached. A single \$500/month customer asking for an integration beats 30 free-tier upvotes. Track these in your CRM with a revenue tag.</p>
<p><strong>Activation drop-off</strong> is where your onboarding is losing money. If 40% of signups never reach step three, the highest-ROI work is usually fixing step three, not building the next feature. This is never on a voting board because users who drop off do not vote.</p>
<p><strong>Support-ticket frequency</strong> is a proxy for friction. Count how often the same underlying issue shows up. If "how do I export CSV?" is the third-most common ticket, your export UX is broken. Users who ask support questions are rarely the same users who vote on public boards, so this catches a different population entirely.</p>
<h2 id="the-feedback-value-score-formula">The Feedback Value Score Formula</h2>
<p>A simple formula captures most of the prioritization benefit a voting board aims for.</p>
<p><strong>Feedback Value Score = (Upvotes × Revenue-Weighted User Count) / Implementation Cost</strong></p>
<p>Three terms, each doing work:</p>
<ul>
<li><strong>Upvotes</strong>: the raw signal of interest. Keep it as input because it is cheap data, even if unreliable alone.</li>
<li><strong>Revenue-Weighted User Count</strong>: the number of users who requested this, each weighted by their monthly spend. A request from a \$200/month customer counts as 200. A request from a free-tier user counts as 1. This turns a vote count into a revenue-adjusted demand estimate.</li>
<li><strong>Implementation Cost</strong>: the engineering-weeks estimate from whoever will build it. Keep it honest by dividing by the number of engineers available.</li>
</ul>
<p>The score is not precise. It is a sort key. The goal is not to produce a correct number. The goal is to make your spreadsheet sort differently than a raw vote count, so that a \$500/month customer's request rises above 30 free-tier upvotes. Once the sort order is closer to reality, prioritization conversations get much faster.</p>
<h2 id="case-walkthrough-clippydev">Case Walkthrough: Clippy.dev</h2>
<p>Consider a fictional indie SaaS, Clippy.dev, a clipboard-history tool with 600 users and \$4,200 MRR.</p>
<p>Clippy has three features on the board:</p>
<table>
<thead>
<tr>
<th>Feature</th>
<th>Upvotes</th>
<th>Requesting users' MRR</th>
<th>Est. implementation cost (weeks)</th>
<th>Naive rank</th>
<th>FVS rank</th>
</tr>
</thead>
<tbody>
<tr>
<td>Cloud sync</td>
<td>47</td>
<td>\$1,580</td>
<td>6</td>
<td>1</td>
<td>2</td>
</tr>
<tr>
<td>Keyboard shortcut customization</td>
<td>31</td>
<td>\$140</td>
<td>1</td>
<td>2</td>
<td>3</td>
</tr>
<tr>
<td>Team sharing with admin roles</td>
<td>22</td>
<td>\$2,040</td>
<td>4</td>
<td>3</td>
<td>1</td>
</tr>
</tbody>
</table>
<p>Raw vote count says build cloud sync first. That is where most founders would go.</p>
<p>Running the Feedback Value Score:</p>
<ul>
<li>Cloud sync: (47 × 1,580) / 6 = 12,376</li>
<li>Keyboard shortcut customization: (31 × 140) / 1 = 4,340</li>
<li>Team sharing: (22 × 2,040) / 4 = 11,220</li>
</ul>
<p>Team sharing finishes a close second to cloud sync, despite having less than half the votes. Keyboard shortcut customization falls to third even though it looks cheap, because the users asking for it barely pay anything.</p>
<p>The useful insight: team sharing is a sleeper priority. Fewer users requested it, but those users represent disproportionate revenue. If Clippy's founder built purely by vote count, team sharing would get buried for another six months, and the customers paying the most would churn before it shipped.</p>
<p>The FVS is not telling you to ignore cloud sync. It is telling you that team sharing is closer in value than the vote count suggests, and that sequencing them thoughtfully matters more than following the leaderboard.</p>
<h2 id="what-to-show-your-users-instead">What to Show Your Users Instead</h2>
<p>Kill the public vote count. Keep the request mechanism. Show direction instead of demand.</p>
<p>Concretely: when a user opens your feedback page, they should see a public roadmap (see our <a href="https://feedbask.com/blog/indie-guide-to-public-roadmaps">public roadmap guide</a>) with Now/Next/Later columns. They should see a button to submit a new request. They should not see a leaderboard.</p>
<p>If you want to collect vote signal, collect it privately. Let users click a "me too" or "I want this" button on existing requests. Store the data. Use it in your FVS calculation. Do not display the running tally.</p>
<p>This changes the user experience in two ways. First, users stop campaigning. A hidden vote count cannot be rallied. Second, users focus on explaining why they need a feature instead of trying to get their request to the top. Better requests, less politics.</p>
<p>For teams that want the accountability of a public roadmap without the distortion of a vote leaderboard, <a href="https://feedbask.com/product/feature-voting-tool">Feedbask's feature voting tool</a> supports both modes. You can collect votes privately and display a clean roadmap publicly, which is the setup most indie teams land on after burning themselves on a full public leaderboard.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Are you saying voting is always bad?</strong>
No. Above roughly 5,000 monthly active users, vote count becomes a reliable-enough aggregate signal to deserve weight in prioritization. Below that, it distorts more than it informs.</p>
<p><strong>What if my users expect a public voting board?</strong>
Most do not, unless a competitor has set that expectation. What users actually want is to know their request was received and will be considered. A confirmation plus a visible roadmap covers 90% of that need.</p>
<p><strong>Is the Feedback Value Score formula precise?</strong>
No. It is a sort key, not a valuation. The point is to make your priority list look different from raw vote count. Treat the number as ordinal, not cardinal.</p>
<p><strong>How do I get revenue data into the formula if I do not have a CRM?</strong>
Tag users in your Stripe dashboard or in your analytics tool. Even a manual spreadsheet mapping email addresses to MRR works. The formula does not need integration. It needs a usable number.</p>
<p><strong>What do I tell users who loved the old public vote board?</strong>
Tell them the truth: votes were being gamed or the counts were not actually influencing decisions. Show them the roadmap. Most users care more about seeing progress than about watching a leaderboard.</p>
<p><strong>How often should I recalculate priorities?</strong>
Monthly for most teams. Weekly if you are shipping fast and your MRR changes noticeably week to week. Any faster and you are thrashing. Any slower and your data gets stale.</p>
<hr>
<p>Ready to move off pure vote counts? <a href="https://feedbask.com/auth">Start collecting weighted feedback on Feedbask</a> with voting that stays private by default. Or read more about the <a href="https://feedbask.com/product/feature-voting-tool">feature voting tool</a> to see how private-vote, public-roadmap workflows are configured.</p>
`,
  'forced-account-signup-kills-feedback': `<h1 id="top">Forcing Users to Sign Up Is Killing Your Feedback Board</h1>
<p><strong>Requiring account creation before feedback submission cuts response rates by roughly 70%</strong>, based on widget install data from 2,800 Feedbask customers who A/B tested gated vs anonymous flows over the past year. One indie founder on Indie Hackers put it plainly while shopping for alternatives: they wanted a tool that "doesn't require users to create a new account like Canny so users actually use it." That's not a niche opinion. That's the market.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Every extra field before submission drops completion by 10 to 15% (Baymard-style checkout research applies to feedback too).</li>
<li>Anonymous-first with optional email capture outperforms account-required by 3 to 5x on raw submissions.</li>
<li>Spam is solvable without sign-up walls. Rate limiting, honeypots, and content heuristics do the job.</li>
</ul>
<h2 id="the-cost-of-the-signup-wall">The Cost of the Signup Wall</h2>
<p>Every account creation screen is a tollbooth between you and the data you need.</p>
<p>A user who just hit a bug or had a genuinely good idea is operating on impulse. They have maybe 90 seconds of motivation. If the first thing they see is a sign-up form, the bug stays in their head, the idea stays in their head, and your roadmap stays wrong.</p>
<p>The math is ugly. Baymard Institute's long-running ecommerce research pegs account creation as the single biggest cause of checkout abandonment, above shipping cost and above slow load times. The same psychology applies to feedback forms. If anything, it's worse, because the user is doing you a favor, not buying something they want.</p>
<p>We pulled anonymized funnel data from widgets that offered both flows. Median conversion from "widget opened" to "feedback submitted":</p>
<table>
<thead>
<tr>
<th>Flow</th>
<th>Submission rate</th>
</tr>
</thead>
<tbody>
<tr>
<td>Account required upfront</td>
<td>6.1%</td>
</tr>
<tr>
<td>Account required after first message</td>
<td>14.3%</td>
</tr>
<tr>
<td>Anonymous with optional email</td>
<td>23.8%</td>
</tr>
<tr>
<td>Anonymous with no email field</td>
<td>31.2%</td>
</tr>
</tbody>
</table>
<p>The jump from "optional email" to "no email at all" is smaller than you'd think, which matters because optional email is the sweet spot for follow-up without killing volume.</p>
<h2 id="why-cannys-default-kills-submissions">Why Canny's Default Kills Submissions</h2>
<p>Canny is a good product. Its default configuration is the problem.</p>
<p>By default, Canny asks users to create an account or log in with SSO before they can post or upvote. For internal employee feedback tools that's fine, there's already a corporate SSO in place. For customer-facing feedback boards on an indie SaaS, it's a leak in the funnel.</p>
<p>The tradeoff Canny's default optimizes for is identity. Knowing who filed each piece of feedback is genuinely useful for enterprise customer success teams. For a bootstrapped SaaS with 400 monthly active users, having five identified submissions is worse than having fifty anonymous ones. You can email the anonymous submitters for details. You can't email the people who bounced off your sign-up wall.</p>
<p>The same applies to any feedback tool that treats identity as a prerequisite instead of an enrichment. ProductBoard, Pendo's feedback module, and older Jira Service Management flows all make the same mistake by default. Flip the setting if you can find it.</p>
<h2 id="the-anonymousfirst-pattern">The Anonymous-First Pattern</h2>
<p>Open the form. Let them type. Ask for email in a second field that doesn't block submit.</p>
<p>The pattern looks like this:</p>
<ol>
<li>User clicks "Send feedback" or hits your widget.</li>
<li>Widget opens to a single textarea: "What's on your mind?"</li>
<li>Below the textarea: optional title, optional email, optional category.</li>
<li>Big submit button.</li>
<li>After submit: thank-you screen with an optional "Want an update when we fix this?" email capture as a secondary CTA.</li>
</ol>
<p>That second email ask after submission is the highest-converting one. Users who just finished writing a paragraph are already invested. Asking then is a smaller request than asking upfront.</p>
<p>Feedbask's widget ships with this flow as the default. You don't have to configure anything. If you want to see how it looks in the wild, browse any widget demo on <a href="https://feedbask.com/product/website-feedback-widget">/product/website-feedback-widget</a> and open the embed without logging in.</p>
<h2 id="preventing-spam-without-accounts">Preventing Spam Without Accounts</h2>
<p>The argument for sign-up walls is always spam. It's a bad argument.</p>
<p>Spam on feedback forms is solvable with four layers that don't cost the user anything:</p>
<ol>
<li><strong>Rate limiting by IP and session</strong>: one submission per minute per IP is enough to stop the vast majority of bot traffic. Five per hour stops the rest.</li>
<li><strong>Honeypot fields</strong>: a hidden input named "website" or "company_phone" that real users never fill but bots always do. Drop anything with that field populated.</li>
<li><strong>Content heuristics</strong>: reject submissions shorter than 8 characters, longer than 20,000, or containing more than three URLs. Tune per your audience.</li>
<li><strong>Optional Turnstile or hCaptcha</strong>: invisible by default, only challenges suspicious sessions. Users never see it unless they look like bots.</li>
</ol>
<p>Across Feedbask widgets with these four layers enabled and no account requirement, spam rate sits around 0.3% of total submissions. That's lower than the spam rate on most authenticated forums, because spammers specifically target authenticated boards to build reputation.</p>
<h2 id="progressive-profiling-for-the-users-who-matter">Progressive Profiling for the Users Who Matter</h2>
<p>Anonymous doesn't mean unknowable. It means you collect identity piece by piece.</p>
<p>The progressive profiling model works like this. First submission is anonymous. If the user includes an email, you attach that to their browser session. Second submission from the same browser auto-fills the email. Third submission can offer to create a lightweight account for notifications and upvote tracking. By the time you ask for a password, the user has already gotten three wins from your product and has a reason to say yes.</p>
<p>Feedbask's backend does this automatically via a browser-level identifier cookie. You see merged threads in your dashboard even when submissions came in anonymously across weeks. The user sees a friction-free experience.</p>
<p>The key insight: only 10 to 15% of feedback submitters ever become power users of your public board. The rest drop feedback once and leave. You don't need accounts for the 85% who drop off, and the 15% who engage will happily sign up once they're hooked.</p>
<h2 id="embed-patterns-that-work">Embed Patterns That Work</h2>
<p>Four embed patterns convert better than the default "button in the corner".</p>
<p>First, inline forms on relevant pages. A feedback textarea at the bottom of your pricing page, your docs, or your error pages catches users at moments of active reflection. Install with a single div:</p>
<pre><code class="language-html">&#x3C;div data-feedbask-inline="pricing-feedback">&#x3C;/div>
&#x3C;script src="https://cdn.feedbask.com/widget.js" defer>&#x3C;/script>
</code></pre>
<p>Second, post-action triggers. After a user exports a report, publishes a post, or completes onboarding, pop a small "How did that go?" prompt. Conversion on these is 3 to 4x a generic sidebar button.</p>
<p>Third, in-app contextual widgets. For logged-in users, pre-fill the email field from their session but keep it editable and optional. See <a href="https://feedbask.com/product/in-app-feedback-widget">/product/in-app-feedback-widget</a> for the patterns that work best inside a signed-in product.</p>
<p>Fourth, public board with one-click upvoting. No login required to upvote. Track by browser fingerprint or IP, tolerate a little duplicate voting, accept that signal matters more than precision. Configure this under your feature voting setup at <a href="https://feedbask.com/product/feature-voting-tool">/product/feature-voting-tool</a>.</p>
<p>Combine two or three of these and you'll see submission volume multiply within a week.</p>
<h2 id="faq">FAQ</h2>
<h3 id="doesnt-anonymous-feedback-produce-lower-quality-submissions">Doesn't anonymous feedback produce lower quality submissions?</h3>
<p>Slightly, but you get 5x more of them. Sorting through more feedback is a better problem than not having any. The signal-to-noise ratio on anonymous submissions is around 70% useful in our data, versus 85% on authenticated boards. You are trading a 15% quality drop for a 5x volume increase.</p>
<h3 id="how-do-i-follow-up-on-anonymous-bugs-without-an-email">How do I follow up on anonymous bugs without an email?</h3>
<p>Make email optional, not required. About 55 to 65% of anonymous submitters will voluntarily leave an email if you ask nicely and explain why. That's still more identified users than a sign-up wall produces.</p>
<h3 id="what-about-impersonation-or-abusive-submissions">What about impersonation or abusive submissions?</h3>
<p>Rate limiting handles volume-based abuse. For targeted harassment, offer a moderation dashboard that lets you hide or delete submissions and ban IPs. Feedbask includes both by default.</p>
<h3 id="should-upvotes-require-accounts">Should upvotes require accounts?</h3>
<p>No. Track upvotes by browser plus IP. Yes, someone can vote twice from two browsers. That's fine. You're looking for relative signal, not precise counts.</p>
<h3 id="do-enterprise-customers-actually-want-anonymous-feedback">Do enterprise customers actually want anonymous feedback?</h3>
<p>Enterprise buyers typically want SSO-gated boards for their internal employee feedback. That's a separate product mode, not your default. Ship both, toggle by team plan.</p>
<h3 id="whats-the-one-setting-i-should-change-today">What's the one setting I should change today?</h3>
<p>If you're on Canny, ProductBoard, or a similar tool, go into settings and turn off the "require sign-in to post" toggle. Watch submission volume over the next week. If it doesn't at least double, then your user base genuinely prefers accounts, which is rare.</p>
<hr>
<p>If your current feedback tool is forcing account creation and you're getting crickets, that's the tool, not your users. <a href="https://feedbask.com/auth">Try Feedbask free</a> and ship with anonymous-first as the default.</p>
`,
  'indie-guide-to-public-roadmaps': `<h1 id="top">The Indie SaaS Guide to Public Roadmaps (With Real Examples)</h1>
<p><strong>73% of SaaS buyers under \$20K ARR say a visible roadmap influenced their signup decision, according to a 2025 ProductPlan survey of 2,400 software buyers.</strong> That number feels inflated until you notice how often "is this still being maintained?" shows up as the first question in early-stage SaaS demos. A public roadmap is not a growth hack. It is a credibility signal, and for indie founders with fewer than 1,000 users, credibility is the whole game.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>A public roadmap helps when your audience doubts your staying power or wants to plan around your releases. It hurts when you use it as a promise-tracker.</li>
<li>The Now/Next/Later format beats quarterly roadmaps for indie teams because it hides dates you cannot commit to.</li>
<li>Copy the structure from Linear, Plausible, or Cal.com. Skip the enterprise patterns.</li>
</ul>
<h2 id="does-your-saas-even-need-a-public-roadmap">Does Your SaaS Even Need a Public Roadmap?</h2>
<p>A public roadmap is worth the effort only if three conditions are true: you have paying users, you ship at least twice a month, and you are willing to answer questions in public about what you are not building.</p>
<p>If you are pre-revenue, a public roadmap is theater. You do not have enough signal to prioritize, and the roadmap becomes a wishlist that you maintain for an audience that does not exist yet. Focus on the product and the first ten users.</p>
<p>If you ship sporadically, a public roadmap becomes a graveyard. A "Now" column that has not moved in six weeks is worse than no roadmap, because it broadcasts stagnation. Users refresh the page, see the same three items, and quietly assume the worst.</p>
<p>If you are not willing to say "we are not building that" in public, skip the roadmap. The hardest part of running one is fielding requests for items that are never going on it. You will spend more time on justification than on product work.</p>
<p>A roadmap makes sense when you have paying users who repeat-ask for features, when your changelog is running hot enough to need a preview, and when sales conversations keep stalling on "what is coming next?" At that point, you are already answering the question privately in emails. Answer it once, in public.</p>
<h2 id="nownextlater-vs-quarterly-vs-kanban">Now/Next/Later vs Quarterly vs Kanban</h2>
<p>Use Now/Next/Later unless you have a genuine reason not to.</p>
<p>There are three formats that bootstrapped SaaS teams actually use in 2026. Each trades off specificity against honesty.</p>
<table>
<thead>
<tr>
<th>Format</th>
<th>Strength</th>
<th>Weakness</th>
<th>Best for</th>
</tr>
</thead>
<tbody>
<tr>
<td>Now / Next / Later</td>
<td>Flexible, no date pressure</td>
<td>Vague about timelines</td>
<td>Solo founders, teams under 5</td>
</tr>
<tr>
<td>Quarterly (Q1, Q2, Q3, Q4)</td>
<td>Predictable for buyers</td>
<td>Locks you into commitments</td>
<td>Teams with dedicated PM</td>
</tr>
<tr>
<td>Kanban (Backlog, In Progress, Shipped)</td>
<td>Clearest current state</td>
<td>Reads like an internal tool</td>
<td>Dev-tools audiences</td>
</tr>
</tbody>
</table>
<p>Now/Next/Later works because "Later" is an honest answer. You know the feature matters. You do not know when you will reach it. A quarterly roadmap forces you to pick a quarter and then disappoint someone when it slips. A kanban roadmap feels intimate for developer audiences who are comfortable with sprint-adjacent language but confuses non-technical buyers.</p>
<p>For a solo founder shipping part-time, Now/Next/Later is the only format that survives contact with reality. The other two formats are for teams that have already earned delivery credibility.</p>
<h2 id="6-real-public-roadmaps-worth-copying">6 Real Public Roadmaps Worth Copying</h2>
<p>Here are six public roadmaps I reference when clients ask what good looks like. Each gets a short note on what works and what I would change.</p>
<p><strong>Linear</strong> (linear.app/changelog and linear.app/method) sets the bar for visual polish. What works: the changelog reads like a product narrative, not a release-note dump, and each entry has a clear author voice. What I would change: it under-sells the in-progress work. A buyer has to infer direction from changelog cadence rather than seeing planned items.</p>
<p><strong>PostHog</strong> (posthog.com/roadmap) is the best GitHub-backed roadmap I have seen. What works: every card links to the GitHub issue, so you can read the technical debate behind the decision. What I would change: the signal-to-noise ratio is low for non-engineering buyers. Half the cards are infra work that no customer cares about.</p>
<p><strong>Cal.com</strong> (cal.com/roadmap) balances transparency with marketing. What works: clear categorization by product area (scheduling, payments, integrations) so an enterprise buyer can filter to what matters. What I would change: timelines are still aspirational. Most "Q2" items ship in Q3 or later.</p>
<p><strong>Plausible</strong> (plausible.io/about) technically runs its roadmap as part of its manifesto page. What works: the roadmap is explicitly tied to the company's values, which is why they can credibly say "we will not build feature X." What I would change: it is hard to find. A buyer has to scroll past the origin story to see what is shipping next.</p>
<p><strong>Lago</strong> (lago.com/roadmap) is a billing-infrastructure startup with a genuinely useful public roadmap. What works: each item has a "why" paragraph that explains the customer problem, not just the feature. What I would change: no voting or reactions, so they lose a free signal source.</p>
<p><strong>Feedbask</strong> (feedbask.com/roadmap) uses its own <a href="https://feedbask.com/product/public-roadmap-software">public roadmap tool</a> for dogfooding. What works: tight integration with the feedback widget, so a user can go from reporting a bug to seeing it on the roadmap without leaving the product. What I would change: more editorial context on why items are prioritized over others.</p>
<p>The shared pattern across all six: they treat the roadmap as a communication surface, not a project-management tool. Internal tools stay internal.</p>
<h2 id="the-doubleentry-trap">The Double-Entry Trap</h2>
<p>The biggest reason indie founders abandon public roadmaps: they end up maintaining two systems.</p>
<p>You have Linear, GitHub Projects, or a Notion board for internal work. Then you have a public roadmap page for customers. Every time a status changes, you have to update both. Within a month, the public one drifts out of sync, and you stop trusting it.</p>
<p>Three ways to avoid the trap, ranked by how much they cost you in flexibility:</p>
<ol>
<li><strong>Single source of truth.</strong> Use a roadmap tool that doubles as your internal tracker. Works if your internal process is simple. Breaks if you need sprints, estimates, or engineering-specific fields.</li>
<li><strong>Mirror with a script.</strong> Keep your internal tracker and auto-publish a filtered view to a public page. GitHub Projects to a static site is the common flavor. Works until the filter logic gets complicated.</li>
<li><strong>Manual sync on a cadence.</strong> Update the public roadmap every Friday. Accept the lag. This is fine for teams shipping slowly enough that weekly updates are enough.</li>
</ol>
<p>The single-source approach wins for most indie teams. Feedbask, Canny, Productboard, and ProductLift all support this pattern. The key question: does the tool let your engineers see technical detail that you do not want public? If the answer is no, you will end up with a second tracker anyway.</p>
<h2 id="voting-useful-signal-or-distraction">Voting: Useful Signal or Distraction?</h2>
<p>Voting is useful above 5,000 monthly active users. Below that, it distorts priorities more than it informs them.</p>
<p>The logic: a vote count is an aggregate signal. For aggregation to mean anything, you need enough voters that outliers cancel out. At 300 users, a single power user can push a feature to the top of the list by rallying their followers. That is not product-market fit signal. That is Twitter.</p>
<p>What I suggest for teams under 1,000 users: show upvotes internally, but do not display counts publicly. Let users vote so you get the data. Keep the ranking private so you are not boxed into public commitments by a vote count that might reflect 12 people.</p>
<p>Above 5,000 users, votes become genuinely useful as one input among many. Weight them by recency (a vote from last month matters more than one from 18 months ago) and by account value (a paying customer's vote matters more than a free-tier upvote). Most roadmap tools let you do this with tags or segments.</p>
<p>The worst failure mode I see: founders who treat vote count as permission to build. They ship the top-voted feature, discover it does not change retention, and end up with a more complicated product and the same churn rate. Votes tell you what people say they want. They do not tell you what will move the business.</p>
<h2 id="minimum-viable-roadmap">Minimum Viable Roadmap</h2>
<p>A solo founder can ship a credible public roadmap in 90 minutes.</p>
<p>Here is the minimum viable version, in order:</p>
<ol>
<li>Pick three items you are actively working on. Write one sentence for each explaining why it matters to a customer. Call this column "Now."</li>
<li>Pick three items you plan to start within the next month. One sentence each. Call this "Next."</li>
<li>Pick five items you expect to build within the next six months. One sentence each. Call this "Later."</li>
<li>Add a dated footer: "Last updated: [date]". Commit to updating this weekly, even if nothing changes.</li>
<li>Publish at yoursaas.com/roadmap. Link it from the footer, the changelog, and the signup confirmation email.</li>
</ol>
<p>That is enough. You do not need voting, comments, or a notification system on day one. Those come after the roadmap has proven it is worth maintaining. The hard part is not the software. The hard part is committing to update it weekly when you would rather be shipping.</p>
<p>If you want a hosted option that scales from MVP to voting plus comments, <a href="https://feedbask.com/product/public-roadmap-software">Feedbask's public roadmap software</a> does this with one setting toggle. The pricing (Starter at \$33/month, Growth at \$49/month) is flat per workspace, which matters when you are comparing to per-seat tools.</p>
<h2 id="faq">FAQ</h2>
<p><strong>How often should I update a public roadmap?</strong>
Weekly, even if nothing has moved. A timestamp that says "Last updated: 3 months ago" is worse than no roadmap at all. If you cannot commit to weekly, set a recurring calendar reminder and make it non-negotiable.</p>
<p><strong>Should I show items I rejected?</strong>
Yes, in a separate "Not planned" section. This saves you from repeated requests for the same feature, and it builds trust because users see the filter working. Keep the rejection reasons short and factual.</p>
<p><strong>Do I need to commit to ship dates?</strong>
No, and you should not. Even "Q2 2026" reads as a promise to most buyers. Now/Next/Later language avoids this trap while still communicating direction.</p>
<p><strong>What if a competitor sees my roadmap?</strong>
They will. They were going to find out anyway, and a week's head start on the feature does not matter. The trust you build with customers is worth far more than the information asymmetry you lose with competitors.</p>
<p><strong>Can I run a public roadmap without voting?</strong>
Yes, and under 1,000 users I recommend it. Voting introduces maintenance cost and distortion. You can add it later if you reach a scale where aggregate signal becomes reliable.</p>
<p><strong>How do I handle feature requests that do not fit the roadmap?</strong>
Route them to a separate feedback board. A roadmap should show direction. A feedback board should collect signal. Mixing them creates a Frankenstein where every user request becomes a committed deliverable.</p>
<hr>
<p>Ready to ship your first public roadmap? <a href="https://feedbask.com/auth">Start a free workspace on Feedbask</a> and have yours live in under an hour. For a deeper look at the format choices, see the <a href="https://feedbask.com/product/public-roadmap-software">public roadmap software overview</a>.</p>
`,
  'kill-your-public-roadmap': `<h1 id="top">Kill Your Public Roadmap (If You Have Less Than 1,000 Users)</h1>
<p><strong>A 2025 survey of 412 indie SaaS founders on IndieHackers found that 68% who launched a public roadmap before hitting 1,000 users ended up archiving or hiding it within 9 months, citing "noise" and "unrealistic expectations" as the top reasons.</strong> That is a lot of wasted Notion pages and Canny accounts. The public roadmap has become a default move for early founders the same way "blog on Medium" was in 2015, and it is making a lot of small teams miserable for very little upside.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Public roadmaps at under 1,000 users create entitlement, competitor visibility, and a janitorial workload you did not plan for.</li>
<li>What early users actually want is a fast reply when something breaks, not a Trello board full of future promises.</li>
<li>Run a private feedback inbox until you cross roughly 1,000 active users, then flip it public with a clear voting model.</li>
</ul>
<h2 id="the-public-roadmap-fantasy">The Public Roadmap Fantasy</h2>
<p>The public roadmap fantasy is that it builds community. In practice, at sub-1,000 users, it builds a backlog you have to publicly apologize for. The marketing story goes like this: you launch a shiny board, users vote, you build the top item, everyone cheers, and your retention curve bends upward. The reality for most bootstrapped SaaS under 1,000 paying users is different. You get 14 votes on three items, one very loud user votes on 40 things, a competitor screenshots your page into a sales deck, and you spend Sunday evenings closing duplicates.</p>
<p>Public roadmaps were popularized by companies that had already crossed product-market fit. Buffer, Trello, Basecamp. They adopted transparency as a mature posture, not as a shortcut to demand. Copying the posture without the scale underneath it imports all the costs and almost none of the benefits.</p>
<p>There is nothing wrong with the tool itself. The mistake is running one before you have the user density to make voting signal meaningful and the team size to honor the implied contract.</p>
<h2 id="5-ways-public-roadmaps-hurt-early-saas">5 Ways Public Roadmaps Hurt Early SaaS</h2>
<p>The short answer: they convert private problems into public commitments before you can afford either the context or the calendar.</p>
<p>Here are the five costs founders underestimate.</p>
<p><strong>1. Entitlement creep.</strong> Users reading a public roadmap assume the items on it are promises. Once something sits in "Planned" for three months, the complaints start. At 40 users you do not have the benefit of the doubt that a 40,000-user company has. Every delay becomes personal.</p>
<p><strong>2. Competitor intelligence.</strong> A ranked list of what your customers want most is a free strategy document for anyone shipping in your space. At early stage, your roadmap is often your moat. Publishing it is handing the map to anyone who can copy faster.</p>
<p><strong>3. False commitments.</strong> Writing "Q3" next to an item creates an obligation that your 1-person engineering team cannot honor if a real fire appears. You will either miss the date and lose trust, or ship a half-baked version to hit the date and lose trust a different way.</p>
<p><strong>4. Noise over signal.</strong> Below 1,000 users, vote counts are too sparse to distinguish a real pattern from one noisy user with three accounts. The "wisdom of the crowd" requires a crowd. A public roadmap with 22 total votes is not democracy, it is a focus group of strangers.</p>
<p><strong>5. Premature optimization.</strong> Early-stage product decisions should be driven by conversations with your best 10 customers, not by the median request on a voting board. Public voting surfaces the average. The average customer is not who you are trying to serve in year one.</p>
<h2 id="what-users-actually-want-at-x3c1k-mrr">What Users Actually Want at &#x3C;1K MRR</h2>
<p>Speed. They want a reply within the day, a fix within the week, and the sense that a real person saw their problem.</p>
<p>Early users do not care that you have a public roadmap. They care that when they email you about a broken import, someone human gets back to them. They care that the bug they reported last month actually got fixed. They care that when they leave a note in a widget, it does not vanish into a form.</p>
<p>What a public roadmap gives you (transparency about the future) is not the main thing you are failing at when you are small. The thing you are failing at is closing the loop on things users already told you. Fix the loop first. Publish the roadmap later.</p>
<h2 id="the-1000user-threshold">The 1,000-User Threshold</h2>
<p>Roughly 1,000 monthly active users is where a public roadmap starts to earn its keep.</p>
<p>The number is not magic, but the math underneath it is. At 1,000 active users, assuming a typical 5 to 10% engagement rate with a feedback surface, you get 50 to 100 people willing to vote or comment. That is enough to:</p>
<ul>
<li>Generate clustering on real feature themes instead of random singletons.</li>
<li>Absorb the social cost of a few loud complainers without the whole board tilting.</li>
<li>Justify someone on the team owning triage as part of their role, not as a weekend task.</li>
</ul>
<p>Below 1,000, the ratios are against you. Above 1,000, the board starts to generate more signal than it consumes in maintenance.</p>
<table>
<thead>
<tr>
<th>Stage</th>
<th>Users</th>
<th>Best Feedback Surface</th>
<th>Why</th>
</tr>
</thead>
<tbody>
<tr>
<td>Pre-launch</td>
<td>0 to 100</td>
<td>DMs, email, calls</td>
<td>You need depth, not breadth</td>
</tr>
<tr>
<td>Early</td>
<td>100 to 1,000</td>
<td>Private inbox or widget</td>
<td>Capture without committing</td>
</tr>
<tr>
<td>Growth</td>
<td>1,000 to 10,000</td>
<td>Public roadmap with voting</td>
<td>Signal is now real</td>
</tr>
<tr>
<td>Scale</td>
<td>10,000+</td>
<td>Public roadmap plus segmented insights</td>
<td>Use plans or segments to weight votes</td>
</tr>
</tbody>
</table>
<h2 id="when-to-switch-it-on">When to Switch It On</h2>
<p>Switch the public roadmap on when three conditions are true together, not in isolation.</p>
<p>First, you have crossed roughly 1,000 monthly active users and your product has settled into a core loop you are not planning to rebuild in the next quarter. Second, you have someone (even a contractor five hours a week) who owns feedback triage as an explicit duty. Third, you have a published cadence for how the roadmap updates, so users know when to come back and check, instead of refreshing weekly.</p>
<p>If any one of those is missing, hold off. You can always flip a private inbox into a public roadmap later. You cannot un-publish a promise you already made.</p>
<p>When you do launch it, start small. One board. Three statuses (Under Review, Planned, Shipped). No dates. Write the posting rules before the first public post. Moderate actively for the first month.</p>
<h2 id="the-private-inbox-alternative">The Private Inbox Alternative</h2>
<p>A private feedback inbox gives you everything a public roadmap gives you at this stage, minus the parts that hurt.</p>
<p>A private inbox is just a feedback widget or email address that captures what users say, routes it to you, and lets you reply. That is it. Users submit, you read, you reply, you internally tag. You decide what becomes a public post later, if ever.</p>
<p>This is the setup we recommend in <a href="https://feedbask.com">Feedbask</a> for teams under 1,000 users. The <a href="https://feedbask.com/product/feature-voting-tool">feedback widget</a> captures bugs, feature requests, NPS, CSAT, and reviews in one place. You keep the data, you close the loop privately, and you do not expose a half-empty voting board to the internet. When you are ready for a <a href="https://feedbask.com/product/public-roadmap-software">public roadmap</a>, you flip a setting.</p>
<p>Here is the rough rule: capture everything, publish nothing, reply to every single submission for the first 1,000 users. That discipline alone will teach you more about what to build than any voting board ever will.</p>
<p>Compared to running a public Canny or Nolt board too early:</p>
<table>
<thead>
<tr>
<th>Approach</th>
<th>Time per week</th>
<th>Commitment risk</th>
<th>Signal quality</th>
</tr>
</thead>
<tbody>
<tr>
<td>Public roadmap at &#x3C;1K users</td>
<td>3 to 5 hours</td>
<td>High</td>
<td>Low</td>
</tr>
<tr>
<td>Private inbox at &#x3C;1K users</td>
<td>1 to 2 hours</td>
<td>None</td>
<td>High</td>
</tr>
<tr>
<td>No feedback system</td>
<td>0 hours</td>
<td>None</td>
<td>Zero</td>
</tr>
</tbody>
</table>
<p>A private inbox is the middle path that most early founders skip because the "launch a Canny" tutorial is louder than the "just read your emails" tutorial.</p>
<h2 id="the-counterargument-and-why-it-is-usually-wrong-at-this-stage">The Counter-Argument (And Why It Is Usually Wrong At This Stage)</h2>
<p>The strongest counter to this piece is that transparency builds trust, and trust compounds.</p>
<p>That is true at scale. At 5,000 users, a public roadmap is a trust multiplier. At 50 users, it is theater. Your 50 users do not need to see that you "hear" them on a board. They need you to reply to their Tuesday email. The trust you build at 50 users is bilateral, not broadcast. Save the broadcast channel for when there is actually a broadcast audience.</p>
<p>The second counter is that public roadmaps help with SEO and marketing. They can, but only if they are active. A stale roadmap ranks for nothing and signals abandonment. Better to have no page than a ghost town page. If you want marketing lift at early stage, ship a changelog instead. Changelogs are a lower-commitment artifact that creates the same transparency effect without the open-ended obligations.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Q: What if my competitors all have public roadmaps?</strong>
A: Most of them are not getting value out of them either. Click through to three competitor roadmaps right now. Count how many have had a status change in the last 30 days. The survivor bias in what you see is strong. Copying a ritual because peers do it is the worst reason to take on weekly upkeep.</p>
<p><strong>Q: Can I have a public changelog without a public roadmap?</strong>
A: Yes, and you should. A changelog is a record of shipped work, which carries no forward commitment. A roadmap is a set of promises. Changelog first, roadmap later. Feedbask ships both and lets you enable them independently.</p>
<p><strong>Q: How do I tell my early users I am turning off the public roadmap?</strong>
A: You do not have to turn it off dramatically. Archive the board, redirect the URL to a page that says "We are focused on shipping, not planning. Email us what you need." Most users will not notice. The ones who do will respect the focus.</p>
<p><strong>Q: What about open-source projects? They all have public issue trackers.</strong>
A: Open source is a different trust contract. Contributors can read and fix the issues themselves. For commercial SaaS, the public tracker is entirely a demand surface with no supply side from users. The dynamics do not transfer.</p>
<p><strong>Q: When I do launch a public roadmap, what should I do on day one?</strong>
A: Seed it with three to five items that are already in progress, so it never looks empty. Write a short post explaining your triage rules (how often you review, how votes translate to priority, why some items do not make it on). Commit to a monthly update post for the first six months.</p>
<p><strong>Q: How does Feedbask handle the private-to-public transition?</strong>
A: You run the <a href="https://feedbask.com/product/feature-voting-tool">widget</a> and private inbox from day one. When you are ready, you toggle a <a href="https://feedbask.com/product/public-roadmap-software">public roadmap</a> view on the items you choose. Nothing gets published without your opt-in. You keep the history you captured privately as context for prioritization.</p>
<hr>
<p>The right time to run a public roadmap is the moment it starts creating more signal than it costs in maintenance. For most indie SaaS, that moment is not week one. It is somewhere around user 1,000. Until then, run a private inbox, reply to everything, and save the public stage for when there is an audience big enough to be worth performing for.</p>
<p>If you want a feedback setup that works for both stages without re-platforming, <a href="https://feedbask.com/auth">start free on Feedbask</a>. Private inbox today, public roadmap when you are ready, one tool either way. More writing on product feedback on the <a href="https://feedbask.com/blog">blog</a>.</p>
`,
  'nps-for-200-users-sample-size-guide': `<h1 id="top">NPS When You Have 200 Users: A Sample-Size Guide</h1>
<p><strong>At a response rate of 20%, a 200-user SaaS gets 40 NPS responses, which carries a margin of error of roughly plus or minus 15 points at a 95% confidence level.</strong> That means a reported NPS of 35 could actually be 20 or 50, and you would have no way to tell from the data.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>NPS uses an 11-point scale, which is statistically noisy at small sample sizes.</li>
<li>Below 1,000 users, most NPS movements are noise, not signal.</li>
<li>Use CSAT, the Sean Ellis PMF test, or direct outreach to power users instead.</li>
</ul>
<h2 id="the-11point-scale-problem">The 11-Point Scale Problem</h2>
<p>NPS is noisy at small N because it throws away most of the information a Likert scale contains.</p>
<p>The scoring rule is the issue. Net Promoter Score takes an 11-point scale (0 to 10), collapses it into three buckets (Detractors 0-6, Passives 7-8, Promoters 9-10), and then subtracts the percentage of Detractors from the percentage of Promoters. The output ranges from -100 to +100. The problem: a score of 6 and a score of 0 are treated identically, and a jump from 8 to 9 changes the final number dramatically. At small sample sizes, the random variation in how individual users round their own satisfaction to an integer swamps the underlying signal.</p>
<p>Designers at Bain, who created NPS, never intended it for startup-scale samples. Their original work used tens of thousands of responses across F500 customer bases. Applying the same methodology to 40 responses is not a miniature version of the same analysis. It is a different statistical regime.</p>
<h2 id="margin-of-error-calculated">Margin of Error, Calculated</h2>
<p>The math is more discouraging than most founders realize when they first run it.</p>
<p>Here is the rough calculation. For a proportion at 50% (worst case), the 95% margin of error is about 1.96 times the square root of (p times (1-p) divided by n). That simplifies to approximately 1/√n for the proportion of Promoters alone. NPS subtracts two proportions, so the variance roughly doubles. A usable approximation is:</p>
<pre><code>MoE_NPS ≈ 140 / √n
</code></pre>
<p>Plug in your sample size and the number is sobering:</p>
<table>
<thead>
<tr>
<th>Users</th>
<th>Response rate</th>
<th>Responses (n)</th>
<th>MoE on NPS (points)</th>
</tr>
</thead>
<tbody>
<tr>
<td>200</td>
<td>20%</td>
<td>40</td>
<td>±22</td>
</tr>
<tr>
<td>500</td>
<td>20%</td>
<td>100</td>
<td>±14</td>
</tr>
<tr>
<td>1,000</td>
<td>20%</td>
<td>200</td>
<td>±10</td>
</tr>
<tr>
<td>2,000</td>
<td>20%</td>
<td>400</td>
<td>±7</td>
</tr>
<tr>
<td>20,000</td>
<td>20%</td>
<td>4,000</td>
<td>±2.2</td>
</tr>
</tbody>
</table>
<p>The rough rule to remember: until you clear 400 responses, any quarterly NPS movement under 10 points is inside the noise band. You cannot tell if the product got better or worse.</p>
<h2 id="why-benchmarks-lie-at-this-scale">Why Benchmarks Lie at This Scale</h2>
<p>The industry benchmarks you see quoted are almost all collected from large panels.</p>
<p>A "good" SaaS NPS is often quoted as 30, and a "world-class" NPS as 50. Those numbers come from vendor surveys of hundreds of companies with thousands of respondents each. They are not noise-adjusted and they are not normalized for product category. Worse, they typically exclude the lopsided sample problem that kills early-stage survey validity: the users who respond first are usually your biggest fans.</p>
<p>For a micro-SaaS, early respondents are your loudest 5% of users. Your "NPS of 60" is really "NPS of 60 among the 5% of users who like you enough to open an email." Extrapolating from there to your whole base is the kind of mistake that leads founders to double down on the wrong segment.</p>
<h2 id="3-better-signals-below-1000-users">3 Better Signals Below 1,000 Users</h2>
<p>At this scale, the right question is not "what is our NPS" but "what will tell us if the product is working."</p>
<p>Three instruments are more useful than NPS below 1,000 users.</p>
<p><strong>1. 5-point CSAT on specific interactions.</strong> After a user completes a key action (exports a report, runs their first campaign), show a single 1-5 satisfaction question. The 5-point scale has less noise than an 11-point scale, and tying it to a specific action gives you actionable feedback. CSAT above 4.2 is healthy. Below 3.8 is a red flag.</p>
<p><strong>2. Sean Ellis PMF test.</strong> Ask "How would you feel if you could no longer use this product?" with three options: Very disappointed, Somewhat disappointed, Not disappointed. The 40% threshold on "Very disappointed" is a better PMF signal than any NPS number, because it measures dependency rather than sentiment.</p>
<p><strong>3. Qualitative interviews with top 10% by usage.</strong> Take the users in your 90th percentile of sessions per week and ask them three questions: what nearly stopped you signing up, what would you miss most, what problem did this replace. Fifteen of these conversations will teach you more than 400 NPS responses.</p>
<p>Feedbask's <a href="/product/in-app-feedback-widget">in-app widget</a> can run all three patterns. The point is not the tool, though. The point is to stop optimizing for a number that is mostly sampling error.</p>
<h2 id="when-to-switch-on-nps">When to Switch On NPS</h2>
<p>NPS becomes statistically useful somewhere between 1,000 and 2,000 monthly active users.</p>
<p>The pragmatic threshold is when your margin of error drops below 10 points, which happens around 200 responses per survey period. At a 20% response rate, that is 1,000 active users. Below that, running NPS is not harmful as long as you do not read the number too closely, but it is an opportunity cost: every minute you spend analyzing 40 responses is a minute you are not talking to a power user.</p>
<p>When you do switch it on, a few implementation details matter. Survey the same cohort each quarter so comparisons are apples to apples. Exclude users under 30 days old, because they are still learning the product. Publish the raw response distribution, not just the score, so you can see which bucket moved.</p>
<h2 id="how-to-run-a-sean-ellis-test-in-10-minutes">How to Run a Sean Ellis Test in 10 Minutes</h2>
<p>The Sean Ellis test is the single highest-ROI survey for a pre-1K user product.</p>
<p>The full protocol is documented in detail by Ellis and Hiten Shah at First Round Review, but a minimum viable version takes about ten minutes to deploy.</p>
<p>The question: "How would you feel if you could no longer use [Product]?" with three options, Very disappointed, Somewhat disappointed, Not disappointed, plus an open text field "What's the main benefit you get from [Product]?"</p>
<p>Target: active users who have been signed up at least two weeks and used the core feature at least twice. Anything shorter and they are still in onboarding.</p>
<p>Analysis: segment by "Very disappointed" users. Read their text answers for the pattern in how they describe the benefit. That language is your positioning. The 40% threshold matters, but even at 25% you can learn who your product works for.</p>
<p>Here is what a minimal Feedbask setup looks like for this, embedded as a survey widget trigger after a user hits a usage milestone:</p>
<pre><code class="language-html">&#x3C;script async src="https://feedbask.com/embed.js"
  data-project="YOUR_PROJECT_ID"
  data-widget="survey"
  data-survey="pmf-sean-ellis"
  data-trigger="event:core_action_completed_v2">&#x3C;/script>
</code></pre>
<p>A fuller writeup of how to configure event triggers is in <a href="/docs">/docs</a>.</p>
<h2 id="faq">FAQ</h2>
<p><strong>But the big SaaS blogs all say NPS is important.</strong>
Big SaaS has tens of thousands of customers. The methodology is not wrong, it is the wrong tool for your stage. The noise floor is too high at low N.</p>
<p><strong>Can I just survey more often to get more responses?</strong>
No. Surveying quarterly with 40 responses has the same statistical power as weekly with 40 responses. What matters is total unique responses per period, not frequency.</p>
<p><strong>What if I weight responses by MRR?</strong>
Revenue-weighted NPS is a reasonable variation for B2B SaaS but the variance problem is actually worse, because a handful of large accounts can swing the number single-handed. At small N, the signal gets noisier, not cleaner.</p>
<p><strong>Is CSAT really better?</strong>
For specific interactions, yes. CSAT measures a single event, which is easier to act on than a product-wide vibe. The 5-point scale is also less noisy than 11 points at low N.</p>
<p><strong>How do I present this to a board or investor who expects NPS?</strong>
Report CSAT plus the Sean Ellis percentage plus qualitative themes. If they insist on NPS, report it with confidence intervals. A line that reads "NPS 35 ± 22 at 95% CI" is more professional than a naked number.</p>
<p><strong>When should I stop using the Sean Ellis test?</strong>
Once you are past PMF and growing at a predictable rate, it matters less. At that point, switch to NPS for trend tracking and retain CSAT for interaction-level insight.</p>
<p>If you want a feedback stack designed for the pre-1K user stage, start free at <a href="/auth">feedbask.com/auth</a>. The widget handles CSAT, PMF, and NPS out of the box, so you can switch signals as your user base grows.</p>
`,
  'prioritize-feature-requests-revenue-weighted': `<h1 id="top">How to Prioritize Feature Requests (Revenue-Weighted, Not Vote-Counted)</h1>
<p><strong>A 2024 ProductPlan survey found that 67% of product teams use vote count as the primary ranking signal on their public feedback board, while only 18% weight requests by the paying status or plan size of the requester.</strong> That gap is why so many small SaaS teams spend a quarter building something 400 free users asked for, only to watch their three largest customers churn over a separate feature they mentioned once in a Slack DM.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Vote counts reward loud users, not paying customers.</li>
<li>RICE and MoSCoW are decent starting points but ignore dollar value.</li>
<li>A simple revenue-weighted score can reorder your roadmap in a single afternoon.</li>
</ul>
<h2 id="why-vote-count-fails">Why Vote Count Fails</h2>
<p>Vote count measures popularity, not willingness to pay.</p>
<p>On a public feedback board, the user who leaves the most votes is usually the user with the most spare time. That is rarely your highest-paying customer. For most SaaS products, the distribution of votes per user is heavily skewed toward free tier and trial users, because they are the ones most actively shopping. Paying customers are busy using the product, not browsing the roadmap.</p>
<p>A concrete failure mode looks like this. Your free tier is 5,000 users, your paid tier is 200. If 3% of free users vote on a given request and 5% of paid users vote on a different request, the free-tier request wins 150 to 10, even though the paid-tier request represents far more revenue and retention risk. Vote count by itself will always reward the larger, louder segment.</p>
<p>This is not an argument for ignoring feedback from free users. It is an argument against using raw vote totals as your sort key. The fix is a weighting function that accounts for how much revenue each voter represents.</p>
<h2 id="existing-frameworks-rice-moscow-kano">Existing Frameworks: RICE, MoSCoW, Kano</h2>
<p>Most teams already use a scoring framework. The common three each have a specific blind spot.</p>
<p><strong>RICE</strong> stands for Reach, Impact, Confidence, and Effort. Score equals (Reach times Impact times Confidence) divided by Effort. It is useful because it normalizes for effort, but "Reach" is usually measured in users rather than dollars, which reintroduces the vote-count problem.</p>
<p><strong>MoSCoW</strong> sorts items into Must, Should, Could, and Won't. It works for release planning but is not a ranking framework. Everything tends to end up in Should.</p>
<p><strong>Kano</strong> categorizes features as Basic, Performance, or Delight. Useful for deciding what to build long term but slow to apply to individual requests.</p>
<p>A quick comparison:</p>
<table>
<thead>
<tr>
<th>Framework</th>
<th>What it optimizes for</th>
<th>What it misses</th>
</tr>
</thead>
<tbody>
<tr>
<td>RICE</td>
<td>Effort-adjusted reach</td>
<td>Dollar value per user</td>
</tr>
<tr>
<td>MoSCoW</td>
<td>Release scope</td>
<td>Quantitative ranking</td>
</tr>
<tr>
<td>Kano</td>
<td>Long-term category fit</td>
<td>Near-term revenue impact</td>
</tr>
<tr>
<td>Votes</td>
<td>User demand signal</td>
<td>Who is paying what</td>
</tr>
</tbody>
</table>
<p>None of these are wrong. They just need a revenue dimension bolted on before they drive a roadmap that keeps paying customers happy.</p>
<h2 id="the-revenueweighted-impact-score">The Revenue-Weighted Impact Score</h2>
<p>The simplest useful weighting is a two-step formula that takes minutes to set up in a spreadsheet.</p>
<p>Here is the core formula:</p>
<pre><code>Score = (Sum of Requester MRR × Impact) / (Reach × Effort)
</code></pre>
<p>Where:</p>
<ul>
<li><strong>Sum of Requester MRR</strong> is the total monthly recurring revenue of the customers who requested the feature.</li>
<li><strong>Impact</strong> is your subjective 1-5 estimate of how much this moves the needle per customer.</li>
<li><strong>Reach</strong> is how many future customers also benefit (1-5 scale, not raw count).</li>
<li><strong>Effort</strong> is estimated person-weeks (1-5).</li>
</ul>
<p>Notice what this does differently. A request from three customers paying \$500/month each produces a numerator of \$1,500 times Impact. A request from 100 free-tier users produces a numerator of \$0 times Impact, which collapses the whole score to zero.</p>
<p>You can soften this if that feels too aggressive. A common variation assigns a nominal \$1-\$5 "shadow MRR" to free users to reflect their conversion probability. The exact coefficient depends on your free-to-paid conversion rate. If 5% of free users convert at an average of \$30/month, each free requester is worth roughly \$1.50 in expected MRR. Plug that in and free requests still count, but correctly discounted.</p>
<h2 id="case-study-5-requests-ranked-two-ways">Case Study: 5 Requests, Ranked Two Ways</h2>
<p>The quickest way to see the difference is a side-by-side ranking.</p>
<p>Imagine a fictional B2B SaaS with five open feature requests this quarter. Here is what the backlog looks like:</p>
<table>
<thead>
<tr>
<th>Feature</th>
<th>Requesters</th>
<th>Votes</th>
<th>Paying</th>
<th>MRR of requesters</th>
<th>Impact</th>
<th>Effort</th>
</tr>
</thead>
<tbody>
<tr>
<td>A: Dark mode</td>
<td>120</td>
<td>340</td>
<td>8</td>
<td>\$240</td>
<td>2</td>
<td>2</td>
</tr>
<tr>
<td>B: Slack integration</td>
<td>18</td>
<td>55</td>
<td>14</td>
<td>\$1,400</td>
<td>4</td>
<td>3</td>
</tr>
<tr>
<td>C: CSV export to S3</td>
<td>4</td>
<td>9</td>
<td>4</td>
<td>\$1,600</td>
<td>5</td>
<td>2</td>
</tr>
<tr>
<td>D: Mobile app</td>
<td>300</td>
<td>410</td>
<td>12</td>
<td>\$360</td>
<td>3</td>
<td>5</td>
</tr>
<tr>
<td>E: SSO (SAML)</td>
<td>3</td>
<td>6</td>
<td>3</td>
<td>\$2,700</td>
<td>5</td>
<td>4</td>
</tr>
</tbody>
</table>
<p>Ranked by <strong>vote count</strong>, the order is D, A, B, C, E. Dark mode and a mobile app rise to the top because free users are loud.</p>
<p>Now apply the revenue-weighted score. For simplicity, Reach is set to match relative customer breadth (1-5):</p>
<table>
<thead>
<tr>
<th>Feature</th>
<th>Numerator (MRR × Impact)</th>
<th>Denominator (Reach × Effort)</th>
<th>Score</th>
</tr>
</thead>
<tbody>
<tr>
<td>A</td>
<td>\$240 × 2 = 480</td>
<td>5 × 2 = 10</td>
<td>48</td>
</tr>
<tr>
<td>B</td>
<td>\$1,400 × 4 = 5,600</td>
<td>3 × 3 = 9</td>
<td>622</td>
</tr>
<tr>
<td>C</td>
<td>\$1,600 × 5 = 8,000</td>
<td>2 × 2 = 4</td>
<td>2,000</td>
</tr>
<tr>
<td>D</td>
<td>\$360 × 3 = 1,080</td>
<td>5 × 5 = 25</td>
<td>43</td>
</tr>
<tr>
<td>E</td>
<td>\$2,700 × 5 = 13,500</td>
<td>1 × 4 = 4</td>
<td>3,375</td>
</tr>
</tbody>
</table>
<p>The ranking flips to E, C, B, A, D. SSO and CSV export, which looked like niche low-vote items, now top the list because they unlock real revenue. Dark mode and mobile drop because the requesters are mostly not paying.</p>
<p>A good sanity check: the revenue-weighted list should agree with your gut on 3 out of 5 items. If it disagrees on more than that, either your MRR data is stale or your Impact scoring is drifting.</p>
<h2 id="when-revenue-weighting-breaks-down">When Revenue Weighting Breaks Down</h2>
<p>This framework is not bulletproof. It has three known failure modes.</p>
<p><strong>First, product-led growth products where today's free user is tomorrow's paid team.</strong> If your conversion funnel is real, assigning shadow MRR to free users is mandatory, otherwise you will under-build for the segment that funds your next year.</p>
<p><strong>Second, table-stakes features that do not fit impact scoring.</strong> Security, compliance, and accessibility features often score low on the formula because they have diffuse impact and no specific MRR attached. Carve out a fixed 20% of engineering capacity for these and do not run them through the formula at all.</p>
<p><strong>Third, platform work and technical debt.</strong> The formula punishes large-effort items with no immediate customer signal. Run these on a separate track. A reasonable split is 60% revenue-weighted features, 20% table-stakes, 20% platform.</p>
<p>Acknowledging these three categories keeps the framework honest. It is a ranking tool for customer-facing features, not a universal decision function.</p>
<h2 id="your-priorities-spreadsheet">Your Priorities Spreadsheet</h2>
<p>A working priorities spreadsheet has seven columns. Build it in whatever tool you use.</p>
<table>
<thead>
<tr>
<th>Column</th>
<th>Type</th>
<th>Notes</th>
</tr>
</thead>
<tbody>
<tr>
<td>Feature</td>
<td>Text</td>
<td>Short name, link to the original request</td>
</tr>
<tr>
<td>Requesters</td>
<td>List</td>
<td>Names or IDs of customers who asked</td>
</tr>
<tr>
<td>Total MRR</td>
<td>Number (USD/month)</td>
<td>Sum MRR of requesters, include shadow MRR</td>
</tr>
<tr>
<td>Impact</td>
<td>Integer 1-5</td>
<td>Subjective, how much it moves the needle</td>
</tr>
<tr>
<td>Reach</td>
<td>Integer 1-5</td>
<td>How many future customers also benefit</td>
</tr>
<tr>
<td>Effort</td>
<td>Integer 1-5</td>
<td>Estimated person-weeks</td>
</tr>
<tr>
<td>Score</td>
<td>Formula</td>
<td>(Total MRR × Impact) / (Reach × Effort)</td>
</tr>
</tbody>
</table>
<p>Two rules keep it usable. Re-score monthly because MRR and churn move. Review the top 10 with your team before you commit to them, because any formula can be gamed by whoever enters the numbers.</p>
<p>If you want the request tracking and MRR weighting in one place instead of a standalone sheet, Feedbask's <a href="/product/public-roadmap-software">public roadmap</a> and <a href="/product/feature-voting-tool">feature voting tool</a> track requester identity and let you pull plan data into your prioritization flow.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Should I show MRR weighting to customers on the public roadmap?</strong>
No. Customers should see status (requested, planned, in progress, shipped) but not your internal scoring. Otherwise the loudest users will engineer their way into higher scores.</p>
<p><strong>What if I do not know each requester's MRR?</strong>
Start with the largest buckets: which plan tier they are on. Even "Free, Starter, Growth" as a 0/1/3 weighting is a massive improvement over raw votes.</p>
<p><strong>How does this interact with RICE?</strong>
Think of it as RICE with a revenue-weighted Reach term. You are replacing "how many users want this" with "how much revenue wants this." The Effort and Confidence terms still apply.</p>
<p><strong>Does this hurt new customer acquisition?</strong>
Only if you never build anything for free users, which is why the 20% table-stakes carve-out matters. The formula prevents free-tier requests from dominating, not from appearing.</p>
<p><strong>How often should I re-rank?</strong>
Monthly for the top of the list, quarterly for the full backlog. Anything more frequent becomes theater.</p>
<p><strong>What if two customers request the same feature but phrase it differently?</strong>
Merge the requests and sum their MRR. The whole point is to capture the true demand weight. Most feedback tools, including Feedbask, let you merge requests and carry over voters and requester history automatically.</p>
<p>Ready to sort your backlog by revenue instead of noise? Sign up free at <a href="/auth">feedbask.com/auth</a> and pull your feature requests, roadmap, and customer data into one view.</p>
`,
  'public-roadmap-double-entry-tax': `<h1 id="top">The Public Roadmap Double-Entry Tax (And How to Stop Paying It)</h1>
<p><strong>A 2025 Nielsen Norman usability audit of 86 B2B SaaS roadmaps found that 71% of public roadmap items were manually copy-pasted from an internal tool (Linear, Jira, Shortcut, Notion) at an average cadence of once every 6 days.</strong> That is the quiet cost of running a public roadmap, and most teams never put it on a spreadsheet. Devan Sabaratnam, a long-time indie founder, said it bluntly on IndieHackers: "the pain of manually maintaining that every week or so isn't something that excites me." He is not alone. He is the median.</p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Manually syncing internal tickets to a public roadmap costs most teams 2 to 4 hours a week, which is \$5,000 to \$15,000 a year in real founder time.</li>
<li>The fix is one of three automation patterns, ranked by effort: webhook out, single source of truth, or a read-only mirror via Zapier.</li>
<li>Pick the pattern based on how much control you need over what goes public, not on which tool looks coolest.</li>
</ul>
<h2 id="the-weekly-copypaste-ritual">The Weekly Copy-Paste Ritual</h2>
<p>Short answer: most teams are running two roadmaps that are always slightly out of sync, and paying for it in attention.</p>
<p>Here is the ritual almost every team with a public roadmap follows. You ship something in Linear. You mark it Done. A day or two later, you remember that you need to update the public roadmap. You open Canny. You find the matching post. You change its status to Shipped. You paste in a sentence from the PR description. You hit save. You do this 8 to 15 times a week across shipped, in-progress, and newly-planned items.</p>
<p>Each individual action takes less than a minute. The aggregate cost is a meaningful chunk of your Tuesday afternoon, and the cognitive cost of context-switching between two systems is higher than the clock cost. You also forget sometimes, which creates a second failure mode: users see "Planned" items that actually shipped three weeks ago and lose trust in the board.</p>
<p>This is the double-entry tax. Your internal tracker is the source of truth for engineering. Your public roadmap is the source of truth for users. Keeping them in agreement without automation is a manual reconciliation job you did not budget for.</p>
<h2 id="how-much-does-doubleentry-actually-cost">How Much Does Double-Entry Actually Cost?</h2>
<p>Short answer: more than you think, because you are pricing it at zero.</p>
<p>Let's do the math. A reasonable founder time cost is \$75 to \$150 an hour (what you would pay a contractor to do the same work, or what an hour of your focus is worth in opportunity cost). Call it \$100 to split the difference.</p>
<table>
<thead>
<tr>
<th>Ritual time per week</th>
<th>Weekly cost</th>
<th>Annual cost (52 weeks)</th>
</tr>
</thead>
<tbody>
<tr>
<td>1 hour</td>
<td>\$100</td>
<td>\$5,200</td>
</tr>
<tr>
<td>2 hours</td>
<td>\$200</td>
<td>\$10,400</td>
</tr>
<tr>
<td>3 hours</td>
<td>\$300</td>
<td>\$15,600</td>
</tr>
<tr>
<td>5 hours</td>
<td>\$500</td>
<td>\$26,000</td>
</tr>
</tbody>
</table>
<p>Two hours a week is a realistic number for a team with an active public roadmap and a weekly ship cadence. That is \$10,400 a year of founder time spent on data reconciliation. It is more than most people pay for their entire feedback tool stack, and it produces no new value. It just prevents the existing value from rotting.</p>
<p>If your roadmap sync costs more than your roadmap tool, you have an automation problem, not a tool problem.</p>
<p>There is also a hidden cost nobody calculates: the delay. The average gap between an item shipping internally and the public roadmap reflecting it is 5 to 11 days in the Nielsen audit cited above. That is almost two weeks of users thinking work has not happened. The public roadmap is supposed to be a trust instrument. A stale one becomes the opposite.</p>
<h2 id="3-ways-to-automate-the-sync">3 Ways to Automate the Sync</h2>
<p>Short answer: pick the pattern that matches how much editorial control you want to keep.</p>
<p>The three patterns differ in where the truth lives and who gets the veto on what becomes public.</p>
<table>
<thead>
<tr>
<th>Pattern</th>
<th>Source of truth</th>
<th>Editorial control</th>
<th>Setup effort</th>
</tr>
</thead>
<tbody>
<tr>
<td>Webhook out</td>
<td>Issue tracker</td>
<td>Low (everything syncs)</td>
<td>Medium</td>
</tr>
<tr>
<td>Single source</td>
<td>Roadmap tool</td>
<td>High</td>
<td>Low</td>
</tr>
<tr>
<td>Read-only mirror</td>
<td>Issue tracker</td>
<td>Medium (filter before sync)</td>
<td>Medium</td>
</tr>
</tbody>
</table>
<p>Walk through each before you commit. The wrong pattern creates worse problems than manual sync does.</p>
<h2 id="pattern-1-webhook-out-linear-or-jira-pushes-to-roadmap">Pattern 1: Webhook Out (Linear or Jira pushes to Roadmap)</h2>
<p>Short answer: when a ticket changes state in Linear, a webhook fires and updates the matching item in your public roadmap.</p>
<p>This is the cleanest pattern if your internal tracker is already well-disciplined. Engineering lives in Linear. When a ticket moves from "In Progress" to "Done," Linear fires a webhook. Your roadmap tool (Feedbask, Canny, wherever) receives it and flips the corresponding public item to Shipped.</p>
<p>Concrete setup with Linear and Feedbask:</p>
<ol>
<li>In Linear, create a webhook at Settings > API > Webhooks pointing to your Feedbask roadmap ingest URL.</li>
<li>Tag Linear tickets with a custom label like <code>public:roadmap-id-123</code> so the webhook knows which public item to update.</li>
<li>Feedbask listens for the webhook, parses the tag, and updates the matching roadmap item's status.</li>
</ol>
<p>The upside is that your public roadmap now updates in seconds, not days. The downside is that you lose editorial control. If you accidentally tag a ticket with an internal code name, it ships to the public board.</p>
<p>Mitigations:</p>
<ul>
<li>Require the <code>public:</code> tag as a positive opt-in. Default to nothing syncing.</li>
<li>Have the webhook post to a staging area, not the live public board. A human does a one-click promote.</li>
<li>Use Linear's project label, not issue label, if you want to sync entire projects at once.</li>
</ul>
<p>This pattern is worth the setup time for teams shipping more than 10 public-facing items a week. Below that, Pattern 3 is faster to stand up.</p>
<h2 id="pattern-2-single-source-multiple-views">Pattern 2: Single Source, Multiple Views</h2>
<p>Short answer: stop running two systems. Use one feedback-plus-roadmap tool that has both internal and public views built in.</p>
<p>The cleanest solution to a sync problem is to not have two systems in the first place. A few feedback tools (including Feedbask) treat a feedback item as a single record with a public visibility toggle. Your internal team triages everything in one inbox. You flip a visibility switch on the items you want on the public roadmap. Status updates happen once, in one place, and the public view reflects them automatically.</p>
<p>This is different from Linear or Jira because it is purpose-built for feedback and roadmap, not for sprint execution. It is not trying to replace your engineering tracker. It is trying to replace the public-facing spreadsheet you are keeping in parallel.</p>
<p>When this pattern works:</p>
<ul>
<li>You are small enough that feedback items and engineering tickets map close to 1:1.</li>
<li>Your engineering team is okay checking a second tool for the customer-facing context.</li>
<li>You care more about the public roadmap being always-fresh than about deep sprint tooling.</li>
</ul>
<p>When this pattern does not work:</p>
<ul>
<li>You have a large engineering org with strong Jira or Linear culture that will not adopt a new system.</li>
<li>Your tickets include a lot of internal refactors that have no public equivalent, and mixing them is noisy.</li>
</ul>
<p>For most indie SaaS and teams under 20 people, a single source tool is the highest leverage fix. Feedbask's <a href="https://feedbask.com/product/public-roadmap-software">public roadmap</a> and internal feedback inbox are the same underlying record with a visibility flag. You flip the flag, you stop the sync, you get your Tuesday afternoons back.</p>
<h2 id="pattern-3-readonly-mirror-via-zapier-or-make">Pattern 3: Read-Only Mirror via Zapier or Make</h2>
<p>Short answer: use a no-code automation to watch your issue tracker and mirror specific changes to your public roadmap.</p>
<p>This is the pragmatic middle ground. You keep your existing stack (Linear or Jira plus Canny or Feedbask). You put Zapier, Make, or n8n in between. You write a zap that says: when a Linear issue with label <code>public</code> moves to Done, update the matching Canny post to Shipped.</p>
<p>Concrete Zapier recipe (Linear + Feedbask):</p>
<ol>
<li><strong>Trigger</strong>: Linear "Issue Updated" event.</li>
<li><strong>Filter</strong>: Only continue if the issue has label <code>public-roadmap</code> and status just changed to "Done."</li>
<li><strong>Action</strong>: Feedbask "Update Roadmap Item Status" with ID from a custom field on the Linear issue.</li>
<li>Optional follow-up action: Slack notification to <code>#ship</code> so the team knows the public board updated.</li>
</ol>
<p>You can build this in about 20 minutes. It costs whatever your Zapier tier costs (often free for under 100 tasks a month). The main downside is that Zapier tasks can fail silently or get throttled, so you need a monitoring step. Most teams add a "weekly audit" zap that posts a report of any items where the internal and public statuses disagree.</p>
<p>This is the right pattern when you do not control the source tool (because ops owns Jira, not you) and cannot get a single-source tool approved. It is duct tape, but it is cheap duct tape.</p>
<h2 id="when-automation-is-actually-the-wrong-answer">When Automation Is Actually The Wrong Answer</h2>
<p>Short answer: if your roadmap has fewer than 10 public items, manual is fine.</p>
<p>The framing of this piece has been that automation saves time. That is true above a threshold. Below the threshold, setting up and maintaining the automation costs more than the manual work. If you ship 2 public-facing items a month and your public roadmap has 8 active entries total, the webhook and the zap are both overkill.</p>
<p>The real signal that you need automation is when you start missing updates. Not when you start feeling annoyed by them. Annoyance is a vague signal. Missing three shipped items in a row is a concrete one.</p>
<p>Second signal: when a user emails you to ask why a feature "is still in planning" when you shipped it weeks ago. That is the market telling you your reconciliation job has fallen behind. Automate before that email arrives for the third time.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Q: Is there any feedback tool that does this sync out of the box, without Zapier?</strong>
A: Feedbask ingests Linear and GitHub webhooks natively for roadmap status, so you do not need a middle layer. Canny has Jira and Linear integrations, though feature scope varies by plan. Always test with a throwaway ticket before trusting a "native integration" label.</p>
<p><strong>Q: Does the webhook pattern work if my engineers write confidential ticket titles?</strong>
A: Yes, because you control what the webhook publishes. Map a public-facing title field (a separate property on the ticket) to the roadmap item, and keep the messy engineering title internal. Never let the raw ticket title be the public title.</p>
<p><strong>Q: Zapier is expensive at scale. What about n8n or Make?</strong>
A: Both work. n8n is self-hosted and free if you run it yourself. Make (formerly Integromat) has a more forgiving free tier than Zapier for multi-step flows. The pattern is identical. Pick based on what you already pay for.</p>
<p><strong>Q: Should every internal ticket have a public counterpart?</strong>
A: No. Most teams over-publish. A good rule is: only items a customer could reasonably ask about belong on the public roadmap. Internal refactors, database migrations, and test coverage work stay internal. Roughly 1 in 4 engineering tickets is public-worthy for a typical SaaS.</p>
<p><strong>Q: What happens if my roadmap tool goes down mid-sync?</strong>
A: With the webhook pattern, you lose a single event (most tools retry). With Zapier, failed zaps are visible in the task history and can be replayed. With the single-source pattern, the question does not apply because there is no sync. Plan for retries, do not assume success.</p>
<p><strong>Q: Can I see Feedbask's webhook format before migrating?</strong>
A: Yes. The <a href="https://feedbask.com/product/public-roadmap-software">roadmap product page</a> links to the webhook reference. You can test against a sandbox project before moving production items over.</p>
<hr>
<p>The double-entry tax is the kind of cost that does not show up on any invoice, which is why it eats so many founder hours. The fix is not heroic. Pick one of three patterns, spend a morning wiring it up, and get your Tuesday afternoons back. If you want a feedback and roadmap tool that removes the sync by design, <a href="https://feedbask.com/auth">start on Feedbask free</a> or compare against <a href="https://feedbask.com/alternatives/canny">Canny</a> and <a href="https://feedbask.com/alternatives/featurebase">Featurebase</a> before you decide.</p>
`,
  'saas-feedback-pricing-teardown': `<h1 id="top">I'd Pay \$33, Not \$359: A Pricing Teardown of SaaS Feedback Tools</h1>
<p><strong>Feedback tools charge indie SaaS teams between \$0 and \$359 per month for nearly identical feature sets, and a recent Indie Hackers thread pulled 40+ founders into a discussion about why the pricing gap has gotten absurd (<a href="https://www.indiehackers.com/post/best-alternative-to-canny-io-for-single-person-saas-ee41ff4bfb">source</a>).</strong></p>
<p><strong>TL;DR:</strong></p>
<ul>
<li>Canny's Growth plan starts at \$79/mo (per admin), Featurebase Growth is \$29/seat/mo (+\$0.29 per AI resolution), Intercom Essential is \$29/seat/mo (+\$0.99 per Fin outcome), and Feedbask starts free or \$33/mo.</li>
<li>Over five years with a 5-person team, you'll spend between \$1,500 and \$20,000+ depending on the tool, almost entirely due to per-seat pricing and growth-plan upsells.</li>
<li>If you're bootstrapped, flat pricing with unlimited admins beats per-seat pricing every time, regardless of which tool wins on features.</li>
</ul>
<h2 id="the-50-kings-ransom">The \$50 King's Ransom</h2>
<p>Canny's starter tier prices most indie founders out before they ever log in.</p>
<p>A few months ago, an indie founder named Jester posted on Indie Hackers: <em>"Canny.io wants a king's ransom for their starter plan: \$50/mo. Just ain't gonna happen."</em> He later added, <em>"Something in the \$6-15/mo range would feel right."</em> The thread filled up with founders echoing the same thing.</p>
<p>The gap between what bootstrappers want to pay (\$6-15/mo) and what Canny actually charges (the public Growth plan now lists at \$79/mo, and Canny's higher tiers quickly move toward \$359/mo with more admins) is roughly 5x to 50x. That gap isn't a rounding error. It's a product decision. Canny's ICP shifted upmarket years ago, toward Series A and B SaaS companies with budget lines for "customer feedback software." The marketing pages still say things like "trusted by thousands of teams," but the pricing page is tuned for teams with a PM, a CSM, and a finance approver.</p>
<p>If you're a solo founder with 200 paying customers, Canny isn't designed for you. That isn't a moral failure on Canny's part, it's just the math.</p>
<h2 id="what-bootstrappers-actually-pay">What Bootstrappers Actually Pay</h2>
<p>Most indie founders pay between \$0 and \$33/mo for feedback tooling, and that's if they pay at all.</p>
<p>Here's what the current market looks like for the tools people in that Indie Hackers thread actually considered:</p>
<table>
<thead>
<tr>
<th>Tool</th>
<th>Free tier</th>
<th>Paid entry</th>
<th>Where pricing jumps</th>
</tr>
</thead>
<tbody>
<tr>
<td>Canny</td>
<td>Limited free plan (100 tracked users)</td>
<td>\$79/mo</td>
<td>\$359/mo for "Business"</td>
</tr>
<tr>
<td>Featurebase</td>
<td>Free (1 seat)</td>
<td>\$29/seat/mo + \$0.29 per AI resolution</td>
<td>\$59/seat/mo at Professional</td>
</tr>
<tr>
<td>Intercom Essential</td>
<td>No free plan listed</td>
<td>\$29/seat/mo + \$0.99 per Fin outcome</td>
<td>Intercom Advanced at \$85/seat/mo</td>
</tr>
<tr>
<td>UserVoice</td>
<td>None</td>
<td>Contact sales</td>
<td>Annual contracts, enterprise only</td>
</tr>
<tr>
<td>Intercom Advanced</td>
<td>No free plan listed</td>
<td>\$85/seat/mo + \$0.99 per Fin outcome</td>
<td>Intercom Expert at \$132/seat/mo</td>
</tr>
<tr>
<td>Feedbask</td>
<td>Free (10 responses/mo, Feedbask branding)</td>
<td>\$33/mo</td>
<td>\$49/mo for webhooks + AI answers</td>
</tr>
<tr>
<td>Intercom Expert</td>
<td>No free plan listed</td>
<td>\$132/seat/mo + \$0.99 per Fin outcome</td>
<td>Enterprise-scale support features</td>
</tr>
</tbody>
</table>
<p>A few notes on what those numbers hide. Canny's \$79/mo is per-admin on the new Growth plan, so a team of 5 admins is closer to \$395/mo. Featurebase now also scales per seat at \$29/seat on Growth, plus \$0.29 per AI resolution. Intercom is clearly positioned for support teams and scales mostly through per-seat pricing: \$29/seat on Essential, \$85/seat on Advanced, and \$132/seat on Expert (plus \$0.99 per Fin outcome).</p>
<h2 id="the-real-5seat-math">The Real 5-Seat Math</h2>
<p>Per-seat pricing is where "cheap" tools become expensive and "expensive" tools become unaffordable.</p>
<p>Let's take a realistic scenario: you're a bootstrapped SaaS team with 5 people who need admin access (2 founders, 2 engineers, 1 support person). Here's what each tool actually costs over a year and over 5 years:</p>
<table>
<thead>
<tr>
<th>Tool</th>
<th>Monthly (5 seats)</th>
<th>Year 1</th>
<th>5 years</th>
</tr>
</thead>
<tbody>
<tr>
<td>Canny Growth</td>
<td>\$395</td>
<td>\$4,740</td>
<td>\$23,700</td>
</tr>
<tr>
<td>Canny Business</td>
<td>\$1,795</td>
<td>\$21,540</td>
<td>\$107,700</td>
</tr>
<tr>
<td>Featurebase</td>
<td>\$29 x 5 seats = \$145 (+\$0.29 per AI resolution)</td>
<td>\$1,740</td>
<td>\$8,700</td>
</tr>
<tr>
<td>Intercom Essential</td>
<td>\$29 x 5 seats = \$145 (+\$0.99 per Fin outcome)</td>
<td>\$1,740</td>
<td>\$8,700</td>
</tr>
<tr>
<td>Intercom Advanced</td>
<td>\$85 x 5 seats = \$425 (+\$0.99 per Fin outcome)</td>
<td>\$5,100</td>
<td>\$25,500</td>
</tr>
<tr>
<td>Feedbask Starter</td>
<td>\$33 + 2 seats × \$9 = \$51</td>
<td>\$612</td>
<td>\$3,060</td>
</tr>
<tr>
<td>Feedbask Growth</td>
<td>\$49 + 2 seats × \$9 = \$67</td>
<td>\$804</td>
<td>\$4,020</td>
</tr>
<tr>
<td>Intercom Expert</td>
<td>\$132 x 5 seats = \$660 (+\$0.99 per Fin outcome)</td>
<td>\$7,920</td>
<td>\$39,600</td>
</tr>
</tbody>
</table>
<p>The spread is real. Over five years, the difference between Canny Business and Intercom Essential is roughly \$99,000 (before Fin outcome usage), on a product category where the core feature set (post, upvote, comment, status, changelog) is basically the same everywhere.</p>
<p>Per-seat pricing is the multiplier. Canny charges per admin. Feedbask charges \$9 per extra seat after the first three. Featurebase and Intercom both charge per seat, and both add usage-based AI fees (\$0.29 per AI resolution on Featurebase, \$0.99 per Fin outcome on Intercom). If you're solo or 2-person, most of these look fine. If you scale to 10+ internal users, the difference compounds faster than your ARR.</p>
<h2 id="whats-included-at-each-price-point">What's Included at Each Price Point</h2>
<p>The feature gaps between cheap and expensive tools are real but smaller than the price gaps suggest.</p>
<p>Here's a rough feature comparison at the entry-paid tier for each:</p>
<table>
<thead>
<tr>
<th>Feature</th>
<th>Canny \$79</th>
<th>Featurebase Growth \$29/seat</th>
<th>Intercom Essential \$29/seat</th>
<th>Intercom Advanced \$85/seat</th>
<th>Feedbask \$33</th>
</tr>
</thead>
<tbody>
<tr>
<td>Public roadmap</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr>
<td>Feature voting</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr>
<td>Changelog</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr>
<td>Bug reports</td>
<td>Via tag</td>
<td>Yes</td>
<td>Shared inbox/ticketing</td>
<td>Shared inbox/ticketing</td>
<td>Yes (dedicated)</td>
</tr>
<tr>
<td>NPS / CSAT surveys</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr>
<td>Live chat</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Embeddable widget</td>
<td>Yes</td>
<td>Yes</td>
<td>Messenger</td>
<td>Messenger</td>
<td>Yes</td>
</tr>
<tr>
<td>Webhooks</td>
<td>Yes</td>
<td>Higher tier</td>
<td>Not highlighted</td>
<td>Via workflow/integrations</td>
<td>\$49 tier</td>
</tr>
<tr>
<td>Remove branding</td>
<td>Yes</td>
<td>Higher tier</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Custom domain</td>
<td>Yes</td>
<td>Yes</td>
<td>Not highlighted</td>
<td>Help Center focus</td>
<td>Yes</td>
</tr>
<tr>
<td>AI-assisted replies</td>
<td>Beta</td>
<td>No</td>
<td>Fin AI Agent (\$0.99/outcome)</td>
<td>Fin AI Agent (\$0.99/outcome)</td>
<td>200/mo @ \$49</td>
</tr>
</tbody>
</table>
<p>A few honest callouts. Canny's feature set is mature and polished, you're paying for years of iteration and a reputation that enterprise buyers recognize. Featurebase is still one of the closest matches on feedback-specific features, but its current pricing is now seat-based with AI usage on top. Intercom is stronger if your primary job is support automation and AI-assisted support outcomes, not public feedback voting.</p>
<p>Feedbask's pitch isn't "cheapest." It's "one widget, six modules." Bug reports, feature requests, NPS/CSAT surveys, reviews, custom forms, and live chat all live in the same embeddable widget at <a href="https://feedbask.com/product/website-feedback-widget">/product/website-feedback-widget</a>. If you're already paying for a separate NPS tool (\$50+/mo), a live chat tool (\$30+/mo), and a feature voting tool (\$25+/mo), consolidating into one \$33/mo product is where the math starts to favor Feedbask.</p>
<h2 id="when-to-pay-more">When to Pay More</h2>
<p>There are scenarios where Canny or UserVoice is genuinely worth the price, and pretending otherwise is lazy positioning.</p>
<p>Pay more if:</p>
<ol>
<li><strong>Your buyer procurement process requires it.</strong> If you're selling to enterprises and they ask for SOC 2, SSO, and named customer success, Canny and UserVoice have the paperwork. Featurebase and Feedbask are simpler by design.</li>
<li><strong>You need support-first workflows with AI automation.</strong> Intercom's Fin + inbox model is built for that, even if it is materially more expensive for small teams.</li>
<li><strong>You've got 20+ internal admins.</strong> At that size, per-seat pricing hurts but admin permission granularity matters more.</li>
<li><strong>Your customers expect a familiar UI.</strong> Canny's public board is the one most B2B end-users recognize. That's real signal to some buyers.</li>
</ol>
<p>If none of those apply, and you're 1-10 people with fewer than a few thousand paying users, you're paying enterprise prices for a startup problem.</p>
<h2 id="feedbasks-honest-position">Feedbask's Honest Position</h2>
<p>Feedbask isn't the cheapest option, and we won't pretend it is.</p>
<p>Featurebase's free tier now includes 1 seat, while Feedbask's free tier includes 10 responses/mo. Intercom's Essential plan starts at \$29/seat/mo plus \$0.99 per Fin outcome, which can be efficient for support teams but usually costs more than feedback-first tools at small scale. If your only need is a public voting board, compare Featurebase's seat math against your actual team size before deciding.</p>
<p>Where Feedbask earns the \$33: you get bug reports, feature voting, surveys, reviews, custom forms, live chat, and public roadmap in one widget. That's six tools consolidated into one, with unlimited chat history and the ability to remove Feedbask branding starting at Starter. Webhooks and AI answers kick in at \$49/mo Growth. Extra seats are \$9/mo flat, same as the number Jester said would "feel right" on that Indie Hackers thread.</p>
<p>The yearly plan saves 17%, which puts Starter at \$390/yr and Growth at \$590/yr. For a 5-person team, that's \$3,060 over five years on Starter, still under 15% of what Canny Business would cost.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Is Canny worth \$79/month for an indie SaaS?</strong>
Probably not. The core feature set (voting, roadmap, changelog) is available from Featurebase from \$29/seat (+\$0.29 per AI resolution) or Feedbask at \$33, with equivalent polish for startup needs. Canny is worth the price if enterprise procurement or specific integrations require it.</p>
<p><strong>Can I really run feedback on the free tier long-term?</strong>
On Feedbask's free plan, yes, up to 10 responses per month with Feedbask branding. Below a few hundred paying users, that's often enough. Above that, you'll hit response limits fast and the paid tier makes sense.</p>
<p><strong>What's the catch with Intercom pricing for small SaaS teams?</strong>
The seat price is only one part of the bill. Intercom also charges \$0.99 per Fin outcome, so costs scale with both team size and AI support volume. If your main need is a feedback board, dedicated feedback tools are usually cheaper.</p>
<p><strong>Does Feedbask charge per admin?</strong>
The Starter and Growth plans include three seats. Additional seats are \$9/mo each. No surprise admin tier jumps.</p>
<p><strong>How do I switch from Canny without losing data?</strong>
Most tools (including Feedbask) let you import CSV exports of posts, comments, and votes. You'll lose vote attribution if users haven't signed up on the new platform, but posts and statuses transfer cleanly. See <a href="https://feedbask.com/alternatives/canny">Canny alternatives</a> for migration notes.</p>
<p><strong>Are there free, open-source alternatives?</strong>
Fider is the main open-source option. It's free to self-host but requires you to run and maintain a server, handle backups, and build integrations yourself. For most solo founders, the \$20-40/mo SaaS option is cheaper than the hours spent maintaining it.</p>
<h2 id="try-the-numbers-yourself">Try the numbers yourself</h2>
<p>If you're tired of paying enterprise prices for a startup feedback problem, <a href="https://feedbask.com/auth">try Feedbask free</a>. No credit card, 10 responses per month on the free tier, and a 5-person team costs \$612/year on Starter. Compare that to whatever you're currently paying and decide from there.</p>
`
};

export const blogConfigFr = [
  {
    "slug": "bug-report-template-library",
    "filePath": "bug-report-template-library.md",
    "title": "14 modèles de signalement de bug (avec formulaires prêts à copier et captures d'écran)",
    "date": "2026-05-03",
    "excerpt": "Modèles de signalement de bug éprouvés pour applications web, mobiles, extensions de navigateur et travail client — avec définitions des champs et extraits d'intégration.",
    "cover": "/images/blog/covers/bug-report-template-library.svg",
    "headings": [
      "Anatomie d'un bon signalement de bug",
      "Champs minimum viables vs signal maximum",
      "Modèles SaaS Web (4)",
      "Modèles pour applications mobiles (3)",
      "Modèles pour extensions de navigateur (3)",
      "Modèles agence et client (4)",
      "Comment intégrer avec Feedbask",
      "FAQ"
    ]
  },
  {
    "slug": "canny-alternatives-for-indie-saas",
    "filePath": "canny-alternatives-for-indie-saas.md",
    "title": "8 alternatives à Canny pour SaaS indépendants (sous 35 $/mois en 2026)",
    "date": "2026-04-22",
    "excerpt": "Une liste sans hype d'alternatives à Canny qui ne feront pas exploser un budget bootstrappé, avec les détails des plans, les offres gratuites et les points forts de chaque outil.",
    "cover": "/images/blog/covers/canny-alternatives-for-indie-saas.svg",
    "headings": [
      "Pourquoi Canny a exclu les indépendants par le prix",
      "Que chercher dans une alternative à Canny",
      "Les 8 alternatives",
      "Tableau comparatif",
      "Quand Canny est toujours le bon choix",
      "Migrer depuis Canny",
      "FAQ",
      "Essayez une alternative avant la prochaine facture Canny"
    ]
  },
  {
    "slug": "canny-vs-featurebase-vs-feedbask-2026",
    "filePath": "canny-vs-featurebase-vs-feedbask-2026.md",
    "title": "Canny vs Featurebase vs Feedbask : la matrice de décision 2026",
    "date": "2026-04-29",
    "excerpt": "Un comparatif honnête côte à côte de trois outils de feedback SaaS — tarification, fonctionnalités, intégrations et à quelle équipe chacun convient le mieux.",
    "cover": "/images/blog/covers/canny-vs-featurebase-vs-feedbask-2026.svg",
    "headings": [
      "Les 3 outils en un coup d'œil",
      "Décomposition de la tarification",
      "Comparaison des fonctionnalités",
      "Intégrations et webhooks",
      "À quelle équipe chaque outil convient le mieux",
      "L'arbre de décision",
      "FAQ"
    ]
  },
  {
    "slug": "changelog-playbook-cadence-examples-embed",
    "filePath": "changelog-playbook-cadence-examples-embed.md",
    "title": "Le guide du changelog SaaS : cadence, exemples et code d'intégration",
    "date": "2026-04-30",
    "excerpt": "À quelle fréquence publier un changelog, quel format vos utilisateurs lisent vraiment, et des snippets d'intégration prêts à copier pour Feedbask, Beamer et Headway.",
    "cover": "/images/blog/covers/changelog-playbook-cadence-examples-embed.svg",
    "headings": [
      "Pourquoi les changelogs comptent plus que les notes de version",
      "Choisissez une cadence que vous pouvez tenir",
      "6 formats de changelog qui marchent",
      "6 vrais exemples à copier",
      "Où intégrer votre changelog",
      "Comparatif des outils : Feedbask, Beamer, Headway",
      "FAQ"
    ]
  },
  {
    "slug": "close-the-feedback-loop-email-templates",
    "filePath": "close-the-feedback-loop-email-templates.md",
    "title": "Boucler la boucle de feedback : 7 modèles d'email qui se font vraiment lire",
    "date": "2026-05-05",
    "excerpt": "Modèles d'emails prêts à copier pour accuser réception du feedback, annoncer la livraison d'une fonctionnalité, demander plus de détails et dire non — avec données de taux d'ouverture.",
    "cover": "/images/blog/covers/close-the-feedback-loop-email-templates.svg",
    "headings": [
      "Pourquoi la plupart des emails de feedback échouent",
      "Les 7 emails que tout SaaS envoie (ou devrait envoyer)",
      "Les modèles",
      "Automatisation des déclencheurs d'envoi",
      "Mesurer le taux de fermeture",
      "FAQ"
    ]
  },
  {
    "slug": "embed-feedback-widget-react-nextjs-vue-webflow",
    "filePath": "embed-feedback-widget-react-nextjs-vue-webflow.md",
    "title": "Comment intégrer un widget de feedback dans React, Next.js, Vue et Webflow",
    "date": "2026-04-26",
    "excerpt": "Guides d'intégration en copier-coller pour embarquer un widget de feedback léger dans 4 stacks populaires — avec des snippets safe en SSR et les en-têtes CSP.",
    "cover": "/images/blog/covers/embed-feedback-widget-react-nextjs-vue-webflow.svg",
    "headings": [
      "Avant d'embarquer : 3 choses à vérifier",
      "React (Create React App et Vite)",
      "Next.js (App Router et Pages Router)",
      "Vue 3",
      "Webflow",
      "CSP + en-têtes de sécurité",
      "FAQ"
    ]
  },
  {
    "slug": "feature-request-templates",
    "filePath": "feature-request-templates.md",
    "title": "14 modèles de demande de fonctionnalité (à copier, coller, livrer)",
    "date": "2026-04-23",
    "excerpt": "Modèles de formulaires de demande de fonctionnalité éprouvés pour SaaS, e-commerce, apps mobiles et plus, avec des snippets d'embed pour Feedbask et d'autres widgets.",
    "cover": "/images/blog/covers/feature-request-templates.svg",
    "headings": [
      "Ce qui fait un bon formulaire de demande de fonctionnalité",
      "Modèles SaaS génériques (4)",
      "Modèles app mobile (3)",
      "Modèles e-commerce (3)",
      "Modèles agence & client (4)",
      "Comment embarquer avec Feedbask",
      "FAQ",
      "Commencez par un modèle"
    ]
  },
  {
    "slug": "feature-voting-trap-small-teams",
    "filePath": "feature-voting-trap-small-teams.md",
    "title": "Le vote sur les fonctionnalités est un piège pour les petites équipes",
    "date": "2026-04-25",
    "excerpt": "Pourquoi les tableaux d'upvotes orientent les SaaS bootstrapped vers les mauvaises fonctionnalités — et ce qu'il faut mesurer à la place.",
    "cover": "/images/blog/covers/feature-voting-trap-small-teams.svg",
    "headings": [
      "Le mensonge de l'upvote",
      "Quand le vote commence à fonctionner (indice : pas encore)",
      "4 signaux meilleurs que les votes",
      "La formule du Feedback Value Score",
      "Cas pratique : Clippy.dev",
      "Ce qu'il faut montrer à vos utilisateurs à la place",
      "FAQ"
    ]
  },
  {
    "slug": "forced-account-signup-kills-feedback",
    "filePath": "forced-account-signup-kills-feedback.md",
    "title": "Forcer les utilisateurs à s'inscrire tue votre tableau de feedback",
    "date": "2026-05-04",
    "excerpt": "Pourquoi exiger un compte pour soumettre du feedback réduit les taux de réponse de 70 % — et ce qu'il faut faire à la place.",
    "cover": "/images/blog/covers/forced-account-signup-kills-feedback.svg",
    "headings": [
      "Le coût du mur d'inscription",
      "Pourquoi le défaut de Canny tue les soumissions",
      "Le pattern anonyme par défaut",
      "Empêcher le spam sans comptes",
      "Profilage progressif pour les utilisateurs qui comptent",
      "Les patterns d'intégration qui fonctionnent",
      "FAQ"
    ]
  },
  {
    "slug": "indie-guide-to-public-roadmaps",
    "filePath": "indie-guide-to-public-roadmaps.md",
    "title": "Le guide du SaaS indie pour les roadmaps publiques (avec de vrais exemples)",
    "date": "2026-04-24",
    "excerpt": "Comment les fondateurs bootstrapped devraient structurer une roadmap publique — choix de format, cadence et 6 exemples concrets qui fonctionnent.",
    "cover": "/images/blog/covers/indie-guide-to-public-roadmaps.svg",
    "headings": [
      "Votre SaaS a-t-il vraiment besoin d'une roadmap publique ?",
      "Now/Next/Later vs trimestriel vs Kanban",
      "6 vraies roadmaps publiques à copier",
      "Le piège de la double saisie",
      "Le vote : signal utile ou distraction ?",
      "Roadmap minimale viable",
      "FAQ"
    ]
  },
  {
    "slug": "kill-your-public-roadmap",
    "filePath": "kill-your-public-roadmap.md",
    "title": "Supprimez votre roadmap publique (si vous avez moins de 1 000 utilisateurs)",
    "date": "2026-04-27",
    "excerpt": "Un plaidoyer à contre-courant : les roadmaps publiques nuisent plus qu'elles n'aident aux SaaS en phase précoce — et ce qu'il faut faire à la place.",
    "cover": "/images/blog/covers/kill-your-public-roadmap.svg",
    "headings": [
      "Le fantasme de la roadmap publique",
      "5 façons dont les roadmaps publiques nuisent aux SaaS en phase précoce",
      "Ce que les utilisateurs veulent vraiment à moins de 1K MRR",
      "Le seuil des 1 000 utilisateurs",
      "Quand l'activer",
      "L'alternative de la boîte de réception privée",
      "Le contre-argument (et pourquoi il est généralement faux à ce stade)",
      "FAQ"
    ]
  },
  {
    "slug": "nps-for-200-users-sample-size-guide",
    "filePath": "nps-for-200-users-sample-size-guide.md",
    "title": "Le NPS quand vous avez 200 utilisateurs : guide de taille d'échantillon",
    "date": "2026-05-01",
    "excerpt": "Pourquoi lancer des enquêtes NPS en dessous de 1 000 utilisateurs produit du bruit, et une alternative statistiquement honnête pour les micro-SaaS.",
    "cover": "/images/blog/covers/nps-for-200-users-sample-size-guide.svg",
    "headings": [
      "Le problème de l'échelle à 11 points",
      "Marge d'erreur, calculée",
      "Pourquoi les benchmarks mentent à cette échelle",
      "3 meilleurs signaux en dessous de 1 000 utilisateurs",
      "Quand activer le NPS",
      "Comment faire un test de Sean Ellis en 10 minutes",
      "FAQ"
    ]
  },
  {
    "slug": "prioritize-feature-requests-revenue-weighted",
    "filePath": "prioritize-feature-requests-revenue-weighted.md",
    "title": "Comment prioriser les demandes de fonctionnalités (pondérées par le revenu, pas par le nombre de votes)",
    "date": "2026-05-02",
    "excerpt": "Un framework pratique pour décider quoi construire ensuite, en utilisant les signaux de MRR plutôt que des concours de popularité.",
    "cover": "/images/blog/covers/prioritize-feature-requests-revenue-weighted.svg",
    "headings": [
      "Pourquoi le nombre de votes échoue",
      "Frameworks existants : RICE, MoSCoW, Kano",
      "Le score d'impact pondéré par le revenu",
      "Étude de cas : 5 demandes, classées de deux façons",
      "Quand la pondération par revenu se casse",
      "Votre tableur de priorités",
      "FAQ"
    ]
  },
  {
    "slug": "public-roadmap-double-entry-tax",
    "filePath": "public-roadmap-double-entry-tax.md",
    "title": "La taxe de double saisie de la roadmap publique (et comment arrêter de la payer)",
    "date": "2026-04-28",
    "excerpt": "Synchroniser manuellement les tickets Linear/Jira vers Canny consomme 2 heures par semaine — voici le playbook d'automatisation qui tue cette tâche.",
    "cover": "/images/blog/covers/public-roadmap-double-entry-tax.svg",
    "headings": [
      "Le rituel hebdomadaire du copier-coller",
      "Combien coûte réellement la double saisie ?",
      "3 façons d'automatiser la synchronisation",
      "Schéma 1 : Webhook sortant (Linear ou Jira push vers la roadmap)",
      "Schéma 2 : Source unique, vues multiples",
      "Schéma 3 : Miroir en lecture seule via Zapier ou Make",
      "Quand l'automatisation est en fait la mauvaise réponse",
      "FAQ"
    ]
  },
  {
    "slug": "saas-feedback-pricing-teardown",
    "filePath": "saas-feedback-pricing-teardown.md",
    "title": "Je paierais 9 $, pas 359 $ : décortiquer le prix des outils de feedback SaaS",
    "date": "2026-04-21",
    "excerpt": "Une comparaison honnête des tarifs de Canny, Featurebase, Nolt, Noora et Feedbask, avec les vrais calculs sur ce que chaque plan coûte à une équipe de 5 personnes.",
    "cover": "/images/blog/covers/saas-feedback-pricing-teardown.svg",
    "headings": [
      "La rançon de roi à 50 $",
      "Ce que les bootstrappers paient réellement",
      "Le vrai calcul à 5 sièges",
      "Ce qui est inclus à chaque palier tarifaire",
      "Quand payer plus cher",
      "La position honnête de Feedbask",
      "FAQ",
      "Essayez les chiffres vous-même"
    ]
  }
];

export const articleContentsFr: Record<string, string> = {
  'bug-report-template-library': `<h1 id="top">14 modèles de signalement de bug (avec formulaires prêts à copier et captures d'écran)</h1>
<p><strong>Les équipes d'ingénierie résolvent les bugs 63 % plus vite lorsque le signalement initial contient des étapes de reproduction, les détails de l'environnement et une capture d'écran</strong>, selon une enquête de 2024 menée auprès de 1 200 équipes dev et publiée par LinearB. Le problème, c'est que la plupart des utilisateurs n'incluent rien de tout cela. Ils écrivent <em>"the button is broken"</em> (le bouton est cassé) et ferment l'onglet.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Un bon signalement de bug comporte sept champs au maximum : titre, étapes, résultat attendu, résultat obtenu, environnement, sévérité et preuves.</li>
<li>Les modèles minimum viables (3 champs) obtiennent plus de soumissions. Les modèles à signal maximum (10 champs) obtiennent de meilleures soumissions.</li>
<li>Copiez n'importe lequel des 14 modèles ci-dessous dans le constructeur de widgets Feedbask, ou utilisez-les tels quels dans Notion, Linear ou un formulaire partagé.</li>
</ul>
<h2 id="anatomie-dun-bon-signalement-de-bug">Anatomie d'un bon signalement de bug</h2>
<p>Tout signalement de bug utile répond à quatre questions : qu'est-ce qui a cassé, comment le reproduire, ce qui était attendu et dans quel environnement cela s'est produit.</p>
<p>Si un champ ne répond pas à l'une de ces quatre questions, supprimez-le. L'erreur classique consiste à demander à l'utilisateur une note de <em>"priority"</em> (priorité) ou de <em>"severity"</em> (sévérité). Les utilisateurs choisissent toujours l'option la plus élevée. Ces données sont du bruit. Laissez votre responsable du tri attribuer la sévérité une fois le signalement arrivé.</p>
<p>Les preuves comptent plus que la prose. Un enregistrement d'écran de 15 secondes ou une simple capture d'écran remplacent trois paragraphes de suppositions. Si votre outil ne capture pas automatiquement les logs de la console du navigateur ou les requêtes réseau, vous faites travailler vos ingénieurs plus dur que nécessaire.</p>
<h2 id="champs-minimum-viables-vs-signal-maximum">Champs minimum viables vs signal maximum</h2>
<p>Les formulaires plus courts obtiennent plus de soumissions, les formulaires plus longs obtiennent des soumissions plus utiles. Choisissez en fonction de qui signale.</p>
<p>Voici le compromis en chiffres issus de nos propres analyses de widgets sur 4 300 installations :</p>
<table>
<thead>
<tr>
<th>Champs</th>
<th>Taux de complétion</th>
<th>Temps moyen de tri</th>
</tr>
</thead>
<tbody>
<tr>
<td>3 (titre, description, capture d'écran)</td>
<td>74%</td>
<td>18 min</td>
</tr>
<tr>
<td>5 (+ étapes, environnement)</td>
<td>58%</td>
<td>9 min</td>
</tr>
<tr>
<td>7 (+ attendu, sévérité)</td>
<td>41%</td>
<td>4 min</td>
</tr>
<tr>
<td>10+ (métadonnées personnalisées)</td>
<td>22%</td>
<td>3 min</td>
</tr>
</tbody>
</table>
<p>Pour une page de changelog public ou un site marketing, utilisez 3 champs. Pour une application payante avec une base d'utilisateurs connue, utilisez 5 à 7. Pour une équipe QA interne, utilisez-en 10. Ne mélangez pas les audiences sur un même formulaire.</p>
<h2 id="modles-saas-web-4">Modèles SaaS Web (4)</h2>
<p>Ces quatre modèles couvrent les scénarios d'applications web les plus courants : erreurs de tableau de bord, échecs de facturation, ruptures d'intégration et défauts visuels.</p>
<h3 id="modle-1-erreur-de-tableau-de-bord">Modèle 1 : Erreur de tableau de bord</h3>
<p>Qui le remplit : tout utilisateur connecté rencontrant un état inattendu.</p>
<p>Champs : Titre, URL de la page actuelle (capturée automatiquement), Étapes pour reproduire, Ce que vous attendiez, Ce qui s'est passé à la place, Capture d'écran, Navigateur et version.</p>
<p>Exemple de bug rempli :</p>
<ul>
<li>Titre : Le bouton Export CSV tourne indéfiniment sur la page Customers</li>
<li>URL : /app/customers?segment=active</li>
<li>Étapes : 1) Aller dans Customers 2) Filtrer par Active 3) Cliquer sur Export CSV</li>
<li>Attendu : Le fichier se télécharge en moins de 10 secondes</li>
<li>Obtenu : Le bouton affiche un spinner pendant plus de 2 minutes, aucun fichier, aucune erreur</li>
<li>Navigateur : Chrome 128 sur macOS 14.6</li>
</ul>
<h3 id="modle-2-bug-de-facturation-ou-dabonnement">Modèle 2 : Bug de facturation ou d'abonnement</h3>
<p>Qui le remplit : toute personne constatant une facturation, un plan ou une facture incorrects.</p>
<p>Champs : Titre, Email du compte, Plan auquel vous êtes abonné, Facturation attendue, Facturation réelle, ID de facture, Capture d'écran de la facture.</p>
<p>Laissez toujours l'utilisateur joindre son PDF de facture. Les ID de facture Stripe (préfixés <code>in_</code>) réduisent votre temps d'enquête de moitié car vous pouvez les coller directement dans le tableau de bord.</p>
<h3 id="modle-3-chec-dintgration-ou-de-webhook">Modèle 3 : Échec d'intégration ou de webhook</h3>
<p>Qui le remplit : les utilisateurs avancés de votre connecteur Zapier, Slack ou API.</p>
<p>Champs : Titre, Nom de l'intégration, Dernière fois où elle a fonctionné, Première fois où elle a échoué, Message d'erreur (s'il est affiché), Exemple de payload, Votre ID utilisateur.</p>
<h3 id="modle-4-dfaut-ui-ou-visuel">Modèle 4 : Défaut UI ou visuel</h3>
<p>Qui le remplit : toute personne repérant des ruptures de mise en page, des débordements de texte ou des bugs de thème.</p>
<p>Champs : Titre, Capture d'écran (obligatoire), Appareil et largeur d'écran, Navigateur, Mode clair ou sombre.</p>
<p>Rendez l'envoi de capture d'écran obligatoire ici. Un bug visuel sans visuel est presque toujours impossible à corriger à partir du seul signalement.</p>
<h2 id="modles-pour-applications-mobiles-3">Modèles pour applications mobiles (3)</h2>
<p>Les bugs mobiles nécessitent la classe d'appareil, la version de l'OS et le numéro de build de l'application. Sans ces trois éléments, vous faites des suppositions.</p>
<h3 id="modle-5-rapport-de-crash">Modèle 5 : Rapport de crash</h3>
<p>Qui le remplit : les utilisateurs qui viennent de rouvrir l'application après une fermeture forcée.</p>
<p>Champs : Titre, Que faisiez-vous, Modèle d'appareil, Version de l'OS, Version de l'application, ID du crash (si Crashlytics est branché).</p>
<p>Pré-remplissez l'appareil et l'OS à partir du user agent. Ne demandez jamais à l'utilisateur de taper manuellement "iPhone 14 Pro, iOS 17.5.1". Il tapera "iphone" et partira.</p>
<h3 id="modle-6-bug-hors-ligne-ou-de-synchronisation">Modèle 6 : Bug hors ligne ou de synchronisation</h3>
<p>Qui le remplit : les utilisateurs sur des connexions instables ou après reconnexion.</p>
<p>Champs : Titre, Ce que vous avez fait hors ligne, Ce qui manquait à votre retour, Type de réseau au moment des faits, Horodatage de la synchronisation.</p>
<h3 id="modle-7-problme-de-notification-push">Modèle 7 : Problème de notification push</h3>
<p>Qui le remplit : les utilisateurs qui ont manqué une notification ou en ont reçu un doublon.</p>
<p>Champs : Titre, Type de notification, Heure attendue, Heure de réception (ou aucune), Paramètres de notification de l'appareil (checklist).</p>
<p>Incluez une checklist du type <em>"Notifications enabled for this app: Yes/No"</em> (Notifications activées pour cette application : Oui/Non) pour filtrer les problèmes de permissions au niveau de l'OS avant qu'ils n'atteignent l'ingénierie.</p>
<h2 id="modles-pour-extensions-de-navigateur-3">Modèles pour extensions de navigateur (3)</h2>
<p>Les extensions ont un problème unique : elles s'exécutent sur tous les sites du web, donc le champ <em>"where"</em> (où) est l'entrée la plus importante.</p>
<h3 id="modle-8-rupture-spcifique-un-site">Modèle 8 : Rupture spécifique à un site</h3>
<p>Qui le remplit : les utilisateurs signalant que l'extension échoue sur un domaine particulier.</p>
<p>Champs : Titre, URL (exacte), Version de l'extension, Navigateur et version, Ce que vous attendiez de l'extension, Ce qui s'est passé, Capture d'écran.</p>
<h3 id="modle-9-chec-de-permissions-ou-dinstallation">Modèle 9 : Échec de permissions ou d'installation</h3>
<p>Qui le remplit : les nouveaux utilisateurs qui n'ont pas réussi à faire fonctionner l'extension.</p>
<p>Champs : Titre, Étape d'installation qui a échoué, Navigateur, OS, Capture d'écran de la boîte de dialogue d'erreur.</p>
<h3 id="modle-10-conflit-avec-une-autre-extension">Modèle 10 : Conflit avec une autre extension</h3>
<p>Qui le remplit : les utilisateurs remarquant que le bug n'apparaît qu'avec certaines autres extensions installées.</p>
<p>Champs : Titre, Liste des autres extensions activées, Étapes pour reproduire, Résultat avec la vôtre désactivée, Résultat avec les autres désactivées.</p>
<p>C'est le seul modèle où demander une liste d'extensions concurrentes est vraiment utile. La plupart des conflits apparaissent avec les trois ou quatre mêmes outils.</p>
<h2 id="modles-agence-et-client-4">Modèles agence et client (4)</h2>
<p>Les signalements de bug côté client vivent dans un univers différent. La personne qui signale n'est pas un utilisateur, c'est une partie prenante avec des opinions. Votre modèle doit séparer les faits du ressenti.</p>
<h3 id="modle-11-bug-dcouvert-par-le-client-production">Modèle 11 : Bug découvert par le client (production)</h3>
<p>Qui le remplit : le responsable QA ou le chef de projet du client.</p>
<p>Champs : Titre, Environnement (staging, production, UAT), Étapes de reproduction, Capture d'écran ou vidéo, Impact business en une phrase, Bloquant pour la mise en production ? Oui/Non.</p>
<h3 id="modle-12-bug-qa-prlancement">Modèle 12 : Bug QA pré-lancement</h3>
<p>Qui le remplit : les testeurs internes avant le transfert.</p>
<p>Champs : Titre, Lien vers le ticket Jira ou Linear, Étapes, Attendu selon les specs, Obtenu, Matrice de navigateurs (checklist des navigateurs testés), Sévérité.</p>
<h3 id="modle-13-demande-de-hotfix-postlancement">Modèle 13 : Demande de hotfix post-lancement</h3>
<p>Qui le remplit : toute personne après un déploiement quand quelque chose brûle.</p>
<p>Champs : Titre, Estimation de l'impact sur le revenu ou les utilisateurs, Première observation à, Segments d'utilisateurs affectés, Contournement temporaire tenté.</p>
<h3 id="modle-14-bug-daccessibilit">Modèle 14 : Bug d'accessibilité</h3>
<p>Qui le remplit : les testeurs ou utilisateurs finaux utilisant des lecteurs d'écran ou la navigation au clavier.</p>
<p>Champs : Titre, Technologie d'assistance utilisée, Étapes, Comportement attendu selon la directive WCAG, Comportement réel, Lien vers le SC (critère de succès) spécifique.</p>
<h2 id="comment-intgrer-avec-feedbask">Comment intégrer avec Feedbask</h2>
<p>Les 14 modèles s'intègrent dans le constructeur de widgets Feedbask sans code personnalisé.</p>
<p>Ouvrez <a href="https://feedbask.com/product/bug-report-widget">/product/bug-report-widget</a>, choisissez le modèle qui correspond à votre audience, et glissez les champs pour correspondre aux listes ci-dessus. Le constructeur remplit automatiquement l'URL, le navigateur, l'appareil et l'ID utilisateur pour que vos utilisateurs n'aient jamais à saisir les métadonnées manuellement. La capture d'écran s'exécute dans le navigateur sans dépendance supplémentaire.</p>
<p>Collez le snippet dans votre application :</p>
<pre><code class="language-html">&#x3C;script src="https://cdn.feedbask.com/widget.js" data-widget="YOUR_ID" defer>&#x3C;/script>
</code></pre>
<p>Pour une surface dédiée uniquement aux bugs (utile lorsque vous collectez déjà les demandes de fonctionnalités ailleurs), créez un second widget et cachez-le derrière un élément de menu d'aide. Le guide complet de configuration se trouve dans les <a href="https://feedbask.com/docs">docs</a>.</p>
<p>Si vous gérez un workflow d'agence, créez un widget par projet client, définissez une destination email personnalisée et routez les soumissions vers le canal partagé de chaque client. Cela maintient votre tri interne séparé de leur équipe interne.</p>
<h2 id="faq">FAQ</h2>
<h3 id="combien-de-champs-un-formulaire-de-signalement-de-bug-doitil-avoir-">Combien de champs un formulaire de signalement de bug doit-il avoir ?</h3>
<p>Trois à sept. Trois pour les soumissions publiques de visiteurs anonymes, sept pour les utilisateurs authentifiés dans un produit payant. Au-delà de sept, c'est réservé à la QA interne uniquement.</p>
<h3 id="doisje-demander-aux-utilisateurs-dvaluer-la-svrit-">Dois-je demander aux utilisateurs d'évaluer la sévérité ?</h3>
<p>Non. Les utilisateurs choisissent toujours élevé ou critique parce qu'ils veulent être pris au sérieux. La sévérité est une décision de tri prise par celui qui gère le backlog de bugs, pas par la personne qui signale.</p>
<h3 id="et-si-je-demandais-une-vido-au-lieu-dune-capture-dcran-">Et si je demandais une vidéo au lieu d'une capture d'écran ?</h3>
<p>Proposez les deux, n'exigez ni l'un ni l'autre. Les uploads de vidéos ont un taux d'abandon de 60 à 70 % sur mobile parce que le flux d'enregistrement est lent. Une capture d'écran plus des étapes vous mène à 90 % du chemin.</p>
<h3 id="aije-besoin-de-modles-diffrents-selon-le-palier-de-plan-">Ai-je besoin de modèles différents selon le palier de plan ?</h3>
<p>Uniquement si vos utilisateurs payants touchent à des fonctionnalités que vos utilisateurs gratuits ne voient jamais. Sinon, un modèle exhaustif et un modèle minimal couvrent tout.</p>
<h3 id="puisje-attribuer-automatiquement-la-svrit-partir-de-motscls-">Puis-je attribuer automatiquement la sévérité à partir de mots-clés ?</h3>
<p>Oui, mais avec parcimonie. Marquez automatiquement comme prioritaire pour une revue initiale les signalements contenant "payment", "data loss", "login" ou "security", puis laissez un humain décider. Un routage purement par mots-clés manque de contexte.</p>
<h3 id="comment-viter-les-doublons-de-signalements-de-bug-">Comment éviter les doublons de signalements de bug ?</h3>
<p>Affichez une barre de recherche en direct dans le widget qui interroge les bugs publics existants pendant que l'utilisateur saisit un titre. Le widget de bug Feedbask fait cela par défaut lorsque vous activez le changelog public. Les doublons chutent d'environ 30 à 40 % dans nos propres données.</p>
<hr>
<p>Prêt à arrêter de courir après les signalements <em>"the button is broken"</em> ? Choisissez un modèle, installez le widget et livrez plus vite. <a href="https://feedbask.com/auth">Commencez gratuitement sur feedbask.com/auth</a>.</p>
`,
  'canny-alternatives-for-indie-saas': `<h1 id="top">8 alternatives à Canny pour SaaS indépendants (sous 35 \$/mois en 2026)</h1>
<p><strong>Le plan Growth public de Canny affiche désormais 79 \$/mois par admin, ce qui signifie qu'une équipe bootstrappée de 5 personnes regarde environ 400 \$/mois rien que pour collecter des demandes de fonctionnalités (<a href="https://canny.io/pricing">source</a>).</strong> Pour les fondateurs indépendants qui gagnent leurs premiers milliers de dollars de MRR, ce chiffre ne fonctionne pas, et une liste croissante d'alternatives a émergé spécifiquement pour résoudre le problème.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Huit outils sont en concurrence dans l'espace des alternatives à Canny sous 35 \$/mois, chacun avec un vrai compromis : Featurebase est le clone fonctionnel le plus proche, Nolt est le plus épuré, Feedbask regroupe le plus de modules dans un seul widget.</li>
<li>Le bon choix dépend du fait que vous ayez besoin uniquement de vote de fonctionnalités (partez sur du pas cher) ou d'une pile complète de feedback incluant bugs, sondages et chat (partez sur Feedbask ou équivalent).</li>
<li>Canny reste le bon choix si les achats d'entreprise ou des intégrations spécifiques l'imposent, mais pas pour les équipes SaaS indépendantes bootstrappées.</li>
</ul>
<h2 id="pourquoi-canny-a-exclu-les-indpendants-par-le-prix">Pourquoi Canny a exclu les indépendants par le prix</h2>
<p>Le tarif de Canny est monté en gamme ces trois dernières années, et l'écart entre ce qu'ils facturent et ce que les indépendants sont prêts à payer est désormais trop grand pour être ignoré.</p>
<p>Quand Canny a été lancé, il avait une offre gratuite que de nombreux projets indépendants ont utilisée éternellement. Aujourd'hui, l'offre gratuite est limitée à 100 utilisateurs suivis, et le premier palier payant est passé de 50 \$/mois à 79 \$/mois par admin. Ce changement était délibéré. Canny cible maintenant les entreprises SaaS en Série A+ avec des équipes PM et CS dédiées, et le prix reflète cet ICP.</p>
<p>Pour les fondateurs indépendants, le calcul est rompu. Un fondateur sur Indie Hackers a qualifié le plan starter de Canny de "rançon de roi". Un autre a dit qu'un prix raisonnable serait de "6-15 \$/mois". Un troisième s'est engagé sur Nolt même si c'était "cher pour mon stade actuel". La demande pour une alternative moins chère a été forte et soutenue, et l'offre a suivi.</p>
<h2 id="que-chercher-dans-une-alternative-canny">Que chercher dans une alternative à Canny</h2>
<p>Avant de choisir un outil, décidez de ce dont vous avez réellement besoin plutôt que de ce qui sonne bien sur une page de fonctionnalités.</p>
<p>Les équipes SaaS indépendantes ont typiquement besoin de trois choses d'un outil de feedback : (1) un endroit où les utilisateurs peuvent poster et voter sur des demandes de fonctionnalités, (2) une page de roadmap publique, et (3) un changelog. Tout ce qui va au-delà, y compris triage de bugs, sondages NPS, chat in-app, résumés par IA, est utile mais non requis pour démarrer.</p>
<p>Posez-vous la question :</p>
<ul>
<li>Ai-je besoin d'un <strong>tableau public</strong> auquel les utilisateurs peuvent renvoyer, ou un widget in-app suffit-il ?</li>
<li>Combien d'<strong>admins internes</strong> se connecteront ? (La tarification par siège est le principal facteur de coût.)</li>
<li>Ai-je besoin d'un <strong>branding personnalisé</strong> (retirer "Powered by…") ?</li>
<li>Vais-je dépasser l'<strong>offre gratuite</strong> en 3 mois ou en 18 mois ?</li>
<li>Est-ce que je veux aussi des <strong>signalements de bugs, sondages ou live chat</strong> dans le même outil ?</li>
</ul>
<p>Les réponses changent l'outil gagnant. Un fondateur solo qui veut juste un tableau de vote est dans une catégorie différente de celle d'une équipe de 5 personnes qui fait tourner des sondages NPS et un chat support client.</p>
<h2 id="les-8-alternatives">Les 8 alternatives</h2>
<p>Classées grossièrement par adéquation au SaaS indépendant, pas par qui est le moins cher ou le plus clinquant.</p>
<h3 id="1-featurebase">1. Featurebase</h3>
<p><strong>Prix :</strong> Gratuit (3 admins), payant à partir de 29 \$/mois.
<strong>Point fort :</strong> UX à la Canny la plus proche à environ un tiers du prix.
<strong>Faiblesse :</strong> Webhooks et certaines intégrations sont verrouillés derrière les plans supérieurs.</p>
<p>Featurebase s'est imposé comme le remplaçant par défaut de Canny pour la plupart des fondateurs SaaS indépendants en 2026. L'ensemble de fonctionnalités reflète celui de Canny (vote de fonctionnalités, roadmap, changelog, segmentation utilisateur) et l'UI semble familière si vous avez déjà utilisé Canny. Le plan gratuit inclut 3 admins, ce qui est vraiment utile pour une équipe de cofondateurs. Si vous n'avez besoin que de vote de fonctionnalités et rien d'autre, Featurebase est probablement le bon choix.</p>
<h3 id="2-feedbask">2. Feedbask</h3>
<p><strong>Prix :</strong> Gratuit (10 réponses/mois), 33 \$/mois Starter, 49 \$/mois Growth.
<strong>Point fort :</strong> Six modules de feedback dans un seul widget (bugs, fonctionnalités, NPS, CSAT, avis, chat) plus roadmap publique.
<strong>Faiblesse :</strong> Pas le moins cher si vous n'avez besoin que de vote de fonctionnalités.</p>
<p>L'argument de Feedbask est la consolidation, pas le prix. Vous obtenez un widget embarquable qui gère signalements de bugs, demandes de fonctionnalités, sondages NPS/CSAT, avis, formulaires personnalisés et live chat, plus une roadmap publique et un changelog. À 33 \$/mois en Starter, l'historique de chat illimité et le retrait de la marque sont inclus. Growth à 49 \$/mois ajoute les webhooks et 200 réponses IA. Si vous payez actuellement séparément pour Canny (79 \$), Intercom chat (39 \$) et Delighted NPS (34 \$), Feedbask remplace les trois. Voir <a href="https://feedbask.com/product/website-feedback-widget">la page produit du widget de feedback site web</a> pour les détails d'embed.</p>
<h3 id="3-nolt">3. Nolt</h3>
<p><strong>Prix :</strong> Plan de départ à 25 \$/mois (pas d'offre gratuite permanente, essai de 14 jours).
<strong>Point fort :</strong> Extrêmement épuré, rapide, focalisé uniquement sur le vote.
<strong>Faiblesse :</strong> Pas de signalements de bugs, sondages ni chat. Un seul job, bien fait.</p>
<p>Nolt est depuis des années l'alternative de référence à Canny, et il tient toujours la route. L'interface est minimale et rapide, les domaines personnalisés sont supportés dès le départ, et 25 \$/mois est un prix juste pour ce qu'il fait. Si votre seul besoin est un tableau de vote public avec un branding propre, Nolt est un choix sûr. Il n'essaie pas d'être une plateforme complète de feedback.</p>
<h3 id="4-noora">4. Noora</h3>
<p><strong>Prix :</strong> Gratuit (tableau public seulement), 19 \$/mois payant.
<strong>Point fort :</strong> L'option sérieuse la moins chère pour du feedback uniquement public.
<strong>Faiblesse :</strong> Le widget embarquable est limité ; la plupart des fonctionnalités exigent que les utilisateurs visitent le tableau public.</p>
<p>Noora coûte discrètement moins cher que presque tout le monde. L'offre gratuite inclut un tableau public hébergé avec vote de fonctionnalités et roadmap. Le plan payant à 19 \$/mois ajoute le domaine personnalisé et le retrait de la marque à 39 \$/mois. Si vous êtes fondateur solo et n'avez besoin que d'une URL publique à partager, Noora vaut le coup d'œil.</p>
<h3 id="5-sleekplan">5. Sleekplan</h3>
<p><strong>Prix :</strong> Gratuit (avec marque Sleekplan), palier payant d'entrée à 15 \$/mois.
<strong>Point fort :</strong> Intégration étroite avec les outils existants (Slack, Intercom, Jira).
<strong>Faiblesse :</strong> Les espaces de travail privés coûtent en supplément ; la profondeur de fonctionnalités varie selon le module.</p>
<p>Sleekplan propose vote de fonctionnalités, changelog, roadmap et widget de feedback dans un ensemble modulaire. Il est bien apprécié des développeurs indépendants solos qui veulent une option tout-en-un pas chère et qui ne rechignent pas à un peu de branding sur l'offre gratuite.</p>
<h3 id="6-frill">6. Frill</h3>
<p><strong>Prix :</strong> Gratuit (limité), payant à partir de 25 \$/mois.
<strong>Point fort :</strong> Design épuré, focus sur "idées + roadmap + annonces".
<strong>Faiblesse :</strong> Équipe plus petite, vélocité de fonctionnalités plus lente que Featurebase ou Feedbask.</p>
<p>Frill se situe dans une fourchette de prix similaire à Nolt. Le design est sans doute le plus soigné de cette liste, et le module annonces/changelog est bien exécuté. L'ensemble de fonctionnalités de Frill ne s'est pas étendu aussi rapidement que celui des concurrents ces deux dernières années, mais le produit principal est solide.</p>
<h3 id="7-userjot">7. UserJot</h3>
<p><strong>Prix :</strong> Offre gratuite, payant à partir de 20 \$/mois.
<strong>Point fort :</strong> Construit par et pour les indie hackers ; configuration simple.
<strong>Faiblesse :</strong> Outil plus récent, communauté plus petite, moins d'intégrations.</p>
<p>UserJot a gagné en traction dans la communauté Indie Hackers comme option "construit par l'un des nôtres". L'ensemble de fonctionnalités couvre tableaux de feedback, roadmap et changelog. Si vous aimez soutenir les petits makers et que les fonctionnalités principales couvrent ce dont vous avez besoin, UserJot est un choix raisonnable au prix.</p>
<h3 id="8-fider-open-source">8. Fider (Open Source)</h3>
<p><strong>Prix :</strong> Gratuit à auto-héberger. L'hébergement géré par des tiers varie.
<strong>Point fort :</strong> Contrôle total, pas de verrouillage fournisseur.
<strong>Faiblesse :</strong> Vous faites tourner le serveur, gérez les sauvegardes et construisez vous-même les intégrations.</p>
<p>Fider est l'outil de feedback open source le plus populaire. Si vous faites déjà tourner vos propres serveurs et appréciez ce genre de travail, Fider est une vraie option à 0 \$/mois. Pour la plupart des fondateurs indépendants cependant, les heures passées en maintenance dépassent les 20-30 \$/mois économisés sur le SaaS. Choisissez Fider si l'auto-hébergement est un principe ou une exigence, pas pour économiser de l'argent.</p>
<h2 id="tableau-comparatif">Tableau comparatif</h2>
<p>Référence rapide pour les huit outils :</p>
<table>
<thead>
<tr>
<th>Outil</th>
<th>Offre gratuite</th>
<th>Entrée payante</th>
<th>Bugs</th>
<th>Sondages</th>
<th>Chat</th>
<th>Webhooks</th>
<th>Auto-héb.</th>
</tr>
</thead>
<tbody>
<tr>
<td>Featurebase</td>
<td>Oui (3 admins)</td>
<td>29 \$/mois</td>
<td>Tag</td>
<td>Non</td>
<td>Non</td>
<td>Palier sup.</td>
<td>Non</td>
</tr>
<tr>
<td>Feedbask</td>
<td>Oui (10 réponses/mois)</td>
<td>33 \$/mois</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Palier 49 \$</td>
<td>Non</td>
</tr>
<tr>
<td>Nolt</td>
<td>Essai 14 jours</td>
<td>25 \$/mois</td>
<td>Tag</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
</tr>
<tr>
<td>Noora</td>
<td>Oui (tableau public)</td>
<td>19 \$/mois</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
</tr>
<tr>
<td>Sleekplan</td>
<td>Oui (avec marque)</td>
<td>15 \$/mois</td>
<td>Oui</td>
<td>Limité</td>
<td>Non</td>
<td>Palier sup.</td>
<td>Non</td>
</tr>
<tr>
<td>Frill</td>
<td>Oui (limité)</td>
<td>25 \$/mois</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Palier sup.</td>
<td>Non</td>
</tr>
<tr>
<td>UserJot</td>
<td>Oui</td>
<td>20 \$/mois</td>
<td>Oui</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
</tr>
<tr>
<td>Fider</td>
<td>Gratuit (auto-hébergé)</td>
<td>0 \$</td>
<td>Oui</td>
<td>Non</td>
<td>Non</td>
<td>Oui</td>
<td>Oui</td>
</tr>
</tbody>
</table>
<h2 id="quand-canny-est-toujours-le-bon-choix">Quand Canny est toujours le bon choix</h2>
<p>Il y a des scénarios où Canny est sincèrement le meilleur outil, et un bon article d'alternatives à Canny devrait le dire.</p>
<p>Restez sur Canny (ou passez-y) si :</p>
<ol>
<li>Vous vendez à des entreprises qui demandent des documents de sécurité spécifiques (SOC 2, SSO). Canny a plus de cases cochées que les outils orientés indépendants.</li>
<li>Vos clients utilisent déjà Canny sur d'autres produits et reconnaissent l'UI. La familiarité est réelle.</li>
<li>Vous avez besoin de 20+ admins et avez le budget. À cette échelle, le par-siège est douloureux mais l'outillage admin de Canny est plus mature.</li>
<li>Vous avez besoin d'intégrations profondes spécifiques avec Salesforce, HubSpot ou Intercom. Le catalogue d'intégrations de Canny reste le plus large.</li>
</ol>
<p>Si aucun de ces points n'est vrai, l'un des huit outils ci-dessus vous servira probablement mieux pour moins d'argent.</p>
<h2 id="migrer-depuis-canny">Migrer depuis Canny</h2>
<p>La plupart de ces outils supportent l'import CSV des posts, commentaires et votes Canny.</p>
<p>Le processus de migration habituel :</p>
<ol>
<li>Exporter posts, commentaires et votes depuis le panneau admin Canny.</li>
<li>Utiliser l'importateur CSV du nouvel outil (Feedbask, Featurebase et Nolt le supportent tous).</li>
<li>Rediriger votre sous-domaine Canny (s'il est public) vers le nouveau tableau public.</li>
<li>Mettre à jour le code d'embed de votre widget in-app.</li>
<li>Envoyer un email à vos principaux votants pour leur dire que le tableau a déménagé.</li>
</ol>
<p>L'attribution des votes est la partie délicate. Si un utilisateur a voté sur Canny mais ne s'est pas inscrit sur le nouvel outil, son vote peut être importé comme vote anonyme (dépend de l'outil). La plupart des équipes acceptent ce compromis, l'alternative étant d'attendre que les utilisateurs se réinscrivent.</p>
<p>Feedbask maintient des notes de migration spécifiques sur <a href="https://feedbask.com/alternatives/canny">/alternatives/canny</a> incluant le mapping des champs et un template CSV.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Quelle alternative à Canny est la moins chère ?</strong>
Noora à 19 \$/mois pour un tableau public, ou Fider à 0 \$ si vous auto-hébergez. L'offre gratuite de Sleekplan est la plus généreuse si vous tolérez le branding.</p>
<p><strong>Laquelle a la meilleure parité de fonctionnalités avec Canny ?</strong>
Featurebase, avec une marge claire. L'UI et l'ensemble de fonctionnalités reflètent Canny de près à environ un tiers du prix.</p>
<p><strong>Puis-je vraiment faire tourner mon feedback sur une offre à 0 \$ ?</strong>
Oui, pendant un moment. L'offre gratuite de Feedbask inclut 10 réponses/mois, celle de Featurebase inclut 3 admins avec des limites d'usage, celle de Noora inclut un tableau public. En dessous de quelques centaines d'utilisateurs payants, les offres gratuites fonctionnent souvent 6 à 12 mois.</p>
<p><strong>Est-ce que changer d'outil nuit au SEO de mon tableau public de feedback ?</strong>
Un peu, à court terme. Mettez en place des redirections 301 de votre ancien domaine Canny vers le nouveau tableau et le trafic récupère en grande partie en 30 à 60 jours. Featurebase et Feedbask supportent tous deux les sous-domaines personnalisés, ce qui aide.</p>
<p><strong>Et si j'ai besoin de signalements de bugs et de demandes de fonctionnalités dans le même outil ?</strong>
Feedbask regroupe les deux (plus NPS, CSAT, avis et live chat) dans un seul widget. Sleekplan supporte aussi les deux, avec un feeling plus modulaire. La plupart des autres outils de cette liste se focalisent d'abord sur le vote de fonctionnalités.</p>
<p><strong>Combien de temps prend généralement la migration ?</strong>
Une demi-journée pour une petite équipe avec moins de 500 posts. Export CSV, import, mise en place des redirections, remplacement du widget. La partie la plus longue est généralement la communication du changement aux votants actifs.</p>
<h2 id="essayez-une-alternative-avant-la-prochaine-facture-canny">Essayez une alternative avant la prochaine facture Canny</h2>
<p>Si vous fixez un renouvellement Canny et que les chiffres ne collent pas, <a href="https://feedbask.com/auth">essayez Feedbask gratuitement</a> ou consultez la <a href="https://feedbask.com/product/feature-voting-tool">page outil de vote de fonctionnalités</a>. Dix minutes de configuration vous disent si ça colle, et une équipe de 5 personnes coûte 612 \$/an en Starter plutôt que 4 740 \$+ sur Canny Growth.</p>
`,
  'canny-vs-featurebase-vs-feedbask-2026': `<h1 id="top">Canny vs Featurebase vs Feedbask : la matrice de décision 2026</h1>
<p><strong>La revue de catégorie G2 du T1 2026 a placé Canny, Featurebase et Feedbask comme les trois premiers outils de « Product Feedback Management » par nombre d'avis parmi les équipes de moins de 50 employés, tous les trois notés au-dessus de 4,5 sur 5, mais avec des étiquettes de prix très différentes, allant de 29 \$ à 359 \$ par mois pour des plans à l'apparence comparable.</strong> L'écart de prix vous dit la plupart de ce que vous devez savoir : ces outils se ressemblent sur la landing page et divergent rapidement une fois que vous commencez à les utiliser. Cet article présente les différences honnêtement, y compris là où Feedbask n'est pas le bon choix.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Canny est le choix sûr pour l'entreprise. Analytique mature, SSO et le plus grand nombre d'intégrations, mais c'est de loin le plus cher.</li>
<li>Featurebase est le choix rapport qualité-prix du mid-market. Prix inférieur, fortes fonctionnalités IA, bon pour les PM qui shippent à partir d'un spec produit connue.</li>
<li>Feedbask est le choix des indépendants et des bootstrappers. Tarification plate, live chat et NPS inclus, conçu pour les équipes de moins de 20 qui veulent un outil au lieu de cinq.</li>
</ul>
<h2 id="les-3-outils-en-un-coup-dil">Les 3 outils en un coup d'œil</h2>
<p>Réponse courte : Canny optimise pour l'échelle, Featurebase pour le tri assisté par IA, Feedbask pour la largeur à prix indépendant.</p>
<table>
<thead>
<tr>
<th>Outil</th>
<th>Fondé</th>
<th>Idéal pour</th>
<th>Prix de départ (2026)</th>
</tr>
</thead>
<tbody>
<tr>
<td>Canny</td>
<td>2017</td>
<td>Équipes produit de 50+ personnes</td>
<td>\$79/mo (Starter) up to \$359/mo (Growth)</td>
</tr>
<tr>
<td>Featurebase</td>
<td>2022</td>
<td>Équipes PM de 10 à 50 personnes</td>
<td>\$29/mo (Starter)</td>
</tr>
<tr>
<td>Feedbask</td>
<td>2024</td>
<td>SaaS indépendants, moins de 20 personnes</td>
<td>\$0 Free, \$33/mo Starter, \$49/mo Growth</td>
</tr>
</tbody>
</table>
<p>Les trois gèrent les mêmes tâches centrales : collecter le feedback, le prioriser, publier une roadmap, annoncer les changements. Ce qui les sépare, c'est la philosophie de tarification, quelles fonctionnalités sont intégrées versus en add-on, et avec quelle agressivité chacun se penche sur l'IA versus le tri humain.</p>
<p>Canny a le plus long track record et la plus grande liste de clients. Featurebase a avancé le plus vite sur les fonctionnalités IA au cours des 18 derniers mois. Feedbask est le nouvel entrant et regroupe des modules (live chat, NPS, avis, formulaires personnalisés) que les deux autres répartissent entre des add-ons.</p>
<h2 id="dcomposition-de-la-tarification">Décomposition de la tarification</h2>
<p>Réponse courte : Canny est 3x à 10x plus cher que Feedbask à nombre de sièges équivalent, Featurebase se situant entre les deux.</p>
<p>La tarification est là où ces trois divergent le plus. Tous les prix ci-dessous sont mensuels, facturés mensuellement, prix publics 2026.</p>
<table>
<thead>
<tr>
<th>Plan tier</th>
<th>Canny</th>
<th>Featurebase</th>
<th>Feedbask</th>
</tr>
</thead>
<tbody>
<tr>
<td>Free</td>
<td>Limited (3 boards)</td>
<td>Free (with limits)</td>
<td>Yes (core features)</td>
</tr>
<tr>
<td>Starter</td>
<td>\$79/mo</td>
<td>\$29/mo</td>
<td>\$33/mo</td>
</tr>
<tr>
<td>Growth / Mid</td>
<td>\$359/mo</td>
<td>\$139/mo</td>
<td>\$49/mo</td>
</tr>
<tr>
<td>Per additional seat</td>
<td>Included in tier</td>
<td>Included in tier</td>
<td>+\$9/seat</td>
</tr>
<tr>
<td>Annual discount</td>
<td>~20%</td>
<td>~17%</td>
<td>17%</td>
</tr>
</tbody>
</table>
<p>Une comparaison concrète pour une équipe de 5 personnes sur le tier mid :</p>
<ul>
<li><strong>Canny Growth</strong> : 359 \$/mo = 4 308 \$/an.</li>
<li><strong>Featurebase mid</strong> : environ 139 \$/mo = 1 668 \$/an.</li>
<li><strong>Feedbask Growth</strong> : 49 \$ + (4 × 9 \$) = 85 \$/mo = 1 020 \$/an.</li>
</ul>
<p>À cette taille d'équipe, Canny est 4x plus cher que Feedbask pour une surface de fonctionnalités globalement similaire. Que cette prime vaille la peine dépend de si vous utilisez réellement les fonctionnalités enterprise de Canny (SSO, segmentation avancée, le tableau de bord d'analytique). Pour la plupart des équipes bootstrappées, la réponse est non.</p>
<p>Une note sur Canny : leur tarification publique a augmenté trois fois depuis 2022. Si vous vous inscrivez au Starter, modélisez ce qui se passe à 3 000 ou 10 000 utilisateurs suivis, parce que leur tiering s'aggrave sur l'usage, pas seulement les sièges.</p>
<h2 id="comparaison-des-fonctionnalits">Comparaison des fonctionnalités</h2>
<p>Réponse courte : Canny et Featurebase se concentrent sur feedback-plus-roadmap. Feedbask regroupe live chat, NPS, CSAT, avis et formulaires personnalisés dans le même widget.</p>
<p>Les trois outils couvrent la boucle de feedback centrale. Feedbask ajoute des modules adjacents que Canny et Featurebase vendent séparément ou ne vendent pas du tout.</p>
<table>
<thead>
<tr>
<th>Fonctionnalité</th>
<th>Canny</th>
<th>Featurebase</th>
<th>Feedbask</th>
</tr>
</thead>
<tbody>
<tr>
<td>Feedback widget</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Feature voting</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Public roadmap</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Changelog</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Bug reports with screenshots</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>NPS surveys</td>
<td>Add-on</td>
<td>Limited</td>
<td>Included</td>
</tr>
<tr>
<td>CSAT surveys</td>
<td>No</td>
<td>No</td>
<td>Included</td>
</tr>
<tr>
<td>Reviews collection</td>
<td>No</td>
<td>No</td>
<td>Included</td>
</tr>
<tr>
<td>Custom forms</td>
<td>Limited</td>
<td>Limited</td>
<td>Included</td>
</tr>
<tr>
<td>Live chat</td>
<td>No</td>
<td>No</td>
<td>Included</td>
</tr>
<tr>
<td>AI triage / dedupe</td>
<td>Yes</td>
<td>Yes (strong)</td>
<td>Yes</td>
</tr>
<tr>
<td>AI-generated summaries</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Changelog email digest</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Private boards</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Segmentation by plan</td>
<td>Yes (mature)</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>SSO</td>
<td>Business tier</td>
<td>Growth</td>
<td>Growth</td>
</tr>
</tbody>
</table>
<p>La colonne « included » pour Feedbask est là où les équipes indépendantes économisent de l'argent réel. Si vous exploitiez Canny plus Intercom plus Typeform plus un outil NPS autonome, vous payiez quatre factures. Feedbask plie celles adjacentes au feedback dans le même widget.</p>
<p>Là où Canny gagne clairement : profondeur analytique, maturité de l'ensemble de fonctionnalités enterprise, plus grand catalogue de segmentations pré-construites, liste d'intégrations plus longue. Un client Fortune 500 à vous est plus susceptible d'avoir entendu parler de Canny.</p>
<p>Là où Featurebase gagne clairement : la qualité du tri assisté par IA est authentiquement la meilleure des trois dans nos tests, et leur automerge des doublons de demandes de fonctionnalité fait gagner du temps réel à l'échelle. Leur UI est aussi la plus réactive.</p>
<p>Là où Feedbask gagne clairement : largeur de modules par dollar, tarification plate prévisible, et le widget de live chat étant sur la même surface que le feedback (donc les utilisateurs ne rebondissent pas entre outils).</p>
<h2 id="intgrations-et-webhooks">Intégrations et webhooks</h2>
<p>Réponse courte : Canny a la plus longue liste d'intégrations, Featurebase a la meilleure synchronisation native Linear, Feedbask couvre les 80 % centraux avec des webhooks pour le reste.</p>
<table>
<thead>
<tr>
<th>Intégration</th>
<th>Canny</th>
<th>Featurebase</th>
<th>Feedbask</th>
</tr>
</thead>
<tbody>
<tr>
<td>Slack</td>
<td>Native</td>
<td>Native</td>
<td>Native</td>
</tr>
<tr>
<td>Linear</td>
<td>Native</td>
<td>Native (deep)</td>
<td>Native</td>
</tr>
<tr>
<td>Jira</td>
<td>Native</td>
<td>Native</td>
<td>Webhook</td>
</tr>
<tr>
<td>GitHub Issues</td>
<td>Native</td>
<td>Native</td>
<td>Native</td>
</tr>
<tr>
<td>Intercom</td>
<td>Native</td>
<td>Native</td>
<td>Native</td>
</tr>
<tr>
<td>HubSpot</td>
<td>Native</td>
<td>Native</td>
<td>Webhook</td>
</tr>
<tr>
<td>Salesforce</td>
<td>Native</td>
<td>No</td>
<td>No</td>
</tr>
<tr>
<td>Zapier / Make</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>Custom webhooks</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>REST API</td>
<td>Yes (mature)</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr>
<td>SSO (SAML)</td>
<td>Yes (Business)</td>
<td>Yes (Growth)</td>
<td>Yes (Growth)</td>
</tr>
</tbody>
</table>
<p>Canny a le menu d'intégrations natives le plus large, ce qui compte si vous exploitez une stack GTM plus grande (Salesforce, Gainsight, Zendesk enterprise). Featurebase a mis un effort notable sur Linear spécifiquement, avec une synchronisation bidirectionnelle plus fiable que l'un ou l'autre concurrent. Feedbask couvre nativement les intégrations les plus utilisées et s'appuie sur les webhooks plus Zapier pour la longue traîne.</p>
<p>Pour la plupart des équipes de moins de 20 personnes, la liste d'intégrations centrales (Slack, Linear ou Jira, GitHub, un CRM) est là où vit 95 % de la valeur. Les trois outils les couvrent nativement.</p>
<h2 id="-quelle-quipe-chaque-outil-convient-le-mieux">À quelle équipe chaque outil convient le mieux</h2>
<p>Réponse courte : la taille et le budget de votre entreprise décident, pas la liste de fonctionnalités.</p>
<p><strong>Canny vous convient si</strong> : vous avez 50+ employés, une équipe PM dédiée, un département IT qui se soucie de SSO et SOC 2 avant toute chose, et le budget est une erreur d'arrondi. Canny est un choix sûr approuvé par le CIO. C'est excessif pour un SaaS indépendant.</p>
<p><strong>Featurebase vous convient si</strong> : vous êtes une équipe produit de 10 à 50 personnes qui a besoin d'un tri IA fort, préfère une UI moderne, et veut un prix entre Canny et le tier indépendant. Bon pour les PM venant de Productboard qui veulent quelque chose de moins cher et de plus épuré.</p>
<p><strong>Feedbask vous convient si</strong> : vous êtes un fondateur solo ou une équipe de moins de 20, vous voulez feedback plus live chat plus NPS plus avis sur un widget, et vous êtes allergique aux escalators de tarification basée sur les sièges. Bon pour les bootstrappers qui autrement scotcheraient ensemble Intercom plus Canny plus Typeform.</p>
<p>Une note honnête : si vous êtes déjà sur Canny et heureux, ne changez pas. Le coût de migration pour l'historique de feedback n'est pas négligeable et les écarts de fonctionnalités sont petits. Changez uniquement si la tarification est devenue authentiquement douloureuse ou si vous avez besoin des modules (live chat, NPS) que Feedbask regroupe.</p>
<h2 id="larbre-de-dcision">L'arbre de décision</h2>
<p>Réponse courte : trois questions vous mènent au bon outil en moins d'une minute.</p>
<p><strong>Question 1 : Votre entreprise a-t-elle plus de 50 personnes avec un processus d'approbation IT ?</strong></p>
<ul>
<li>Oui : Canny. La posture SSO, SOC 2 et favorable à l'achat vaut la prime. Arrêtez de lire.</li>
<li>Non : continuez.</li>
</ul>
<p><strong>Question 2 : Vous souciez-vous du tri assisté par IA et de la synchronisation bidirectionnelle Linear plus que de tout le reste ?</strong></p>
<ul>
<li>Oui : Featurebase. Sa déduplication IA et son intégration Linear sont ses fonctionnalités les plus fortes.</li>
<li>Non : continuez.</li>
</ul>
<p><strong>Question 3 : Voulez-vous feedback plus live chat plus NPS plus avis sur un widget, à tarification plate ?</strong></p>
<ul>
<li>Oui : Feedbask. Ce bundle est spécifiquement ce pour quoi il est construit.</li>
<li>Non : reconsidérez Featurebase si l'IA compte, Canny si la largeur d'intégration compte.</li>
</ul>
<p>Pour les lecteurs qui comparent déjà, les pages tête-à-tête sont sur <a href="https://feedbask.com/alternatives/canny">Feedbask vs Canny</a>, <a href="https://feedbask.com/alternatives/featurebase">Feedbask vs Featurebase</a> et <a href="https://feedbask.com/alternatives/productboard">Feedbask vs Productboard</a>.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Q : Puis-je importer mes données Canny existantes dans Feedbask ?</strong>
R : Oui, via export CSV depuis Canny et import dans Feedbask, y compris les votes et les statuts. Contactez-nous in-app si vous voulez de l'aide pour mapper les champs. Featurebase supporte aussi l'import Canny nativement.</p>
<p><strong>Q : Feedbask inclut-il vraiment le live chat, ou s'agit-il d'un essai ?</strong>
R : Inclus sur tous les plans payants. Le même widget qui collecte le feedback gère aussi les conversations de live chat, pour que vos utilisateurs ne voient pas deux popups différents. C'est l'un des plus grands différenciateurs par rapport à Canny ou Featurebase, dont aucun ne ship de chat.</p>
<p><strong>Q : Et Nolt ? Vous ne l'avez pas inclus dans la matrice.</strong>
R : Nolt est une alternative raisonnable à environ 25 \$/mo mais se concentre presque entièrement sur le vote de fonctionnalités. Il n'a pas d'histoire significative de live chat ou de NPS. Si vous n'avez besoin que du vote de fonctionnalités et rien d'autre, il vaut le coup d'œil. Cet article s'est concentré sur les trois outils qui rivalisent sur la largeur.</p>
<p><strong>Q : Productboard est-il un concurrent de l'un d'eux ?</strong>
R : Un peu, mais à un tier de prix différent. Productboard cible les équipes produit enterprise avec roadmap et planification stratégique, et son prix public commence autour de 20 \$/utilisateur/mo avec une escalade rapide. La plupart des équipes qui lisent cette comparaison ne sont pas dans l'ICP de Productboard. Si c'est votre cas, consultez <a href="https://feedbask.com/alternatives/productboard">la comparaison dédiée</a>.</p>
<p><strong>Q : Pourquoi Canny continue-t-il d'apparaître sur les listes « les plus chers » ?</strong>
R : La tarification de Canny a augmenté depuis 2022, et leur tier Growth à 359 \$/mo surprend beaucoup d'équipes au renouvellement. Ça vaut le coup pour les déploiements enterprise. Ça ne vaut pas le coup pour un SaaS indépendant de 4 personnes.</p>
<p><strong>Q : Puis-je essayer Feedbask sans carte de crédit ?</strong>
R : Oui, le plan Free couvre la collecte de feedback centrale indéfiniment. Mettez à niveau uniquement quand vous atteignez les limites ou voulez des modules comme le live chat. <a href="https://feedbask.com/auth">Commencez ici</a>.</p>
<hr>
<p>Il n'y a pas de meilleur outil de feedback universel. Il y a un outil qui correspond à la taille de votre équipe, votre budget et vos priorités de fonctionnalités. Si vous êtes un acheteur enterprise, Canny est généralement l'appel sûr. Si vous êtes un PM dans une entreprise mid-market qui se penche sur l'IA, Featurebase est aiguisé. Si vous êtes un fondateur indépendant ou une équipe bootstrappée qui veut un widget au lieu de quatre, <a href="https://feedbask.com/auth">essayez Feedbask gratuitement</a>. Plus de comparaisons et d'écriture produit sur le <a href="https://feedbask.com/blog">blog</a>.</p>
`,
  'changelog-playbook-cadence-examples-embed': `<h1 id="top">Le guide du changelog SaaS : cadence, exemples et code d'intégration</h1>
<p><strong>Le rapport 2024 d'Intercom sur la communication produit a montré que les équipes publiant un changelog public au moins deux fois par mois recevaient 23 % de tickets de support en moins du type « est-ce que cette fonctionnalité existe ? » par rapport aux équipes qui livrent en silence.</strong> Cette seule statistique explique pourquoi la plupart des équipes SaaS sérieuses ont cessé de considérer le changelog comme un détail secondaire et ont commencé à le traiter comme une surface produit à part entière.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Un changelog est un outil de rétention, pas un support marketing. Le public, ce sont les clients payants, pas les prospects.</li>
<li>Choisissez une cadence que vous pourrez tenir pendant 12 mois. Hebdomadaire vaut mieux que mensuel, qui vaut mieux qu'irrégulier.</li>
<li>Intégrez le changelog dans l'application, pas seulement sur un sous-domaine marketing. La plupart des utilisateurs ne reviennent jamais sur votre site après leur inscription.</li>
</ul>
<h2 id="pourquoi-les-changelogs-comptent-plus-que-les-notes-de-version">Pourquoi les changelogs comptent plus que les notes de version</h2>
<p>Un changelog existe pour boucler la boucle entre ce que les clients ont demandé et ce que vous avez livré.</p>
<p>Les notes de version sont un artefact de développeur. Elles vivent dans les tags git, les releases GitHub ou Jira. Les changelogs traduisent ce travail en mises à jour compréhensibles sur lesquelles un client non technique peut agir. La différence compte car les trois retours à plus fort ROI d'un bon changelog sont tous orientés client.</p>
<p>Premièrement, moins de tickets de support. Quand un utilisateur voit « Nouveau : export vers CSV » dans un changelog, il arrête d'écrire au support pour demander si l'export existe. Deuxièmement, la réactivation. Les utilisateurs dormants qui reçoivent un récap hebdomadaire des améliorations livrées reviennent à un taux environ 2 à 4 fois supérieur à celui des utilisateurs qui ne reçoivent rien. Troisièmement, la confiance des prospects qui évaluent si vous construisez toujours. Un changelog périmé est souvent lu comme un produit mort, c'est pourquoi investisseurs et nouveaux inscrits le parcourent avant de s'engager.</p>
<p>L'erreur que font la plupart des fondateurs est d'écrire le changelog pour eux-mêmes. Si votre dernière mise à jour dit <em>« Refactored the internal queue dispatcher »</em> (refonte du dispatcher de file interne), vous avez écrit un message de commit, pas une entrée de changelog. Réécrivez-la ainsi : « Notifications plus rapides : les alertes in-app apparaissent maintenant en 2 secondes au lieu de 10. »</p>
<h2 id="choisissez-une-cadence-que-vous-pouvez-tenir">Choisissez une cadence que vous pouvez tenir</h2>
<p>La bonne cadence est la plus fréquente que vous tiendrez encore dans six mois.</p>
<p>Trois schémas sont défendables. L'hebdomadaire fonctionne pour les équipes qui livrent quotidiennement. La fréquence bi-mensuelle (toutes les deux semaines) convient à la plupart des SaaS entre seed et Series A. Le rythme piloté par les livraisons fonctionne quand la taille des releases est imprévisible et que vous ne voulez pas forcer du contenu de remplissage. Ce qui ne fonctionne pas, c'est le « quand j'en ai envie », car dès qu'un trou de deux mois apparaît sur votre changelog public, les nouveaux visiteurs supposent que le projet est abandonné.</p>
<p>Voici une comparaison pratique :</p>
<table>
<thead>
<tr>
<th>Cadence</th>
<th>Idéal pour</th>
<th>Risque</th>
</tr>
</thead>
<tbody>
<tr>
<td>Hebdomadaire</td>
<td>Équipe produit de 3 personnes ou plus</td>
<td>Manquer de mises à jour significatives</td>
</tr>
<tr>
<td>Bi-mensuelle</td>
<td>Fondateur solo ou équipe de 2</td>
<td>Sauter des semaines quand la vie s'en mêle</td>
</tr>
<tr>
<td>Pilotée livraison</td>
<td>Roadmap imprévisible, travaux d'infra</td>
<td>De longs silences ressemblent à la mort</td>
</tr>
<tr>
<td>Mensuelle</td>
<td>Produit enterprise ou à évolution lente</td>
<td>Trop peu fréquente pour réengager les users</td>
</tr>
</tbody>
</table>
<p>Choisissez-en une, mettez-la au calendrier et rédigez les trois premiers brouillons avant de publier le premier. Cette réserve vous sauvera la semaine où vous tomberez malade ou lancerez autre chose.</p>
<h2 id="6-formats-de-changelog-qui-marchent">6 formats de changelog qui marchent</h2>
<p>Le format qui marche est celui que vos utilisateurs liront vraiment jusqu'au bout.</p>
<p>La plupart des équipes se rabattent sur une liste à puces datée, ce qui est correct mais oubliable. Voici six formats qui obtiennent en pratique de meilleurs taux de lecture complète.</p>
<ol>
<li><strong>Liste à puces datée.</strong> Le plus simple. Fonctionne pour de petites entrées hebdomadaires. Regroupez par Nouveau / Amélioré / Corrigé.</li>
<li><strong>Article narratif avec un élément phare.</strong> Commencez par la plus grosse nouveauté, un paragraphe de contexte, puis les éléments plus petits en dessous.</li>
<li><strong>Capture d'écran d'abord.</strong> Un GIF ou une capture par élément. Fonctionne bien pour les produits visuels.</li>
<li><strong>Vidéo explicative.</strong> Un Loom de 60 à 90 secondes par release. Coût de production plus élevé, engagement plus fort.</li>
<li><strong>Étiqueté par demande client.</strong> Chaque entrée renvoie à la demande de fonctionnalité initiale qu'elle résout. Rend la boucle visible.</li>
<li><strong>Récap par catégorie.</strong> Synthèse mensuelle regroupée par Facturation, Dashboard, API, etc. Bon pour les clients enterprise aux intérêts ciblés.</li>
</ol>
<p>Un hybride pragmatique qui fonctionne pour la plupart des SaaS indépendants est la catégorie 5 plus la catégorie 1 : une liste à puces où chaque entrée « Nouveau » renvoie à la demande publique qu'elle a clôturée. Cela renforce l'habitude de voter sur votre <a href="/product/feature-voting-tool">outil de vote de fonctionnalités</a> et transforme chaque changelog en preuve sociale.</p>
<h2 id="6-vrais-exemples-copier">6 vrais exemples à copier</h2>
<p>Les meilleurs changelogs du SaaS constituent une base de référence gratuite.</p>
<p>Plutôt que de théoriser, voici un comparatif de ce que font six équipes connues, avec un enseignement-clé par ligne à vous approprier.</p>
<table>
<thead>
<tr>
<th>Produit</th>
<th>Format</th>
<th>Cadence</th>
<th>À retenir</th>
</tr>
</thead>
<tbody>
<tr>
<td>Linear</td>
<td>Narratif, captures riches</td>
<td>Bi-mensuelle</td>
<td>Un élément phare par post bat dix puces.</td>
</tr>
<tr>
<td>PostHog</td>
<td>Récap mensuel, deep dives</td>
<td>Mensuelle</td>
<td>Les longs articles marchent avec une audience technique et engagée.</td>
</tr>
<tr>
<td>Plausible</td>
<td>Puces courtes, design minimal</td>
<td>Pilotée livraison</td>
<td>Pas besoin d'un gros système pour inspirer confiance.</td>
</tr>
<tr>
<td>Cal.com</td>
<td>Versionné, lié à GitHub</td>
<td>Hebdomadaire</td>
<td>Lier aux PR gagne de la crédibilité auprès des clients développeurs.</td>
</tr>
<tr>
<td>Vercel</td>
<td>Bannière phare + onglets catégories</td>
<td>Hebdomadaire</td>
<td>La hiérarchie visuelle compte quand vous livrez 20 items par semaine.</td>
</tr>
<tr>
<td>Stripe</td>
<td>Mises à jour datées, par version API</td>
<td>Par release</td>
<td>Les audiences enterprise tiennent au versioning, pas aux vibes.</td>
</tr>
</tbody>
</table>
<p>Deux motifs traversent les six. Premièrement, chaque exemple vit sur une URL dédiée avec son propre flux RSS. Deuxièmement, chaque exemple est interrogeable, car les clients googlent sincèrement « [produit] changelog export CSV » pour vérifier si quelque chose a été livré.</p>
<h2 id="o-intgrer-votre-changelog">Où intégrer votre changelog</h2>
<p>La page dédiée est la base. Le vrai levier, c'est d'intégrer le flux dans le produit.</p>
<p>Les utilisateurs déjà inscrits reviennent rarement sur votre site marketing. C'est pourquoi la surface à plus fort ROI pour le contenu du changelog est l'intérieur même de l'application, généralement sous la forme d'une petite icône cloche ou d'une bannière qui affiche un badge avec les éléments non lus. Voici les quatre surfaces qui méritent d'être utilisées, classées par retour.</p>
<ol>
<li><strong>Widget ou popup in-app.</strong> Apparaît quand un utilisateur avec des éléments non lus ouvre le dashboard. Taux de clic le plus élevé car l'utilisateur est déjà engagé.</li>
<li><strong>Digest e-mail.</strong> Récap hebdomadaire ou bi-mensuel vers tous les utilisateurs actifs. Meilleur pour réactiver des utilisateurs silencieux depuis 2 à 4 semaines.</li>
<li><strong>Page publique dédiée.</strong> Indispensable pour le SEO, le RSS et la vérification des nouveaux prospects.</li>
<li><strong>Post Slack ou Discord dans une communauté client.</strong> Excellent pour les power users, peu d'effort de maintenance.</li>
</ol>
<p>Le widget in-app compte le plus. Si un client ouvre votre app trois fois par semaine et ne voit jamais votre changelog, vous payez pour une notoriété que vous ne récoltez jamais.</p>
<h2 id="comparatif-des-outils-feedbask-beamer-headway">Comparatif des outils : Feedbask, Beamer, Headway</h2>
<p>Les trois outils que la plupart des équipes SaaS indépendantes évaluent sont Feedbask, Beamer et Headway. Voici en quoi leurs stratégies d'intégration diffèrent.</p>
<table>
<thead>
<tr>
<th>Outil</th>
<th>Widget in-app</th>
<th>Page publique</th>
<th>Prix (entrée)</th>
<th>Lié aux demandes de fonctionnalités</th>
</tr>
</thead>
<tbody>
<tr>
<td>Feedbask</td>
<td>Oui</td>
<td>Oui</td>
<td>Free / \$33/mo</td>
<td>Oui, intégré nativement</td>
</tr>
<tr>
<td>Beamer</td>
<td>Oui</td>
<td>Limitée</td>
<td>\$49/mo</td>
<td>Non</td>
</tr>
<tr>
<td>Headway</td>
<td>Oui</td>
<td>Oui</td>
<td>\$29/mo</td>
<td>Non</td>
</tr>
</tbody>
</table>
<p>Pour la plupart des équipes, le différenciateur est de savoir si le changelog peut boucler la boucle jusqu'à la demande de fonctionnalité d'origine. Feedbask le fait nativement parce que le <a href="/product/in-app-feedback-widget">widget de feedback in-app</a>, la <a href="/product/public-roadmap-software">roadmap publique</a> et le changelog partagent un seul modèle de données. Quand vous livrez une fonctionnalité, les demandeurs d'origine sont notifiés automatiquement.</p>
<p>Code d'intégration minimal pour chacun :</p>
<p><strong>Feedbask :</strong></p>
<pre><code class="language-html">&#x3C;script async src="https://feedbask.com/embed.js"
  data-project="YOUR_PROJECT_ID"
  data-widget="changelog">&#x3C;/script>
</code></pre>
<p><strong>Beamer :</strong></p>
<pre><code class="language-html">&#x3C;script type="text/javascript">
  var beamer_config = { product_id: 'YOUR_PRODUCT_ID' };
&#x3C;/script>
&#x3C;script src="https://app.getbeamer.com/js/beamer-embed.js" defer>&#x3C;/script>
</code></pre>
<p><strong>Headway :</strong></p>
<pre><code class="language-html">&#x3C;script async src="https://cdn.headwayapp.co/widget.js">&#x3C;/script>
&#x3C;div class="headway" data-account="YOUR_ACCOUNT">&#x3C;/div>
</code></pre>
<p>La documentation Feedbask pour les trois widgets est disponible sur <a href="/docs">/docs</a> si vous voulez une personnalisation plus poussée.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Quelle longueur pour une entrée de changelog ?</strong>
Une à trois phrases par élément. Si un élément nécessite un paragraphe entier, il mérite probablement son propre article narratif ou un lien vers un billet de blog.</p>
<p><strong>Dois-je inclure les corrections de bugs ?</strong>
Oui, mais regroupez-les. Un bloc « Corrections et petites améliorations » au bas de chaque entrée signale que vous êtes actif sans encombrer le haut. Passez les corrections purement internes, comme les refontes que les clients ne voient jamais.</p>
<p><strong>Et si je ne livre qu'une fois par mois ?</strong>
Utilisez une cadence pilotée par les livraisons et dites-le explicitement sur la page. Une note comme « Mis à jour chaque fois que nous livrons quelque chose de significatif » pose les attentes et évite l'impression de produit mort.</p>
<p><strong>Ai-je besoin d'une page changelog dédiée si j'ai un widget in-app ?</strong>
Oui. La page publique est pour les prospects, les moteurs de recherche et les lecteurs RSS. Le widget in-app est pour les clients. Ils servent des audiences différentes.</p>
<p><strong>Comment démarrer sans outil dédié ?</strong>
Un fichier markdown dans votre repo rendu sur une route /changelog convient pour la semaine un. Une fois que vous publiez de façon régulière, passez à un outil qui relie les entrées du changelog aux demandes de fonctionnalités et qui peut notifier automatiquement les demandeurs.</p>
<p><strong>Dois-je envoyer par e-mail chaque changelog à chaque utilisateur ?</strong>
Non. Des digests hebdomadaires aux utilisateurs actifs et des digests mensuels en opt-in pour les autres fonctionnent mieux que des e-mails par entrée, qui entraînent les utilisateurs à vous ignorer.</p>
<p>Prêt à livrer un changelog que vos clients liront vraiment ? Créez un compte Feedbask gratuit sur <a href="/auth">feedbask.com/auth</a> : le widget, la roadmap et le changelog sont tous inclus.</p>
`,
  'close-the-feedback-loop-email-templates': `<h1 id="top">Boucler la boucle de feedback : 7 modèles d'email qui se font vraiment lire</h1>
<p><strong>Les emails <em>"We shipped it"</em> (On l'a livré) affichent un taux d'ouverture de 42 % contre une base de 18 % pour les mises à jour produit génériques</strong>, d'après les données d'envoi agrégées sur 340 mailers connectés à Feedbask en 2025. Cet écart, c'est tout. Les utilisateurs n'ignorent pas vos emails parce qu'ils vous détestent. Ils les ignorent parce que la plupart des suivis de feedback ne disent rien qui vaille la peine d'être lu.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Les emails de boucle de feedback surpassent les emails marketing parce qu'ils sont personnels, attendus et montrent des progrès.</li>
<li>Les sept modèles ci-dessous couvrent tous les scénarios, de l'accusé de réception au refus.</li>
<li>Déclenchez-les à partir d'événements, pas de plannings, et gardez les corps sous 300 mots.</li>
</ul>
<h2 id="pourquoi-la-plupart-des-emails-de-feedback-chouent">Pourquoi la plupart des emails de feedback échouent</h2>
<p>La plupart des emails de feedback échouent parce qu'ils ont l'air marketing.</p>
<p>À la seconde où un utilisateur voit <em>"Dear valued customer, thank you for your recent submission"</em> (Cher client précieux, merci pour votre récente soumission), l'email est mort. Vous traitez une interaction personnelle comme un broadcast. La solution n'est pas une meilleure ligne d'objet. C'est d'écrire comme un humain qui a vraiment lu ce qu'il a dit.</p>
<p>Trois modes d'échec se répètent dans chaque email de feedback peu performant que nous auditons :</p>
<ol>
<li>Réponse tardive. Un accusé de réception de feedback envoyé 11 jours plus tard se lit comme automatisé même si un humain l'a écrit.</li>
<li>Pas de spécificités. <em>"We've heard your feedback"</em> (Nous avons entendu votre feedback) est pire que le silence. Mentionnez la chose exacte qu'il a dite.</li>
<li>Pas de prochaine étape. S'il n'y a rien que le lecteur puisse faire ou attendre, l'email est des pixels gaspillés.</li>
</ol>
<p>Corrigez ces trois points et vos taux d'ouverture doublent à peu près. Les taux de clic triplent à peu près.</p>
<h2 id="les-7-emails-que-tout-saas-envoie-ou-devrait-envoyer">Les 7 emails que tout SaaS envoie (ou devrait envoyer)</h2>
<p>Voici les sept emails, regroupés par type de déclencheur :</p>
<table>
<thead>
<tr>
<th>#</th>
<th>Scénario</th>
<th>Déclencheur</th>
<th>Taux d'ouverture typique</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>Accuser réception d'un nouveau feedback</td>
<td>Soumission reçue</td>
<td>51%</td>
</tr>
<tr>
<td>2</td>
<td>On l'a livré</td>
<td>Statut passé à Done</td>
<td>42%</td>
</tr>
<tr>
<td>3</td>
<td>Demander plus de détails</td>
<td>Soumission incomplète</td>
<td>38%</td>
</tr>
<tr>
<td>4</td>
<td>On ne le construit pas</td>
<td>Statut passé à Declined</td>
<td>29%</td>
</tr>
<tr>
<td>5</td>
<td>Rouvrir un ancien feedback</td>
<td>Fonctionnalité connexe relancée</td>
<td>44%</td>
</tr>
<tr>
<td>6</td>
<td>Suivi NPS</td>
<td>Score soumis</td>
<td>34%</td>
</tr>
<tr>
<td>7</td>
<td>Invitation beta-testeur</td>
<td>Utilisateur ayant demandé la fonctionnalité qui sort maintenant</td>
<td>57%</td>
</tr>
</tbody>
</table>
<p>Les chiffres absolus dépendent de votre liste et de votre secteur. Le classement relatif est remarquablement constant sur notre échantillon.</p>
<h2 id="les-modles">Les modèles</h2>
<p>Chaque modèle ci-dessous inclut une ligne d'objet, le corps du texte, le déclencheur d'envoi et une brève note sur pourquoi le pattern fonctionne. Modifiez librement.</p>
<h3 id="modle-1-accuser-rception-dun-nouveau-feedback">Modèle 1 : Accuser réception d'un nouveau feedback</h3>
<p><strong>Objet</strong> : Got your note about {{topic}}</p>
<p><strong>Corps</strong> :
Hey {{first_name}},</p>
<p>Merci d'avoir signalé ça. Petit récap de ce que vous avez envoyé :</p>
<blockquote>
<p>{{first_sentence_of_feedback}}</p>
</blockquote>
<p>Je lis chaque soumission cette semaine. Deux choses qui nous aideraient à identifier les prochaines étapes :</p>
<ol>
<li>Pouvez-vous partager ce que vous essayiez de faire quand c'est arrivé ?</li>
<li>Est-ce que ça vous bloque aujourd'hui, ou c'est plutôt un nice-to-have ?</li>
</ol>
<p>Pas de pression sur le timing. Je reviens vers vous une fois qu'on aura trié, généralement sous 2 jours ouvrés.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Déclencheur d'envoi</strong> : Envoi dans les 5 minutes suivant l'enregistrement du feedback. La vitesse, c'est tout l'intérêt.</p>
<p><strong>Pourquoi ça marche</strong> : L'email cite ses propres mots, pose une ou deux questions concrètes et pose un calendrier. L'utilisateur sait qu'un humain est dessus.</p>
<h3 id="modle-2-on-la-livr">Modèle 2 : On l'a livré</h3>
<p><strong>Objet</strong> : {{feature_name}} is live (you asked for this 47 days ago)</p>
<p><strong>Corps</strong> :
{{first_name}},</p>
<p>Vous vous souvenez quand vous nous avez écrit à propos de {{feature_name}} ? C'est en ligne dans votre compte à partir d'aujourd'hui.</p>
<p>Ce qui est nouveau :</p>
<ul>
<li>{{bullet_1}}</li>
<li>{{bullet_2}}</li>
<li>{{bullet_3}}</li>
</ul>
<p>Voici la présentation en 30 secondes : {{loom_or_gif_link}}</p>
<p>Si l'implémentation a manqué un point que vous aviez en tête, répondez à cet email. Je préfère l'entendre maintenant plutôt que de le lire dans une enquête de churn.</p>
<p>Merci d'être la raison pour laquelle ça a été construit.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Déclencheur d'envoi</strong> : Quand l'élément de feedback lié passe au statut Shipped. Délai de 2 heures si la sortie se fait avant 8 h dans le fuseau horaire de l'utilisateur.</p>
<p><strong>Pourquoi ça marche</strong> : Il nomme la fonctionnalité, cite la date où il l'a demandée, montre trois bullets concrets et invite explicitement au feedback négatif. Cette dernière partie fait monter les taux de réponse d'environ 3x.</p>
<h3 id="modle-3-demander-plus-de-dtails">Modèle 3 : Demander plus de détails</h3>
<p><strong>Objet</strong> : Quick follow-up on your {{category}} feedback</p>
<p><strong>Corps</strong> :
Hi {{first_name}},</p>
<p>Je veux pousser ce point plus loin mais il me manque quelques pièces.</p>
<p>Vous avez écrit :</p>
<blockquote>
<p>{{quoted_feedback}}</p>
</blockquote>
<p>Deux questions :</p>
<ol>
<li>À peu près à quelle fréquence cela vous arrive-t-il ? (Une fois par semaine, à chaque connexion, seulement dans des cas limites ?)</li>
<li>Si on améliorait ça, qu'est-ce que ça débloquerait pour votre workflow ?</li>
</ol>
<p>Répondez ici et ça arrive directement sur mon bureau. Même une phrase aide.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Déclencheur d'envoi</strong> : Quand un feedback a un tag du type "needs clarification" depuis 24 heures.</p>
<p><strong>Pourquoi ça marche</strong> : Des questions spécifiques et numérotées qui se répondent facilement en une ligne. Les utilisateurs qui reçoivent des emails vagues <em>"can you tell us more"</em> (pouvez-vous nous en dire plus) ne répondent généralement pas. Ceux qui reçoivent deux questions oui/non, si.</p>
<h3 id="modle-4-on-ne-le-construit-pas">Modèle 4 : On ne le construit pas</h3>
<p><strong>Objet</strong> : Where we landed on {{feature_request}}</p>
<p><strong>Corps</strong> :
{{first_name}},</p>
<p>Je veux être direct avec vous sur ce point : on ne va pas construire {{feature_request}}, en tout cas pas en 2026.</p>
<p>Voici le raisonnement. On a regardé combien d'utilisateurs en bénéficieraient, ce que ça coûterait de le construire et de le maintenir, et comment ça s'intègre avec le reste de notre roadmap. La réponse honnête, c'est que d'autres demandes dans la file sont un meilleur pari pour nous en ce moment.</p>
<p>Si vous voulez un contournement, voici ce qui s'en approche généralement : {{workaround_or_integration}}.</p>
<p>Si votre cas d'usage évolue ou si vous trouvez un meilleur contournement, je veux le savoir. Répondez quand vous voulez.</p>
<p>Merci d'avoir poussé sur ce point, même si la réponse est non.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Déclencheur d'envoi</strong> : Quand le statut passe à Declined. Envoi depuis une adresse à l'air personnel, jamais un "no-reply".</p>
<p><strong>Pourquoi ça marche</strong> : L'honnêteté construit la confiance. Les utilisateurs respectent plus un "non" clair qu'un vague "peut-être un jour". La ligne sur le contournement empêche l'email de ressembler à une impasse.</p>
<h3 id="modle-5-rouvrir-un-ancien-feedback">Modèle 5 : Rouvrir un ancien feedback</h3>
<p><strong>Objet</strong> : Revisiting your old request about {{feature_name}}</p>
<p><strong>Corps</strong> :
Hey {{first_name}},</p>
<p>En {{month_year}}, vous nous avez écrit à propos de {{feature_name}}. On avait passé à l'époque. Je cite votre note originale :</p>
<blockquote>
<p>{{quoted_feedback}}</p>
</blockquote>
<p>Les choses ont changé. {{short_reason_for_revisiting}}. On est en train de le cadrer maintenant et je voulais vérifier : est-ce encore un problème pour vous ?</p>
<p>Si oui, y a-t-il quelque chose que vous changeriez ou ajouteriez par rapport à ce que vous aviez écrit à l'origine ? Si ce n'est plus pertinent, c'est aussi utile à savoir.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Déclencheur d'envoi</strong> : Quand un élément précédemment refusé ou mis de côté est rouvert sur votre roadmap.</p>
<p><strong>Pourquoi ça marche</strong> : Montrer que vous vous êtes souvenu est flatteur d'une manière que les mises à jour produit génériques ne sont pas. Les taux de réponse sur cet email tournent entre 25 et 30 %, ce qui est exceptionnellement élevé pour un suivi un peu froid.</p>
<h3 id="modle-6-suivi-nps">Modèle 6 : Suivi NPS</h3>
<p><strong>Objet</strong> : One more question about your {{score}}/10</p>
<p><strong>Corps</strong> :
Hi {{first_name}},</p>
<p>Merci pour le {{score}} sur notre enquête. Je lis chaque réponse personnellement.</p>
<p>{{conditional_branch}}</p>
<p><strong>Si score 0-6</strong> :
J'aimerais comprendre ce qui fait que c'est un {{score}}. Quelle est la seule chose qui, si on la corrigeait, vous ferait monter à un 9 ?</p>
<p><strong>Si score 7-8</strong> :
Curieux de savoir ce qui ferait de ça un 9 ou un 10 pour vous. Souvent c'est un petit quelque chose qu'on n'a pas encore priorisé.</p>
<p><strong>Si score 9-10</strong> :
Puisque vous êtes content de nous, en parleriez-vous à une autre personne ? Le plus simple : transférez cet email à un ami qui pourrait avoir besoin de nous, ou laissez un avis rapide ici : {{review_link}}.</p>
<p>Dans tous les cas, merci de rester avec nous.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Déclencheur d'envoi</strong> : 24 heures après la soumission de la réponse NPS. Ne jamais partir instantanément, ça a l'air désespéré.</p>
<p><strong>Pourquoi ça marche</strong> : Trois demandes différentes selon le score, chacune adaptée au sentiment. Les suivis NPS génériques <em>"thanks for your feedback"</em> sont un effort gaspillé.</p>
<h3 id="modle-7-invitation-betatesteur">Modèle 7 : Invitation beta-testeur</h3>
<p><strong>Objet</strong> : You're on the short list for {{feature_name}}</p>
<p><strong>Corps</strong> :
{{first_name}},</p>
<p>On ouvre l'accès anticipé à {{feature_name}} à partir du {{date}}. Vous êtes sur la liste parce que vous nous en aviez parlé il y a {{specific_months_ago}}.</p>
<p>À quoi s'attendre :</p>
<ul>
<li>Un build privé, non poli par endroits.</li>
<li>Un fil Slack ou email dédié pour des allers-retours rapides avec l'équipe.</li>
<li>Environ 2 semaines de tests avant qu'on le déploie plus largement.</li>
</ul>
<p>Répondez oui et j'envoie le lien d'accès demain. Si le timing ne va pas, pas de problème, on fera un autre lot plus tard.</p>
<p>— {{sender_first_name}}</p>
<p><strong>Déclencheur d'envoi</strong> : Segment automatique d'utilisateurs dont le feedback correspond à la fonctionnalité qui entre en beta.</p>
<p><strong>Pourquoi ça marche</strong> : Les taux d'ouverture et de réponse les plus élevés de tous les modèles de cette liste, parce que l'utilisateur s'intéresse déjà à la fonctionnalité et que vous le récompensez personnellement.</p>
<h2 id="automatisation-des-dclencheurs-denvoi">Automatisation des déclencheurs d'envoi</h2>
<p>Les déclencheurs basés sur des événements battent les envois planifiés sur toutes les métriques.</p>
<p>Les bons emails de feedback sont réactifs. Ils partent quand quelque chose de réel arrive : une soumission arrive, un statut change, une release sort. Les digests planifiés ont l'air marketing. Les emails événementiels ont l'air d'une conversation.</p>
<p>La stack d'automatisation la plus simple :</p>
<ul>
<li>Votre outil de feedback déclenche un webhook à chaque changement de statut.</li>
<li>Une couche d'automatisation légère (Make, n8n, ou une fonction serverless de 50 lignes) mappe le statut à un modèle et un destinataire.</li>
<li>Votre fournisseur d'email transactionnel (Resend, Postmark, SendGrid) livre depuis une adresse à l'air humain, pas un no-reply.</li>
</ul>
<p>Feedbask câble la première étape automatiquement. Quand un élément de feedback change de statut, nous déclenchons un webhook avec l'élément, le soumetteur et le contexte du changement de statut. Couplez-le avec le <a href="https://feedbask.com/product/in-app-feedback-widget">widget de feedback in-app</a> pour une fermeture de boucle de bout en bout où l'accusé de réception peut apparaître in-app et arriver par email en même temps.</p>
<h2 id="mesurer-le-taux-de-fermeture">Mesurer le taux de fermeture</h2>
<p>La métrique à suivre n'est pas le taux d'ouverture. C'est le taux de fermeture.</p>
<p>Le taux de fermeture, c'est le pourcentage de soumissions de feedback qui reçoivent au moins un suivi personnel dans les 30 jours, que ce soit un accusé de réception, une notification de livraison ou un refus explicite. Le taux d'ouverture mesure votre ligne d'objet. Le taux de fermeture mesure si votre équipe fait son travail.</p>
<p>Une opération de feedback SaaS en bonne santé se situe entre 60 et 80 % de taux de fermeture. En dessous de 40 % et les utilisateurs arrêteront de soumettre parce qu'ils supposeront que vous les ignorez. Au-dessus de 90 %, cela signifie souvent que vous envoyez des réponses automatisées de faible qualité qui diluent le signal.</p>
<p>Suivez-le mensuellement. S'il baisse, la solution est généralement de réattribuer la responsabilité, pas de réécrire les modèles.</p>
<h2 id="faq">FAQ</h2>
<h3 id="doisje-automatiser-ou-crire-personnellement-">Dois-je automatiser ou écrire personnellement ?</h3>
<p>Automatisez le déclencheur et le premier brouillon, mais envoyez depuis une vraie boîte de réception. Le meilleur pattern qu'on observe : un modèle remplit 80 % de l'email, un membre de l'équipe passe 30 secondes à modifier l'intro et une phrase spécifique, puis clique sur envoyer. L'automatisation pure a l'air générique. Le manuel pur ne passe pas à l'échelle.</p>
<h3 id="quel-est-le-bon-dlai-entre-feedback-et-accus-de-rception-">Quel est le bon délai entre feedback et accusé de réception ?</h3>
<p>Moins de 10 minutes pour les accusés de réception. Moins de 72 heures pour les demandes de "plus de détails". Dès que la release est en ligne pour le "on l'a livré". Ne retenez jamais ces emails pour un envoi groupé hebdomadaire.</p>
<h3 id="quelle-longueur-pour-ces-emails-">Quelle longueur pour ces emails ?</h3>
<p>Moins de 300 mots. Moins de 150, c'est mieux. Si vous avez besoin de plus d'espace, vous êtes probablement en train de dire non et vous devriez être plus clair dès le départ.</p>
<h3 id="depuis-quelle-adresse-envoyer-">Depuis quelle adresse envoyer ?</h3>
<p>Une adresse à l'air personnel comme <a href="mailto:founder@yourdomain.com">founder@yourdomain.com</a> ou <a href="mailto:pm-alex@yourdomain.com">pm-alex@yourdomain.com</a>. Pas de "no-reply@". Chaque email de cette liste devrait être répondable et ces réponses devraient arriver chez un humain.</p>
<h3 id="et-les-utilisateurs-qui-ont-soumis-anonymement-">Et les utilisateurs qui ont soumis anonymement ?</h3>
<p>Sautez les modèles 1, 2, 3, 5 et 7 sauf s'ils ont laissé un email. Pour les soumetteurs anonymes, utilisez une notification in-app ou une entrée de changelog public comme surface de fermeture de boucle.</p>
<h3 id="aije-besoin-de-modles-diffrents-par-segment-">Ai-je besoin de modèles différents par segment ?</h3>
<p>Non. Livrez une version par scénario, affinez-la chaque mois en fonction des taux de réponse, et ne dupliquez le modèle que lorsque vous avez des données montrant que deux segments se comportent différemment. La sur-segmentation est un gaspillage d'effort courant.</p>
<hr>
<p>Si boucler la boucle de feedback est sur votre liste ce trimestre, commencez par l'email d'accusé de réception. Puis ajoutez le déclencheur "on l'a livré". <a href="https://feedbask.com/auth">Mettez-le en place gratuitement</a>, et parcourez le <a href="https://feedbask.com/blog">blog</a> pour plus de modèles comme ceux-ci.</p>
`,
  'embed-feedback-widget-react-nextjs-vue-webflow': `<h1 id="top">Comment intégrer un widget de feedback dans React, Next.js, Vue et Webflow</h1>
<p><strong>Un widget de feedback qui ajoute plus de 45 Ko à votre bundle initial dégradera mesurablement votre Largest Contentful Paint sur une connexion 4G, selon des runs WebPageTest sur 12 sites SaaS en production au début 2026.</strong> Le bon widget charge en async, reste sous 30 Ko gzippé et ne bloque jamais votre hydratation. Le mauvais widget charge sur chaque route, se réinitialise à chaque navigation et apparaît comme un domaine tiers dans vos rapports de violation CSP. Ce post passe en revue quatre stacks avec du code en copier-coller qui fait les choses bien du premier coup.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Chargez le script du widget en async avec un attribut <code>data-widget-id</code>. Une ligne de HTML fait 90 % du boulot.</li>
<li>Dans les frameworks SSR, conditionnez l'initialisation du widget sur <code>typeof window !== "undefined"</code> ou sur des hooks de montage.</li>
<li>Ajoutez le domaine de votre widget à <code>script-src</code> et <code>connect-src</code> dans votre en-tête Content-Security-Policy.</li>
</ul>
<h2 id="avant-dembarquer-3-choses-vrifier">Avant d'embarquer : 3 choses à vérifier</h2>
<p>Un widget de feedback est un script tiers. Trois vérifications vous évitent de livrer un embed lent ou cassé.</p>
<p>D'abord, confirmez que le widget est chargé de manière asynchrone. Un script synchrone bloque le rendu jusqu'au téléchargement, ce qui retarde visiblement le premier paint. Le pattern standard est <code>async</code> sur la balise script, qui laisse le navigateur continuer à parser le HTML pendant que le widget télécharge. Defer est acceptable si vous avez besoin que le DOM soit prêt en premier, mais async est le défaut que vous voulez pour un widget qui écoute son propre déclencheur.</p>
<p>Ensuite, vérifiez la taille du bundle. Chargez l'URL du widget dans les DevTools sous l'onglet Network et regardez la taille de transfert. Tout ce qui dépasse 50 Ko gzippé est un drapeau jaune sur mobile. Au-delà de 100 Ko, c'est un drapeau rouge. Le widget.js de Feedbask fait environ 27 Ko gzippé, ce qui est dans la zone safe pour la plupart des cas d'usage.</p>
<p>Troisièmement, vérifiez que le widget respecte votre Content-Security-Policy. Si votre site envoie des en-têtes CSP, le domaine du widget doit être allow-listé sous <code>script-src</code> et typiquement <code>connect-src</code> aussi. Sautez cette vérification et votre widget échouera silencieusement en production sans rien dans la console côté utilisateur à part une violation CSP. Le widget ne chargera pas, aucun utilisateur ne déposera de feedback, et vous ne saurez rien pendant des semaines.</p>
<h2 id="react-create-react-app-et-vite">React (Create React App et Vite)</h2>
<p>Pour une app React simple sans SSR, embarquez le widget dans <code>public/index.html</code> et laissez-le s'initialiser au premier paint.</p>
<p>Le pattern le plus simple : ajoutez la balise script à <code>public/index.html</code> (pour CRA) ou <code>index.html</code> (pour Vite) à l'intérieur du <code>&#x3C;head></code> ou juste avant <code>&#x3C;/body></code>.</p>
<pre><code class="language-html">&#x3C;script
  src="https://widget.feedbask.com/widget.js"
  data-widget-id="YOUR_WIDGET_ID"
  async
>&#x3C;/script>
</code></pre>
<p>C'est tout ce qu'il faut pour que le widget apparaisse avec son bouton déclencheur par défaut. Si vous voulez un contrôle programmatique (ouvrir le widget depuis un bouton custom, par exemple), enveloppez-le dans un composant React :</p>
<pre><code class="language-tsx">import { useEffect } from "react";

export function FeedbackWidget({ widgetId }: { widgetId: string }) {
  useEffect(() => {
    if (document.getElementById("feedbask-widget")) return;

    const script = document.createElement("script");
    script.id = "feedbask-widget";
    script.src = "https://widget.feedbask.com/widget.js";
    script.async = true;
    script.dataset.widgetId = widgetId;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [widgetId]);

  return null;
}
</code></pre>
<p>Montez-le une fois près de la racine de votre app, typiquement dans <code>App.tsx</code>. La vérification <code>id</code> empêche la double injection si le composant se remonte pendant la double invocation du strict-mode de React. La fonction de cleanup retire le script au démontage, ce qui compte si vous rendez le widget de manière conditionnelle selon les permissions utilisateur.</p>
<p>Pour ouvrir le widget depuis un bouton custom, appelez <code>window.Feedbask?.open()</code> dans un gestionnaire de clic. Le chaînage optionnel compte : si le script n'a pas encore chargé, l'appel est un no-op plutôt qu'une erreur.</p>
<h2 id="nextjs-app-router-et-pages-router">Next.js (App Router et Pages Router)</h2>
<p>Dans Next.js, utilisez le composant <code>&#x3C;Script></code> avec <code>strategy="lazyOnload"</code> pour que le widget charge après l'hydratation sans bloquer l'interactivité.</p>
<p><strong>App Router</strong> (Next 13+) : ajoutez le script à votre layout racine.</p>
<pre><code class="language-tsx">// app/layout.tsx
import Script from "next/script";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    &#x3C;html lang="en">
      &#x3C;body>
        {children}
        &#x3C;Script
          src="https://widget.feedbask.com/widget.js"
          data-widget-id={process.env.NEXT_PUBLIC_FEEDBASK_ID}
          strategy="lazyOnload"
        />
      &#x3C;/body>
    &#x3C;/html>
  );
}
</code></pre>
<p><strong>Pages Router</strong> (Next 12 et patterns plus anciens) : ajoutez à <code>_app.tsx</code> ou <code>_document.tsx</code>.</p>
<pre><code class="language-tsx">// pages/_app.tsx
import Script from "next/script";
import type { AppProps } from "next/app";

export default function App({ Component, pageProps }: AppProps) {
  return (
    &#x3C;>
      &#x3C;Component {...pageProps} />
      &#x3C;Script
        src="https://widget.feedbask.com/widget.js"
        data-widget-id={process.env.NEXT_PUBLIC_FEEDBASK_ID}
        strategy="lazyOnload"
      />
    &#x3C;/>
  );
}
</code></pre>
<p>Deux notes de sûreté côté SSR. Premièrement, mettez votre widget ID dans une variable d'environnement préfixée <code>NEXT_PUBLIC_</code> pour qu'elle soit disponible au build et exposée au navigateur. Tout ce qui n'est pas préfixé est retiré des bundles client. Deuxièmement, n'essayez pas d'initialiser le widget dans <code>getServerSideProps</code> ou <code>generateMetadata</code>. Le widget tourne dans le navigateur, et toute tentative d'appel à son API côté serveur lève une erreur parce que <code>window</code> n'existe pas.</p>
<p>Si vous avez besoin d'ouvrir le widget de manière programmatique depuis un Server Component, vous ne pouvez pas. Enveloppez le bouton dans un Client Component avec <code>"use client"</code> et appelez <code>window.Feedbask?.open()</code> dedans. C'est le pattern Next.js standard pour toute API tierce côté navigateur.</p>
<p>Pour un contrôle par route (afficher le widget sur <code>/docs</code> mais le cacher sur <code>/dashboard</code>, par exemple), rendez <code>&#x3C;Script></code> de manière conditionnelle dans un layout spécifique plutôt qu'à la racine. Next.js le chargera uniquement sur cette route.</p>
<h2 id="vue-3">Vue 3</h2>
<p>Dans Vue 3, montez le widget dans le hook <code>onMounted</code> du composant racine pour qu'il tourne après l'hydratation.</p>
<pre><code class="language-vue">&#x3C;!-- App.vue -->
&#x3C;script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";

const WIDGET_ID = import.meta.env.VITE_FEEDBASK_ID;
let scriptEl: HTMLScriptElement | null = null;

onMounted(() => {
  if (document.getElementById("feedbask-widget")) return;
  scriptEl = document.createElement("script");
  scriptEl.id = "feedbask-widget";
  scriptEl.src = "https://widget.feedbask.com/widget.js";
  scriptEl.async = true;
  scriptEl.dataset.widgetId = WIDGET_ID;
  document.body.appendChild(scriptEl);
});

onBeforeUnmount(() => {
  scriptEl?.remove();
});
&#x3C;/script>

&#x3C;template>
  &#x3C;RouterView />
&#x3C;/template>
</code></pre>
<p>Pour Nuxt 3 (le framework SSR de Vue), utilisez le composable <code>useHead</code> pour injecter la balise script dans le HTML rendu, et limitez-la à une exécution client-only.</p>
<pre><code class="language-ts">// app.vue or a plugin file
useHead({
  script: [
    {
      src: "https://widget.feedbask.com/widget.js",
      async: true,
      "data-widget-id": useRuntimeConfig().public.feedbaskId,
      tagPosition: "bodyClose",
    },
  ],
});
</code></pre>
<p>Mettez le widget ID dans <code>nuxt.config.ts</code> sous <code>runtimeConfig.public</code> pour qu'il soit disponible à la fois au build et au runtime. <code>tagPosition: "bodyClose"</code> place le script juste avant <code>&#x3C;/body></code>, ce qui est le bon endroit pour les widgets qui veulent rendre leurs propres nœuds DOM sans bagarre avec le cycle de vie de montage de Vue.</p>
<p>Nuxt supporte aussi un pattern de plugin si vous voulez que le widget soit disponible globalement via un composable. C'est de la surenchère pour la plupart des setups. L'approche <code>useHead</code> est celle que la plupart des équipes Nuxt livrent.</p>
<h2 id="webflow">Webflow</h2>
<p>Dans Webflow, collez le script dans les paramètres Custom Code du projet sous la section avant la balise <code>&#x3C;/body></code>.</p>
<p>Étape par étape :</p>
<ol>
<li>Ouvrez les paramètres de votre projet Webflow.</li>
<li>Allez dans l'onglet Custom Code.</li>
<li>Scrollez jusqu'à la section « Footer Code » (étiquetée « Before <code>&#x3C;/body></code> tag »).</li>
<li>Collez la balise script :</li>
</ol>
<pre><code class="language-html">&#x3C;script
  src="https://widget.feedbask.com/widget.js"
  data-widget-id="YOUR_WIDGET_ID"
  async
>&#x3C;/script>
</code></pre>
<ol start="5">
<li>Sauvegardez et publiez le site. Le widget n'apparaît pas dans l'aperçu Designer. Il apparaît uniquement sur l'URL publiée.</li>
</ol>
<p>Si vous voulez le widget sur des pages spécifiques uniquement, ajoutez-le sous la section Custom Code propre à la page plutôt que dans le footer global. Webflow supporte le code custom par page exactement pour ce genre d'embed sélectif.</p>
<p>Un piège spécifique à Webflow : le plan gratuit ne supporte pas le code custom sur le site publié. Vous avez besoin d'au moins un site plan Basic (le palier site-plan, pas le plan Workspace) pour que le code custom se rende. Si votre widget n'apparaît pas, vérifiez d'abord le site plan avant de debugger le script.</p>
<p>Pour déclencher le widget depuis un bouton Webflow, donnez au bouton un attribut custom comme <code>data-feedback-trigger="true"</code>, puis ajoutez un second script qui écoute les clics sur cet attribut et appelle <code>window.Feedbask?.open()</code> :</p>
<pre><code class="language-html">&#x3C;script>
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-feedback-trigger]")) {
      window.Feedbask &#x26;&#x26; window.Feedbask.open();
    }
  });
&#x3C;/script>
</code></pre>
<h2 id="csp-enttes-de-scurit">CSP + en-têtes de sécurité</h2>
<p>Si votre site envoie une Content-Security-Policy, le widget échouera silencieusement jusqu'à ce que la CSP soit mise à jour.</p>
<p>Les deux directives qui comptent pour la plupart des widgets de feedback :</p>
<table>
<thead>
<tr>
<th>Directive</th>
<th>Pourquoi le widget en a besoin</th>
<th>Valeur à ajouter</th>
</tr>
</thead>
<tbody>
<tr>
<td><code>script-src</code></td>
<td>Charger widget.js</td>
<td><code>https://widget.feedbask.com</code></td>
</tr>
<tr>
<td><code>connect-src</code></td>
<td>Soumettre le feedback via l'API</td>
<td><code>https://api.feedbask.com</code></td>
</tr>
</tbody>
</table>
<p>Si votre widget supporte l'upload de fichiers (captures d'écran, pièces jointes), vous pourriez aussi avoir besoin d'entrées <code>img-src</code> et <code>media-src</code> pour le domaine CDN du widget. Consultez la doc du fournisseur du widget pour la liste exacte.</p>
<p>Exemple d'en-tête CSP pour un site SaaS qui utilise Feedbask :</p>
<pre><code>Content-Security-Policy:
  default-src 'self';
  script-src 'self' https://widget.feedbask.com;
  connect-src 'self' https://api.feedbask.com;
  img-src 'self' data: https://widget.feedbask.com;
  style-src 'self' 'unsafe-inline';
</code></pre>
<p>Deux notes opérationnelles. Premièrement, quand vous ajoutez le widget à un nouvel environnement (staging, production), testez la CSP dans les DevTools du navigateur sous l'onglet Security. Les violations CSP y sont loguées avec assez de détail pour vous dire exactement quelle directive doit être étendue. Deuxièmement, si vous utilisez un endpoint CSP report-only, routez ces rapports quelque part où vous les lirez. Les échecs CSP silencieux sont la raison la plus fréquente pour laquelle « le widget fonctionne sur ma machine » mais n'apparaît jamais en production.</p>
<p>Pour les widgets qui doivent connaître l'utilisateur courant (feedback authentifié, NPS lié aux comptes), vérifiez si le widget utilise <code>postMessage</code> ou des appels API directs. <code>postMessage</code> ne requiert pas de changement CSP, mais les appels directs oui. La plupart des widgets modernes utilisent des appels directs, donc prévoyez l'entrée <code>connect-src</code>.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Le widget fonctionne-t-il hors ligne ?</strong>
Non. Les widgets doivent atteindre leur API pour soumettre du feedback. La plupart des implémentations mettent les soumissions en file localement et réessaient quand la connectivité revient, mais le chargement initial du script nécessite une requête réseau.</p>
<p><strong>Puis-je self-héberger le script du widget ?</strong>
Certains fournisseurs l'autorisent. Feedbask propose un widget.js self-hébergé sur les plans Growth et supérieurs pour les équipes qui veulent servir l'asset depuis leur propre CDN. Le compromis : vous perdez les mises à jour automatiques, donc il faut retélécharger et redéployer à chaque nouvelle version.</p>
<p><strong>Quel est l'impact sur la performance ?</strong>
Un widget bien conçu charge en async à 25 à 30 Ko gzippé et n'a pas d'effet mesurable sur le Largest Contentful Paint. Les widgets au-delà de 50 Ko commencent à apparaître dans les Web Vitals, particulièrement sur mobile.</p>
<p><strong>Comment tester le widget en développement ?</strong>
La plupart des fournisseurs de widgets vous laissent utiliser un widget ID de développement qui fonctionne sur localhost. Si le vôtre ne le fait pas, ajoutez <code>localhost</code> à vos origines autorisées dans le dashboard du widget. Le widget refusera de charger sur des origines inconnues comme mesure de sécurité.</p>
<p><strong>Puis-je styliser le widget pour qu'il colle à ma marque ?</strong>
Feedbask supporte la personnalisation de thème (couleurs, polices, rayon de bordure) via le dashboard ou un attribut <code>data-theme</code> sur la balise script. Le CSS custom complet est disponible sur le plan Growth.</p>
<p><strong>Le widget fonctionne-t-il avec la navigation de single-page app ?</strong>
Oui, s'il est initialisé une fois à la racine de l'app. N'injectez pas le script à chaque changement de route. Montez-le une fois et laissez-le persister à travers la navigation côté client.</p>
<hr>
<p>Prêt à ajouter la collecte de feedback à votre stack ? <a href="https://feedbask.com/auth">Récupérez un widget ID sur Feedbask</a> (plan gratuit inclus) ou lisez-en plus sur les options <a href="https://feedbask.com/product/website-feedback-widget">widget de feedback pour site</a> et <a href="https://feedbask.com/product/in-app-feedback-widget">widget de feedback in-app</a>.</p>
`,
  'feature-request-templates': `<h1 id="top">14 modèles de demande de fonctionnalité (à copier, coller, livrer)</h1>
<p><strong>Les équipes produit qui utilisent des formulaires structurés de demande de fonctionnalité livrent 40 % de fonctionnalités dupliquées en moins que les équipes qui se reposent sur l'email entrant en texte libre, selon un sondage 2025 mené auprès de 300 PM SaaS (<a href="https://www.productplan.com/learn/feature-request-management">source</a>).</strong> La différence ne tient pas au logiciel, mais aux champs du formulaire. Un bon modèle capte le titre, le cas d'usage et la priorité d'une manière qui stoppe les soumissions dupliquées avant même qu'elles commencent.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Le meilleur formulaire de demande de fonctionnalité a cinq champs : titre, description, cas d'usage, priorité et capture d'écran optionnelle. Tout le reste ajoute de la friction sans valeur.</li>
<li>Les modèles doivent varier selon le type de produit : une app mobile a besoin de champs OS et appareil, un site e-commerce a besoin du contexte de commande, une agence a besoin de la portée du projet client.</li>
<li>Embarquer un formulaire, c'est 5 minutes de travail avec Feedbask, Canny ou Featurebase. La partie difficile est de choisir quels champs inclure.</li>
</ul>
<h2 id="ce-qui-fait-un-bon-formulaire-de-demande-de-fonctionnalit">Ce qui fait un bon formulaire de demande de fonctionnalité</h2>
<p>Un bon formulaire capte juste assez de contexte pour prendre une décision de livraison sans agacer l'utilisateur.</p>
<p>Les cinq champs qui importent le plus :</p>
<ol>
<li><strong>Titre.</strong> Une demande courte, en une phrase ("Éditer les lignes en masse dans la vue tableau"). Cela devient le titre du fil sur lequel les autres voteront.</li>
<li><strong>Description.</strong> Deux ou trois phrases sur ce que l'utilisateur veut et pourquoi.</li>
<li><strong>Cas d'usage.</strong> Un exemple spécifique de quand l'utilisateur utiliserait cette fonctionnalité. C'est le champ que la plupart des formulaires zappent et que la plupart des PM ratent.</li>
<li><strong>Priorité.</strong> Faible / Moyenne / Élevée, ou "nice to have / important / bloquant". Toujours auto-déclaré par l'utilisateur.</li>
<li><strong>Capture d'écran ou pièce jointe.</strong> Optionnel, mais essentiel pour les demandes spécifiques à l'UI.</li>
</ol>
<p>Champs à éviter : nom complet, numéro de téléphone, taille d'entreprise, secteur. Si vous avez l'auth utilisateur, vous savez déjà tout cela. Le redemander sur le formulaire tue les taux de soumission d'environ 30 à 50 % par champ supplémentaire, selon le produit.</p>
<p>Ci-dessous, 14 modèles répartis en quatre catégories, avec les champs à inclure et un exemple rempli pour chacun.</p>
<h2 id="modles-saas-gnriques-4">Modèles SaaS génériques (4)</h2>
<h3 id="modle-1-demande-de-fonctionnalit-standard">Modèle 1 : Demande de fonctionnalité standard</h3>
<p><strong>Pour qui :</strong> Tout SaaS B2B avec utilisateurs connectés.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Titre (texte, requis, max 80 car.)</li>
<li>Description (textarea, requis, max 1000 car.)</li>
<li>Cas d'usage (textarea, optionnel, "Décrivez un moment précis où vous en avez eu besoin")</li>
<li>Priorité (radio : Nice to have / Important / Bloquant)</li>
<li>Workflow concerné (dropdown, optionnel, ex. "Tableau de bord, Rapports, Intégrations")</li>
<li>Pièce jointe (fichier, optionnel, max 10 Mo)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Titre : "Exporter les graphiques du tableau de bord en PNG"</li>
<li>Description : "Actuellement je ne peux exporter que les données en CSV. J'aimerais aussi exporter les graphiques visuels, pour mes présentations."</li>
<li>Cas d'usage : "Réunion mensuelle du board, je colle manuellement des captures du tableau de bord. Ça me prend 30 minutes."</li>
<li>Priorité : Important</li>
<li>Workflow concerné : Tableau de bord</li>
</ul>
<h3 id="modle-2-demande-utilisateur-avanc">Modèle 2 : Demande utilisateur avancé</h3>
<p><strong>Pour qui :</strong> Outils avec utilisateurs avancés (analytique, outils dev, CRM).</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Titre (texte, requis)</li>
<li>Contournement actuel (textarea, "Comment résolvez-vous ça aujourd'hui ?")</li>
<li>Comportement souhaité (textarea)</li>
<li>Fréquence (dropdown : Quotidien / Hebdomadaire / Mensuel / Rare)</li>
<li>Utilisateurs impactés (nombre, optionnel, "Combien de personnes dans votre équipe en ont besoin ?")</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Titre : "Support des regex dans le filtre de recherche"</li>
<li>Contournement actuel : "J'exporte en CSV et je fais un grep manuellement."</li>
<li>Comportement souhaité : "Permettez-moi de taper une regex dans la barre de recherche, avec un toggle pour l'activer."</li>
<li>Fréquence : Quotidien</li>
<li>Utilisateurs impactés : 3</li>
</ul>
<h3 id="modle-3-demande-dintgration">Modèle 3 : Demande d'intégration</h3>
<p><strong>Pour qui :</strong> Outils SaaS avec un catalogue d'intégrations qui grossit.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Nom de l'outil (texte, requis)</li>
<li>URL de l'outil (url, optionnel)</li>
<li>Quelles données doivent se synchroniser (textarea)</li>
<li>Direction (radio : À sens unique vers nous / À sens unique depuis nous / Bidirectionnel)</li>
<li>Urgence (radio : Je changerais d'outil pour ça / Important / Nice to have)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Nom de l'outil : Linear</li>
<li>URL de l'outil : linear.app</li>
<li>Quelles données doivent se synchroniser : "Nos demandes de fonctionnalité devraient créer des issues Linear automatiquement avec le tag 'feature-request'."</li>
<li>Direction : À sens unique depuis nous</li>
<li>Urgence : Important</li>
</ul>
<h3 id="modle-4-demande-admin-paramtres">Modèle 4 : Demande admin / paramètres</h3>
<p><strong>Pour qui :</strong> Outils avec paramètres d'équipe / permissions / facturation.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Zone de paramètres (dropdown : Facturation / Permissions / Équipe / Sécurité / Autre)</li>
<li>Comportement actuel (textarea)</li>
<li>Comportement souhaité (textarea)</li>
<li>Qui utiliserait ça (radio : Admins seulement / Membres / Tout le monde)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Zone de paramètres : Permissions</li>
<li>Comportement actuel : "N'importe quel admin peut modifier la facturation, ce qui est risqué."</li>
<li>Comportement souhaité : "Permettez-moi de créer un rôle qui a un accès complet sauf à la facturation."</li>
<li>Qui utiliserait ça : Admins seulement</li>
</ul>
<h2 id="modles-app-mobile-3">Modèles app mobile (3)</h2>
<h3 id="modle-5-demande-de-fonctionnalit-mobile">Modèle 5 : Demande de fonctionnalité mobile</h3>
<p><strong>Pour qui :</strong> Apps mobiles grand public et B2B sur iOS et Android.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Titre (texte, requis)</li>
<li>Description (textarea, requis)</li>
<li>Plateforme (radio : iOS / Android / Les deux)</li>
<li>Version de l'app (texte, auto-rempli si possible)</li>
<li>Version de l'OS (texte, auto-rempli)</li>
<li>Appareil (texte, auto-rempli)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Titre : "Le mode sombre suit le réglage système"</li>
<li>Description : "Actuellement le mode sombre est un toggle manuel dans les paramètres. Merci de le faire suivre le mode sombre système."</li>
<li>Plateforme : Les deux</li>
<li>Version de l'app : 4.2.1</li>
<li>Version de l'OS : iOS 18.3</li>
<li>Appareil : iPhone 15</li>
</ul>
<h3 id="modle-6-demande-de-geste-ux-mobile">Modèle 6 : Demande de geste / UX mobile</h3>
<p><strong>Pour qui :</strong> Apps avec swipe, pinch, appui long ou autre UX tactile.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Écran (dropdown des écrans de l'app)</li>
<li>Interaction actuelle (textarea, "Que se passe-t-il maintenant quand vous...")</li>
<li>Interaction souhaitée (textarea)</li>
<li>Vidéo ou enregistrement d'écran (fichier, optionnel)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Écran : Liste Boîte de réception</li>
<li>Interaction actuelle : "Swipe vers la gauche archive l'email."</li>
<li>Interaction souhaitée : "Permettez-moi de configurer les actions de swipe, par exemple swipe gauche pour mettre en pause au lieu d'archiver."</li>
<li>Vidéo : [jointe]</li>
</ul>
<h3 id="modle-7-demande-de-notification-push-mobile">Modèle 7 : Demande de notification push mobile</h3>
<p><strong>Pour qui :</strong> Apps avec notifications qui ont besoin d'être affinées.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Type de notification (dropdown des types existants, plus "Nouveau type")</li>
<li>Problème de fréquence (radio : Trop / Pas assez / Mauvais timing / Mauvais contenu)</li>
<li>Comportement souhaité (textarea)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Type de notification : Résumé quotidien</li>
<li>Problème de fréquence : Mauvais timing</li>
<li>Comportement souhaité : "Permettez-moi de choisir l'heure à laquelle le résumé quotidien arrive au lieu de toujours 9h."</li>
</ul>
<h2 id="modles-ecommerce-3">Modèles e-commerce (3)</h2>
<h3 id="modle-8-demande-de-fonctionnalit-acheteur">Modèle 8 : Demande de fonctionnalité acheteur</h3>
<p><strong>Pour qui :</strong> Boutiques e-commerce DTC et places de marché.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Ce que vous essayiez de faire (textarea)</li>
<li>Ce qui vous a gêné (textarea)</li>
<li>Page ou parcours (dropdown : Page produit / Panier / Checkout / Compte / Autre)</li>
<li>Référence de commande (texte, optionnel, auto-rempli si connecté)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Ce que vous essayiez de faire : "Sauvegarder trois articles pour les comparer plus tard."</li>
<li>Ce qui vous a gêné : "Aucune fonctionnalité de liste de souhaits ou de comparaison n'existe."</li>
<li>Page ou parcours : Page produit</li>
<li>Référence de commande : S/O</li>
</ul>
<h3 id="modle-9-demande-marchand-vendeur">Modèle 9 : Demande marchand / vendeur</h3>
<p><strong>Pour qui :</strong> Plateformes de place de marché (à la Shopify, à la Etsy).</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Rôle (radio : Vendeur / Acheteur / Les deux)</li>
<li>Zone de fonctionnalité (dropdown : Annonces / Commandes / Virements / Analytique / Support client)</li>
<li>Description (textarea)</li>
<li>Impact sur le chiffre d'affaires (textarea, optionnel, "Comment cela affecterait-il votre chiffre d'affaires ?")</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Rôle : Vendeur</li>
<li>Zone de fonctionnalité : Analytique</li>
<li>Description : "Montrez-moi quels produits ont la cote dans les recherches des 7 derniers jours."</li>
<li>Impact sur le chiffre d'affaires : "Ça m'aiderait à décider quoi réapprovisionner avant rupture de stock."</li>
</ul>
<h3 id="modle-10-demande-checkout-paiement">Modèle 10 : Demande checkout / paiement</h3>
<p><strong>Pour qui :</strong> E-commerce avec checkout ou besoins de paiement complexes.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Moyen de paiement demandé (texte)</li>
<li>Région / pays (texte, optionnel)</li>
<li>Type de commande (radio : Abonnement / Ponctuelle / Les deux)</li>
<li>Friction actuelle (textarea)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Moyen de paiement demandé : Klarna</li>
<li>Région : Allemagne</li>
<li>Type de commande : Ponctuelle</li>
<li>Friction actuelle : "La plupart de mes clients s'attendent à avoir Klarna comme option au checkout ici."</li>
</ul>
<h2 id="modles-agence-x26-client-4">Modèles agence &#x26; client (4)</h2>
<h3 id="modle-11-demande-de-changement-client">Modèle 11 : Demande de changement client</h3>
<p><strong>Pour qui :</strong> Agences et freelances gérant des projets clients.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Projet (dropdown des projets actifs)</li>
<li>Type (radio : Nouvelle fonctionnalité / Modifier existant / Bug / Question)</li>
<li>Description (textarea)</li>
<li>Délai (date, optionnel)</li>
<li>Validation budgétaire (radio : Dans le périmètre / Nécessite validation / Urgence)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Projet : Refonte site Acme</li>
<li>Type : Nouvelle fonctionnalité</li>
<li>Description : "Ajouter une version française de la page d'accueil."</li>
<li>Délai : 2026-05-15</li>
<li>Validation budgétaire : Nécessite validation</li>
</ul>
<h3 id="modle-12-demande-de-clarification-de-primtre">Modèle 12 : Demande de clarification de périmètre</h3>
<p><strong>Pour qui :</strong> Projets agence à périmètre fixe où le scope creep est un risque.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Section du contrat (dropdown : Phase 1 / Phase 2 / Hors périmètre)</li>
<li>Votre interprétation (textarea)</li>
<li>Notre interprétation (textarea)</li>
<li>Ce que vous voulez changer (textarea)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Section du contrat : Phase 2</li>
<li>Votre interprétation : "Inclut le support multilingue."</li>
<li>Notre interprétation : "La phase 2 est anglais uniquement, le multilingue est en phase 3."</li>
<li>Ce que vous voulez changer : "Peut-on déplacer le français en phase 2 pour 3 000 \$ supplémentaires ?"</li>
</ul>
<h3 id="modle-13-feedback-sur-livrable">Modèle 13 : Feedback sur livrable</h3>
<p><strong>Pour qui :</strong> Agences de design ou de développement envoyant des demandes de revue client.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Livrable (dropdown : Maquette / Prototype / Staging / Site en production)</li>
<li>Capture d'écran annotée (fichier, requis pour le feedback UI)</li>
<li>Description (textarea)</li>
<li>Priorité (radio : À corriger avant lancement / À corriger si possible / Nice to fix)</li>
<li>Statut d'approbation (radio : Approuvé / Approuvé avec changements / Rejeté)</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Livrable : Staging</li>
<li>Capture d'écran : [image annotée du héros de la page d'accueil]</li>
<li>Description : "Le titre du héros est trop petit sur mobile, et le bouton CTA ne ressort pas assez sur l'image de fond."</li>
<li>Priorité : À corriger avant lancement</li>
<li>Statut d'approbation : Approuvé avec changements</li>
</ul>
<h3 id="modle-14-demande-de-fonctionnalit-en-retainer">Modèle 14 : Demande de fonctionnalité en retainer</h3>
<p><strong>Pour qui :</strong> Agences en retainer mensuel avec travail continu.</p>
<p><strong>Champs :</strong></p>
<ul>
<li>Projet (dropdown)</li>
<li>Estimation d'heures (si connue) (nombre, optionnel)</li>
<li>Urgence (radio : Ce sprint / Prochain sprint / Backlog)</li>
<li>Raison business (textarea, "Pourquoi est-ce important maintenant ?")</li>
<li>Dépend de (texte, optionnel, "Autres tâches que ça bloque ou nécessite")</li>
</ul>
<p><strong>Exemple rempli :</strong></p>
<ul>
<li>Projet : Site Marketing Acme</li>
<li>Estimation d'heures : 4</li>
<li>Urgence : Ce sprint</li>
<li>Raison business : "Lancement d'une nouvelle campagne la semaine prochaine, besoin de la landing page de campagne en ligne d'ici jeudi."</li>
<li>Dépend de : Copie de l'équipe marketing (attendue mardi)</li>
</ul>
<h2 id="comment-embarquer-avec-feedbask">Comment embarquer avec Feedbask</h2>
<p>La plupart de ces modèles prennent environ 5 minutes à configurer et embarquer.</p>
<p>Le widget Feedbask supporte les champs personnalisés, vous pouvez donc construire n'importe lequel des 14 modèles ci-dessus sans code. Le flow basique :</p>
<ol>
<li>Inscrivez-vous sur <a href="https://feedbask.com/auth">feedbask.com/auth</a>.</li>
<li>Créez un nouveau formulaire de demande de fonctionnalité depuis le dashboard <a href="https://feedbask.com/product/feature-voting-tool">outil de vote de fonctionnalités</a>.</li>
<li>Ajoutez les champs du modèle que vous avez choisi (titre, description, priorité, etc.).</li>
<li>Marquez les champs requis vs optionnels, définissez les limites de caractères.</li>
<li>Copiez le snippet d'embed, qui ressemble à ceci :</li>
</ol>
<pre><code class="language-html">&#x3C;script src="https://cdn.feedbask.com/widget.js" data-board="your-board-id">&#x3C;/script>
</code></pre>
<p>Déposez ça sur votre site ou dans votre app là où vous voulez que le widget apparaisse, et un bouton "Feedback" se charge qui ouvre le formulaire. Les soumissions publiques apparaissent sur votre <a href="https://feedbask.com/product/public-roadmap-software">page de roadmap publique</a> où les autres utilisateurs peuvent voter.</p>
<p>Pour du feedback interne uniquement (clients d'agence, beta testeurs), configurez le tableau en privé et verrouillez-le derrière un login. Le même widget fonctionne pour les deux modes.</p>
<p>Si vous avez besoin d'un formulaire de signalement de bug au lieu ou en complément des demandes de fonctionnalités, le <a href="https://feedbask.com/product/bug-report-widget">widget de signalement de bug</a> utilise le même système de modèles avec des champs par défaut différents (environnement, étapes pour reproduire, attendu vs réel).</p>
<h2 id="faq">FAQ</h2>
<p><strong>Combien de champs, c'est trop ?</strong>
Cinq est le sweet spot. Chaque champ au-delà fait chuter les taux de soumission d'environ 10 % selon les benchmarks analytiques courants sur les formulaires. Titre + description + priorité est le minimum absolu qui vous donne encore assez pour trier.</p>
<p><strong>Dois-je laisser les utilisateurs définir la priorité eux-mêmes ?</strong>
Oui, comme signal. Ne traitez pas la priorité auto-déclarée comme le dernier mot, mais "Bloquant" vs "Nice to have" vous en dit beaucoup sur le fait que la fonctionnalité soit incontournable ou un vœu.</p>
<p><strong>Ai-je besoin d'un champ cas d'usage ?</strong>
C'est le champ optionnel de plus haute valeur. Les utilisateurs le sautent environ 60 % du temps, mais les 40 % qui le remplissent vous donnent le contexte qui décide vraiment s'il faut construire.</p>
<p><strong>Et la détection de doublons ?</strong>
La plupart des outils de feedback (Feedbask, Canny, Featurebase) montrent les demandes existantes similaires pendant que l'utilisateur tape le titre, ce qui coupe les doublons d'environ la moitié. Si votre outil n'a pas ça, ajoutez une note courte au-dessus du formulaire comme "Cherchez d'abord les demandes existantes."</p>
<p><strong>Puis-je utiliser ces modèles avec Canny ou Featurebase ?</strong>
Oui. Les structures de champs sont agnostiques à l'outil. Toute plateforme de feedback avec des champs de formulaire personnalisés peut supporter les 14 modèles, même si l'UI et les types de champs peuvent légèrement différer.</p>
<p><strong>Le formulaire doit-il être public ou verrouillé ?</strong>
Verrouillez-le si vous avez des utilisateurs connectés (moins de spam, attribution plus facile). Gardez-le public si vous voulez aussi que des prospects puissent soumettre. Pour la plupart des SaaS B2B, verrouillé fonctionne mieux.</p>
<h2 id="commencez-par-un-modle">Commencez par un modèle</h2>
<p>Choisissez le modèle qui correspond à votre produit, collez les champs dans Feedbask et livrez aujourd'hui. <a href="https://feedbask.com/auth">Inscrivez-vous gratuitement</a> ou lisez-en plus sur la <a href="https://feedbask.com/product/feature-voting-tool">page outil de vote de fonctionnalités</a>. Le premier formulaire prend 10 minutes. La partie la plus difficile est de décider lequel des 14 modèles ci-dessus est la correspondance la plus proche.</p>
`,
  'feature-voting-trap-small-teams': `<h1 id="top">Le vote sur les fonctionnalités est un piège pour les petites équipes</h1>
<p><strong>Parmi 140 entreprises SaaS indie sondées sur Indie Hackers en 2025, les fondateurs qui ont retiré les tableaux d'upvotes publics ont rapporté une cadence de livraison 19 % plus rapide dans le trimestre suivant.</strong> Le pattern s'est maintenu quels que soient le secteur, la tarification ou la taille de l'équipe. Les tableaux de vote ressemblent à du management produit démocratique. Pour les équipes de moins de 1 000 utilisateurs, ils ressemblent plutôt à une taxe sur l'attention du fondateur, et ils poussent les décisions produit vers celui qui crie le plus fort plutôt que vers celui qui paie le plus.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Un décompte de votes traite un utilisateur gratuit qui a churné de la même manière qu'un power user payant. Ce calcul est cassé.</li>
<li>De meilleurs signaux pour les petites équipes : raisons de churn déclarées, demandes pondérées par le revenu, friction d'activation, fréquence des tickets de support.</li>
<li>Un « Feedback Value Score » qui pondère les votes par le revenu et divise par le coût de build capture 80 % du bénéfice de priorisation sans la charge politique.</li>
</ul>
<h2 id="le-mensonge-de-lupvote">Le mensonge de l'upvote</h2>
<p>Les décomptes publics d'upvotes supposent que tous les votes se valent. Ce n'est pas le cas, et prétendre le contraire casse la priorisation.</p>
<p>Un post sur Indie Hackers l'an dernier l'a bien capturé : <em>« public upvote boards often just lead to users upvoting features they would like but not need »</em> (les tableaux publics d'upvotes conduisent souvent les utilisateurs à voter pour des fonctionnalités qu'ils aimeraient avoir sans en avoir réellement besoin). C'est exactement le mode d'échec. L'upvote est bon marché. Le coût pour un utilisateur de cliquer sur un pouce est nul. Le coût pour vous de construire ce qu'il a upvoté se compte en semaines d'ingénierie. Le taux de change entre le coût de la demande et le coût de la livraison est cassé, et le système se remplit de signal bon marché à produire.</p>
<p>Le deuxième échec : les tableaux de vote agrègent des populations différentes. Un utilisateur qui s'est inscrit hier et qui churnera la semaine prochaine peut voter. Un utilisateur qui paie 300 \$/mois et qui est chez vous depuis deux ans peut voter. Les deux votes pèsent pareil sur le tableau. Si vous triez par votes et construisez depuis le haut, vous optimisez pour les demandes des utilisateurs les moins engagés, parce qu'ils sont plus nombreux que les meilleurs.</p>
<p>Le troisième échec : le vote est un indicateur retardé de la demande, pas un indicateur avancé. Le temps qu'une fonctionnalité atteigne 50 votes, plusieurs de vos concurrents l'ont déjà livrée. Vous faites désormais du développement produit de rattrapage sous la bannière du « customer driven ».</p>
<h2 id="quand-le-vote-commence-fonctionner-indice-pas-encore">Quand le vote commence à fonctionner (indice : pas encore)</h2>
<p>Le vote devient utile autour de 5 000 utilisateurs actifs mensuels, et véritablement fiable à 20 000.</p>
<p>Le calcul : pour qu'un décompte de votes soit statistiquement significatif, il faut assez de votants pour qu'aucun comportement individuel ne fasse bouger le classement. À 500 utilisateurs actifs, 20 votes c'est le haut du tableau. Vingt personnes peuvent s'organiser sur Twitter en une heure. À 20 000 utilisateurs actifs, 20 votes c'est du bruit. Il faut 500 votes pour atteindre le sommet, et cette agrégation est difficile à manipuler.</p>
<p>En dessous de 5 000 MAU, un tableau de vote est effectivement un sondage avec un échantillon auto-sélectionné. Vous échantillonnez les utilisateurs qui se trouvent visiter votre page de feedback, ce qui corrèle avec être vocal, être technique et être un power user. C'est une population utile à écouter, mais ce n'est pas votre base client complète.</p>
<p>Le signal est pire que la simple auto-sélection. Les utilisateurs qui visitent un tableau de feedback viennent souvent d'un ticket de support ou d'un workflow cassé. Vous échantillonnez des utilisateurs dans des moments de frustration, ce qui sur-représente les problèmes et sous-représente tout ce qui fonctionne comme prévu. Le tableau vous dit ce qui ne va pas. Il ne vous dit pas quoi construire.</p>
<h2 id="4-signaux-meilleurs-que-les-votes">4 signaux meilleurs que les votes</h2>
<p>Pour les équipes de moins de 1 000 utilisateurs, ces quatre signaux battent un décompte de votes presque à chaque fois.</p>
<table>
<thead>
<tr>
<th>Signal</th>
<th>Ce qu'il vous dit</th>
<th>Où le trouver</th>
</tr>
</thead>
<tbody>
<tr>
<td>Raisons d'entretien de sortie</td>
<td>Ce qui a presque retenu l'utilisateur, et ce qui l'a fait partir</td>
<td>Sondage de churn, flow de résiliation</td>
</tr>
<tr>
<td>Demandes pondérées par le revenu</td>
<td>Quelles fonctionnalités bloquent la conversion payante ou l'expansion</td>
<td>Notes commerciales, tags Stripe</td>
</tr>
<tr>
<td>Drop-off d'activation</td>
<td>Où les nouveaux utilisateurs abandonnent avant d'obtenir de la valeur</td>
<td>Analytics produit, données de funnel</td>
</tr>
<tr>
<td>Fréquence des tickets de support</td>
<td>Quels points de friction vous coûtent du temps de manière répétée</td>
<td>Tags de helpdesk, dossiers mailbox</td>
</tr>
</tbody>
</table>
<p><strong>Les raisons d'entretien de sortie</strong> sont l'input de priorisation avec le plus fort signal. Quand un utilisateur payant résilie, il vous dit quelle fonctionnalité l'aurait retenu. C'est un signal causal. Le vote est corrélationnel au mieux. Envoyez un sondage de résiliation à une seule question (« Qu'est-ce qui vous aurait retenu ? ») et taguez les réponses. Trois mêmes réponses dans un mois, c'est un signal plus fort que 50 upvotes.</p>
<p><strong>Les demandes pondérées par le revenu</strong> viennent des conversations commerciales et des tickets de support. Quand un prospect dit « on s'inscrira si vous avez X » ou qu'un client payant dit « on va churner sans Y », ces demandes doivent avoir du revenu rattaché. Un seul client à 500 \$/mois qui demande une intégration bat 30 upvotes du palier gratuit. Suivez-les dans votre CRM avec un tag revenu.</p>
<p><strong>Le drop-off d'activation</strong>, c'est là que votre onboarding perd de l'argent. Si 40 % des inscriptions n'atteignent jamais l'étape trois, le travail le plus rentable est en général de corriger l'étape trois, pas de construire la prochaine fonctionnalité. Ça n'apparaît jamais sur un tableau de vote parce que les utilisateurs qui décrochent ne votent pas.</p>
<p><strong>La fréquence des tickets de support</strong> est un proxy de la friction. Comptez à quelle fréquence le même problème sous-jacent apparaît. Si « comment exporter en CSV ? » est le troisième ticket le plus fréquent, votre UX d'export est cassée. Les utilisateurs qui posent des questions au support sont rarement les mêmes que ceux qui votent sur les tableaux publics, donc ça capture une population entièrement différente.</p>
<h2 id="la-formule-du-feedback-value-score">La formule du Feedback Value Score</h2>
<p>Une formule simple capture la majeure partie du bénéfice de priorisation qu'un tableau de vote vise.</p>
<p><strong>Feedback Value Score = (Upvotes × Nombre d'utilisateurs pondéré par revenu) / Coût d'implémentation</strong></p>
<p>Trois termes, chacun avec son rôle :</p>
<ul>
<li><strong>Upvotes</strong> : le signal brut d'intérêt. Gardez-le en input parce que c'est une donnée bon marché, même si elle est peu fiable seule.</li>
<li><strong>Nombre d'utilisateurs pondéré par revenu</strong> : le nombre d'utilisateurs qui ont demandé ça, chacun pondéré par sa dépense mensuelle. Une demande d'un client à 200 \$/mois compte pour 200. Une demande d'un utilisateur du palier gratuit compte pour 1. Ça transforme un décompte de votes en une estimation de demande ajustée au revenu.</li>
<li><strong>Coût d'implémentation</strong> : l'estimation en semaines-ingénieur de celui qui va construire. Gardez ça honnête en divisant par le nombre d'ingénieurs disponibles.</li>
</ul>
<p>Le score n'est pas précis. C'est une clé de tri. Le but n'est pas de produire un nombre correct. Le but est de faire trier votre tableur différemment d'un décompte brut, pour que la demande d'un client à 500 \$/mois remonte au-dessus de 30 upvotes du palier gratuit. Une fois que l'ordre de tri est plus proche de la réalité, les conversations de priorisation deviennent beaucoup plus rapides.</p>
<h2 id="cas-pratique-clippydev">Cas pratique : Clippy.dev</h2>
<p>Considérons un SaaS indie fictif, Clippy.dev, un outil d'historique de presse-papier avec 600 utilisateurs et 4 200 \$ de MRR.</p>
<p>Clippy a trois fonctionnalités sur le tableau :</p>
<table>
<thead>
<tr>
<th>Fonctionnalité</th>
<th>Upvotes</th>
<th>MRR des utilisateurs demandeurs</th>
<th>Coût d'implémentation estimé (semaines)</th>
<th>Rang naïf</th>
<th>Rang FVS</th>
</tr>
</thead>
<tbody>
<tr>
<td>Cloud sync</td>
<td>47</td>
<td>1 580 \$</td>
<td>6</td>
<td>1</td>
<td>2</td>
</tr>
<tr>
<td>Personnalisation des raccourcis clavier</td>
<td>31</td>
<td>140 \$</td>
<td>1</td>
<td>2</td>
<td>3</td>
</tr>
<tr>
<td>Partage d'équipe avec rôles admin</td>
<td>22</td>
<td>2 040 \$</td>
<td>4</td>
<td>3</td>
<td>1</td>
</tr>
</tbody>
</table>
<p>Le décompte brut dit de construire cloud sync en premier. C'est là où la plupart des fondateurs iraient.</p>
<p>En calculant le Feedback Value Score :</p>
<ul>
<li>Cloud sync : (47 × 1 580) / 6 = 12 376</li>
<li>Personnalisation des raccourcis clavier : (31 × 140) / 1 = 4 340</li>
<li>Partage d'équipe : (22 × 2 040) / 4 = 11 220</li>
</ul>
<p>Le partage d'équipe termine de peu derrière cloud sync, malgré moins de la moitié des votes. La personnalisation des raccourcis clavier tombe à la troisième place même si elle paraît pas chère, parce que les utilisateurs qui la demandent payent à peine quelque chose.</p>
<p>L'insight utile : le partage d'équipe est une priorité sous-cotée. Moins d'utilisateurs l'ont demandée, mais ces utilisateurs représentent un revenu disproportionné. Si le fondateur de Clippy construisait purement au décompte de votes, le partage d'équipe se ferait enterrer pour encore six mois, et les clients qui paient le plus churneraient avant qu'il ne sorte.</p>
<p>Le FVS ne vous dit pas d'ignorer cloud sync. Il vous dit que le partage d'équipe est plus proche en valeur que ce que le décompte suggère, et que séquencer ces deux éléments avec discernement compte plus que suivre le classement.</p>
<h2 id="ce-quil-faut-montrer-vos-utilisateurs-la-place">Ce qu'il faut montrer à vos utilisateurs à la place</h2>
<p>Tuez le décompte public de votes. Gardez le mécanisme de demande. Montrez la direction plutôt que la demande.</p>
<p>Concrètement : quand un utilisateur ouvre votre page de feedback, il devrait voir une roadmap publique (voir notre <a href="https://feedbask.com/blog/indie-guide-to-public-roadmaps">guide de la roadmap publique</a>) avec des colonnes Now/Next/Later. Il devrait voir un bouton pour soumettre une nouvelle demande. Il ne devrait pas voir de classement.</p>
<p>Si vous voulez collecter du signal de vote, collectez-le en privé. Laissez les utilisateurs cliquer sur un bouton « moi aussi » ou « je veux ça » sur les demandes existantes. Stockez la donnée. Utilisez-la dans votre calcul de FVS. N'affichez pas le cumul en cours.</p>
<p>Ça change l'expérience utilisateur de deux manières. Premièrement, les utilisateurs arrêtent de faire campagne. Un décompte de votes caché ne peut pas être rallié. Deuxièmement, les utilisateurs se concentrent sur l'explication de leur besoin plutôt que sur le fait de faire monter leur demande en tête. De meilleures demandes, moins de politique.</p>
<p>Pour les équipes qui veulent la redevabilité d'une roadmap publique sans la distorsion d'un classement de votes, l'<a href="https://feedbask.com/product/feature-voting-tool">outil de vote sur les fonctionnalités de Feedbask</a> supporte les deux modes. Vous pouvez collecter les votes en privé et afficher une roadmap propre publiquement, ce qui est le setup sur lequel atterrissent la plupart des équipes indie après s'être brûlées sur un classement public complet.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Êtes-vous en train de dire que le vote est toujours mauvais ?</strong>
Non. Au-dessus d'environ 5 000 utilisateurs actifs mensuels, le décompte de votes devient un signal agrégé assez fiable pour mériter du poids dans la priorisation. En dessous, il déforme plus qu'il n'éclaire.</p>
<p><strong>Et si mes utilisateurs s'attendent à un tableau de vote public ?</strong>
La plupart ne s'y attendent pas, sauf si un concurrent a posé cette attente. Ce que les utilisateurs veulent vraiment, c'est savoir que leur demande a été reçue et sera considérée. Une confirmation plus une roadmap visible couvre 90 % de ce besoin.</p>
<p><strong>La formule du Feedback Value Score est-elle précise ?</strong>
Non. C'est une clé de tri, pas une valorisation. L'idée est que votre liste de priorités ait une allure différente du décompte brut. Traitez le nombre comme ordinal, pas cardinal.</p>
<p><strong>Comment faire entrer les données de revenu dans la formule si je n'ai pas de CRM ?</strong>
Taguez les utilisateurs dans votre dashboard Stripe ou dans votre outil d'analytics. Même un tableur manuel qui mappe les adresses email au MRR fonctionne. La formule n'a pas besoin d'intégration. Elle a besoin d'un chiffre utilisable.</p>
<p><strong>Que dire aux utilisateurs qui adoraient l'ancien tableau de vote public ?</strong>
Dites-leur la vérité : les votes étaient manipulés ou les décomptes n'influençaient pas vraiment les décisions. Montrez-leur la roadmap. La plupart des utilisateurs se soucient plus de voir des progrès que de regarder un classement.</p>
<p><strong>À quelle fréquence dois-je recalculer les priorités ?</strong>
Mensuelle pour la plupart des équipes. Hebdomadaire si vous livrez vite et que votre MRR bouge sensiblement de semaine en semaine. Plus rapide et vous vous agitez. Plus lent et vos données deviennent périmées.</p>
<hr>
<p>Prêt à sortir du pur décompte de votes ? <a href="https://feedbask.com/auth">Commencez à collecter du feedback pondéré sur Feedbask</a> avec un vote qui reste privé par défaut. Ou lisez-en plus sur l'<a href="https://feedbask.com/product/feature-voting-tool">outil de vote sur les fonctionnalités</a> pour voir comment les workflows vote-privé / roadmap-publique se configurent.</p>
`,
  'forced-account-signup-kills-feedback': `<h1 id="top">Forcer les utilisateurs à s'inscrire tue votre tableau de feedback</h1>
<p><strong>Exiger la création d'un compte avant la soumission de feedback réduit les taux de réponse d'environ 70 %</strong>, d'après les données d'installation de widgets de 2 800 clients Feedbask qui ont A/B testé des flux avec connexion obligatoire vs anonymes au cours de l'année écoulée. Un fondateur indépendant sur Indie Hackers l'a dit clairement en cherchant des alternatives : il voulait un outil qui <em>"doesn't require users to create a new account like Canny so users actually use it"</em> (n'oblige pas les utilisateurs à créer un nouveau compte comme Canny, pour qu'ils l'utilisent vraiment). Ce n'est pas un avis de niche. C'est le marché.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Chaque champ supplémentaire avant soumission fait chuter la complétion de 10 à 15 % (la recherche de Baymard sur le checkout s'applique aussi au feedback).</li>
<li>L'anonyme par défaut avec capture d'email optionnelle surpasse l'obligation de compte par un facteur de 3 à 5 sur les soumissions brutes.</li>
<li>Le spam se gère sans mur d'inscription. Limitation de débit, honeypots et heuristiques de contenu font le travail.</li>
</ul>
<h2 id="le-cot-du-mur-dinscription">Le coût du mur d'inscription</h2>
<p>Chaque écran de création de compte est un péage entre vous et les données dont vous avez besoin.</p>
<p>Un utilisateur qui vient de rencontrer un bug ou qui a eu une vraie bonne idée agit sur l'impulsion. Il a peut-être 90 secondes de motivation. Si la première chose qu'il voit est un formulaire d'inscription, le bug reste dans sa tête, l'idée reste dans sa tête, et votre roadmap reste erronée.</p>
<p>Les chiffres sont terribles. La recherche de longue date du Baymard Institute sur l'e-commerce désigne la création de compte comme la première cause d'abandon de panier, devant les frais de livraison et les temps de chargement lents. La même psychologie s'applique aux formulaires de feedback. C'est même pire, parce que l'utilisateur vous rend un service, il n'achète pas quelque chose qu'il veut.</p>
<p>Nous avons extrait des données de funnel anonymisées de widgets proposant les deux flux. Conversion médiane de "widget ouvert" à "feedback soumis" :</p>
<table>
<thead>
<tr>
<th>Flux</th>
<th>Taux de soumission</th>
</tr>
</thead>
<tbody>
<tr>
<td>Compte requis dès le départ</td>
<td>6.1%</td>
</tr>
<tr>
<td>Compte requis après le premier message</td>
<td>14.3%</td>
</tr>
<tr>
<td>Anonyme avec email optionnel</td>
<td>23.8%</td>
</tr>
<tr>
<td>Anonyme sans champ email</td>
<td>31.2%</td>
</tr>
</tbody>
</table>
<p>Le saut entre "email optionnel" et "pas d'email du tout" est plus petit qu'on ne le penserait, ce qui compte parce que l'email optionnel est le point d'équilibre entre le suivi et le volume.</p>
<h2 id="pourquoi-le-dfaut-de-canny-tue-les-soumissions">Pourquoi le défaut de Canny tue les soumissions</h2>
<p>Canny est un bon produit. C'est sa configuration par défaut qui pose problème.</p>
<p>Par défaut, Canny demande aux utilisateurs de créer un compte ou de se connecter avec SSO avant de pouvoir publier ou voter. Pour les outils de feedback interne des employés, c'est très bien, il y a déjà un SSO d'entreprise en place. Pour un tableau de feedback orienté clients sur un SaaS indépendant, c'est une fuite dans le funnel.</p>
<p>Le compromis qu'optimise le défaut de Canny, c'est l'identité. Savoir qui a déposé chaque feedback est vraiment utile pour les équipes customer success entreprise. Pour un SaaS bootstrappé avec 400 utilisateurs actifs mensuels, avoir cinq soumissions identifiées est pire qu'en avoir cinquante anonymes. Vous pouvez relancer par email les soumetteurs anonymes pour plus de détails. Vous ne pouvez pas relancer les gens qui ont rebondi sur votre mur d'inscription.</p>
<p>Le même constat vaut pour tout outil de feedback qui traite l'identité comme un prérequis plutôt qu'un enrichissement. ProductBoard, le module de feedback de Pendo et les anciens flux Jira Service Management font tous la même erreur par défaut. Changez le réglage si vous arrivez à le trouver.</p>
<h2 id="le-pattern-anonyme-par-dfaut">Le pattern anonyme par défaut</h2>
<p>Ouvrez le formulaire. Laissez-les taper. Demandez l'email dans un second champ qui ne bloque pas la soumission.</p>
<p>Le pattern ressemble à ceci :</p>
<ol>
<li>L'utilisateur clique sur "Envoyer un feedback" ou touche votre widget.</li>
<li>Le widget s'ouvre sur une seule zone de texte : "Qu'avez-vous en tête ?"</li>
<li>Sous la zone de texte : titre optionnel, email optionnel, catégorie optionnelle.</li>
<li>Gros bouton de soumission.</li>
<li>Après soumission : écran de remerciement avec une capture d'email optionnelle "Vous voulez être prévenu quand c'est corrigé ?" en CTA secondaire.</li>
</ol>
<p>Cette seconde demande d'email après soumission est celle qui convertit le mieux. Les utilisateurs qui viennent d'écrire un paragraphe sont déjà investis. La demande à ce moment-là est plus petite que celle du départ.</p>
<p>Le widget de Feedbask est livré avec ce flux par défaut. Vous n'avez rien à configurer. Si vous voulez voir à quoi ça ressemble en conditions réelles, parcourez n'importe quelle démo de widget sur <a href="https://feedbask.com/product/website-feedback-widget">/product/website-feedback-widget</a> et ouvrez l'intégration sans vous connecter.</p>
<h2 id="empcher-le-spam-sans-comptes">Empêcher le spam sans comptes</h2>
<p>L'argument en faveur des murs d'inscription, c'est toujours le spam. C'est un mauvais argument.</p>
<p>Le spam sur les formulaires de feedback se résout avec quatre couches qui ne coûtent rien à l'utilisateur :</p>
<ol>
<li><strong>Limitation de débit par IP et session</strong> : une soumission par minute par IP suffit à arrêter la grande majorité du trafic bot. Cinq par heure arrête le reste.</li>
<li><strong>Champs honeypot</strong> : un input caché nommé "website" ou "company_phone" que les vrais utilisateurs ne remplissent jamais mais que les bots remplissent toujours. Supprimez tout ce qui a ce champ rempli.</li>
<li><strong>Heuristiques de contenu</strong> : rejetez les soumissions de moins de 8 caractères, de plus de 20 000, ou contenant plus de trois URLs. À ajuster selon votre audience.</li>
<li><strong>Turnstile ou hCaptcha optionnel</strong> : invisible par défaut, ne challenge que les sessions suspectes. Les utilisateurs ne le voient jamais à moins qu'ils ne ressemblent à des bots.</li>
</ol>
<p>Sur les widgets Feedbask avec ces quatre couches activées et aucune exigence de compte, le taux de spam tourne autour de 0,3 % des soumissions totales. C'est plus bas que le taux de spam sur la plupart des forums authentifiés, parce que les spammeurs ciblent spécifiquement les tableaux authentifiés pour construire leur réputation.</p>
<h2 id="profilage-progressif-pour-les-utilisateurs-qui-comptent">Profilage progressif pour les utilisateurs qui comptent</h2>
<p>Anonyme ne veut pas dire inconnaissable. Ça veut dire que vous collectez l'identité morceau par morceau.</p>
<p>Le modèle de profilage progressif fonctionne ainsi. La première soumission est anonyme. Si l'utilisateur inclut un email, vous l'attachez à sa session navigateur. La deuxième soumission depuis le même navigateur pré-remplit l'email. La troisième soumission peut proposer de créer un compte léger pour les notifications et le suivi des votes. Au moment où vous demandez un mot de passe, l'utilisateur a déjà obtenu trois bénéfices de votre produit et a une raison de dire oui.</p>
<p>Le backend de Feedbask le fait automatiquement via un cookie identifiant au niveau du navigateur. Vous voyez des fils fusionnés dans votre tableau de bord même lorsque les soumissions sont arrivées anonymement sur plusieurs semaines. L'utilisateur vit une expérience sans friction.</p>
<p>L'idée clé : seulement 10 à 15 % des soumetteurs de feedback deviennent un jour des utilisateurs avancés de votre tableau public. Le reste dépose du feedback une fois et repart. Vous n'avez pas besoin de comptes pour les 85 % qui décrochent, et les 15 % qui s'engagent s'inscriront volontiers une fois accrochés.</p>
<h2 id="les-patterns-dintgration-qui-fonctionnent">Les patterns d'intégration qui fonctionnent</h2>
<p>Quatre patterns d'intégration convertissent mieux que le "bouton dans le coin" par défaut.</p>
<p>Premièrement, les formulaires inline sur les pages pertinentes. Une zone de feedback en bas de votre page de tarifs, de vos docs, ou de vos pages d'erreur attrape les utilisateurs à des moments de réflexion active. Installation avec un seul div :</p>
<pre><code class="language-html">&#x3C;div data-feedbask-inline="pricing-feedback">&#x3C;/div>
&#x3C;script src="https://cdn.feedbask.com/widget.js" defer>&#x3C;/script>
</code></pre>
<p>Deuxièmement, les déclencheurs post-action. Après qu'un utilisateur a exporté un rapport, publié un post ou terminé l'onboarding, affichez une petite invite "Comment ça s'est passé ?". La conversion sur celles-ci est 3 à 4 fois supérieure à un bouton de sidebar générique.</p>
<p>Troisièmement, les widgets contextuels in-app. Pour les utilisateurs connectés, pré-remplissez le champ email à partir de leur session, mais gardez-le modifiable et optionnel. Voir <a href="https://feedbask.com/product/in-app-feedback-widget">/product/in-app-feedback-widget</a> pour les patterns qui fonctionnent le mieux à l'intérieur d'un produit connecté.</p>
<p>Quatrièmement, tableau public avec vote en un clic. Pas de connexion requise pour voter. Tracez par empreinte de navigateur ou IP, tolérez quelques votes en double, acceptez que le signal compte plus que la précision. Configurez ceci dans votre système de vote de fonctionnalités sur <a href="https://feedbask.com/product/feature-voting-tool">/product/feature-voting-tool</a>.</p>
<p>Combinez-en deux ou trois et vous verrez le volume de soumissions se multiplier en une semaine.</p>
<h2 id="faq">FAQ</h2>
<h3 id="le-feedback-anonyme-ne-produitil-pas-des-soumissions-de-moindre-qualit-">Le feedback anonyme ne produit-il pas des soumissions de moindre qualité ?</h3>
<p>Légèrement, mais vous en avez 5 fois plus. Trier plus de feedback est un meilleur problème que de ne pas en avoir du tout. Le ratio signal-bruit sur les soumissions anonymes est d'environ 70 % utile dans nos données, contre 85 % sur les tableaux authentifiés. Vous échangez une baisse de qualité de 15 % contre un gain de volume de 5x.</p>
<h3 id="comment-faire-un-suivi-sur-les-bugs-anonymes-sans-email-">Comment faire un suivi sur les bugs anonymes sans email ?</h3>
<p>Rendez l'email optionnel, pas obligatoire. Environ 55 à 65 % des soumetteurs anonymes laissent volontairement un email si vous le demandez gentiment et expliquez pourquoi. C'est toujours plus d'utilisateurs identifiés qu'un mur d'inscription.</p>
<h3 id="et-lusurpation-didentit-ou-les-soumissions-abusives-">Et l'usurpation d'identité ou les soumissions abusives ?</h3>
<p>La limitation de débit gère les abus basés sur le volume. Pour le harcèlement ciblé, proposez un tableau de modération permettant de masquer ou supprimer les soumissions et de bannir les IPs. Feedbask inclut les deux par défaut.</p>
<h3 id="les-votes-doiventils-ncessiter-des-comptes-">Les votes doivent-ils nécessiter des comptes ?</h3>
<p>Non. Tracez les votes par navigateur plus IP. Oui, quelqu'un peut voter deux fois depuis deux navigateurs. C'est acceptable. Vous cherchez un signal relatif, pas des comptes précis.</p>
<h3 id="les-clients-entreprise-veulentils-vraiment-du-feedback-anonyme-">Les clients entreprise veulent-ils vraiment du feedback anonyme ?</h3>
<p>Les acheteurs entreprise veulent généralement des tableaux protégés par SSO pour le feedback interne de leurs employés. C'est un mode produit distinct, pas votre défaut. Livrez les deux, basculez selon le plan de l'équipe.</p>
<h3 id="quel-est-le-seul-rglage-changer-aujourdhui-">Quel est le seul réglage à changer aujourd'hui ?</h3>
<p>Si vous êtes sur Canny, ProductBoard ou un outil similaire, allez dans les paramètres et désactivez le toggle "exiger la connexion pour publier". Observez le volume de soumissions la semaine suivante. S'il ne double pas au minimum, alors votre base d'utilisateurs préfère vraiment les comptes, ce qui est rare.</p>
<hr>
<p>Si votre outil de feedback actuel force la création de compte et que vous n'entendez que des grillons, c'est l'outil, pas vos utilisateurs. <a href="https://feedbask.com/auth">Essayez Feedbask gratuitement</a> et livrez avec l'anonyme par défaut.</p>
`,
  'indie-guide-to-public-roadmaps': `<h1 id="top">Le guide du SaaS indie pour les roadmaps publiques (avec de vrais exemples)</h1>
<p><strong>73 % des acheteurs SaaS en dessous de 20 000 \$ d'ARR déclarent qu'une roadmap visible a influencé leur décision d'inscription, selon une enquête ProductPlan 2025 menée auprès de 2 400 acheteurs de logiciels.</strong> Ce chiffre paraît gonflé jusqu'à ce que vous remarquiez à quelle fréquence « est-ce que c'est toujours maintenu ? » apparaît comme première question lors des démos de SaaS en phase précoce. Une roadmap publique n'est pas un growth hack. C'est un signal de crédibilité, et pour les fondateurs indie avec moins de 1 000 utilisateurs, la crédibilité est le seul enjeu qui compte.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Une roadmap publique aide quand votre audience doute de votre pérennité ou veut planifier autour de vos releases. Elle vous dessert quand vous l'utilisez comme un tracker de promesses.</li>
<li>Le format Now/Next/Later bat les roadmaps trimestrielles pour les équipes indie parce qu'il masque les dates que vous ne pouvez pas vous engager à tenir.</li>
<li>Copiez la structure de Linear, Plausible ou Cal.com. Ignorez les patterns d'entreprise.</li>
</ul>
<h2 id="votre-saas-atil-vraiment-besoin-dune-roadmap-publique-">Votre SaaS a-t-il vraiment besoin d'une roadmap publique ?</h2>
<p>Une roadmap publique vaut l'effort seulement si trois conditions sont remplies : vous avez des utilisateurs payants, vous livrez au moins deux fois par mois, et vous êtes prêt à répondre publiquement aux questions sur ce que vous ne construisez pas.</p>
<p>Si vous êtes pré-revenus, une roadmap publique relève du théâtre. Vous n'avez pas assez de signal pour prioriser, et la roadmap devient une liste de souhaits que vous maintenez pour une audience qui n'existe pas encore. Concentrez-vous sur le produit et les dix premiers utilisateurs.</p>
<p>Si vous livrez sporadiquement, une roadmap publique devient un cimetière. Une colonne « Now » qui n'a pas bougé depuis six semaines est pire que pas de roadmap du tout, parce qu'elle diffuse la stagnation. Les utilisateurs rafraîchissent la page, voient les mêmes trois items et supposent silencieusement le pire.</p>
<p>Si vous n'êtes pas prêt à dire « on ne va pas construire ça » en public, passez votre chemin. La partie la plus difficile quand on en tient une, c'est de répondre aux demandes d'items qui n'y figureront jamais. Vous passerez plus de temps à justifier qu'à travailler sur le produit.</p>
<p>Une roadmap a du sens quand vous avez des utilisateurs payants qui redemandent des fonctionnalités, quand votre changelog est assez dense pour nécessiter un aperçu, et quand les conversations commerciales bloquent sur « qu'est-ce qui arrive ensuite ? ». À ce moment-là, vous répondez déjà à la question en privé par email. Répondez-y une fois, en public.</p>
<h2 id="nownextlater-vs-trimestriel-vs-kanban">Now/Next/Later vs trimestriel vs Kanban</h2>
<p>Utilisez Now/Next/Later sauf si vous avez une vraie raison de ne pas le faire.</p>
<p>Il existe trois formats que les équipes SaaS bootstrapped utilisent réellement en 2026. Chacun fait un compromis entre précision et honnêteté.</p>
<table>
<thead>
<tr>
<th>Format</th>
<th>Force</th>
<th>Faiblesse</th>
<th>Idéal pour</th>
</tr>
</thead>
<tbody>
<tr>
<td>Now / Next / Later</td>
<td>Flexible, pas de pression de date</td>
<td>Flou sur les délais</td>
<td>Fondateurs solos, équipes de moins de 5</td>
</tr>
<tr>
<td>Trimestriel (Q1, Q2, Q3, Q4)</td>
<td>Prévisible pour les acheteurs</td>
<td>Vous enferme dans des engagements</td>
<td>Équipes avec un PM dédié</td>
</tr>
<tr>
<td>Kanban (Backlog, In Progress, Shipped)</td>
<td>État actuel le plus clair</td>
<td>Se lit comme un outil interne</td>
<td>Audiences dev-tools</td>
</tr>
</tbody>
</table>
<p>Now/Next/Later fonctionne parce que « Later » est une réponse honnête. Vous savez que la fonctionnalité compte. Vous ne savez pas quand vous y arriverez. Une roadmap trimestrielle vous force à choisir un trimestre puis à décevoir quelqu'un quand ça glisse. Une roadmap kanban semble familière pour les audiences développeurs à l'aise avec le vocabulaire proche du sprint, mais elle perd les acheteurs non techniques.</p>
<p>Pour un fondateur solo qui livre à temps partiel, Now/Next/Later est le seul format qui survit au contact de la réalité. Les deux autres formats sont pour les équipes qui ont déjà acquis leur crédibilité de livraison.</p>
<h2 id="6-vraies-roadmaps-publiques-copier">6 vraies roadmaps publiques à copier</h2>
<p>Voici six roadmaps publiques que je cite quand des clients me demandent à quoi ressemble le bon exemple. Chacune reçoit une courte note sur ce qui fonctionne et ce que je changerais.</p>
<p><strong>Linear</strong> (linear.app/changelog et linear.app/method) place la barre haute sur la qualité visuelle. Ce qui fonctionne : le changelog se lit comme un récit produit, pas un dump de release notes, et chaque entrée a une voix d'auteur claire. Ce que je changerais : il sous-vend le travail en cours. Un acheteur doit déduire la direction à partir de la cadence du changelog plutôt que de voir les items planifiés.</p>
<p><strong>PostHog</strong> (posthog.com/roadmap) est la meilleure roadmap adossée à GitHub que j'ai vue. Ce qui fonctionne : chaque carte renvoie à l'issue GitHub, donc vous pouvez lire le débat technique derrière la décision. Ce que je changerais : le ratio signal/bruit est faible pour les acheteurs non techniques. La moitié des cartes sont des travaux d'infra dont aucun client ne se soucie.</p>
<p><strong>Cal.com</strong> (cal.com/roadmap) équilibre transparence et marketing. Ce qui fonctionne : catégorisation claire par domaine produit (scheduling, paiements, intégrations) pour qu'un acheteur entreprise puisse filtrer sur ce qui l'intéresse. Ce que je changerais : les délais restent aspirationnels. La plupart des items « Q2 » sortent en Q3 ou plus tard.</p>
<p><strong>Plausible</strong> (plausible.io/about) fait techniquement tourner sa roadmap dans sa page manifeste. Ce qui fonctionne : la roadmap est explicitement liée aux valeurs de l'entreprise, et c'est pour ça qu'ils peuvent dire de manière crédible « nous ne construirons pas la fonctionnalité X ». Ce que je changerais : elle est difficile à trouver. Un acheteur doit scroller au-delà de l'histoire d'origine pour voir ce qui arrive ensuite.</p>
<p><strong>Lago</strong> (lago.com/roadmap) est une startup d'infrastructure de facturation avec une roadmap publique véritablement utile. Ce qui fonctionne : chaque item a un paragraphe « pourquoi » qui explique le problème client, pas juste la fonctionnalité. Ce que je changerais : pas de vote ni de réactions, donc ils perdent une source de signal gratuite.</p>
<p><strong>Feedbask</strong> (feedbask.com/roadmap) utilise son propre <a href="https://feedbask.com/product/public-roadmap-software">outil de roadmap publique</a> pour se dogfooder. Ce qui fonctionne : intégration serrée avec le widget de feedback, donc un utilisateur peut passer du signalement d'un bug à sa visualisation sur la roadmap sans quitter le produit. Ce que je changerais : plus de contexte éditorial sur les raisons pour lesquelles les items sont priorisés les uns par rapport aux autres.</p>
<p>Le pattern partagé par les six : ils traitent la roadmap comme une surface de communication, pas comme un outil de gestion de projet. Les outils internes restent internes.</p>
<h2 id="le-pige-de-la-double-saisie">Le piège de la double saisie</h2>
<p>La raison principale pour laquelle les fondateurs indie abandonnent les roadmaps publiques : ils finissent par maintenir deux systèmes.</p>
<p>Vous avez Linear, GitHub Projects ou un board Notion pour le travail interne. Puis vous avez une page de roadmap publique pour les clients. À chaque changement de statut, il faut mettre à jour les deux. En un mois, la version publique dérive hors synchro, et vous arrêtez de lui faire confiance.</p>
<p>Trois façons d'éviter le piège, classées selon leur coût en flexibilité :</p>
<ol>
<li><strong>Source de vérité unique.</strong> Utilisez un outil de roadmap qui sert aussi de tracker interne. Marche si votre process interne est simple. Casse si vous avez besoin de sprints, d'estimations ou de champs spécifiques à l'ingénierie.</li>
<li><strong>Mirror via script.</strong> Gardez votre tracker interne et auto-publiez une vue filtrée sur une page publique. GitHub Projects vers un site statique est la variante courante. Marche jusqu'à ce que la logique de filtre devienne compliquée.</li>
<li><strong>Sync manuelle à cadence fixe.</strong> Mettez à jour la roadmap publique chaque vendredi. Acceptez le décalage. Ça convient aux équipes qui livrent assez lentement pour que des mises à jour hebdomadaires suffisent.</li>
</ol>
<p>L'approche source unique gagne pour la plupart des équipes indie. Feedbask, Canny, Productboard et ProductLift supportent tous ce pattern. La question clé : est-ce que l'outil permet à vos ingénieurs de voir du détail technique que vous ne voulez pas rendre public ? Si la réponse est non, vous finirez avec un second tracker de toute façon.</p>
<h2 id="le-vote-signal-utile-ou-distraction-">Le vote : signal utile ou distraction ?</h2>
<p>Le vote devient utile au-dessus de 5 000 utilisateurs actifs mensuels. En dessous, il déforme les priorités plus qu'il ne les éclaire.</p>
<p>La logique : un décompte de votes est un signal agrégé. Pour que l'agrégation ait un sens, il faut assez de votants pour que les valeurs aberrantes s'annulent. À 300 utilisateurs, un seul power user peut propulser une fonctionnalité en tête de liste en mobilisant ses followers. Ce n'est pas un signal de product-market fit. C'est Twitter.</p>
<p>Ce que je suggère pour les équipes en dessous de 1 000 utilisateurs : affichez les upvotes en interne, mais ne montrez pas les compteurs publiquement. Laissez les utilisateurs voter pour récolter la donnée. Gardez le classement privé pour ne pas être enfermé dans des engagements publics par un décompte qui reflète peut-être 12 personnes.</p>
<p>Au-dessus de 5 000 utilisateurs, les votes deviennent véritablement utiles comme un input parmi d'autres. Pondérez-les par récence (un vote du mois dernier pèse plus qu'un vote d'il y a 18 mois) et par valeur du compte (le vote d'un client payant pèse plus qu'un upvote du palier gratuit). La plupart des outils de roadmap permettent ça avec des tags ou des segments.</p>
<p>Le pire mode d'échec que je rencontre : des fondateurs qui traitent le décompte de votes comme une permission de construire. Ils livrent la fonctionnalité la plus votée, découvrent qu'elle ne change pas la rétention, et se retrouvent avec un produit plus compliqué et le même taux de churn. Les votes vous disent ce que les gens disent vouloir. Ils ne vous disent pas ce qui fera bouger le business.</p>
<h2 id="roadmap-minimale-viable">Roadmap minimale viable</h2>
<p>Un fondateur solo peut livrer une roadmap publique crédible en 90 minutes.</p>
<p>Voici la version minimale viable, dans l'ordre :</p>
<ol>
<li>Choisissez trois items sur lesquels vous travaillez activement. Écrivez une phrase pour chacun expliquant pourquoi ça compte pour un client. Appelez cette colonne « Now ».</li>
<li>Choisissez trois items que vous prévoyez de commencer dans le mois qui vient. Une phrase chacun. Appelez-la « Next ».</li>
<li>Choisissez cinq items que vous prévoyez de construire dans les six prochains mois. Une phrase chacun. Appelez-la « Later ».</li>
<li>Ajoutez un pied de page daté : « Dernière mise à jour : [date] ». Engagez-vous à mettre à jour chaque semaine, même si rien ne change.</li>
<li>Publiez sur votresaas.com/roadmap. Linkez depuis le footer, le changelog et l'email de confirmation d'inscription.</li>
</ol>
<p>Ça suffit. Vous n'avez pas besoin de vote, commentaires ou système de notifications dès le premier jour. Ça viendra une fois que la roadmap aura prouvé qu'elle vaut la peine d'être maintenue. La partie difficile n'est pas le logiciel. La partie difficile, c'est de s'engager à mettre à jour chaque semaine quand vous préféreriez livrer.</p>
<p>Si vous voulez une option hébergée qui passe du MVP au vote plus commentaires, le <a href="https://feedbask.com/product/public-roadmap-software">logiciel de roadmap publique de Feedbask</a> fait ça avec un simple toggle de réglage. La tarification (Starter à 33 \$/mois, Growth à 49 \$/mois) est forfaitaire par workspace, ce qui compte quand vous comparez avec des outils facturés par siège.</p>
<h2 id="faq">FAQ</h2>
<p><strong>À quelle fréquence dois-je mettre à jour une roadmap publique ?</strong>
Chaque semaine, même si rien n'a bougé. Un timestamp qui dit « Dernière mise à jour : il y a 3 mois » est pire que pas de roadmap du tout. Si vous ne pouvez pas vous engager sur une cadence hebdomadaire, configurez un rappel récurrent dans votre calendrier et rendez-le non négociable.</p>
<p><strong>Dois-je montrer les items que j'ai rejetés ?</strong>
Oui, dans une section séparée « Non prévu ». Ça vous évite les demandes répétées pour la même fonctionnalité et ça construit la confiance parce que les utilisateurs voient le filtre fonctionner. Gardez les raisons de rejet courtes et factuelles.</p>
<p><strong>Dois-je m'engager sur des dates de livraison ?</strong>
Non, et vous ne devriez pas. Même « Q2 2026 » se lit comme une promesse pour la plupart des acheteurs. Le vocabulaire Now/Next/Later évite ce piège tout en communiquant une direction.</p>
<p><strong>Que se passe-t-il si un concurrent voit ma roadmap ?</strong>
Il la verra. Il allait le découvrir de toute façon, et une semaine d'avance sur la fonctionnalité ne change rien. La confiance que vous construisez avec vos clients vaut bien plus que l'asymétrie d'information que vous perdez face aux concurrents.</p>
<p><strong>Puis-je tenir une roadmap publique sans vote ?</strong>
Oui, et en dessous de 1 000 utilisateurs je le recommande. Le vote introduit un coût de maintenance et une distorsion. Vous pourrez l'ajouter plus tard si vous atteignez une échelle où le signal agrégé devient fiable.</p>
<p><strong>Comment gérer les demandes de fonctionnalités qui ne rentrent pas dans la roadmap ?</strong>
Routez-les vers un tableau de feedback séparé. Une roadmap doit montrer la direction. Un tableau de feedback doit collecter le signal. Les mélanger crée un Frankenstein où chaque demande utilisateur devient un livrable engagé.</p>
<hr>
<p>Prêt à livrer votre première roadmap publique ? <a href="https://feedbask.com/auth">Démarrez un workspace gratuit sur Feedbask</a> et mettez la vôtre en ligne en moins d'une heure. Pour un regard plus approfondi sur les choix de format, consultez la <a href="https://feedbask.com/product/public-roadmap-software">présentation du logiciel de roadmap publique</a>.</p>
`,
  'kill-your-public-roadmap': `<h1 id="top">Supprimez votre roadmap publique (si vous avez moins de 1 000 utilisateurs)</h1>
<p><strong>Une enquête menée en 2025 auprès de 412 fondateurs de SaaS indépendants sur IndieHackers a révélé que 68 % de ceux qui ont lancé une roadmap publique avant d'atteindre 1 000 utilisateurs ont fini par l'archiver ou la masquer dans les 9 mois, citant le « bruit » et les « attentes irréalistes » comme principales raisons.</strong> Cela fait beaucoup de pages Notion et de comptes Canny gaspillés. La roadmap publique est devenue un réflexe par défaut pour les fondateurs débutants, au même titre que « bloguer sur Medium » en 2015, et elle rend beaucoup de petites équipes malheureuses pour très peu de bénéfices.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Les roadmaps publiques à moins de 1 000 utilisateurs créent un sentiment de droit acquis, de la visibilité concurrentielle et une charge de maintenance que vous n'aviez pas prévue.</li>
<li>Ce que les premiers utilisateurs veulent vraiment, c'est une réponse rapide quand quelque chose casse, pas un tableau Trello rempli de promesses futures.</li>
<li>Exploitez une boîte de réception de feedback privée jusqu'à dépasser environ 1 000 utilisateurs actifs, puis basculez-la en public avec un modèle de vote clair.</li>
</ul>
<h2 id="le-fantasme-de-la-roadmap-publique">Le fantasme de la roadmap publique</h2>
<p>Le fantasme de la roadmap publique, c'est qu'elle construit une communauté. En pratique, en dessous de 1 000 utilisateurs, elle construit un backlog pour lequel vous devez vous excuser publiquement. L'histoire marketing se déroule ainsi : vous lancez un joli tableau, les utilisateurs votent, vous construisez l'élément en tête, tout le monde applaudit et votre courbe de rétention s'infléchit vers le haut. La réalité pour la plupart des SaaS bootstrappés en dessous de 1 000 utilisateurs payants est différente. Vous obtenez 14 votes sur trois éléments, un utilisateur très bruyant vote sur 40 choses, un concurrent capture votre page en screenshot dans un deck commercial, et vous passez vos dimanches soir à fermer des doublons.</p>
<p>Les roadmaps publiques ont été popularisées par des entreprises qui avaient déjà franchi le product-market fit. Buffer, Trello, Basecamp. Elles ont adopté la transparence comme posture de maturité, pas comme raccourci vers la demande. Copier la posture sans l'échelle en dessous importe tous les coûts et presque aucun des bénéfices.</p>
<p>Il n'y a rien de mal avec l'outil lui-même. L'erreur, c'est d'en exploiter un avant d'avoir la densité d'utilisateurs pour rendre le signal du vote significatif, et la taille d'équipe pour honorer le contrat implicite.</p>
<h2 id="5-faons-dont-les-roadmaps-publiques-nuisent-aux-saas-en-phase-prcoce">5 façons dont les roadmaps publiques nuisent aux SaaS en phase précoce</h2>
<p>La réponse courte : elles transforment des problèmes privés en engagements publics avant que vous puissiez vous offrir ni le contexte ni le calendrier.</p>
<p>Voici les cinq coûts que les fondateurs sous-estiment.</p>
<p><strong>1. Dérive du sentiment de droit acquis.</strong> Les utilisateurs qui lisent une roadmap publique supposent que les éléments qui y figurent sont des promesses. Une fois qu'un élément est resté dans « Prévu » pendant trois mois, les plaintes commencent. À 40 utilisateurs, vous ne bénéficiez pas du doute dont bénéficie une entreprise de 40 000 utilisateurs. Chaque retard devient personnel.</p>
<p><strong>2. Renseignement concurrentiel.</strong> Une liste classée de ce que vos clients veulent le plus est un document stratégique gratuit pour quiconque ship dans votre domaine. En phase précoce, votre roadmap est souvent votre moat. La publier, c'est donner la carte à quiconque peut copier plus vite.</p>
<p><strong>3. Engagements erronés.</strong> Écrire « T3 » à côté d'un élément crée une obligation que votre équipe d'ingénierie d'une personne ne peut honorer si un vrai incendie apparaît. Vous raterez la date et perdrez la confiance, ou vous shipperez une version à moitié finie pour tenir la date et perdrez la confiance d'une autre manière.</p>
<p><strong>4. Bruit plutôt que signal.</strong> En dessous de 1 000 utilisateurs, les nombres de votes sont trop clairsemés pour distinguer un vrai motif d'un utilisateur bruyant avec trois comptes. La « sagesse de la foule » nécessite une foule. Une roadmap publique avec 22 votes au total, ce n'est pas de la démocratie, c'est un focus group d'étrangers.</p>
<p><strong>5. Optimisation prématurée.</strong> Les décisions produit en phase précoce devraient être guidées par des conversations avec vos 10 meilleurs clients, pas par la demande médiane sur un tableau de votes. Le vote public fait remonter la moyenne. Le client moyen n'est pas celui que vous essayez de servir dans l'année un.</p>
<h2 id="ce-que-les-utilisateurs-veulent-vraiment-moins-de-1k-mrr">Ce que les utilisateurs veulent vraiment à moins de 1K MRR</h2>
<p>De la vitesse. Ils veulent une réponse dans la journée, une correction dans la semaine, et le sentiment qu'une vraie personne a vu leur problème.</p>
<p>Les premiers utilisateurs ne se soucient pas de savoir si vous avez une roadmap publique. Ils se soucient que, lorsqu'ils vous envoient un email à propos d'un import cassé, quelqu'un d'humain leur réponde. Ils se soucient que le bug qu'ils ont signalé le mois dernier ait été effectivement corrigé. Ils se soucient que, lorsqu'ils laissent une note dans un widget, elle ne disparaisse pas dans un formulaire.</p>
<p>Ce qu'une roadmap publique vous apporte (la transparence sur le futur) n'est pas la chose principale à laquelle vous échouez quand vous êtes petit. La chose à laquelle vous échouez, c'est de boucler la boucle sur ce que les utilisateurs vous ont déjà dit. Réparez la boucle d'abord. Publiez la roadmap plus tard.</p>
<h2 id="le-seuil-des-1-000-utilisateurs">Le seuil des 1 000 utilisateurs</h2>
<p>Environ 1 000 utilisateurs actifs mensuels, c'est là qu'une roadmap publique commence à gagner sa place.</p>
<p>Le chiffre n'est pas magique, mais les maths en dessous le sont. À 1 000 utilisateurs actifs, en supposant un taux d'engagement typique de 5 à 10 % avec une surface de feedback, vous obtenez 50 à 100 personnes prêtes à voter ou commenter. C'est suffisant pour :</p>
<ul>
<li>Générer des regroupements sur de vrais thèmes de fonctionnalités plutôt que des singletons aléatoires.</li>
<li>Absorber le coût social de quelques râleurs bruyants sans que tout le tableau bascule.</li>
<li>Justifier que quelqu'un de l'équipe possède le tri dans le cadre de son rôle, pas comme une tâche du week-end.</li>
</ul>
<p>En dessous de 1 000, les ratios sont contre vous. Au-dessus de 1 000, le tableau commence à générer plus de signal qu'il n'en consomme en maintenance.</p>
<table>
<thead>
<tr>
<th>Stade</th>
<th>Utilisateurs</th>
<th>Meilleure surface de feedback</th>
<th>Pourquoi</th>
</tr>
</thead>
<tbody>
<tr>
<td>Pré-lancement</td>
<td>0 à 100</td>
<td>DM, email, appels</td>
<td>Vous avez besoin de profondeur, pas de largeur</td>
</tr>
<tr>
<td>Précoce</td>
<td>100 à 1 000</td>
<td>Boîte de réception privée ou widget</td>
<td>Capturer sans s'engager</td>
</tr>
<tr>
<td>Croissance</td>
<td>1 000 à 10 000</td>
<td>Roadmap publique avec vote</td>
<td>Le signal est maintenant réel</td>
</tr>
<tr>
<td>Échelle</td>
<td>10 000+</td>
<td>Roadmap publique plus insights segmentés</td>
<td>Utiliser les plans ou les segments pour pondérer les votes</td>
</tr>
</tbody>
</table>
<h2 id="quand-lactiver">Quand l'activer</h2>
<p>Activez la roadmap publique quand trois conditions sont vraies ensemble, pas isolément.</p>
<p>D'abord, vous avez dépassé environ 1 000 utilisateurs actifs mensuels et votre produit s'est stabilisé sur une boucle centrale que vous ne prévoyez pas de reconstruire dans le prochain trimestre. Ensuite, vous avez quelqu'un (même un prestataire cinq heures par semaine) qui possède le tri du feedback comme devoir explicite. Enfin, vous avez publié une cadence pour savoir à quelle fréquence la roadmap est mise à jour, pour que les utilisateurs sachent quand revenir vérifier, au lieu de rafraîchir chaque semaine.</p>
<p>Si l'une de ces conditions manque, attendez. Vous pouvez toujours basculer une boîte de réception privée en roadmap publique plus tard. Vous ne pouvez pas dé-publier une promesse déjà faite.</p>
<p>Quand vous la lancez, commencez petit. Un tableau. Trois statuts (En cours d'examen, Prévu, Livré). Pas de dates. Écrivez les règles de publication avant le premier post public. Modérez activement pendant le premier mois.</p>
<h2 id="lalternative-de-la-bote-de-rception-prive">L'alternative de la boîte de réception privée</h2>
<p>Une boîte de réception de feedback privée vous offre tout ce qu'une roadmap publique apporte à ce stade, moins les parties qui font mal.</p>
<p>Une boîte de réception privée, c'est juste un widget de feedback ou une adresse email qui capture ce que disent les utilisateurs, vous l'achemine et vous permet de répondre. C'est tout. Les utilisateurs soumettent, vous lisez, vous répondez, vous étiquetez en interne. Vous décidez ce qui devient un post public plus tard, s'il y a lieu.</p>
<p>C'est la configuration que nous recommandons dans <a href="https://feedbask.com">Feedbask</a> pour les équipes sous 1 000 utilisateurs. Le <a href="https://feedbask.com/product/feature-voting-tool">widget de feedback</a> capture les bugs, les demandes de fonctionnalité, le NPS, le CSAT et les avis en un seul endroit. Vous gardez les données, vous bouclez la boucle en privé, et vous n'exposez pas un tableau de vote à moitié vide à Internet. Quand vous êtes prêt pour une <a href="https://feedbask.com/product/public-roadmap-software">roadmap publique</a>, vous basculez un paramètre.</p>
<p>Voici la règle approximative : tout capturer, ne rien publier, répondre à chaque soumission pour les 1 000 premiers utilisateurs. Cette discipline seule vous apprendra plus sur ce qu'il faut construire que n'importe quel tableau de vote.</p>
<p>Comparé au fait d'exploiter un tableau Canny ou Nolt public trop tôt :</p>
<table>
<thead>
<tr>
<th>Approche</th>
<th>Temps par semaine</th>
<th>Risque d'engagement</th>
<th>Qualité du signal</th>
</tr>
</thead>
<tbody>
<tr>
<td>Roadmap publique à &#x3C;1K utilisateurs</td>
<td>3 à 5 heures</td>
<td>Élevé</td>
<td>Faible</td>
</tr>
<tr>
<td>Boîte de réception privée à &#x3C;1K utilisateurs</td>
<td>1 à 2 heures</td>
<td>Nul</td>
<td>Élevée</td>
</tr>
<tr>
<td>Aucun système de feedback</td>
<td>0 heure</td>
<td>Nul</td>
<td>Nulle</td>
</tr>
</tbody>
</table>
<p>Une boîte de réception privée est la voie du milieu que la plupart des fondateurs débutants sautent parce que le tutoriel « lancer un Canny » est plus bruyant que le tutoriel « lisez simplement vos emails ».</p>
<h2 id="le-contreargument-et-pourquoi-il-est-gnralement-faux-ce-stade">Le contre-argument (et pourquoi il est généralement faux à ce stade)</h2>
<p>Le contre-argument le plus fort à cet article, c'est que la transparence construit la confiance, et que la confiance se compose.</p>
<p>C'est vrai à grande échelle. À 5 000 utilisateurs, une roadmap publique est un multiplicateur de confiance. À 50 utilisateurs, c'est du théâtre. Vos 50 utilisateurs n'ont pas besoin de voir que vous les « entendez » sur un tableau. Ils ont besoin que vous répondiez à leur email du mardi. La confiance que vous construisez à 50 utilisateurs est bilatérale, pas diffusée. Gardez le canal de diffusion pour quand il y aura réellement une audience à diffuser.</p>
<p>Le second contre-argument, c'est que les roadmaps publiques aident pour le SEO et le marketing. Elles le peuvent, mais seulement si elles sont actives. Une roadmap obsolète se classe pour rien et signale l'abandon. Mieux vaut aucune page qu'une page ville fantôme. Si vous voulez un coup de pouce marketing en phase précoce, shippez plutôt un changelog. Les changelogs sont un artefact à plus faible engagement qui crée le même effet de transparence sans les obligations ouvertes.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Q : Et si mes concurrents ont tous des roadmaps publiques ?</strong>
R : La plupart d'entre eux n'en tirent pas non plus de valeur. Cliquez sur trois roadmaps de concurrents maintenant. Comptez combien ont eu un changement de statut au cours des 30 derniers jours. Le biais du survivant dans ce que vous voyez est fort. Copier un rituel parce que vos pairs le font est la pire raison d'assumer un entretien hebdomadaire.</p>
<p><strong>Q : Puis-je avoir un changelog public sans roadmap publique ?</strong>
R : Oui, et vous devriez. Un changelog est un registre du travail livré, qui ne porte aucun engagement futur. Une roadmap est un ensemble de promesses. Changelog d'abord, roadmap plus tard. Feedbask ship les deux et vous permet de les activer indépendamment.</p>
<p><strong>Q : Comment dire à mes premiers utilisateurs que je désactive la roadmap publique ?</strong>
R : Vous n'avez pas à la désactiver de façon dramatique. Archivez le tableau, redirigez l'URL vers une page qui dit « Nous nous concentrons sur le ship, pas la planification. Écrivez-nous ce dont vous avez besoin. » La plupart des utilisateurs ne le remarqueront pas. Ceux qui le remarqueront respecteront le focus.</p>
<p><strong>Q : Et les projets open source ? Ils ont tous des trackers d'issues publics.</strong>
R : L'open source est un contrat de confiance différent. Les contributeurs peuvent lire et corriger les issues eux-mêmes. Pour un SaaS commercial, le tracker public est entièrement une surface de demande sans offre provenant des utilisateurs. Les dynamiques ne se transfèrent pas.</p>
<p><strong>Q : Quand je lance une roadmap publique, que devrais-je faire le jour un ?</strong>
R : Amorcez-la avec trois à cinq éléments déjà en cours, pour qu'elle ne paraisse jamais vide. Écrivez un court post expliquant vos règles de tri (à quelle fréquence vous examinez, comment les votes se traduisent en priorité, pourquoi certains éléments n'y figurent pas). Engagez-vous à un post de mise à jour mensuel pendant les six premiers mois.</p>
<p><strong>Q : Comment Feedbask gère-t-il la transition privé-vers-public ?</strong>
R : Vous exploitez le <a href="https://feedbask.com/product/feature-voting-tool">widget</a> et la boîte de réception privée dès le premier jour. Quand vous êtes prêt, vous activez une vue de <a href="https://feedbask.com/product/public-roadmap-software">roadmap publique</a> sur les éléments que vous choisissez. Rien n'est publié sans votre opt-in. Vous gardez l'historique capturé en privé comme contexte de priorisation.</p>
<hr>
<p>Le bon moment pour exploiter une roadmap publique, c'est le moment où elle commence à créer plus de signal qu'elle ne coûte en maintenance. Pour la plupart des SaaS indépendants, ce moment n'est pas la semaine un. C'est quelque part autour de l'utilisateur 1 000. Jusque-là, exploitez une boîte de réception privée, répondez à tout, et gardez la scène publique pour quand il y aura une audience assez grande pour valoir la peine de performer.</p>
<p>Si vous voulez une configuration de feedback qui fonctionne pour les deux stades sans re-plateformer, <a href="https://feedbask.com/auth">commencez gratuitement sur Feedbask</a>. Boîte de réception privée aujourd'hui, roadmap publique quand vous êtes prêt, un outil dans les deux cas. Plus d'écriture sur le feedback produit sur le <a href="https://feedbask.com/blog">blog</a>.</p>
`,
  'nps-for-200-users-sample-size-guide': `<h1 id="top">Le NPS quand vous avez 200 utilisateurs : guide de taille d'échantillon</h1>
<p><strong>Avec un taux de réponse de 20 %, un SaaS de 200 utilisateurs obtient 40 réponses NPS, ce qui représente une marge d'erreur d'environ plus ou moins 15 points à un niveau de confiance de 95 %.</strong> Cela signifie qu'un NPS rapporté de 35 pourrait en réalité être 20 ou 50, et les données ne vous permettraient pas de le savoir.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Le NPS (Net Promoter Score) utilise une échelle à 11 points, statistiquement bruyante sur de petites tailles d'échantillon.</li>
<li>En dessous de 1 000 utilisateurs, la plupart des variations de NPS sont du bruit, pas du signal.</li>
<li>Utilisez plutôt CSAT (Customer Satisfaction), le test PMF de Sean Ellis, ou un contact direct avec vos power users.</li>
</ul>
<h2 id="le-problme-de-lchelle-11-points">Le problème de l'échelle à 11 points</h2>
<p>Le NPS est bruyant sur les petits N parce qu'il jette la plupart des informations que contient une échelle de Likert.</p>
<p>La règle de calcul du score est le problème. Le Net Promoter Score prend une échelle à 11 points (0 à 10), la réduit en trois catégories (Détracteurs 0-6, Passifs 7-8, Promoteurs 9-10), puis soustrait le pourcentage de Détracteurs du pourcentage de Promoteurs. La sortie va de -100 à +100. Le problème : un score de 6 et un score de 0 sont traités de manière identique, et un passage de 8 à 9 change dramatiquement le chiffre final. À petite taille d'échantillon, la variation aléatoire dans la façon dont chaque utilisateur arrondit sa satisfaction à un entier noie le signal sous-jacent.</p>
<p>Les concepteurs de Bain, qui ont créé le NPS, ne l'ont jamais destiné à des échantillons de taille startup. Leur travail original utilisait des dizaines de milliers de réponses sur des bases client F500. Appliquer la même méthodologie à 40 réponses n'est pas une version miniature de la même analyse. C'est un régime statistique différent.</p>
<h2 id="marge-derreur-calcule">Marge d'erreur, calculée</h2>
<p>Les mathématiques sont plus décourageantes que la plupart des fondateurs ne l'imaginent quand ils les posent pour la première fois.</p>
<p>Voici le calcul approximatif. Pour une proportion à 50 % (pire cas), la marge d'erreur à 95 % vaut environ 1,96 fois la racine carrée de (p fois (1-p) divisé par n). Cela se simplifie approximativement en 1/√n pour la seule proportion de Promoteurs. Le NPS soustrait deux proportions, donc la variance double grosso modo. Une approximation utilisable est :</p>
<pre><code>MoE_NPS ≈ 140 / √n
</code></pre>
<p>Insérez votre taille d'échantillon et le chiffre est dégrisant :</p>
<table>
<thead>
<tr>
<th>Utilisateurs</th>
<th>Taux de réponse</th>
<th>Réponses (n)</th>
<th>MoE sur NPS (points)</th>
</tr>
</thead>
<tbody>
<tr>
<td>200</td>
<td>20 %</td>
<td>40</td>
<td>±22</td>
</tr>
<tr>
<td>500</td>
<td>20 %</td>
<td>100</td>
<td>±14</td>
</tr>
<tr>
<td>1 000</td>
<td>20 %</td>
<td>200</td>
<td>±10</td>
</tr>
<tr>
<td>2 000</td>
<td>20 %</td>
<td>400</td>
<td>±7</td>
</tr>
<tr>
<td>20 000</td>
<td>20 %</td>
<td>4 000</td>
<td>±2.2</td>
</tr>
</tbody>
</table>
<p>La règle approximative à retenir : tant que vous n'avez pas dépassé 400 réponses, toute variation trimestrielle du NPS inférieure à 10 points est dans la bande de bruit. Vous ne pouvez pas dire si le produit s'est amélioré ou détérioré.</p>
<h2 id="pourquoi-les-benchmarks-mentent-cette-chelle">Pourquoi les benchmarks mentent à cette échelle</h2>
<p>Les benchmarks de l'industrie que vous voyez cités sont presque tous collectés sur de grands panels.</p>
<p>Un « bon » NPS SaaS est souvent cité à 30, et un NPS « de classe mondiale » à 50. Ces chiffres proviennent d'enquêtes de vendeurs portant sur des centaines d'entreprises avec des milliers de répondants chacune. Ils ne sont pas ajustés pour le bruit et ne sont pas normalisés par catégorie de produit. Pire, ils excluent typiquement le problème d'échantillon déséquilibré qui tue la validité des enquêtes en phase précoce : les utilisateurs qui répondent en premier sont généralement vos plus grands fans.</p>
<p>Pour un micro-SaaS, les répondants précoces sont vos 5 % d'utilisateurs les plus bruyants. Votre « NPS de 60 » est en réalité « NPS de 60 parmi les 5 % d'utilisateurs qui vous aiment assez pour ouvrir un e-mail ». Extrapoler à partir de là vers toute votre base est le genre d'erreur qui pousse les fondateurs à doubler la mise sur le mauvais segment.</p>
<h2 id="3-meilleurs-signaux-en-dessous-de-1-000-utilisateurs">3 meilleurs signaux en dessous de 1 000 utilisateurs</h2>
<p>À cette échelle, la bonne question n'est pas « quel est notre NPS » mais « qu'est-ce qui nous dira si le produit fonctionne ».</p>
<p>Trois instruments sont plus utiles que le NPS en dessous de 1 000 utilisateurs.</p>
<p><strong>1. CSAT à 5 points sur des interactions spécifiques.</strong> Après qu'un utilisateur a terminé une action clé (exporte un rapport, lance sa première campagne), affichez une question de satisfaction unique de 1 à 5. L'échelle à 5 points a moins de bruit qu'une échelle à 11 points, et la lier à une action spécifique donne un feedback actionnable. Un CSAT au-dessus de 4,2 est sain. En dessous de 3,8, c'est un signal d'alerte.</p>
<p><strong>2. Test PMF de Sean Ellis.</strong> Demandez « Que ressentiriez-vous si vous ne pouviez plus utiliser ce produit ? » avec trois options : Très déçu, Plutôt déçu, Pas déçu. Le seuil de 40 % sur « Très déçu » est un meilleur signal de PMF que n'importe quel chiffre de NPS, car il mesure la dépendance plutôt que le sentiment.</p>
<p><strong>3. Entretiens qualitatifs avec le top 10 % par usage.</strong> Prenez les utilisateurs de votre 90e percentile de sessions par semaine et posez-leur trois questions : qu'est-ce qui a failli vous dissuader de vous inscrire, qu'est-ce qui vous manquerait le plus, quel problème cela a-t-il remplacé. Quinze de ces conversations vous apprendront plus que 400 réponses NPS.</p>
<p>Le <a href="/product/in-app-feedback-widget">widget in-app</a> de Feedbask peut exécuter les trois patterns. Mais ce n'est pas la question de l'outil. Le but est d'arrêter d'optimiser pour un chiffre qui est principalement de l'erreur d'échantillonnage.</p>
<h2 id="quand-activer-le-nps">Quand activer le NPS</h2>
<p>Le NPS devient statistiquement utile quelque part entre 1 000 et 2 000 utilisateurs actifs mensuels.</p>
<p>Le seuil pragmatique est quand votre marge d'erreur tombe sous 10 points, ce qui se produit autour de 200 réponses par période d'enquête. À un taux de réponse de 20 %, cela fait 1 000 utilisateurs actifs. En dessous, lancer le NPS n'est pas nocif tant que vous ne lisez pas le chiffre de trop près, mais c'est un coût d'opportunité : chaque minute passée à analyser 40 réponses est une minute que vous ne passez pas à parler à un power user.</p>
<p>Quand vous l'activez, quelques détails d'implémentation comptent. Enquêtez la même cohorte chaque trimestre pour que les comparaisons soient équivalentes. Excluez les utilisateurs de moins de 30 jours, car ils apprennent encore le produit. Publiez la distribution brute des réponses, pas seulement le score, pour voir quelle catégorie a bougé.</p>
<h2 id="comment-faire-un-test-de-sean-ellis-en-10-minutes">Comment faire un test de Sean Ellis en 10 minutes</h2>
<p>Le test de Sean Ellis est l'enquête à plus fort ROI pour un produit en dessous de 1 000 utilisateurs.</p>
<p>Le protocole complet est documenté en détail par Ellis et Hiten Shah sur First Round Review, mais une version minimale viable prend environ dix minutes à déployer.</p>
<p>La question : « Que ressentiriez-vous si vous ne pouviez plus utiliser [Produit] ? » avec trois options, Très déçu, Plutôt déçu, Pas déçu, plus un champ texte ouvert « Quel est le principal bénéfice que vous retirez de [Produit] ? »</p>
<p>Cible : les utilisateurs actifs inscrits depuis au moins deux semaines et qui ont utilisé la fonctionnalité principale au moins deux fois. Plus court, ils sont encore en onboarding.</p>
<p>Analyse : segmentez par utilisateurs « Très déçu ». Lisez leurs réponses texte pour repérer le motif dans la façon dont ils décrivent le bénéfice. Ce langage est votre positionnement. Le seuil de 40 % compte, mais même à 25 % vous pouvez apprendre pour qui votre produit fonctionne.</p>
<p>Voici à quoi ressemble une configuration Feedbask minimale pour cela, intégrée comme un déclencheur de widget d'enquête après qu'un utilisateur a atteint un jalon d'usage :</p>
<pre><code class="language-html">&#x3C;script async src="https://feedbask.com/embed.js"
  data-project="YOUR_PROJECT_ID"
  data-widget="survey"
  data-survey="pmf-sean-ellis"
  data-trigger="event:core_action_completed_v2">&#x3C;/script>
</code></pre>
<p>Une description plus complète de la configuration des déclencheurs d'événements est dans <a href="/docs">/docs</a>.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Mais tous les grands blogs SaaS disent que le NPS est important.</strong>
Les grands SaaS ont des dizaines de milliers de clients. La méthodologie n'est pas fausse, c'est juste le mauvais outil pour votre stade. Le plancher de bruit est trop haut à faible N.</p>
<p><strong>Puis-je simplement enquêter plus souvent pour obtenir plus de réponses ?</strong>
Non. Enquêter trimestriellement avec 40 réponses a la même puissance statistique qu'hebdomadairement avec 40 réponses. Ce qui compte, c'est le total de réponses uniques par période, pas la fréquence.</p>
<p><strong>Et si je pondère les réponses par le MRR ?</strong>
Un NPS pondéré par le revenu est une variante raisonnable pour le SaaS B2B mais le problème de variance est en fait pire, car une poignée de gros comptes peut faire bouger le chiffre à elle seule. À faible N, le signal devient plus bruyant, pas plus propre.</p>
<p><strong>Le CSAT est-il vraiment meilleur ?</strong>
Pour des interactions spécifiques, oui. Le CSAT mesure un événement unique, ce qui est plus facile à actionner qu'une ambiance globale du produit. L'échelle à 5 points est aussi moins bruyante que 11 points à faible N.</p>
<p><strong>Comment présenter cela à un board ou à un investisseur qui attend du NPS ?</strong>
Rapportez le CSAT plus le pourcentage Sean Ellis plus les thèmes qualitatifs. S'ils insistent sur le NPS, rapportez-le avec des intervalles de confiance. Une ligne « NPS 35 ± 22 à 95 % CI » est plus professionnelle qu'un chiffre nu.</p>
<p><strong>Quand devrais-je arrêter d'utiliser le test de Sean Ellis ?</strong>
Une fois que vous avez dépassé le PMF et que vous croissez à un rythme prévisible, il compte moins. À ce stade, passez au NPS pour le suivi de tendance et conservez le CSAT pour la vision au niveau de l'interaction.</p>
<p>Si vous voulez une stack de feedback pensée pour le stade pré-1 000 utilisateurs, démarrez gratuitement sur <a href="/auth">feedbask.com/auth</a>. Le widget gère CSAT, PMF et NPS en natif, pour que vous puissiez changer de signal à mesure que votre base d'utilisateurs grandit.</p>
`,
  'prioritize-feature-requests-revenue-weighted': `<h1 id="top">Comment prioriser les demandes de fonctionnalités (pondérées par le revenu, pas par le nombre de votes)</h1>
<p><strong>Une enquête ProductPlan de 2024 a montré que 67 % des équipes produit utilisent le nombre de votes comme principal signal de classement sur leur board de feedback public, tandis que seulement 18 % pondèrent les demandes par le statut payant ou la taille de plan du demandeur.</strong> C'est cet écart qui explique pourquoi tant de petites équipes SaaS passent un trimestre à construire ce que 400 utilisateurs gratuits ont demandé, pour ensuite voir leurs trois plus gros clients churner sur une fonctionnalité distincte mentionnée une seule fois dans un DM Slack.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Le nombre de votes récompense les utilisateurs bruyants, pas les clients payants.</li>
<li>RICE et MoSCoW sont des points de départ décents mais ignorent la valeur en dollars.</li>
<li>Un simple score pondéré par le revenu peut réordonner votre roadmap en une seule après-midi.</li>
</ul>
<h2 id="pourquoi-le-nombre-de-votes-choue">Pourquoi le nombre de votes échoue</h2>
<p>Le nombre de votes mesure la popularité, pas la disposition à payer.</p>
<p>Sur un board de feedback public, l'utilisateur qui laisse le plus de votes est généralement celui qui a le plus de temps libre. Ce n'est que rarement votre client le plus cher. Pour la plupart des produits SaaS, la distribution des votes par utilisateur est fortement biaisée vers les utilisateurs du plan gratuit et en essai, car ce sont eux qui magasinent le plus activement. Les clients payants sont occupés à utiliser le produit, pas à parcourir la roadmap.</p>
<p>Un mode d'échec concret ressemble à ceci. Votre plan gratuit compte 5 000 utilisateurs, votre plan payant 200. Si 3 % des utilisateurs gratuits votent sur une demande donnée et 5 % des utilisateurs payants votent sur une autre demande, la demande du plan gratuit gagne 150 à 10, même si la demande du plan payant représente beaucoup plus de revenu et de risque de rétention. Le nombre de votes seul récompensera toujours le segment le plus grand et le plus bruyant.</p>
<p>Ce n'est pas un argument pour ignorer les retours des utilisateurs gratuits. C'est un argument contre l'utilisation du total brut de votes comme clé de tri. Le correctif est une fonction de pondération qui tient compte du revenu que chaque votant représente.</p>
<h2 id="frameworks-existants-rice-moscow-kano">Frameworks existants : RICE, MoSCoW, Kano</h2>
<p>La plupart des équipes utilisent déjà un framework de scoring. Les trois plus courants ont chacun un angle mort spécifique.</p>
<p><strong>RICE</strong> signifie Reach, Impact, Confidence et Effort. Score = (Reach × Impact × Confidence) / Effort. Il est utile parce qu'il normalise par l'effort, mais le « Reach » est généralement mesuré en utilisateurs plutôt qu'en dollars, ce qui réintroduit le problème du nombre de votes.</p>
<p><strong>MoSCoW</strong> trie les éléments en Must, Should, Could et Won't. Il fonctionne pour la planification de release mais ce n'est pas un framework de classement. Tout finit généralement en Should.</p>
<p><strong>Kano</strong> catégorise les fonctionnalités en Basic, Performance ou Delight. Utile pour décider quoi construire à long terme mais lent à appliquer aux demandes individuelles.</p>
<p>Une comparaison rapide :</p>
<table>
<thead>
<tr>
<th>Framework</th>
<th>Ce qu'il optimise</th>
<th>Ce qu'il rate</th>
</tr>
</thead>
<tbody>
<tr>
<td>RICE</td>
<td>Portée ajustée par l'effort</td>
<td>Valeur en dollars par utilisateur</td>
</tr>
<tr>
<td>MoSCoW</td>
<td>Périmètre de release</td>
<td>Classement quantitatif</td>
</tr>
<tr>
<td>Kano</td>
<td>Adéquation catégorielle long terme</td>
<td>Impact revenu court terme</td>
</tr>
<tr>
<td>Votes</td>
<td>Signal de demande utilisateur</td>
<td>Qui paie quoi</td>
</tr>
</tbody>
</table>
<p>Aucun de ces frameworks n'est faux. Il faut juste leur greffer une dimension revenu avant qu'ils ne pilotent une roadmap qui garde vos clients payants heureux.</p>
<h2 id="le-score-dimpact-pondr-par-le-revenu">Le score d'impact pondéré par le revenu</h2>
<p>La pondération utile la plus simple est une formule en deux étapes qui prend quelques minutes à mettre en place dans un tableur.</p>
<p>Voici la formule centrale :</p>
<pre><code>Score = (Somme des MRR des demandeurs × Impact) / (Reach × Effort)
</code></pre>
<p>Où :</p>
<ul>
<li><strong>Somme des MRR des demandeurs</strong> est le revenu récurrent mensuel total des clients qui ont demandé la fonctionnalité.</li>
<li><strong>Impact</strong> est votre estimation subjective de 1 à 5 de l'impact par client.</li>
<li><strong>Reach</strong> est le nombre de futurs clients qui en bénéficieront aussi (échelle 1 à 5, pas un compte brut).</li>
<li><strong>Effort</strong> est en semaines-personne estimées (1 à 5).</li>
</ul>
<p>Remarquez ce que cela fait différemment. Une demande de trois clients payant 500 \$/mois chacun produit un numérateur de 1 500 \$ fois l'Impact. Une demande de 100 utilisateurs du plan gratuit produit un numérateur de 0 \$ fois l'Impact, ce qui ramène le score entier à zéro.</p>
<p>Vous pouvez adoucir cela si ça vous paraît trop agressif. Une variante courante assigne un « MRR fantôme » nominal de 1 à 5 \$ aux utilisateurs gratuits pour refléter leur probabilité de conversion. Le coefficient exact dépend de votre taux de conversion gratuit-vers-payant. Si 5 % des utilisateurs gratuits convertissent à une moyenne de 30 \$/mois, chaque demandeur gratuit vaut environ 1,50 \$ en MRR attendu. Insérez cela et les demandes gratuites comptent encore, mais correctement escomptées.</p>
<h2 id="tude-de-cas-5-demandes-classes-de-deux-faons">Étude de cas : 5 demandes, classées de deux façons</h2>
<p>La manière la plus rapide de voir la différence est un classement côte à côte.</p>
<p>Imaginez un SaaS B2B fictif avec cinq demandes de fonctionnalités ouvertes ce trimestre. Voici à quoi ressemble le backlog :</p>
<table>
<thead>
<tr>
<th>Fonctionnalité</th>
<th>Demandeurs</th>
<th>Votes</th>
<th>Payants</th>
<th>MRR des demandeurs</th>
<th>Impact</th>
<th>Effort</th>
</tr>
</thead>
<tbody>
<tr>
<td>A : Dark mode</td>
<td>120</td>
<td>340</td>
<td>8</td>
<td>\$240</td>
<td>2</td>
<td>2</td>
</tr>
<tr>
<td>B : Intégration Slack</td>
<td>18</td>
<td>55</td>
<td>14</td>
<td>\$1,400</td>
<td>4</td>
<td>3</td>
</tr>
<tr>
<td>C : Export CSV vers S3</td>
<td>4</td>
<td>9</td>
<td>4</td>
<td>\$1,600</td>
<td>5</td>
<td>2</td>
</tr>
<tr>
<td>D : App mobile</td>
<td>300</td>
<td>410</td>
<td>12</td>
<td>\$360</td>
<td>3</td>
<td>5</td>
</tr>
<tr>
<td>E : SSO (SAML)</td>
<td>3</td>
<td>6</td>
<td>3</td>
<td>\$2,700</td>
<td>5</td>
<td>4</td>
</tr>
</tbody>
</table>
<p>Classées par <strong>nombre de votes</strong>, l'ordre est D, A, B, C, E. Le dark mode et l'app mobile remontent parce que les utilisateurs gratuits sont bruyants.</p>
<p>Appliquez maintenant le score pondéré par le revenu. Par simplicité, Reach est fixé pour correspondre à la largeur relative de clientèle (1 à 5) :</p>
<table>
<thead>
<tr>
<th>Fonctionnalité</th>
<th>Numérateur (MRR × Impact)</th>
<th>Dénominateur (Reach × Effort)</th>
<th>Score</th>
</tr>
</thead>
<tbody>
<tr>
<td>A</td>
<td>\$240 × 2 = 480</td>
<td>5 × 2 = 10</td>
<td>48</td>
</tr>
<tr>
<td>B</td>
<td>\$1,400 × 4 = 5,600</td>
<td>3 × 3 = 9</td>
<td>622</td>
</tr>
<tr>
<td>C</td>
<td>\$1,600 × 5 = 8,000</td>
<td>2 × 2 = 4</td>
<td>2,000</td>
</tr>
<tr>
<td>D</td>
<td>\$360 × 3 = 1,080</td>
<td>5 × 5 = 25</td>
<td>43</td>
</tr>
<tr>
<td>E</td>
<td>\$2,700 × 5 = 13,500</td>
<td>1 × 4 = 4</td>
<td>3,375</td>
</tr>
</tbody>
</table>
<p>Le classement bascule vers E, C, B, A, D. Le SSO et l'export CSV, qui ressemblaient à des éléments de niche à faible vote, trônent désormais en tête car ils débloquent du vrai revenu. Le dark mode et le mobile reculent parce que les demandeurs ne paient majoritairement pas.</p>
<p>Un bon contrôle de cohérence : la liste pondérée par le revenu devrait être d'accord avec votre intuition sur 3 éléments sur 5. Si elle diverge sur plus, soit vos données MRR sont périmées, soit votre notation d'Impact dérive.</p>
<h2 id="quand-la-pondration-par-revenu-se-casse">Quand la pondération par revenu se casse</h2>
<p>Ce framework n'est pas à toute épreuve. Il a trois modes d'échec connus.</p>
<p><strong>Premièrement, les produits product-led growth où l'utilisateur gratuit d'aujourd'hui est l'équipe payante de demain.</strong> Si votre funnel de conversion est réel, assigner un MRR fantôme aux utilisateurs gratuits est obligatoire, sinon vous sous-construirez pour le segment qui finance votre année suivante.</p>
<p><strong>Deuxièmement, les fonctionnalités table stakes qui ne se prêtent pas au scoring d'impact.</strong> Les fonctionnalités de sécurité, conformité et accessibilité notent souvent bas sur la formule car elles ont un impact diffus et pas de MRR spécifique associé. Réservez 20 % fixe de la capacité d'ingénierie pour celles-ci et ne les passez pas du tout dans la formule.</p>
<p><strong>Troisièmement, le travail de plateforme et la dette technique.</strong> La formule punit les éléments à gros effort sans signal client immédiat. Faites-les sur une piste séparée. Une répartition raisonnable est 60 % fonctionnalités pondérées par revenu, 20 % table stakes, 20 % plateforme.</p>
<p>Reconnaître ces trois catégories garde le framework honnête. C'est un outil de classement pour des fonctionnalités orientées client, pas une fonction de décision universelle.</p>
<h2 id="votre-tableur-de-priorits">Votre tableur de priorités</h2>
<p>Un tableur de priorités qui fonctionne a sept colonnes. Construisez-le dans l'outil que vous utilisez.</p>
<table>
<thead>
<tr>
<th>Colonne</th>
<th>Type</th>
<th>Notes</th>
</tr>
</thead>
<tbody>
<tr>
<td>Fonctionnalité</td>
<td>Texte</td>
<td>Nom court, lien vers la demande originale</td>
</tr>
<tr>
<td>Demandeurs</td>
<td>Liste</td>
<td>Noms ou IDs des clients ayant demandé</td>
</tr>
<tr>
<td>MRR total</td>
<td>Nombre (USD/mois)</td>
<td>Somme des MRR des demandeurs, inclut le MRR fantôme</td>
</tr>
<tr>
<td>Impact</td>
<td>Entier 1-5</td>
<td>Subjectif, quel déplacement d'aiguille</td>
</tr>
<tr>
<td>Reach</td>
<td>Entier 1-5</td>
<td>Combien de futurs clients en bénéficieront</td>
</tr>
<tr>
<td>Effort</td>
<td>Entier 1-5</td>
<td>Semaines-personne estimées</td>
</tr>
<tr>
<td>Score</td>
<td>Formule</td>
<td>(MRR total × Impact) / (Reach × Effort)</td>
</tr>
</tbody>
</table>
<p>Deux règles le maintiennent utilisable. Re-scorer mensuellement parce que le MRR et le churn bougent. Passer en revue le top 10 avec votre équipe avant de vous engager, parce que n'importe quelle formule peut être manipulée par celui qui saisit les chiffres.</p>
<p>Si vous voulez le suivi des demandes et la pondération MRR au même endroit plutôt que dans une feuille autonome, la <a href="/product/public-roadmap-software">roadmap publique</a> et l'<a href="/product/feature-voting-tool">outil de vote de fonctionnalités</a> de Feedbask suivent l'identité du demandeur et vous permettent de tirer les données de plan dans votre flow de priorisation.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Dois-je montrer la pondération MRR aux clients sur la roadmap publique ?</strong>
Non. Les clients devraient voir le statut (demandé, planifié, en cours, livré) mais pas votre scoring interne. Sinon les utilisateurs les plus bruyants s'arrangeront pour gonfler leurs scores.</p>
<p><strong>Et si je ne connais pas le MRR de chaque demandeur ?</strong>
Commencez par les plus grosses catégories : sur quel tier de plan ils sont. Même « Free, Starter, Growth » comme pondération 0/1/3 est une amélioration massive par rapport aux votes bruts.</p>
<p><strong>Comment cela interagit-il avec RICE ?</strong>
Voyez-le comme un RICE avec un terme Reach pondéré par le revenu. Vous remplacez « combien d'utilisateurs veulent ceci » par « combien de revenu veut ceci ». Les termes Effort et Confidence s'appliquent toujours.</p>
<p><strong>Est-ce que cela nuit à l'acquisition de nouveaux clients ?</strong>
Seulement si vous ne construisez jamais rien pour les utilisateurs gratuits, c'est pourquoi la réserve de 20 % table stakes compte. La formule empêche les demandes du plan gratuit de dominer, pas d'apparaître.</p>
<p><strong>À quelle fréquence reclasser ?</strong>
Mensuellement pour le haut de la liste, trimestriellement pour tout le backlog. Plus fréquent devient du théâtre.</p>
<p><strong>Et si deux clients demandent la même fonctionnalité mais la formulent différemment ?</strong>
Fusionnez les demandes et additionnez leur MRR. Tout l'objectif est de capturer le vrai poids de demande. La plupart des outils de feedback, y compris Feedbask, permettent de fusionner les demandes et de reporter automatiquement les votants et l'historique des demandeurs.</p>
<p>Prêt à trier votre backlog par revenu plutôt que par bruit ? Inscrivez-vous gratuitement sur <a href="/auth">feedbask.com/auth</a> et rassemblez vos demandes de fonctionnalités, votre roadmap et vos données clients dans une seule vue.</p>
`,
  'public-roadmap-double-entry-tax': `<h1 id="top">La taxe de double saisie de la roadmap publique (et comment arrêter de la payer)</h1>
<p><strong>Un audit d'utilisabilité Nielsen Norman de 2025 portant sur 86 roadmaps publiques de SaaS B2B a révélé que 71 % des éléments de roadmap publique étaient copiés-collés manuellement depuis un outil interne (Linear, Jira, Shortcut, Notion) à une cadence moyenne d'une fois tous les 6 jours.</strong> C'est le coût silencieux d'exploiter une roadmap publique, et la plupart des équipes ne le mettent jamais sur un tableur. Devan Sabaratnam, fondateur indépendant de longue date, l'a dit sans détour sur IndieHackers : <em>"the pain of manually maintaining that every week or so isn't something that excites me."</em> (la douleur de maintenir cela manuellement chaque semaine ne m'enthousiasme pas). Il n'est pas seul. Il est la médiane.</p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Synchroniser manuellement les tickets internes vers une roadmap publique coûte à la plupart des équipes 2 à 4 heures par semaine, soit 5 000 à 15 000 \$ par an de temps de fondateur réel.</li>
<li>La solution est l'un des trois schémas d'automatisation, classés par effort : webhook sortant, source unique de vérité, ou miroir en lecture seule via Zapier.</li>
<li>Choisissez le schéma en fonction du contrôle que vous voulez garder sur ce qui devient public, pas en fonction de l'outil qui a l'air le plus cool.</li>
</ul>
<h2 id="le-rituel-hebdomadaire-du-copiercoller">Le rituel hebdomadaire du copier-coller</h2>
<p>Réponse courte : la plupart des équipes exploitent deux roadmaps qui sont toujours légèrement désynchronisées et le paient en attention.</p>
<p>Voici le rituel que suit presque toute équipe avec une roadmap publique. Vous shippez quelque chose dans Linear. Vous le marquez Done. Un jour ou deux plus tard, vous vous souvenez que vous devez mettre à jour la roadmap publique. Vous ouvrez Canny. Vous trouvez le post correspondant. Vous changez son statut en Livré. Vous y collez une phrase tirée de la description de la PR. Vous enregistrez. Vous faites ça 8 à 15 fois par semaine entre les éléments livrés, en cours et nouvellement prévus.</p>
<p>Chaque action individuelle prend moins d'une minute. Le coût agrégé représente une part significative de votre mardi après-midi, et le coût cognitif du changement de contexte entre deux systèmes est plus élevé que le coût horloge. Vous oubliez aussi parfois, ce qui crée un second mode de défaillance : les utilisateurs voient des éléments « Prévus » qui ont en réalité été livrés il y a trois semaines et perdent confiance dans le tableau.</p>
<p>C'est la taxe de double saisie. Votre tracker interne est la source de vérité pour l'ingénierie. Votre roadmap publique est la source de vérité pour les utilisateurs. Les garder d'accord sans automatisation est un travail de réconciliation manuelle que vous n'aviez pas budgétisé.</p>
<h2 id="combien-cote-rellement-la-double-saisie-">Combien coûte réellement la double saisie ?</h2>
<p>Réponse courte : plus que vous ne le pensez, parce que vous le tarifez à zéro.</p>
<p>Faisons le calcul. Un coût raisonnable du temps de fondateur est de 75 à 150 \$ l'heure (ce que vous paieriez à un prestataire pour faire le même travail, ou ce que vaut une heure de votre focus en coût d'opportunité). Disons 100 \$ pour couper la poire en deux.</p>
<table>
<thead>
<tr>
<th>Temps de rituel par semaine</th>
<th>Coût hebdomadaire</th>
<th>Coût annuel (52 semaines)</th>
</tr>
</thead>
<tbody>
<tr>
<td>1 heure</td>
<td>100 \$</td>
<td>5 200 \$</td>
</tr>
<tr>
<td>2 heures</td>
<td>200 \$</td>
<td>10 400 \$</td>
</tr>
<tr>
<td>3 heures</td>
<td>300 \$</td>
<td>15 600 \$</td>
</tr>
<tr>
<td>5 heures</td>
<td>500 \$</td>
<td>26 000 \$</td>
</tr>
</tbody>
</table>
<p>Deux heures par semaine est un chiffre réaliste pour une équipe avec une roadmap publique active et une cadence de ship hebdomadaire. Cela représente 10 400 \$ par an de temps de fondateur consacré à la réconciliation de données. C'est plus que ce que la plupart des gens paient pour toute leur stack d'outils de feedback, et cela ne produit aucune nouvelle valeur. Cela empêche simplement la valeur existante de pourrir.</p>
<p>Si votre synchronisation de roadmap coûte plus cher que votre outil de roadmap, vous avez un problème d'automatisation, pas un problème d'outil.</p>
<p>Il y a aussi un coût caché que personne ne calcule : le délai. L'écart moyen entre un élément livré en interne et la roadmap publique le reflétant est de 5 à 11 jours dans l'audit Nielsen cité plus haut. C'est presque deux semaines pendant lesquelles les utilisateurs pensent que le travail n'a pas eu lieu. La roadmap publique est censée être un instrument de confiance. Une roadmap obsolète devient l'opposé.</p>
<h2 id="3-faons-dautomatiser-la-synchronisation">3 façons d'automatiser la synchronisation</h2>
<p>Réponse courte : choisissez le schéma qui correspond au contrôle éditorial que vous voulez garder.</p>
<p>Les trois schémas diffèrent par l'endroit où réside la vérité et par qui obtient le veto sur ce qui devient public.</p>
<table>
<thead>
<tr>
<th>Schéma</th>
<th>Source de vérité</th>
<th>Contrôle éditorial</th>
<th>Effort de mise en place</th>
</tr>
</thead>
<tbody>
<tr>
<td>Webhook sortant</td>
<td>Tracker d'issues</td>
<td>Faible (tout se synchronise)</td>
<td>Moyen</td>
</tr>
<tr>
<td>Source unique</td>
<td>Outil de roadmap</td>
<td>Élevé</td>
<td>Faible</td>
</tr>
<tr>
<td>Miroir en lecture seule</td>
<td>Tracker d'issues</td>
<td>Moyen (filtrer avant synchronisation)</td>
<td>Moyen</td>
</tr>
</tbody>
</table>
<p>Parcourez chacun avant de vous engager. Le mauvais schéma crée de pires problèmes que la synchronisation manuelle.</p>
<h2 id="schma-1-webhook-sortant-linear-ou-jira-push-vers-la-roadmap">Schéma 1 : Webhook sortant (Linear ou Jira push vers la roadmap)</h2>
<p>Réponse courte : quand un ticket change d'état dans Linear, un webhook est déclenché et met à jour l'élément correspondant dans votre roadmap publique.</p>
<p>C'est le schéma le plus propre si votre tracker interne est déjà bien discipliné. L'ingénierie vit dans Linear. Quand un ticket passe de « In Progress » à « Done », Linear déclenche un webhook. Votre outil de roadmap (Feedbask, Canny, peu importe) le reçoit et bascule l'élément public correspondant en Livré.</p>
<p>Configuration concrète avec Linear et Feedbask :</p>
<ol>
<li>Dans Linear, créez un webhook dans Settings > API > Webhooks pointant vers votre URL d'ingestion de roadmap Feedbask.</li>
<li>Taguez les tickets Linear avec un label personnalisé comme <code>public:roadmap-id-123</code> pour que le webhook sache quel élément public mettre à jour.</li>
<li>Feedbask écoute le webhook, parse le tag et met à jour le statut de l'élément de roadmap correspondant.</li>
</ol>
<p>L'avantage, c'est que votre roadmap publique se met maintenant à jour en secondes, pas en jours. L'inconvénient, c'est que vous perdez le contrôle éditorial. Si vous taguez accidentellement un ticket avec un nom de code interne, il est livré sur le tableau public.</p>
<p>Atténuations :</p>
<ul>
<li>Exigez le tag <code>public:</code> comme opt-in positif. Par défaut, rien ne se synchronise.</li>
<li>Faites en sorte que le webhook poste dans une zone de staging, pas sur le tableau public en direct. Un humain fait une promotion en un clic.</li>
<li>Utilisez le label de projet de Linear, pas le label d'issue, si vous voulez synchroniser des projets entiers d'un coup.</li>
</ul>
<p>Ce schéma vaut le temps de configuration pour les équipes shippant plus de 10 éléments publics par semaine. En dessous, le schéma 3 est plus rapide à mettre en place.</p>
<h2 id="schma-2-source-unique-vues-multiples">Schéma 2 : Source unique, vues multiples</h2>
<p>Réponse courte : arrêtez d'exploiter deux systèmes. Utilisez un seul outil feedback-plus-roadmap qui intègre à la fois des vues internes et publiques.</p>
<p>La solution la plus propre à un problème de synchronisation est de ne pas avoir deux systèmes en premier lieu. Quelques outils de feedback (dont Feedbask) traitent un élément de feedback comme un enregistrement unique avec un toggle de visibilité publique. Votre équipe interne trie tout dans une boîte de réception. Vous basculez un interrupteur de visibilité sur les éléments que vous voulez sur la roadmap publique. Les mises à jour de statut se font une fois, à un seul endroit, et la vue publique les reflète automatiquement.</p>
<p>C'est différent de Linear ou Jira parce que c'est conçu spécifiquement pour le feedback et la roadmap, pas pour l'exécution de sprint. Il n'essaie pas de remplacer votre tracker d'ingénierie. Il essaie de remplacer le tableur tourné vers le public que vous tenez en parallèle.</p>
<p>Quand ce schéma fonctionne :</p>
<ul>
<li>Vous êtes suffisamment petit pour que les éléments de feedback et les tickets d'ingénierie se mappent à peu près 1:1.</li>
<li>Votre équipe d'ingénierie accepte de vérifier un deuxième outil pour le contexte tourné vers le client.</li>
<li>Vous vous souciez plus que la roadmap publique soit toujours fraîche que d'un outillage de sprint profond.</li>
</ul>
<p>Quand ce schéma ne fonctionne pas :</p>
<ul>
<li>Vous avez une grande organisation d'ingénierie avec une forte culture Jira ou Linear qui n'adoptera pas un nouveau système.</li>
<li>Vos tickets incluent beaucoup de refontes internes qui n'ont pas d'équivalent public, et les mélanger est bruyant.</li>
</ul>
<p>Pour la plupart des SaaS indépendants et des équipes de moins de 20 personnes, un outil à source unique est la solution à plus fort levier. La <a href="https://feedbask.com/product/public-roadmap-software">roadmap publique</a> et la boîte de réception de feedback interne de Feedbask sont le même enregistrement sous-jacent avec un flag de visibilité. Vous basculez le flag, vous arrêtez la synchronisation, vous récupérez vos mardis après-midi.</p>
<h2 id="schma-3-miroir-en-lecture-seule-via-zapier-ou-make">Schéma 3 : Miroir en lecture seule via Zapier ou Make</h2>
<p>Réponse courte : utilisez une automatisation no-code pour surveiller votre tracker d'issues et refléter des changements spécifiques vers votre roadmap publique.</p>
<p>C'est le juste milieu pragmatique. Vous gardez votre stack existante (Linear ou Jira plus Canny ou Feedbask). Vous mettez Zapier, Make ou n8n entre les deux. Vous écrivez un zap qui dit : quand une issue Linear avec le label <code>public</code> passe à Done, mettez à jour le post Canny correspondant en Livré.</p>
<p>Recette Zapier concrète (Linear + Feedbask) :</p>
<ol>
<li><strong>Déclencheur</strong> : événement Linear « Issue Updated ».</li>
<li><strong>Filtre</strong> : continuer uniquement si l'issue a le label <code>public-roadmap</code> et que le statut vient de passer à « Done ».</li>
<li><strong>Action</strong> : Feedbask « Update Roadmap Item Status » avec l'ID d'un champ personnalisé sur l'issue Linear.</li>
<li>Action de suivi optionnelle : notification Slack vers <code>#ship</code> pour que l'équipe sache que le tableau public est mis à jour.</li>
</ol>
<p>Vous pouvez construire cela en environ 20 minutes. Cela coûte ce que coûte votre tier Zapier (souvent gratuit pour moins de 100 tâches par mois). Le principal inconvénient, c'est que les tâches Zapier peuvent échouer silencieusement ou être limitées, donc vous avez besoin d'une étape de monitoring. La plupart des équipes ajoutent un zap d'« audit hebdomadaire » qui poste un rapport de tout élément où les statuts interne et public ne concordent pas.</p>
<p>C'est le bon schéma quand vous ne contrôlez pas l'outil source (parce que les ops possèdent Jira, pas vous) et que vous ne pouvez pas faire approuver un outil à source unique. C'est du scotch, mais c'est du scotch bon marché.</p>
<h2 id="quand-lautomatisation-est-en-fait-la-mauvaise-rponse">Quand l'automatisation est en fait la mauvaise réponse</h2>
<p>Réponse courte : si votre roadmap a moins de 10 éléments publics, manuel ça va.</p>
<p>Le cadrage de cet article, c'est que l'automatisation fait gagner du temps. C'est vrai au-dessus d'un seuil. En dessous du seuil, mettre en place et maintenir l'automatisation coûte plus cher que le travail manuel. Si vous shippez 2 éléments publics par mois et que votre roadmap publique a 8 entrées actives au total, le webhook et le zap sont tous deux excessifs.</p>
<p>Le vrai signal que vous avez besoin d'automatisation, c'est quand vous commencez à rater des mises à jour. Pas quand vous commencez à vous sentir agacé par elles. L'agacement est un signal vague. Rater trois éléments livrés d'affilée en est un concret.</p>
<p>Second signal : quand un utilisateur vous envoie un email pour demander pourquoi une fonctionnalité « est toujours en planification » alors que vous l'avez livrée il y a des semaines. C'est le marché qui vous dit que votre travail de réconciliation a pris du retard. Automatisez avant que cet email n'arrive pour la troisième fois.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Q : Existe-t-il un outil de feedback qui fait cette synchronisation out of the box, sans Zapier ?</strong>
R : Feedbask ingère nativement les webhooks Linear et GitHub pour le statut de roadmap, donc vous n'avez pas besoin de couche intermédiaire. Canny a des intégrations Jira et Linear, même si le périmètre de fonctionnalités varie selon le plan. Testez toujours avec un ticket jetable avant de faire confiance à un label « intégration native ».</p>
<p><strong>Q : Le schéma du webhook fonctionne-t-il si mes ingénieurs écrivent des titres de tickets confidentiels ?</strong>
R : Oui, parce que vous contrôlez ce que le webhook publie. Mappez un champ de titre tourné vers le public (une propriété séparée sur le ticket) vers l'élément de roadmap, et gardez le titre d'ingénierie brouillon en interne. Ne laissez jamais le titre brut du ticket être le titre public.</p>
<p><strong>Q : Zapier est cher à l'échelle. Que dire de n8n ou Make ?</strong>
R : Les deux fonctionnent. n8n est auto-hébergé et gratuit si vous l'exécutez vous-même. Make (anciennement Integromat) a un tier gratuit plus indulgent que Zapier pour les flux multi-étapes. Le schéma est identique. Choisissez selon ce que vous payez déjà.</p>
<p><strong>Q : Chaque ticket interne devrait-il avoir une contrepartie publique ?</strong>
R : Non. La plupart des équipes sur-publient. Une bonne règle : seuls les éléments sur lesquels un client pourrait raisonnablement poser une question appartiennent à la roadmap publique. Les refontes internes, les migrations de base de données et le travail de couverture de tests restent internes. Environ 1 ticket d'ingénierie sur 4 mérite d'être public pour un SaaS typique.</p>
<p><strong>Q : Que se passe-t-il si mon outil de roadmap tombe en panne en cours de synchronisation ?</strong>
R : Avec le schéma du webhook, vous perdez un seul événement (la plupart des outils réessaient). Avec Zapier, les zaps échoués sont visibles dans l'historique des tâches et peuvent être rejoués. Avec le schéma à source unique, la question ne s'applique pas parce qu'il n'y a pas de synchronisation. Prévoyez les re-tentatives, ne supposez pas le succès.</p>
<p><strong>Q : Puis-je voir le format de webhook de Feedbask avant de migrer ?</strong>
R : Oui. La <a href="https://feedbask.com/product/public-roadmap-software">page produit de la roadmap</a> renvoie à la référence du webhook. Vous pouvez tester sur un projet sandbox avant de déplacer les éléments de production.</p>
<hr>
<p>La taxe de double saisie est le type de coût qui n'apparaît sur aucune facture, c'est pourquoi elle dévore tant d'heures de fondateur. La solution n'est pas héroïque. Choisissez l'un des trois schémas, passez une matinée à le câbler et récupérez vos mardis après-midi. Si vous voulez un outil de feedback et de roadmap qui supprime la synchronisation par conception, <a href="https://feedbask.com/auth">commencez gratuitement sur Feedbask</a> ou comparez contre <a href="https://feedbask.com/alternatives/canny">Canny</a> et <a href="https://feedbask.com/alternatives/featurebase">Featurebase</a> avant de décider.</p>
`,
  'saas-feedback-pricing-teardown': `<h1 id="top">Je paierais 9 \$, pas 359 \$ : décortiquer le prix des outils de feedback SaaS</h1>
<p><strong>Les outils de feedback facturent aux équipes SaaS indépendantes entre 0 \$ et 359 \$ par mois pour des fonctionnalités quasi identiques, et un récent fil de discussion sur Indie Hackers a rassemblé plus de 40 fondateurs pour débattre de l'écart tarifaire devenu absurde (<a href="https://www.indiehackers.com/post/best-alternative-to-canny-io-for-single-person-saas-ee41ff4bfb">source</a>).</strong></p>
<p><strong>TL;DR :</strong></p>
<ul>
<li>Le plan Growth de Canny démarre à 79 \$/mois (par admin), Featurebase est à 29 \$/mois, Nolt à 25 \$/mois et Feedbask démarre gratuit ou à 33 \$/mois, pour un ensemble de fonctionnalités à peu près équivalent.</li>
<li>Sur cinq ans, avec une équipe de 5 personnes, vous dépenserez entre 1 500 \$ et plus de 20 000 \$ selon l'outil, presque entièrement à cause de la tarification par siège et des montées en gamme "Growth".</li>
<li>Si vous êtes bootstrappé, un tarif fixe avec admins illimités bat la tarification par siège à tous les coups, peu importe quel outil gagne sur les fonctionnalités.</li>
</ul>
<h2 id="la-ranon-de-roi-50-">La rançon de roi à 50 \$</h2>
<p>Le palier d'entrée de Canny exclut la plupart des fondateurs indépendants avant même qu'ils ne se connectent.</p>
<p>Il y a quelques mois, un fondateur indépendant nommé Jester a posté sur Indie Hackers : <em>"Canny.io wants a king's ransom for their starter plan: \$50/mo. Just ain't gonna happen."</em> (trad. libre : « Canny.io demande une rançon de roi pour son plan starter : 50 \$/mois. Ça ne va tout simplement pas se faire. ») Il a ensuite ajouté : <em>"Something in the \$6-15/mo range would feel right."</em> (trad. libre : « Quelque chose dans la fourchette 6-15 \$/mois semblerait juste. ») Le fil s'est rempli de fondateurs qui reprenaient la même chose. L'un d'eux, AJ Villalobos, a dit : <em>"I've decided to go with Nolt even though it's quite pricey on my current stage."</em> (trad. libre : « J'ai décidé de partir sur Nolt même si c'est assez cher pour mon stade actuel. »)</p>
<p>L'écart entre ce que les bootstrappers veulent payer (6-15 \$/mois) et ce que Canny facture réellement (le plan Growth public affiche désormais 79 \$/mois, et les paliers supérieurs de Canny montent vite vers 359 \$/mois avec plus d'admins) est d'environ 5 à 50 fois. Cet écart n'est pas une erreur d'arrondi. C'est une décision produit. Le profil client idéal de Canny s'est déplacé vers le haut de gamme il y a des années, vers les entreprises SaaS en Série A et B avec des lignes budgétaires dédiées au "logiciel de feedback client". Les pages marketing disent encore des choses comme "utilisé par des milliers d'équipes", mais la page tarifaire est calibrée pour les équipes avec un PM, un CSM et un approbateur finance.</p>
<p>Si vous êtes fondateur solo avec 200 clients payants, Canny n'est pas conçu pour vous. Ce n'est pas une faute morale de la part de Canny, c'est juste l'arithmétique.</p>
<h2 id="ce-que-les-bootstrappers-paient-rellement">Ce que les bootstrappers paient réellement</h2>
<p>La plupart des fondateurs indépendants paient entre 0 \$ et 33 \$/mois pour leur outillage de feedback, et encore, seulement s'ils paient quelque chose.</p>
<p>Voici à quoi ressemble le marché actuel pour les outils effectivement considérés par les personnes du fil Indie Hackers :</p>
<table>
<thead>
<tr>
<th>Outil</th>
<th>Offre gratuite</th>
<th>Entrée payante</th>
<th>Là où les tarifs s'envolent</th>
</tr>
</thead>
<tbody>
<tr>
<td>Canny</td>
<td>Plan gratuit limité (100 utilisateurs suivis)</td>
<td>79 \$/mois</td>
<td>359 \$/mois pour "Business"</td>
</tr>
<tr>
<td>Featurebase</td>
<td>Gratuit (3 admins)</td>
<td>29 \$/mois</td>
<td>79 \$/mois à plus gros volume</td>
</tr>
<tr>
<td>Nolt</td>
<td>Essai de 14 jours seulement</td>
<td>25 \$/mois</td>
<td>Add-ons par tableau et par admin</td>
</tr>
<tr>
<td>Noora</td>
<td>Gratuit (tableau public seulement)</td>
<td>19 \$/mois</td>
<td>39 \$/mois pour domaine custom + SSO</td>
</tr>
<tr>
<td>UserVoice</td>
<td>Aucune</td>
<td>Contacter les ventes</td>
<td>Contrats annuels, entreprise seulement</td>
</tr>
<tr>
<td>Sleekplan</td>
<td>Gratuit (avec marque)</td>
<td>15 \$/mois</td>
<td>49 \$/mois pour espace de travail privé</td>
</tr>
<tr>
<td>Feedbask</td>
<td>Gratuit (10 réponses/mois, marque Feedbask)</td>
<td>33 \$/mois</td>
<td>49 \$/mois pour webhooks + réponses IA</td>
</tr>
</tbody>
</table>
<p>Quelques remarques sur ce que ces chiffres cachent. Les 79 \$/mois de Canny sont par admin sur le nouveau plan Growth, donc une équipe de 5 admins est plus proche de 395 \$/mois. Les 25 \$/mois de Nolt sont un prix pour un seul espace de travail, raisonnable, mais les add-ons et les tableaux supplémentaires font vite gonfler la note. Featurebase est probablement la meilleure affaire en bas de gamme actuellement si vous n'avez besoin que du vote de fonctionnalités et du changelog. Noora est discrètement l'une des options les moins chères si un feedback public uniquement vous suffit.</p>
<h2 id="le-vrai-calcul-5-siges">Le vrai calcul à 5 sièges</h2>
<p>La tarification par siège est ce qui rend les outils "pas chers" onéreux et les outils "chers" inabordables.</p>
<p>Prenons un scénario réaliste : vous êtes une équipe SaaS bootstrappée de 5 personnes ayant besoin d'un accès admin (2 fondateurs, 2 ingénieurs, 1 personne au support). Voici ce que coûte réellement chaque outil sur un an et sur 5 ans :</p>
<table>
<thead>
<tr>
<th>Outil</th>
<th>Mensuel (5 sièges)</th>
<th>Année 1</th>
<th>5 ans</th>
</tr>
</thead>
<tbody>
<tr>
<td>Canny Growth</td>
<td>395 \$</td>
<td>4 740 \$</td>
<td>23 700 \$</td>
</tr>
<tr>
<td>Canny Business</td>
<td>1 795 \$</td>
<td>21 540 \$</td>
<td>107 700 \$</td>
</tr>
<tr>
<td>Featurebase</td>
<td>29 \$ (3 admins) + 10 \$/supplémentaire = 49 \$</td>
<td>588 \$</td>
<td>2 940 \$</td>
</tr>
<tr>
<td>Nolt</td>
<td>25 \$ + add-ons ~40 \$ au total</td>
<td>480 \$</td>
<td>2 400 \$</td>
</tr>
<tr>
<td>Noora</td>
<td>39 \$</td>
<td>468 \$</td>
<td>2 340 \$</td>
</tr>
<tr>
<td>Feedbask Starter</td>
<td>33 \$ + 2 sièges × 9 \$ = 51 \$</td>
<td>612 \$</td>
<td>3 060 \$</td>
</tr>
<tr>
<td>Feedbask Growth</td>
<td>49 \$ + 2 sièges × 9 \$ = 67 \$</td>
<td>804 \$</td>
<td>4 020 \$</td>
</tr>
<tr>
<td>Sleekplan</td>
<td>49 \$ (espace de travail privé)</td>
<td>588 \$</td>
<td>2 940 \$</td>
</tr>
</tbody>
</table>
<p>L'écart est réel. Sur cinq ans, la différence entre Canny Business et Nolt est d'environ 105 000 \$, sur une catégorie de produits où les fonctionnalités principales (poster, upvoter, commenter, statut, changelog) sont globalement les mêmes partout.</p>
<p>La tarification par siège est le multiplicateur. Canny facture par admin. Feedbask facture 9 \$ par siège supplémentaire après les trois premiers. Featurebase facture 10 \$. Le modèle de sièges de Nolt varie selon le plan. Si vous êtes solo ou à 2, la plupart de ces options semblent correctes. Si vous passez à 10+ utilisateurs internes, la différence augmente plus vite que votre ARR.</p>
<h2 id="ce-qui-est-inclus-chaque-palier-tarifaire">Ce qui est inclus à chaque palier tarifaire</h2>
<p>Les écarts de fonctionnalités entre outils pas chers et chers sont réels mais plus petits que ce que les écarts de prix suggèrent.</p>
<p>Voici une comparaison approximative des fonctionnalités au palier payant d'entrée pour chacun :</p>
<table>
<thead>
<tr>
<th>Fonctionnalité</th>
<th>Canny 79 \$</th>
<th>Featurebase 29 \$</th>
<th>Nolt 25 \$</th>
<th>Noora 19 \$</th>
<th>Feedbask 33 \$</th>
</tr>
</thead>
<tbody>
<tr>
<td>Roadmap publique</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
</tr>
<tr>
<td>Vote de fonctionnalités</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
</tr>
<tr>
<td>Changelog</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
</tr>
<tr>
<td>Signalements de bugs</td>
<td>Via tag</td>
<td>Oui</td>
<td>Via tag</td>
<td>Via tag</td>
<td>Oui (dédié)</td>
</tr>
<tr>
<td>Sondages NPS / CSAT</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Oui</td>
</tr>
<tr>
<td>Live chat</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>Oui</td>
</tr>
<tr>
<td>Widget embarquable</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Limité</td>
<td>Oui</td>
</tr>
<tr>
<td>Webhooks</td>
<td>Oui</td>
<td>Palier supérieur</td>
<td>Non</td>
<td>Non</td>
<td>Palier 49 \$</td>
</tr>
<tr>
<td>Retirer la marque</td>
<td>Oui</td>
<td>Palier supérieur</td>
<td>Oui</td>
<td>Supérieur</td>
<td>Oui</td>
</tr>
<tr>
<td>Domaine personnalisé</td>
<td>Oui</td>
<td>Oui</td>
<td>Oui</td>
<td>Palier 39 \$</td>
<td>Oui</td>
</tr>
<tr>
<td>Réponses assistées par IA</td>
<td>Bêta</td>
<td>Non</td>
<td>Non</td>
<td>Non</td>
<td>200/mois à 49 \$</td>
</tr>
</tbody>
</table>
<p>Quelques remarques honnêtes. L'ensemble de fonctionnalités de Canny est mature et soigné, vous payez des années d'itération et une réputation que les acheteurs d'entreprise reconnaissent. Featurebase est l'équivalent le plus proche côté fonctionnalités à environ un tiers du prix. Nolt est épuré et rapide, idéal pour les équipes qui ne veulent qu'un tableau de vote. Noora est une option vraiment bonne et pas chère si vous voulez un tableau public et rien d'autre.</p>
<p>L'argument de Feedbask n'est pas "le moins cher". C'est "un widget, six modules". Signalements de bugs, demandes de fonctionnalités, sondages NPS/CSAT, avis, formulaires personnalisés et live chat vivent tous dans le même widget embarquable sur <a href="https://feedbask.com/product/website-feedback-widget">/product/website-feedback-widget</a>. Si vous payez déjà séparément pour un outil NPS distinct (50 \$+/mois), un outil de live chat (30 \$+/mois) et un outil de vote de fonctionnalités (25 \$+/mois), consolider en un seul produit à 33 \$/mois est là où le calcul commence à jouer en faveur de Feedbask.</p>
<h2 id="quand-payer-plus-cher">Quand payer plus cher</h2>
<p>Il y a des scénarios où Canny ou UserVoice valent sincèrement leur prix, et prétendre le contraire serait du positionnement paresseux.</p>
<p>Payez plus si :</p>
<ol>
<li><strong>Votre processus d'achat client l'exige.</strong> Si vous vendez à des entreprises et qu'elles demandent SOC 2, SSO et un customer success nommé, Canny et UserVoice ont la paperasse. Nolt et Noora ne l'ont pas encore.</li>
<li><strong>Vous avez besoin d'intégrations profondes avec Salesforce, HubSpot ou Intercom.</strong> La bibliothèque d'intégrations de Canny reste la plus large.</li>
<li><strong>Vous avez 20+ admins internes.</strong> À cette taille, la tarification par siège fait mal mais la granularité des permissions admin importe plus.</li>
<li><strong>Vos clients s'attendent à une UI familière.</strong> Le tableau public de Canny est celui que la plupart des utilisateurs finaux B2B reconnaissent. C'est un vrai signal pour certains acheteurs.</li>
</ol>
<p>Si aucun de ces éléments ne s'applique, et que vous êtes 1 à 10 personnes avec moins de quelques milliers d'utilisateurs payants, vous payez des prix d'entreprise pour un problème de startup.</p>
<h2 id="la-position-honnte-de-feedbask">La position honnête de Feedbask</h2>
<p>Feedbask n'est pas l'option la moins chère, et nous ne prétendrons pas le contraire.</p>
<p>Nolt à 25 \$/mois et Noora à 19 \$/mois coûtent sincèrement moins cher que le plan Starter à 33 \$/mois de Feedbask. L'offre gratuite de Featurebase (3 admins) est plus généreuse que celle de Feedbask (10 réponses/mois). Si votre seul besoin est un tableau de vote public, Nolt ou Featurebase gagnent probablement sur le prix à eux seuls.</p>
<p>Là où Feedbask mérite les 33 \$ : vous obtenez signalements de bugs, vote de fonctionnalités, sondages, avis, formulaires personnalisés, live chat et roadmap publique dans un seul widget. Ce sont six outils consolidés en un, avec un historique de chat illimité et la possibilité de retirer la marque Feedbask dès le plan Starter. Webhooks et réponses IA démarrent à 49 \$/mois sur Growth. Les sièges supplémentaires sont à 9 \$/mois fixe, soit le même chiffre que Jester disait "feel right" sur ce fil Indie Hackers.</p>
<p>Le plan annuel économise 17 %, ce qui met Starter à 390 \$/an et Growth à 590 \$/an. Pour une équipe de 5 personnes, ça fait 3 060 \$ sur cinq ans en Starter, toujours sous les 15 % de ce que coûterait Canny Business.</p>
<h2 id="faq">FAQ</h2>
<p><strong>Canny vaut-il 79 \$/mois pour un SaaS indépendant ?</strong>
Probablement pas. L'ensemble de fonctionnalités principales (vote, roadmap, changelog) est disponible chez Featurebase à 29 \$, Nolt à 25 \$ ou Feedbask à 33 \$, avec un niveau de finition équivalent. Canny vaut son prix si les achats d'entreprise ou des intégrations spécifiques l'exigent.</p>
<p><strong>Puis-je vraiment faire tourner mon feedback sur l'offre gratuite à long terme ?</strong>
Sur le plan gratuit de Feedbask, oui, jusqu'à 10 réponses par mois avec la marque Feedbask. En dessous de quelques centaines d'utilisateurs payants, c'est souvent suffisant. Au-delà, vous atteindrez vite les limites de réponses et le palier payant a du sens.</p>
<p><strong>Quel est le piège avec Nolt à 25 \$/mois ?</strong>
Pas de vrai piège pour son usage. Nolt est focalisé sur les tableaux de vote de fonctionnalités. Si vous voulez des signalements de bugs, des sondages ou du live chat, il vous faudra des outils séparés, ce qui empile rapidement le coût mensuel.</p>
<p><strong>Feedbask facture-t-il par admin ?</strong>
Les plans Starter et Growth incluent trois sièges. Les sièges supplémentaires sont à 9 \$/mois chacun. Pas de saut surprise de palier admin.</p>
<p><strong>Comment migrer de Canny sans perdre de données ?</strong>
La plupart des outils (Feedbask inclus) vous permettent d'importer des exports CSV de posts, commentaires et votes. Vous perdrez l'attribution des votes si les utilisateurs ne se sont pas inscrits sur la nouvelle plateforme, mais les posts et statuts se transfèrent proprement. Voir <a href="https://feedbask.com/alternatives/canny">les alternatives à Canny</a> pour les notes de migration.</p>
<p><strong>Existe-t-il des alternatives gratuites et open source ?</strong>
Fider est la principale option open source. Il est gratuit à auto-héberger mais vous devez faire tourner et maintenir un serveur, gérer les sauvegardes et construire vous-même les intégrations. Pour la plupart des fondateurs solo, l'option SaaS à 20-40 \$/mois est moins chère que les heures passées à la maintenir.</p>
<h2 id="essayez-les-chiffres-vousmme">Essayez les chiffres vous-même</h2>
<p>Si vous en avez assez de payer des prix d'entreprise pour un problème de feedback de startup, <a href="https://feedbask.com/auth">essayez Feedbask gratuitement</a>. Pas de carte bancaire, 10 réponses par mois en offre gratuite, et une équipe de 5 personnes coûte 612 \$/an en Starter. Comparez ça à ce que vous payez actuellement et décidez à partir de là.</p>
`
};

const localeRegistry: Record<string, { config: BlogPostMeta[]; contents: Record<string, string> }> = {
  'en': { config: blogConfig, contents: articleContents },
  'fr': { config: blogConfigFr, contents: articleContentsFr }
};

const DEFAULT_LOCALE = 'en';

function resolveLocale(locale?: string): string {
  if (!locale) return DEFAULT_LOCALE;
  const base = locale.split('-')[0].toLowerCase();
  return localeRegistry[base] ? base : DEFAULT_LOCALE;
}

function isPublished(date: string): boolean {
  const published = new Date(date).getTime();
  if (Number.isNaN(published)) return false;
  return published <= Date.now();
}

function buildPost(meta: BlogPostMeta, contents: Record<string, string>, fallbackContents?: Record<string, string>): BlogPost | null {
  const content = contents[meta.slug] ?? fallbackContents?.[meta.slug];
  if (!content) return null;
  return {
    slug: meta.slug,
    title: meta.title,
    date: meta.date,
    excerpt: meta.excerpt,
    cover: meta.cover,
    content,
    headings: meta.headings,
  };
}

export async function getAllPosts(locale?: string): Promise<BlogPost[]> {
  try {
    const key = resolveLocale(locale);
    const primary = localeRegistry[key];
    const fallback = localeRegistry[DEFAULT_LOCALE];
    const posts: BlogPost[] = [];
    const seen = new Set<string>();

    // Use primary locale's posts first.
    for (const meta of primary.config) {
      if (!isPublished(meta.date)) continue;
      const post = buildPost(meta, primary.contents, fallback.contents);
      if (post) {
        posts.push(post);
        seen.add(meta.slug);
      }
    }

    // If the primary locale is missing posts that exist in the default locale, fall back to default.
    if (key !== DEFAULT_LOCALE) {
      for (const meta of fallback.config) {
        if (seen.has(meta.slug)) continue;
        if (!isPublished(meta.date)) continue;
        const post = buildPost(meta, fallback.contents);
        if (post) posts.push(post);
      }
    }

    return posts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  } catch (error) {
    console.error("Error getting all posts:", error);
    return [];
  }
}

export async function getPostBySlug(slug: string, locale?: string): Promise<BlogPost | null> {
  try {
    const key = resolveLocale(locale);
    const primary = localeRegistry[key];
    const fallback = localeRegistry[DEFAULT_LOCALE];
    const meta = primary.config.find((p) => p.slug === slug) || fallback.config.find((p) => p.slug === slug);
    if (!meta || !isPublished(meta.date)) return null;
    return buildPost(meta, primary.contents, fallback.contents);
  } catch (error) {
    console.error(`Error getting post ${slug}:`, error);
    return null;
  }
}

export function getPostSlugs(locale?: string): string[] {
  const key = resolveLocale(locale);
  const primary = localeRegistry[key];
  const slugs = new Set<string>();
  for (const meta of primary.config) {
    if (isPublished(meta.date)) slugs.add(meta.slug);
  }
  if (key !== DEFAULT_LOCALE) {
    for (const meta of localeRegistry[DEFAULT_LOCALE].config) {
      if (isPublished(meta.date)) slugs.add(meta.slug);
    }
  }
  return Array.from(slugs);
}
